var _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtPharmacist1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.73,129.68a3.22,3.22,0,0,0-1.89-2.65,10.15,10.15,0,0,0-9.17,0,3.22,3.22,0,0,0-1.89,2.65h0v2.87h0a3.22,3.22,0,0,0,1.89,2.64,10.15,10.15,0,0,0,9.17,0,3.22,3.22,0,0,0,1.89-2.64h0v-2.87Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.94,136.14a3.24,3.24,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0V139h0a3.22,3.22,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.24,3.24,0,0,0,1.9-2.65h0v-2.87Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.16,137.51a3.24,3.24,0,0,0-1.9-2.64,10.15,10.15,0,0,0-9.17,0,3.22,3.22,0,0,0-1.89,2.64h0v2.88h0a3.22,3.22,0,0,0,1.89,2.64,10.15,10.15,0,0,0,9.17,0,3.24,3.24,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.36,144a3.22,3.22,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.2,3.2,0,0,0-1.9,2.64h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.24,3.24,0,0,0,1.9-2.65h0V144Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.58,145.35a3.24,3.24,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.24,3.24,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.78,151.82a3.2,3.2,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.2,3.2,0,0,0-1.9,2.64h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.22,3.22,0,0,0,1.9-2.65h0v-2.87Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,153.19a3.24,3.24,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.24,3.24,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.2,159.66a3.2,3.2,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.2,3.2,0,0,0-1.9,2.64h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.22,3.22,0,0,0,1.9-2.65h0v-2.87Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.42,161a3.21,3.21,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.21,3.21,0,0,0,1.9-2.64h0V161Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.62,167.5a3.2,3.2,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.22,3.22,0,0,0-1.9,2.64h0v2.87h0a3.24,3.24,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.22,3.22,0,0,0,1.9-2.65h0V167.5Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.84,168.87a3.21,3.21,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.21,3.21,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99,175.34a3.2,3.2,0,0,0-1.9-2.64,10.06,10.06,0,0,0-9.16,0,3.22,3.22,0,0,0-1.9,2.64h0v2.87h0a3.24,3.24,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.22,3.22,0,0,0,1.9-2.65h0v-2.87Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.26,176.71a3.21,3.21,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.24,3.24,0,0,0-1.9,2.64h0v2.88h0a3.24,3.24,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.21,3.21,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-14--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.46,183.18a3.21,3.21,0,0,0-1.89-2.64,10.09,10.09,0,0,0-9.17,0,3.21,3.21,0,0,0-1.89,2.64h0v2.87h0a3.22,3.22,0,0,0,1.89,2.65,10.15,10.15,0,0,0,9.17,0,3.22,3.22,0,0,0,1.89-2.65h0v-2.87Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-15--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.37,259.63c0-1.3-.86-2.59-2.57-3.58a13.69,13.69,0,0,0-12.4,0c-1.71,1-2.57,2.28-2.57,3.58h0v3.88h0c0,1.3.86,2.59,2.57,3.58a13.69,13.69,0,0,0,12.4,0c1.71-1,2.57-2.28,2.57-3.58h0v-3.88Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-16--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.68,271.35c0-1.29-.86-2.59-2.57-3.58a13.75,13.75,0,0,0-12.4,0c-1.71,1-2.57,2.29-2.57,3.58h0v3.89h0c0,1.29.86,2.59,2.57,3.58a13.75,13.75,0,0,0,12.4,0c1.71-1,2.57-2.29,2.57-3.58h0v-3.89Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-17--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.12,269c0-1.3-.86-2.59-2.57-3.58a13.69,13.69,0,0,0-12.4,0c-1.71,1-2.56,2.28-2.56,3.58h0v3.88h0c0,1.3.85,2.59,2.56,3.58a13.69,13.69,0,0,0,12.4,0c1.71-1,2.57-2.28,2.57-3.58h0V269Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-18--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.43,280.73c0-1.29-.86-2.59-2.57-3.58a13.75,13.75,0,0,0-12.4,0c-1.71,1-2.56,2.29-2.56,3.58h0v3.89h0c0,1.3.85,2.59,2.56,3.58a13.69,13.69,0,0,0,12.4,0c1.71-1,2.57-2.28,2.57-3.58h0v-3.89Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-3",
    d: "M89.16,435.19C.33,383.9.33,300.75,89.16,249.46s232.85-51.28,321.68,0,88.83,134.44,0,185.73S178,486.47,89.16,435.19Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-3",
    d: "M66,411.54c-12.51,7.23-12.51,18.94,0,26.17s32.82,7.23,45.33,0,12.52-18.94,0-26.17S78.48,404.32,66,411.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M356.61,350.86c-26.34,15.21-26.34,39.86,0,55.07s69.05,15.21,95.39,0,26.34-39.86,0-55.07S383,335.65,356.61,350.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M180.35,230.27l-38-22a2.9,2.9,0,0,0-2.6,0L32.65,270.13c-.72.42-.72,1.09,0,1.5l38,22a2.9,2.9,0,0,0,2.6,0l107.08-61.82C181.07,231.35,181.07,230.68,180.35,230.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-3",
    points: "65.08 381.67 186.94 452.02 446.91 301.93 268.18 198.74 195.06 240.95 251.93 273.79 65.08 381.67",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelving--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "73.2 281.99 73.2 288.99 41.02 270.41 41.02 263.41 73.2 281.99",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.2 288.99 77.01 286.8 77.01 279.79 73.2 281.99 73.2 288.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.76 226.24 169.76 233.24 137.58 214.66 137.58 207.66 169.76 226.24",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.76 233.24 173.57 231.05 173.57 224.04 169.76 226.24 169.76 233.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.56 43.86 178.93 40.77 178.93 221.75 173.56 224.85 173.56 43.86",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 43.86 173.57 224.85 141.38 206.27 141.38 25.28 173.57 43.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 43.86 173.57 224.85 141.38 206.27 141.38 25.28 173.57 43.86"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "71.64 277.61 173.57 218.76 141.38 200.18 39.46 259.03 71.64 277.61",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 218.76 173.57 224.85 71.64 283.7 71.64 277.61 173.57 218.76",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.64 277.61 39.46 259.03 39.46 265.12 71.64 283.7 71.64 277.61",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 149.14 141.38 130.56 39.46 189.4 39.46 195.49 71.64 214.07 173.57 155.23 173.57 149.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 149.14 173.57 155.23 71.64 214.07 71.64 207.98 173.57 149.14",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.64 207.98 39.46 189.4 39.46 195.49 71.64 214.07 71.64 207.98",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.32,145.89a10.15,10.15,0,0,0,9.17,0c2.53-1.46,2.53-3.83,0-5.29a10.15,10.15,0,0,0-9.17,0C141.79,142.06,141.79,144.43,144.32,145.89Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.36,132.46a3,3,0,0,0-1.79-2.49,9.51,9.51,0,0,0-8.63,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.51,9.51,0,0,0,8.63,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,129.69v15.94a4.77,4.77,0,0,0,.55-.29,4.47,4.47,0,0,0,1-.73v-13.9a4.49,4.49,0,0,0-1-.74C153.4,129.87,153.21,129.78,153,129.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.41,146.15c.31-.07.6-.15.88-.24v-16.5a6,6,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.26,131.81a4.37,4.37,0,0,0-1.42-1.23,10.26,10.26,0,0,0-8.62-.28v-.48l-.28.15a3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.51,9.51,0,0,0,8.63,0,4.21,4.21,0,0,0,1.09-.85c-1.13,1.06-4,1.65-6.06,1.23s-3.38-1.75-3.38-2.7v-.93a9.11,9.11,0,0,0,4.23.94v-4.65a9.09,9.09,0,0,1-4.23-.87v-1.36a10.26,10.26,0,0,0,8.62-.28,4.19,4.19,0,0,0,1.52-1.41v-2A2.14,2.14,0,0,0,155.26,131.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,143.29V130.5a2.63,2.63,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.61,7.61,0,0,0,2.32.84C145,145.56,144.18,144,144.18,143.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.73,129.68a3.22,3.22,0,0,0-1.89-2.65,10.15,10.15,0,0,0-9.17,0,3.22,3.22,0,0,0-1.89,2.65h0v2.87h0a3.22,3.22,0,0,0,1.89,2.64,10.15,10.15,0,0,0,9.17,0,3.22,3.22,0,0,0,1.89-2.64h0v-2.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155.58,
    y: 129.41,
    width: 0.31,
    height: 4.47
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 154.86,
    y: 130.62,
    width: 0.31,
    height: 4.49
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 153.78,
    y: 131.45,
    width: 0.31,
    height: 4.52
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152.55,
    y: 131.96,
    width: 0.31,
    height: 4.54
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 151.19,
    y: 132.31,
    width: 0.31,
    height: 4.56
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 149.76,
    y: 132.48,
    width: 0.31,
    height: 4.59
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.3,
    y: 132.47,
    width: 0.31,
    height: 4.61
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 146.88,
    y: 132.28,
    width: 0.31,
    height: 4.64
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 145.54,
    y: 131.9,
    width: 0.31,
    height: 4.66
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 144.34,
    y: 131.31,
    width: 0.31,
    height: 4.68
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 143.38,
    y: 130.48,
    width: 0.31,
    height: 4.71
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 142.62,
    y: 129.14,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.81,136.18c-3.21,0-4.9-1-5.42-1.88a6.68,6.68,0,0,1-.45-3s-.37-2.69-.3-2.7-.77-.18-1.39-.31a2.41,2.41,0,0,0-.47,1.41h0v2.87h0a3.22,3.22,0,0,0,1.89,2.64A10,10,0,0,0,150.81,136.18Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.67,132.32a10.15,10.15,0,0,0,9.17,0c2.53-1.46,2.53-3.83,0-5.29a10.15,10.15,0,0,0-9.17,0C142.14,128.49,142.14,130.86,144.67,132.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.18,132.1c2.18-1.47,2.06-3.68-.34-5.07a9.37,9.37,0,0,0-4.46-1.09,7,7,0,0,0-2.36.8,2.72,2.72,0,0,0,0,5A8.94,8.94,0,0,0,154.18,132.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.29,145.07a9.94,9.94,0,0,0,7.93,0c2.19-1.11,2.19-2.89,0-4a9.94,9.94,0,0,0-7.93,0C143.1,142.18,143.1,144,145.29,145.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.15,135.15a3,3,0,0,0,1.79,2.5,8.78,8.78,0,0,0,4.31,1v4.58a8.78,8.78,0,0,1-4.31-1,3,3,0,0,1-1.79-2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.27,131.11a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.33,5.91-3a2.53,2.53,0,0,0-.55-2.35,2.69,2.69,0,0,1,.92,1.93v2.87c0,.24.13,1.07-1.19,2.16a3.19,3.19,0,0,0,.78-1.72v-2s-1.44,2.41-5.87,2.41S143.49,131.47,143.27,131.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.53,152.36a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.06,10.06,0,0,0-9.16,0C153,148.53,153,150.9,155.53,152.36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.57,138.93a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.22,136.16v15.93a5.85,5.85,0,0,0,.56-.28,4.42,4.42,0,0,0,1-.74V137.18a4.42,4.42,0,0,0-1-.74A5.85,5.85,0,0,0,164.22,136.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.62,152.61a6.74,6.74,0,0,0,.88-.24V135.88a6.74,6.74,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.46,138.28a4.37,4.37,0,0,0-1.42-1.23,10.2,10.2,0,0,0-8.61-.28v-.48l-.29.15a3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.63,4.63,0,0,0,1.09-.85c-1.14,1.06-4,1.64-6.07,1.23s-3.37-1.75-3.37-2.71v-.92a9,9,0,0,0,4.22.94v-4.65a9.14,9.14,0,0,1-4.22-.87v-1.36a10.23,10.23,0,0,0,8.61-.28,4.31,4.31,0,0,0,1.53-1.41v-2A2.11,2.11,0,0,0,166.46,138.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.38,149.75V137a2.61,2.61,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.61,7.61,0,0,0,2.32.84C156.16,152,155.38,150.46,155.38,149.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.94,136.14a3.24,3.24,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0V139h0a3.22,3.22,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.24,3.24,0,0,0,1.9-2.65h0v-2.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 166.78,
    y: 135.88,
    width: 0.31,
    height: 4.47
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 166.07,
    y: 137.08,
    width: 0.31,
    height: 4.49
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 164.98,
    y: 137.91,
    width: 0.31,
    height: 4.52
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 163.75,
    y: 138.43,
    width: 0.31,
    height: 4.54
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 162.39,
    y: 138.77,
    width: 0.31,
    height: 4.56
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 160.96,
    y: 138.95,
    width: 0.31,
    height: 4.59
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 159.5,
    y: 138.94,
    width: 0.31,
    height: 4.61
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 158.08,
    y: 138.75,
    width: 0.31,
    height: 4.64
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 156.74,
    y: 138.37,
    width: 0.31,
    height: 4.66
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 155.54,
    y: 137.77,
    width: 0.31,
    height: 4.68
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 154.58,
    y: 136.95,
    width: 0.31,
    height: 4.71
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 153.82,
    y: 135.61,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M162,142.64c-3.21,0-4.9-1-5.41-1.87a6.55,6.55,0,0,1-.46-3s-.36-2.69-.29-2.7-.77-.18-1.4-.32a2.48,2.48,0,0,0-.47,1.41h0V139h0a3.22,3.22,0,0,0,1.9,2.65A10,10,0,0,0,162,142.64Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.88,138.79a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C153.35,135,153.35,137.33,155.88,138.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.39,138.57c2.17-1.47,2.05-3.68-.35-5.07a9.26,9.26,0,0,0-4.46-1.09,7.08,7.08,0,0,0-2.36.8,2.72,2.72,0,0,0,0,5A9,9,0,0,0,165.39,138.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.49,151.53a9.94,9.94,0,0,0,7.93,0c2.2-1.1,2.2-2.88,0-4a9.86,9.86,0,0,0-7.93,0C154.3,148.65,154.3,150.43,156.49,151.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35,141.62a3,3,0,0,0,1.79,2.5,8.9,8.9,0,0,0,4.32,1v4.58a8.79,8.79,0,0,1-4.32-1,3,3,0,0,1-1.79-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47,137.58a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.33,5.92-3a2.59,2.59,0,0,0-.55-2.35,2.74,2.74,0,0,1,.92,1.92V139c0,.25.12,1.08-1.19,2.16a3.16,3.16,0,0,0,.77-1.71v-2s-1.44,2.41-5.87,2.41S154.7,137.94,154.47,137.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74,153.73a10.15,10.15,0,0,0,9.17,0c2.53-1.46,2.53-3.83,0-5.29a10.15,10.15,0,0,0-9.17,0C128.21,149.9,128.21,152.27,130.74,153.73Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,140.3a3,3,0,0,0-1.78-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.78-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.44,137.53v15.94a5.93,5.93,0,0,0,.56-.29,5,5,0,0,0,1-.73v-13.9a5,5,0,0,0-1-.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84,154q.45-.11.87-.24v-16.5a6.2,6.2,0,0,0-.87-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,139.65a4.37,4.37,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.28v-.48l-.29.15a3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.15,4.15,0,0,0,1.08-.85c-1.13,1.06-4,1.65-6.06,1.23s-3.37-1.75-3.37-2.7v-.93a9,9,0,0,0,4.22.94v-4.65a9.14,9.14,0,0,1-4.22-.87V144a10.23,10.23,0,0,0,8.61-.28,4.19,4.19,0,0,0,1.52-1.41v-2A2.14,2.14,0,0,0,141.68,139.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,151.13V138.34a2.63,2.63,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.61,7.61,0,0,0,2.32.84C131.38,153.4,130.6,151.83,130.6,151.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.16,137.51a3.24,3.24,0,0,0-1.9-2.64,10.15,10.15,0,0,0-9.17,0,3.22,3.22,0,0,0-1.89,2.64h0v2.88h0a3.22,3.22,0,0,0,1.89,2.64,10.15,10.15,0,0,0,9.17,0,3.24,3.24,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 137.25,
    width: 0.31,
    height: 4.47
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 141.28,
    y: 138.46,
    width: 0.31,
    height: 4.49
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 140.2,
    y: 139.28,
    width: 0.31,
    height: 4.52
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 138.97,
    y: 139.8,
    width: 0.31,
    height: 4.54
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 137.61,
    y: 140.15,
    width: 0.31,
    height: 4.56
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 136.18,
    y: 140.32,
    width: 0.31,
    height: 4.59
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 134.72,
    y: 140.31,
    width: 0.31,
    height: 4.61
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 140.12,
    width: 0.31,
    height: 4.64
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 131.96,
    y: 139.74,
    width: 0.31,
    height: 4.66
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 139.15,
    width: 0.31,
    height: 4.68
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 129.8,
    y: 138.32,
    width: 0.31,
    height: 4.71
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 129.04,
    y: 136.98,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M137.23,144c-3.21,0-4.9-1-5.42-1.87a6.68,6.68,0,0,1-.45-3s-.37-2.69-.29-2.7-.77-.18-1.4-.31a2.47,2.47,0,0,0-.47,1.4h0v2.88h0a3.22,3.22,0,0,0,1.89,2.64A10,10,0,0,0,137.23,144Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.09,140.16a10.15,10.15,0,0,0,9.17,0c2.53-1.46,2.53-3.83,0-5.29a10.15,10.15,0,0,0-9.17,0C128.56,136.33,128.56,138.7,131.09,140.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61,139.94c2.17-1.47,2-3.68-.35-5.07a9.37,9.37,0,0,0-4.46-1.09,7.08,7.08,0,0,0-2.36.8,2.72,2.72,0,0,0,0,5A9,9,0,0,0,140.61,139.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,152.9a9.86,9.86,0,0,0,7.93,0c2.2-1.1,2.2-2.88,0-4a9.94,9.94,0,0,0-7.93,0C129.52,150,129.52,151.8,131.71,152.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,143a3,3,0,0,0,1.79,2.5,8.79,8.79,0,0,0,4.32,1v4.58a8.9,8.9,0,0,1-4.32-1,3,3,0,0,1-1.79-2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.69,139a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.33,5.91-3a2.55,2.55,0,0,0-.54-2.35,2.76,2.76,0,0,1,.92,1.92v2.88c0,.24.12,1.07-1.19,2.16a3.21,3.21,0,0,0,.77-1.72v-2s-1.44,2.41-5.87,2.41S129.92,139.31,129.69,139Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,160.2a10.13,10.13,0,0,0,9.16,0c2.53-1.47,2.53-3.83,0-5.29a10.06,10.06,0,0,0-9.16,0C139.42,156.37,139.42,158.73,142,160.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,146.77a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.64,144v15.93a5.85,5.85,0,0,0,.56-.28,4.2,4.2,0,0,0,1-.74V145a4.47,4.47,0,0,0-1-.73A5.85,5.85,0,0,0,150.64,144Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,160.45a6.74,6.74,0,0,0,.88-.24V143.72a6.74,6.74,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.88,146.12a4.37,4.37,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.29v-.47a2.64,2.64,0,0,0-.29.15,3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.63,4.63,0,0,0,1.09-.85c-1.14,1.06-4,1.64-6.07,1.23s-3.37-1.75-3.37-2.71v-.92a9.07,9.07,0,0,0,4.22.94v-4.65a9.17,9.17,0,0,1-4.22-.87v-1.36a10.23,10.23,0,0,0,8.61-.28,4.22,4.22,0,0,0,1.53-1.41v-2A2.11,2.11,0,0,0,152.88,146.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,157.59V144.81a2.61,2.61,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.61,7.61,0,0,0,2.32.84C142.58,159.86,141.8,158.3,141.8,157.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.36,144a3.22,3.22,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.2,3.2,0,0,0-1.9,2.64h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.24,3.24,0,0,0,1.9-2.65h0V144Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 153.2,
    y: 143.72,
    width: 0.31,
    height: 4.47
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 152.49,
    y: 144.92,
    width: 0.31,
    height: 4.49
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 151.41,
    y: 145.75,
    width: 0.31,
    height: 4.52
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 150.17,
    y: 146.27,
    width: 0.31,
    height: 4.54
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 148.81,
    y: 146.61,
    width: 0.31,
    height: 4.56
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 147.38,
    y: 146.79,
    width: 0.31,
    height: 4.59
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 145.92,
    y: 146.78,
    width: 0.31,
    height: 4.61
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 146.59,
    width: 0.31,
    height: 4.64
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 143.17,
    y: 146.21,
    width: 0.31,
    height: 4.66
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 141.96,
    y: 145.61,
    width: 0.31,
    height: 4.68
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 144.79,
    width: 0.31,
    height: 4.71
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 140.24,
    y: 143.45,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M148.43,150.48c-3.21,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.69-.29-2.7-.77-.18-1.4-.32a2.48,2.48,0,0,0-.47,1.41h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65A10,10,0,0,0,148.43,150.48Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,146.63a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C139.77,142.8,139.77,145.17,142.3,146.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.81,146.4c2.17-1.46,2.06-3.67-.35-5.06a9.35,9.35,0,0,0-4.46-1.1,7.32,7.32,0,0,0-2.36.81,2.72,2.72,0,0,0,0,5A9,9,0,0,0,151.81,146.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.91,159.37a10,10,0,0,0,7.94,0c2.19-1.1,2.19-2.88,0-4a10,10,0,0,0-7.94,0C140.72,156.49,140.72,158.27,142.91,159.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,149.46a3.06,3.06,0,0,0,1.79,2.5,8.9,8.9,0,0,0,4.32,1v4.58a8.79,8.79,0,0,1-4.32-1,3,3,0,0,1-1.79-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.89,145.42a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.33,5.92-3a2.59,2.59,0,0,0-.55-2.35,2.74,2.74,0,0,1,.92,1.92v2.87c0,.25.12,1.08-1.19,2.16a3.16,3.16,0,0,0,.77-1.71v-2s-1.44,2.41-5.87,2.41S141.12,145.78,140.89,145.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.17,161.57a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C114.64,157.74,114.64,160.11,117.17,161.57Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.21,148.14a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.86,145.37v15.94a5.93,5.93,0,0,0,.56-.29,4.47,4.47,0,0,0,1-.73v-13.9a4.49,4.49,0,0,0-1-.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.26,161.83c.3-.07.59-.15.88-.24v-16.5a6.74,6.74,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1,147.49a4.37,4.37,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.28v-.48l-.29.15a3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.39,4.39,0,0,0,1.09-.85c-1.14,1.06-4,1.65-6.07,1.23s-3.37-1.75-3.37-2.7v-.93a9,9,0,0,0,4.22.94v-4.65a9.14,9.14,0,0,1-4.22-.87v-1.36a10.23,10.23,0,0,0,8.61-.28,4.31,4.31,0,0,0,1.53-1.41v-2A2.16,2.16,0,0,0,128.1,147.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,159V146.18a2.63,2.63,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.61,7.61,0,0,0,2.32.84C117.8,161.24,117,159.67,117,159Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.58,145.35a3.24,3.24,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.24,3.24,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 145.09,
    width: 0.31,
    height: 4.47
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 127.71,
    y: 146.29,
    width: 0.31,
    height: 4.49
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 126.62,
    y: 147.12,
    width: 0.31,
    height: 4.52
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 125.39,
    y: 147.64,
    width: 0.31,
    height: 4.54
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 124.03,
    y: 147.99,
    width: 0.31,
    height: 4.56
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 122.6,
    y: 148.16,
    width: 0.31,
    height: 4.59
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 121.14,
    y: 148.15,
    width: 0.31,
    height: 4.61
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 119.72,
    y: 147.96,
    width: 0.31,
    height: 4.64
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 118.38,
    y: 147.58,
    width: 0.31,
    height: 4.66
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 117.18,
    y: 146.99,
    width: 0.31,
    height: 4.68
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 116.22,
    y: 146.16,
    width: 0.31,
    height: 4.71
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 115.46,
    y: 144.82,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M123.65,151.85c-3.21,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.69-.29-2.7-.77-.18-1.4-.32a2.53,2.53,0,0,0-.47,1.41h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64A9.91,9.91,0,0,0,123.65,151.85Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.52,148a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C115,144.17,115,146.54,117.52,148Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,147.78c2.17-1.47,2.06-3.68-.35-5.07a9.34,9.34,0,0,0-4.46-1.09,7.08,7.08,0,0,0-2.36.8,2.72,2.72,0,0,0,0,5A9,9,0,0,0,127,147.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.13,160.74a9.88,9.88,0,0,0,7.94,0c2.19-1.1,2.19-2.88,0-4a10,10,0,0,0-7.94,0C115.94,157.86,115.94,159.64,118.13,160.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,150.83a3,3,0,0,0,1.79,2.5,8.79,8.79,0,0,0,4.32,1v4.58a8.9,8.9,0,0,1-4.32-1,3,3,0,0,1-1.79-2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,146.79a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.33,5.92-3a2.59,2.59,0,0,0-.55-2.35,2.74,2.74,0,0,1,.92,1.92v2.88c0,.24.12,1.07-1.19,2.16a3.21,3.21,0,0,0,.77-1.72v-2s-1.44,2.41-5.87,2.41S116.34,147.15,116.11,146.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,168a10.13,10.13,0,0,0,9.16,0c2.53-1.47,2.53-3.83,0-5.29a10.09,10.09,0,0,0-9.16,0C125.84,164.21,125.84,166.57,128.37,168Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.41,154.61a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0V165h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.06,151.84v15.93a5.85,5.85,0,0,0,.56-.28,4.2,4.2,0,0,0,1-.74v-13.9a4.47,4.47,0,0,0-1-.73A5.85,5.85,0,0,0,137.06,151.84Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.46,168.29a6.74,6.74,0,0,0,.88-.24V151.56a6.74,6.74,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.3,154a4.27,4.27,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.29V152a2.64,2.64,0,0,0-.29.15,3,3,0,0,0-1.79,2.49V157h0v4.58h0V165a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.69,4.69,0,0,0,1.09-.85c-1.14,1.06-4,1.64-6.07,1.23s-3.37-1.75-3.37-2.71v-.92a9.1,9.1,0,0,0,4.22.94v-4.65a9.2,9.2,0,0,1-4.22-.87V158.3a10.23,10.23,0,0,0,8.61-.28,4.22,4.22,0,0,0,1.53-1.41v-2A2.11,2.11,0,0,0,139.3,154Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.22,165.43V152.65a2.64,2.64,0,0,0-1,2V165a3,3,0,0,0,1.79,2.49,7.71,7.71,0,0,0,2.32.84C129,167.7,128.22,166.14,128.22,165.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.78,151.82a3.2,3.2,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.2,3.2,0,0,0-1.9,2.64h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.22,3.22,0,0,0,1.9-2.65h0v-2.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 139.62,
    y: 151.56,
    width: 0.31,
    height: 4.47
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 138.91,
    y: 152.76,
    width: 0.31,
    height: 4.49
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 137.83,
    y: 153.59,
    width: 0.31,
    height: 4.52
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 136.59,
    y: 154.11,
    width: 0.31,
    height: 4.54
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 135.24,
    y: 154.45,
    width: 0.31,
    height: 4.56
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 133.8,
    y: 154.63,
    width: 0.31,
    height: 4.59
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 132.34,
    y: 154.62,
    width: 0.31,
    height: 4.61
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 130.92,
    y: 154.43,
    width: 0.31,
    height: 4.64
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 129.59,
    y: 154.05,
    width: 0.31,
    height: 4.66
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 128.38,
    y: 153.45,
    width: 0.31,
    height: 4.68
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 127.42,
    y: 152.63,
    width: 0.31,
    height: 4.71
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 126.66,
    y: 151.29,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M134.85,158.32c-3.21,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.7-.29-2.7-.77-.18-1.39-.32a2.42,2.42,0,0,0-.48,1.41h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65A10,10,0,0,0,134.85,158.32Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.72,154.47a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C126.19,150.64,126.19,153,128.72,154.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,154.24c2.17-1.47,2.06-3.67-.35-5.06a9.23,9.23,0,0,0-4.46-1.1,7.32,7.32,0,0,0-2.36.81,2.72,2.72,0,0,0,0,5A9,9,0,0,0,138.23,154.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,167.21a10,10,0,0,0,7.94,0c2.19-1.1,2.19-2.88,0-4a10,10,0,0,0-7.94,0C127.14,164.33,127.14,166.11,129.33,167.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,157.3a3.06,3.06,0,0,0,1.79,2.5,8.93,8.93,0,0,0,4.32,1v4.58a8.82,8.82,0,0,1-4.32-1,3,3,0,0,1-1.79-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32,153.26a8.64,8.64,0,0,0,6.17,2c4.08-.11,5.7-2.34,5.92-3a2.56,2.56,0,0,0-.55-2.35,2.74,2.74,0,0,1,.92,1.92v2.87c0,.25.12,1.08-1.19,2.16a3.16,3.16,0,0,0,.77-1.71v-2s-1.44,2.41-5.87,2.41S127.54,153.62,127.32,153.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.59,169.41a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C101.06,165.58,101.06,168,103.59,169.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.63,156a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.28,153.21v15.94a5.93,5.93,0,0,0,.56-.29,4.47,4.47,0,0,0,1-.73v-13.9a4.2,4.2,0,0,0-1-.74A5.85,5.85,0,0,0,112.28,153.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.68,169.67a8.84,8.84,0,0,0,.88-.25V152.93a6.74,6.74,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.52,155.33a4.37,4.37,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.28v-.48l-.29.15a3,3,0,0,0-1.79,2.49v2.39h0V163h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.63,4.63,0,0,0,1.09-.85c-1.14,1.06-4,1.65-6.07,1.23s-3.37-1.75-3.37-2.7v-.93a9.1,9.1,0,0,0,4.22.94V161.9a9.2,9.2,0,0,1-4.22-.87v-1.36a10.23,10.23,0,0,0,8.61-.28,4.22,4.22,0,0,0,1.53-1.41v-2A2.16,2.16,0,0,0,114.52,155.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.44,166.81V154a2.61,2.61,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.71,7.71,0,0,0,2.32.84C104.22,169.08,103.44,167.51,103.44,166.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,153.19a3.24,3.24,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.24,3.24,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 114.84,
    y: 152.93,
    width: 0.31,
    height: 4.47
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 114.13,
    y: 154.13,
    width: 0.31,
    height: 4.49
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 113.05,
    y: 154.96,
    width: 0.31,
    height: 4.52
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 111.81,
    y: 155.48,
    width: 0.31,
    height: 4.54
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 110.46,
    y: 155.82,
    width: 0.31,
    height: 4.56
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 109.02,
    y: 156,
    width: 0.31,
    height: 4.59
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 107.56,
    y: 155.99,
    width: 0.31,
    height: 4.61
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 106.14,
    y: 155.8,
    width: 0.31,
    height: 4.64
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 155.42,
    width: 0.31,
    height: 4.66
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 103.6,
    y: 154.83,
    width: 0.31,
    height: 4.68
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 102.64,
    y: 154,
    width: 0.31,
    height: 4.71
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 101.88,
    y: 152.66,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,159.69c-3.21,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.69-.29-2.7-.77-.18-1.39-.32a2.44,2.44,0,0,0-.48,1.41h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64A9.91,9.91,0,0,0,110.07,159.69Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.94,155.84a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C101.41,152,101.41,154.38,103.94,155.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,155.62c2.17-1.47,2.06-3.68-.35-5.07a9.23,9.23,0,0,0-4.46-1.09,7.08,7.08,0,0,0-2.36.8,2.72,2.72,0,0,0,0,5A9,9,0,0,0,113.45,155.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.55,168.58a9.88,9.88,0,0,0,7.94,0c2.19-1.1,2.19-2.88,0-4a10,10,0,0,0-7.94,0C102.36,165.7,102.36,167.48,104.55,168.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.41,158.67a3,3,0,0,0,1.79,2.5,8.79,8.79,0,0,0,4.32,1v4.58a8.9,8.9,0,0,1-4.32-1,3.06,3.06,0,0,1-1.79-2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.53,154.63a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.33,5.92-3a2.56,2.56,0,0,0-.55-2.35,2.74,2.74,0,0,1,.92,1.92v2.88c0,.24.12,1.07-1.19,2.16a3.21,3.21,0,0,0,.77-1.72v-2s-1.44,2.41-5.87,2.41S102.76,155,102.53,154.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,175.87a10.06,10.06,0,0,0,9.16,0c2.53-1.46,2.53-3.82,0-5.29a10.13,10.13,0,0,0-9.16,0C112.26,172.05,112.26,174.41,114.79,175.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83,162.45A3,3,0,0,0,124,160a9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.48,159.68v15.93a5.85,5.85,0,0,0,.56-.28,4.2,4.2,0,0,0,1-.74v-13.9a4.47,4.47,0,0,0-1-.73A4.18,4.18,0,0,0,123.48,159.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.88,176.13a6.74,6.74,0,0,0,.88-.24V159.4a8.84,8.84,0,0,0-.88-.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,161.8a4.27,4.27,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.29v-.47a2.64,2.64,0,0,0-.29.15,3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.69,4.69,0,0,0,1.09-.85c-1.14,1.06-4,1.64-6.07,1.23s-3.37-1.75-3.37-2.71v-.92a9.11,9.11,0,0,0,4.23.94v-4.65a9.21,9.21,0,0,1-4.23-.87v-1.36a10.23,10.23,0,0,0,8.61-.28,4.31,4.31,0,0,0,1.53-1.41v-2A2.11,2.11,0,0,0,125.72,161.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,173.27V160.49a2.64,2.64,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.71,7.71,0,0,0,2.32.84C115.43,175.54,114.64,174,114.64,173.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2,159.66a3.2,3.2,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.2,3.2,0,0,0-1.9,2.64h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.22,3.22,0,0,0,1.9-2.65h0v-2.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 126.04,
    y: 159.4,
    width: 0.31,
    height: 4.47
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 125.33,
    y: 160.6,
    width: 0.31,
    height: 4.49
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 124.25,
    y: 161.43,
    width: 0.31,
    height: 4.52
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 123.01,
    y: 161.95,
    width: 0.31,
    height: 4.54
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 121.66,
    y: 162.29,
    width: 0.31,
    height: 4.56
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 120.22,
    y: 162.47,
    width: 0.31,
    height: 4.59
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 118.76,
    y: 162.46,
    width: 0.31,
    height: 4.61
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 117.34,
    y: 162.27,
    width: 0.31,
    height: 4.64
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 116.01,
    y: 161.89,
    width: 0.31,
    height: 4.66
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: 161.29,
    width: 0.31,
    height: 4.68
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 113.84,
    y: 160.47,
    width: 0.31,
    height: 4.71
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 113.09,
    y: 159.13,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M121.27,166.16c-3.21,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.7-.29-2.7-.77-.18-1.39-.32a2.42,2.42,0,0,0-.48,1.41h0v2.87h0a3.22,3.22,0,0,0,1.9,2.65A10,10,0,0,0,121.27,166.16Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.14,162.31a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C112.61,158.48,112.61,160.85,115.14,162.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.65,162.08c2.17-1.47,2.06-3.67-.35-5.06a9.22,9.22,0,0,0-4.45-1.1,7.29,7.29,0,0,0-2.37.81,2.72,2.72,0,0,0,0,5A9,9,0,0,0,124.65,162.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.72,
    cy: 173.06,
    rx: 5.61,
    ry: 2.82,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.61,165.14a3,3,0,0,0,1.79,2.49,8.82,8.82,0,0,0,4.32,1v4.58a8.82,8.82,0,0,1-4.32-1,3,3,0,0,1-1.79-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.74,161.1a8.65,8.65,0,0,0,6.18,2c4.07-.11,5.69-2.34,5.91-3a2.56,2.56,0,0,0-.55-2.35,2.69,2.69,0,0,1,.92,1.92v2.87c0,.25.12,1.08-1.19,2.16a3.16,3.16,0,0,0,.77-1.71v-2s-1.44,2.41-5.86,2.41S114,161.46,113.74,161.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,177.25a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29A10.13,10.13,0,0,0,90,172C87.48,173.42,87.48,175.79,90,177.25Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.05,163.82a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7,161.05V177a4.18,4.18,0,0,0,.56-.28,4.47,4.47,0,0,0,1-.73v-13.9a4.2,4.2,0,0,0-1-.74A5.85,5.85,0,0,0,98.7,161.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1,177.51a8.84,8.84,0,0,0,.88-.25V160.77a6.74,6.74,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,163.17a4.27,4.27,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.28v-.48l-.29.15a3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.44,4.44,0,0,0,1.09-.85c-1.14,1.06-4,1.65-6.07,1.23s-3.37-1.75-3.37-2.7v-.93a9.1,9.1,0,0,0,4.22.94v-4.65a9.2,9.2,0,0,1-4.22-.87v-1.36a10.23,10.23,0,0,0,8.61-.28,4.22,4.22,0,0,0,1.53-1.41v-2A2.16,2.16,0,0,0,100.94,163.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.86,174.65V161.86a2.64,2.64,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.71,7.71,0,0,0,2.32.84C90.64,176.92,89.86,175.35,89.86,174.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.42,161a3.21,3.21,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.21,3.21,0,0,0,1.9-2.64h0V161Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 160.77,
    width: 0.31,
    height: 4.47
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 161.97,
    width: 0.31,
    height: 4.49
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 99.47,
    y: 162.8,
    width: 0.31,
    height: 4.52
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 98.23,
    y: 163.32,
    width: 0.31,
    height: 4.54
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 96.88,
    y: 163.66,
    width: 0.31,
    height: 4.56
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 95.44,
    y: 163.84,
    width: 0.31,
    height: 4.59
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 93.98,
    y: 163.83,
    width: 0.31,
    height: 4.61
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 92.56,
    y: 163.64,
    width: 0.31,
    height: 4.64
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 91.23,
    y: 163.26,
    width: 0.31,
    height: 4.66
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 90.02,
    y: 162.66,
    width: 0.31,
    height: 4.68
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 89.06,
    y: 161.84,
    width: 0.31,
    height: 4.71
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 88.31,
    y: 160.5,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.49,167.53c-3.21,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.69-.29-2.7-.77-.18-1.39-.32a2.44,2.44,0,0,0-.48,1.41h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64A9.91,9.91,0,0,0,96.49,167.53Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.36,163.68a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C87.83,159.85,87.83,162.22,90.36,163.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,163.46c2.17-1.47,2.06-3.68-.35-5.07a9.23,9.23,0,0,0-4.46-1.09,7.08,7.08,0,0,0-2.36.8,2.72,2.72,0,0,0,0,5A9,9,0,0,0,99.87,163.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,176.42a9.88,9.88,0,0,0,7.94,0c2.19-1.1,2.19-2.88,0-4a9.88,9.88,0,0,0-7.94,0C88.78,173.54,88.78,175.32,91,176.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.83,166.51a3,3,0,0,0,1.79,2.5,8.82,8.82,0,0,0,4.32,1v4.58a8.93,8.93,0,0,1-4.32-1,3.06,3.06,0,0,1-1.79-2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,162.47a8.64,8.64,0,0,0,6.17,2c4.08-.11,5.7-2.33,5.92-3a2.56,2.56,0,0,0-.55-2.35,2.74,2.74,0,0,1,.92,1.92v2.88c0,.24.12,1.07-1.19,2.16a3.21,3.21,0,0,0,.77-1.72v-2s-1.44,2.41-5.87,2.41S89.18,162.83,89,162.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,183.71a10.06,10.06,0,0,0,9.16,0c2.53-1.46,2.53-3.82,0-5.29a10.13,10.13,0,0,0-9.16,0C98.68,179.89,98.68,182.25,101.21,183.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.25,170.29a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9,167.51v15.94a4.87,4.87,0,0,0,.56-.28,4.2,4.2,0,0,0,1-.74v-13.9a4.47,4.47,0,0,0-1-.73A4.92,4.92,0,0,0,109.9,167.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.3,184a6.33,6.33,0,0,0,.88-.24V167.24a8.13,8.13,0,0,0-.88-.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.14,169.64a4.27,4.27,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.29v-.47a2.64,2.64,0,0,0-.29.15,3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.69,4.69,0,0,0,1.09-.85c-1.14,1.06-4,1.64-6.07,1.23s-3.37-1.75-3.37-2.71v-.92a9.11,9.11,0,0,0,4.23.94V176.2a9.21,9.21,0,0,1-4.23-.86V174a10.23,10.23,0,0,0,8.61-.28,4.31,4.31,0,0,0,1.53-1.41v-2A2.11,2.11,0,0,0,112.14,169.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.06,181.11V168.33a2.64,2.64,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.81,7.81,0,0,0,2.32.84C101.85,183.38,101.06,181.82,101.06,181.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62,167.5a3.2,3.2,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.22,3.22,0,0,0-1.9,2.64h0v2.87h0a3.24,3.24,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.22,3.22,0,0,0,1.9-2.65h0V167.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 112.47,
    y: 167.24,
    width: 0.31,
    height: 4.47
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 111.75,
    y: 168.44,
    width: 0.31,
    height: 4.49
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 110.67,
    y: 169.27,
    width: 0.31,
    height: 4.52
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 109.44,
    y: 169.79,
    width: 0.31,
    height: 4.54
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 108.08,
    y: 170.13,
    width: 0.31,
    height: 4.56
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 106.64,
    y: 170.31,
    width: 0.31,
    height: 4.59
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 105.19,
    y: 170.3,
    width: 0.31,
    height: 4.61
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 103.76,
    y: 170.11,
    width: 0.31,
    height: 4.64
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 102.43,
    y: 169.73,
    width: 0.31,
    height: 4.66
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 101.22,
    y: 169.13,
    width: 0.31,
    height: 4.68
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 100.26,
    y: 168.31,
    width: 0.31,
    height: 4.71
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 99.51,
    y: 166.97,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M107.69,174c-3.2,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.7-.29-2.7-.77-.19-1.39-.32a2.42,2.42,0,0,0-.48,1.41h0v2.87h0a3.24,3.24,0,0,0,1.9,2.65A10,10,0,0,0,107.69,174Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.56,170.15a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C99,166.32,99,168.69,101.56,170.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,169.92c2.17-1.47,2.06-3.67-.35-5.06a9.22,9.22,0,0,0-4.45-1.1,7.38,7.38,0,0,0-2.37.81,2.72,2.72,0,0,0,0,5A9,9,0,0,0,111.07,169.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.17,182.89a10,10,0,0,0,7.94,0c2.19-1.1,2.19-2.89,0-4a10,10,0,0,0-7.94,0C100,180,100,181.79,102.17,182.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,173a3,3,0,0,0,1.79,2.49,8.85,8.85,0,0,0,4.32,1v4.58a8.85,8.85,0,0,1-4.32-1,3,3,0,0,1-1.79-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.16,168.94a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.34,5.91-3a2.52,2.52,0,0,0-.55-2.34,2.69,2.69,0,0,1,.92,1.92v2.87c0,.25.13,1.08-1.19,2.16a3.16,3.16,0,0,0,.77-1.72v-2s-1.44,2.41-5.86,2.41S100.38,169.3,100.16,168.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.43,185.09a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C73.9,181.26,73.9,183.63,76.43,185.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.47,171.66a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0A3,3,0,0,0,77,184.54a9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.12,168.89v15.93a5.85,5.85,0,0,0,.56-.28,4.47,4.47,0,0,0,1-.73v-13.9a4.2,4.2,0,0,0-1-.74A5.85,5.85,0,0,0,85.12,168.89Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,185.34a6.33,6.33,0,0,0,.88-.24V168.61a6.33,6.33,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.36,171a4.27,4.27,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.28V169l-.29.15a3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42A3,3,0,0,0,77,184.54a9.53,9.53,0,0,0,8.64,0,4.44,4.44,0,0,0,1.09-.85c-1.14,1.06-4,1.65-6.07,1.23s-3.37-1.75-3.37-2.71v-.92a9.11,9.11,0,0,0,4.23.94v-4.65a9.21,9.21,0,0,1-4.23-.87v-1.36a10.23,10.23,0,0,0,8.61-.28,4.22,4.22,0,0,0,1.53-1.41v-2A2.16,2.16,0,0,0,87.36,171Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.28,182.49V169.7a2.64,2.64,0,0,0-1,2v10.39A3,3,0,0,0,77,184.54a7.71,7.71,0,0,0,2.32.84C77.07,184.76,76.28,183.19,76.28,182.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.84,168.87a3.21,3.21,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.21,3.21,0,0,0-1.9,2.64h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.21,3.21,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 87.68,
    y: 168.61,
    width: 0.31,
    height: 4.47
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 86.97,
    y: 169.81,
    width: 0.31,
    height: 4.49
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 85.89,
    y: 170.64,
    width: 0.31,
    height: 4.52
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 84.65,
    y: 171.16,
    width: 0.31,
    height: 4.54
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3,
    y: 171.5,
    width: 0.31,
    height: 4.56
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 81.86,
    y: 171.68,
    width: 0.31,
    height: 4.59
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4,
    y: 171.67,
    width: 0.31,
    height: 4.61
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 78.98,
    y: 171.48,
    width: 0.31,
    height: 4.64
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 77.65,
    y: 171.1,
    width: 0.31,
    height: 4.66
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 76.44,
    y: 170.5,
    width: 0.31,
    height: 4.68
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 75.48,
    y: 169.68,
    width: 0.31,
    height: 4.71
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 74.73,
    y: 168.34,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M82.91,175.37c-3.2,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.69-.29-2.7-.77-.18-1.39-.32a2.42,2.42,0,0,0-.48,1.41h0v2.88h0a3.21,3.21,0,0,0,1.9,2.64A9.91,9.91,0,0,0,82.91,175.37Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.78,171.52a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C74.25,167.69,74.25,170.06,76.78,171.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.29,171.3c2.17-1.47,2.06-3.68-.35-5.07a9.22,9.22,0,0,0-4.45-1.09,7.06,7.06,0,0,0-2.37.8,2.72,2.72,0,0,0,0,5A9,9,0,0,0,86.29,171.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.39,184.26a10,10,0,0,0,7.94,0c2.19-1.1,2.19-2.88,0-4a9.88,9.88,0,0,0-7.94,0C75.2,181.38,75.2,183.16,77.39,184.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.25,174.35a3,3,0,0,0,1.79,2.5,8.82,8.82,0,0,0,4.32,1v4.58a8.82,8.82,0,0,1-4.32-1,3,3,0,0,1-1.79-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.38,170.31a8.65,8.65,0,0,0,6.18,2c4.07-.11,5.69-2.33,5.91-3a2.56,2.56,0,0,0-.55-2.35,2.7,2.7,0,0,1,.92,1.92v2.88c0,.24.12,1.07-1.19,2.15a3.16,3.16,0,0,0,.77-1.71v-2s-1.44,2.41-5.86,2.41S75.6,170.67,75.38,170.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.21,
    cy: 188.91,
    rx: 6.48,
    ry: 3.74,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.67,178.13a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0A3,3,0,0,0,88.24,191a9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.32,175.35v15.94c.2-.09.38-.18.56-.28a4.49,4.49,0,0,0,1-.74v-13.9a4.47,4.47,0,0,0-1-.73A4.92,4.92,0,0,0,96.32,175.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,191.81a6.33,6.33,0,0,0,.88-.24v-16.5c-.28-.09-.58-.17-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.57,177.48a4.31,4.31,0,0,0-1.43-1.23,10.23,10.23,0,0,0-8.61-.29v-.47l-.29.15a3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42A3,3,0,0,0,88.24,191a9.53,9.53,0,0,0,8.64,0,4.69,4.69,0,0,0,1.09-.85c-1.14,1.06-4,1.64-6.06,1.23s-3.38-1.75-3.38-2.71v-.92a9.11,9.11,0,0,0,4.23.94V184a9.21,9.21,0,0,1-4.23-.86v-1.36a10.27,10.27,0,0,0,8.61-.28,4.23,4.23,0,0,0,1.53-1.41v-2A2.05,2.05,0,0,0,98.57,177.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.49,189V176.17a2.62,2.62,0,0,0-1,2v10.39A3,3,0,0,0,88.24,191a7.53,7.53,0,0,0,2.32.83C88.27,191.22,87.49,189.66,87.49,189Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,175.34a3.2,3.2,0,0,0-1.9-2.64,10.06,10.06,0,0,0-9.16,0,3.22,3.22,0,0,0-1.9,2.64h0v2.87h0a3.24,3.24,0,0,0,1.9,2.65,10.13,10.13,0,0,0,9.16,0,3.22,3.22,0,0,0,1.9-2.65h0v-2.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 98.89,
    y: 175.08,
    width: 0.31,
    height: 4.47
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 98.17,
    y: 176.28,
    width: 0.31,
    height: 4.49
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 97.09,
    y: 177.11,
    width: 0.31,
    height: 4.52
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 95.86,
    y: 177.63,
    width: 0.31,
    height: 4.54
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 177.97,
    width: 0.31,
    height: 4.56
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 93.06,
    y: 178.15,
    width: 0.31,
    height: 4.59
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 91.61,
    y: 178.14,
    width: 0.31,
    height: 4.61
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 90.18,
    y: 177.95,
    width: 0.31,
    height: 4.64
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 88.85,
    y: 177.57,
    width: 0.31,
    height: 4.66
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 87.64,
    y: 176.97,
    width: 0.31,
    height: 4.68
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 86.68,
    y: 176.15,
    width: 0.31,
    height: 4.71
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 85.93,
    y: 174.81,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94.11,181.84c-3.2,0-4.89-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.7-.29-2.7-.77-.19-1.39-.32a2.42,2.42,0,0,0-.48,1.41h0v2.87h0a3.24,3.24,0,0,0,1.9,2.65A10,10,0,0,0,94.11,181.84Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88,178a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.06,10.06,0,0,0-9.16,0C85.45,174.16,85.45,176.53,88,178Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49,177.76c2.17-1.47,2.06-3.67-.35-5.06a9.22,9.22,0,0,0-4.45-1.1,7.38,7.38,0,0,0-2.37.81,2.73,2.73,0,0,0,0,5A9,9,0,0,0,97.49,177.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6,190.73a9.94,9.94,0,0,0,7.93,0c2.19-1.1,2.19-2.89,0-4a9.94,9.94,0,0,0-7.93,0C86.4,187.84,86.4,189.63,88.6,190.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.45,180.82a3,3,0,0,0,1.79,2.49,8.85,8.85,0,0,0,4.32,1v4.58a8.85,8.85,0,0,1-4.32-1,3,3,0,0,1-1.79-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,176.78a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.34,5.91-3a2.52,2.52,0,0,0-.55-2.34,2.65,2.65,0,0,1,.92,1.92v2.87c0,.25.13,1.08-1.19,2.16a3.16,3.16,0,0,0,.77-1.72v-2s-1.44,2.41-5.86,2.41S86.8,177.14,86.58,176.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.85,192.93a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C60.32,189.1,60.32,191.47,62.85,192.93Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.89,179.5A3,3,0,0,0,72.1,177a9.53,9.53,0,0,0-8.64,0,3,3,0,0,0-1.79,2.49h0v10.39h0a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.54,176.73v15.93a4.87,4.87,0,0,0,.56-.28,4.47,4.47,0,0,0,1-.73v-13.9a4.2,4.2,0,0,0-1-.74A4.87,4.87,0,0,0,71.54,176.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.94,193.18a6.33,6.33,0,0,0,.88-.24V176.45a6.33,6.33,0,0,0-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.78,178.85a4.27,4.27,0,0,0-1.42-1.23,10.23,10.23,0,0,0-8.61-.28v-.48l-.29.15a3,3,0,0,0-1.79,2.49v2.39h0v4.58h0v3.42a3,3,0,0,0,1.79,2.49,9.53,9.53,0,0,0,8.64,0,4.44,4.44,0,0,0,1.09-.85c-1.14,1.06-4,1.64-6.06,1.23s-3.38-1.75-3.38-2.71v-.92a9.11,9.11,0,0,0,4.23.94v-4.65a9.21,9.21,0,0,1-4.23-.87v-1.36a10.23,10.23,0,0,0,8.61-.28,4.14,4.14,0,0,0,1.53-1.41v-2A2.11,2.11,0,0,0,73.78,178.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.71,190.33V177.54a2.62,2.62,0,0,0-1,2v10.39a3,3,0,0,0,1.79,2.49,7.81,7.81,0,0,0,2.32.84C63.49,192.6,62.71,191,62.71,190.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.26,176.71a3.21,3.21,0,0,0-1.9-2.64,10.13,10.13,0,0,0-9.16,0,3.24,3.24,0,0,0-1.9,2.64h0v2.88h0a3.24,3.24,0,0,0,1.9,2.64,10.13,10.13,0,0,0,9.16,0,3.21,3.21,0,0,0,1.9-2.64h0v-2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 74.11,
    y: 176.45,
    width: 0.31,
    height: 4.47
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 73.39,
    y: 177.65,
    width: 0.31,
    height: 4.49
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 72.31,
    y: 178.48,
    width: 0.31,
    height: 4.52
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 71.08,
    y: 179,
    width: 0.31,
    height: 4.54
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 69.72,
    y: 179.34,
    width: 0.31,
    height: 4.56
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 68.28,
    y: 179.52,
    width: 0.31,
    height: 4.59
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 66.83,
    y: 179.51,
    width: 0.31,
    height: 4.61
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4,
    y: 179.32,
    width: 0.31,
    height: 4.64
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 64.07,
    y: 178.94,
    width: 0.31,
    height: 4.66
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 62.86,
    y: 178.34,
    width: 0.31,
    height: 4.68
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 61.9,
    y: 177.52,
    width: 0.31,
    height: 4.71
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 61.15,
    y: 176.18,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M69.33,183.21c-3.2,0-4.9-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.69-.29-2.7-.77-.18-1.39-.32a2.42,2.42,0,0,0-.48,1.41h0v2.88h0a3.24,3.24,0,0,0,1.9,2.64A9.91,9.91,0,0,0,69.33,183.21Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,179.36a10.13,10.13,0,0,0,9.16,0c2.53-1.46,2.53-3.83,0-5.29a10.13,10.13,0,0,0-9.16,0C60.67,175.53,60.67,177.9,63.2,179.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.71,179.14c2.17-1.47,2.06-3.68-.35-5.07A9.22,9.22,0,0,0,67.91,173a7.13,7.13,0,0,0-2.37.8,2.73,2.73,0,0,0,0,5A9,9,0,0,0,72.71,179.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.81,192.1a10,10,0,0,0,7.94,0c2.19-1.1,2.19-2.88,0-4a9.88,9.88,0,0,0-7.94,0C61.62,189.22,61.62,191,63.81,192.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.67,182.19a3,3,0,0,0,1.79,2.5,9,9,0,0,0,4.32,1v4.58a8.85,8.85,0,0,1-4.32-1,3,3,0,0,1-1.79-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8,178.15a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.33,5.91-3a2.53,2.53,0,0,0-.55-2.35,2.67,2.67,0,0,1,.92,1.92v2.88c0,.24.13,1.07-1.19,2.15a3.16,3.16,0,0,0,.77-1.71v-2s-1.44,2.41-5.86,2.41S62,178.51,61.8,178.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,199.39a10.15,10.15,0,0,0,9.17,0c2.53-1.46,2.53-3.83,0-5.29a10.15,10.15,0,0,0-9.17,0C71.52,195.56,71.52,197.93,74.05,199.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.09,186a3,3,0,0,0-1.79-2.49,9.53,9.53,0,0,0-8.64,0A3,3,0,0,0,72.88,186h0v10.39h0a3,3,0,0,0,1.78,2.49,9.53,9.53,0,0,0,8.64,0,3,3,0,0,0,1.79-2.49h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,183.19v15.94a5.84,5.84,0,0,0,.56-.28,4.49,4.49,0,0,0,1-.74v-13.9a4.47,4.47,0,0,0-1-.73A4.21,4.21,0,0,0,82.74,183.19Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.14,199.65a6,6,0,0,0,.88-.24v-16.5c-.28-.09-.57-.17-.88-.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,185.32a4.51,4.51,0,0,0-1.42-1.24A10.29,10.29,0,0,0,75,183.8v-.47l-.29.15A3,3,0,0,0,72.88,186v2.39h0v4.58h0v3.42a3,3,0,0,0,1.78,2.49,9.53,9.53,0,0,0,8.64,0,4.69,4.69,0,0,0,1.09-.85c-1.13,1.06-4,1.64-6.06,1.23S75,197.47,75,196.52v-.92a9.11,9.11,0,0,0,4.23.94v-4.66A9.21,9.21,0,0,1,75,191v-1.36a10.29,10.29,0,0,0,8.62-.28A4.27,4.27,0,0,0,85.09,188v-2A2.05,2.05,0,0,0,85,185.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.91,196.79V184a2.61,2.61,0,0,0-1,2v10.39a3,3,0,0,0,1.78,2.49,7.53,7.53,0,0,0,2.32.83C74.69,199.06,73.91,197.49,73.91,196.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.46,183.18a3.21,3.21,0,0,0-1.89-2.64,10.09,10.09,0,0,0-9.17,0,3.21,3.21,0,0,0-1.89,2.64h0v2.87h0a3.22,3.22,0,0,0,1.89,2.65,10.15,10.15,0,0,0,9.17,0,3.22,3.22,0,0,0,1.89-2.65h0v-2.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-14--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 85.31,
    y: 182.91,
    width: 0.31,
    height: 4.47
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 84.59,
    y: 184.12,
    width: 0.31,
    height: 4.49
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 83.51,
    y: 184.95,
    width: 0.31,
    height: 4.52
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 82.28,
    y: 185.47,
    width: 0.31,
    height: 4.54
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 80.92,
    y: 185.81,
    width: 0.31,
    height: 4.56
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 79.49,
    y: 185.98,
    width: 0.31,
    height: 4.59
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 78.03,
    y: 185.98,
    width: 0.31,
    height: 4.61
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 76.6,
    y: 185.79,
    width: 0.31,
    height: 4.64
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 75.27,
    y: 185.41,
    width: 0.31,
    height: 4.66
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 184.81,
    width: 0.31,
    height: 4.68
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1,
    y: 183.99,
    width: 0.31,
    height: 4.71
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 72.35,
    y: 182.65,
    width: 0.31,
    height: 4.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M80.53,189.68c-3.2,0-4.89-1-5.41-1.87a6.69,6.69,0,0,1-.46-3s-.36-2.7-.29-2.7-.77-.19-1.39-.32a2.41,2.41,0,0,0-.47,1.41h0v2.87h0a3.22,3.22,0,0,0,1.89,2.65A10,10,0,0,0,80.53,189.68Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,185.83a10.15,10.15,0,0,0,9.17,0c2.53-1.47,2.53-3.83,0-5.29a10.09,10.09,0,0,0-9.17,0C71.87,182,71.87,184.36,74.4,185.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.91,185.6c2.17-1.47,2.06-3.68-.34-5.06a9.26,9.26,0,0,0-4.46-1.1,7.38,7.38,0,0,0-2.37.81,2.73,2.73,0,0,0,0,5A9,9,0,0,0,83.91,185.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,198.57a9.94,9.94,0,0,0,7.93,0c2.19-1.1,2.19-2.89,0-4a9.94,9.94,0,0,0-7.93,0C72.82,195.68,72.82,197.47,75,198.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.88,188.66a3,3,0,0,0,1.78,2.49,8.85,8.85,0,0,0,4.32,1v4.58a8.85,8.85,0,0,1-4.32-1,3,3,0,0,1-1.78-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,184.62a8.68,8.68,0,0,0,6.18,2c4.07-.11,5.7-2.34,5.91-3a2.51,2.51,0,0,0-.55-2.34,2.65,2.65,0,0,1,.92,1.92v2.87c0,.24.13,1.08-1.19,2.16a3.16,3.16,0,0,0,.77-1.72v-2s-1.44,2.41-5.86,2.41S73.22,185,73,184.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 112.32 141.38 93.74 39.46 152.58 39.46 158.67 71.64 177.25 173.57 118.41 173.57 112.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 112.32 173.57 118.41 71.64 177.25 71.64 171.16 173.57 112.32",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.64 171.16 39.46 152.58 39.46 158.67 71.64 177.25 71.64 171.16",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,110.08c-2.07-1.18-2.07-3.1,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.19,2.07,3.11,0,4.29A8.39,8.39,0,0,1,146,110.08Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,95.24a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08V91.5H147.9v2.33a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33A2.52,2.52,0,0,0,145,97.32v10a2.5,2.5,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.51,2.51,0,0,0,1.48-2.07v-10A2.52,2.52,0,0,0,153.65,95.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,95.24a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08V91.5H147.9v2.33a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33A2.52,2.52,0,0,0,145,97.32v10a2.5,2.5,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.51,2.51,0,0,0,1.48-2.07v-10A2.52,2.52,0,0,0,153.65,95.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,109.36c-2-1.13-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.14,2,3,0,4.11A8,8,0,0,1,146.47,109.36Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,109.36c-2-1.13-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.14,2,3,0,4.11A8,8,0,0,1,146.47,109.36Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35,100.23V107a2.14,2.14,0,0,1-1.26,1.75,3.89,3.89,0,0,1-.5.25l-.09,0-.11,0a7.49,7.49,0,0,1-2.33.36,7.14,7.14,0,0,1-2.51-.43h0l-.49-.25a2.1,2.1,0,0,1-1.25-1.75v-6.74A2.13,2.13,0,0,1,147,98.48a6.74,6.74,0,0,1,6.06,0A2.14,2.14,0,0,1,154.35,100.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.91,106.18l-.27.68a.61.61,0,0,1-1.15,0l-.27-.68a6.08,6.08,0,0,1-.41-2.19V90.82h2.51V104A6.08,6.08,0,0,1,150.91,106.18Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.81,97.87V104a6.08,6.08,0,0,0,.41,2.19l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.08,6.08,0,0,0,.41-2.19V97.87A7.06,7.06,0,0,0,148.81,97.87Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,107.07l.06.06.09.05,0,0,.11,0s-.22-.07-.28-.61-.21-1.89-.21-2.57V97.79a4.52,4.52,0,0,0-.63.08V104a6.08,6.08,0,0,0,.41,2.19l.27.68a.51.51,0,0,0,.09.16S149.61,107.05,149.63,107.07Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35,107a2.14,2.14,0,0,1-1.26,1.75,3.89,3.89,0,0,1-.5.25l-.09,0-.11,0a7,7,0,0,1-4.84-.07h0l-.49-.25a1.84,1.84,0,0,1,0-3.49,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,154.35,107Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,107.38v-5.53l.24-1.55L146.38,99a1.78,1.78,0,0,0-.6,1.26V107a2.1,2.1,0,0,0,1.25,1.75l.49.25h0a7.14,7.14,0,0,0,2.51.43,7.49,7.49,0,0,0,2.33-.36l.11,0,.09,0,.14-.06C150,109.59,148,108.4,148,107.38Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,108.89l.31-.17a3.29,3.29,0,0,0,.7-.53v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.75,109.22a4.07,4.07,0,0,0,.5-.13v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,98c1.6.48,2.41,1.36,2.41,2.23s-.81,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.24s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,151.94,98Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,98c1.6.48,2.41,1.36,2.41,2.23s-.81,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.24s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,151.94,98Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.32,100.23v2.37a7.55,7.55,0,0,1-2.51,0v-2.3a.68.68,0,0,0,.36.45,2,2,0,0,0,1.78,0A.62.62,0,0,0,151.32,100.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17,100.75a.68.68,0,0,1-.36-.45v2.3c.21,0,.42.06.63.08v-1.82A1.69,1.69,0,0,1,149.17,100.75Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.32,97.87v2.36a.62.62,0,0,1-.37.52,2,2,0,0,1-1.78,0,.68.68,0,0,1-.36-.45V97.87A7.06,7.06,0,0,1,151.32,97.87Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84,104.6a6.18,6.18,0,0,0,.38,1.58l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.18,6.18,0,0,0,.38-1.58A7.74,7.74,0,0,0,148.84,104.6Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,107.31V97.62a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13V91.5H147.9v2.33a1.17,1.17,0,0,1-.74,1.08,5.53,5.53,0,0,0-.69.33A2.52,2.52,0,0,0,145,97.32v10a2.5,2.5,0,0,0,1.49,2.07,7.93,7.93,0,0,0,5.28.69C147.62,110.33,146.62,108.57,146.62,107.31Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,95.24a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08V91.5h-.47v2.77a1.31,1.31,0,0,0,.75,1c.41.22,1.7.78,2,1.4a9,9,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,5.83,5.83,0,0,0,1-.44,2.47,2.47,0,0,0,1.48-2.08v-10A2.52,2.52,0,0,0,153.65,95.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.81,97.87v2.43a.68.68,0,0,0,.36.45,1.69,1.69,0,0,0,.27.11V97.79A4.52,4.52,0,0,0,148.81,97.87Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.41,106.91c0,.1-.15.17-.35.17s-.34-.07-.34-.17.15-.17.34-.17S150.41,106.82,150.41,106.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.18,106.29a4.49,4.49,0,0,0,.11-1.36V90.82h-.23V105A3.73,3.73,0,0,0,150.18,106.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,90.82h-.46V106h0a4.4,4.4,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,90.82v.68a1.34,1.34,0,0,1-.8,1.12,4.26,4.26,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52,1,1,0,0,1-.2-.59v-.69a.62.62,0,0,1,0-.19,1.42,1.42,0,0,1,.78-.93l0,0a4.27,4.27,0,0,1,3.83,0,1.45,1.45,0,0,1,.78.93A.62.62,0,0,1,152.8,90.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29,92.4v-1c0-.4.1-1-.6-1a1.93,1.93,0,0,1-1.52-.7l0,0a1.42,1.42,0,0,0-.78.93.62.62,0,0,0,0,.19v.69a1,1,0,0,0,.2.59,1.74,1.74,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C151.24,92.92,150.29,92.78,150.29,92.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,91.93a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,148.13,91.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,91.93a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,148.13,91.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,88.73v1.71a.62.62,0,0,1,0,.19,1.45,1.45,0,0,1-.78.93,3.81,3.81,0,0,1-1.71.46,4,4,0,0,1-2.16-.46,1.74,1.74,0,0,1-.6-.52.88.88,0,0,1-.18-.41.55.55,0,0,1,0-.18V88.72a1.36,1.36,0,0,1,.8-1.12l.14-.07a4.31,4.31,0,0,1,3.73.07A1.34,1.34,0,0,1,152.8,88.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.06,83.4a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0V84.89A1.5,1.5,0,0,0,150.06,83.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92,83.67h0a1.49,1.49,0,0,0-2.35,1.22v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.88.88,0,0,0,.35-.34,1.32,1.32,0,0,1-1.25.15c-.6-.23-.78-.81-.78-1.61V85C149.44,84,150.25,83.21,150.92,83.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,87.06h0a.39.39,0,0,1-.39-.39V84.55a.39.39,0,0,1,.39-.39h0a.39.39,0,0,1,.39.39v2.12A.39.39,0,0,1,150.86,87.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.86,
    cy: 87.91,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.53,91a1.74,1.74,0,0,0,.6.52,4,4,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.81,2.81,0,0,1-1.89-1,1.38,1.38,0,0,1,.47-1.84l-.14.07a1.36,1.36,0,0,0-.8,1.12v1.73a.55.55,0,0,0,0,.18A.88.88,0,0,0,147.53,91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.09,98.48c-.14-.08-.3-.15-.45-.22,2.36,1.21,1.28,3-.18,3.73a8.74,8.74,0,0,1-5.2.11,6.73,6.73,0,0,0,5.83-.12,2.12,2.12,0,0,0,1.26-1.75A2.14,2.14,0,0,0,153.09,98.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,115.31c-2.07-1.19-2.07-3.11,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.29A8.39,8.39,0,0,1,155,115.31Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.71,100.47a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.09V96.73H157v2.32a1.19,1.19,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,162.71,100.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.71,100.47a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.09V96.73H157v2.32a1.19,1.19,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,162.71,100.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,114.59c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.11A8,8,0,0,1,155.52,114.59Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,114.59c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.11A8,8,0,0,1,155.52,114.59Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,105.46v6.74a2.13,2.13,0,0,1-1.26,1.75c-.15.09-.32.17-.49.25l-.09,0-.12,0a7.2,7.2,0,0,1-2.33.37,7.38,7.38,0,0,1-2.51-.43l0,0a4.44,4.44,0,0,1-.49-.24,2.14,2.14,0,0,1-1.25-1.75v-6.74a2.14,2.14,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.13,2.13,0,0,1,163.4,105.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,111.4l-.27.69a.62.62,0,0,1-1.15,0l-.27-.69a6,6,0,0,1-.41-2.18V96h2.51v13.18A6,6,0,0,1,160,111.4Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.86,103.09v6.13a6,6,0,0,0,.41,2.18l.27.69a.62.62,0,0,0,1.15,0l.27-.69a6,6,0,0,0,.41-2.18v-6.13A7.55,7.55,0,0,0,157.86,103.09Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.68,112.3a.18.18,0,0,0,.07,0l.08.06,0,0,.11,0s-.21-.06-.28-.6-.21-1.9-.21-2.57V103l-.63.08v6.13a6,6,0,0,0,.41,2.18l.27.69a.38.38,0,0,0,.09.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,112.2a2.13,2.13,0,0,1-1.26,1.75c-.15.09-.32.17-.49.25l-.09,0-.12,0a7,7,0,0,1-4.84-.06l0,0a4.44,4.44,0,0,1-.49-.24,1.85,1.85,0,0,1,0-3.5,6.67,6.67,0,0,1,6.06,0A2.13,2.13,0,0,1,163.4,112.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,112.6v-5.53l.24-1.54-1.85-1.33a1.76,1.76,0,0,0-.6,1.26v6.74a2.14,2.14,0,0,0,1.25,1.75,4.44,4.44,0,0,0,.49.24l0,0a7.38,7.38,0,0,0,2.51.43,7.2,7.2,0,0,0,2.33-.37l.12,0,.09,0,.13-.07C159.06,114.82,157,113.63,157,112.6Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,114.11l.31-.16a2.65,2.65,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8,114.45a4.1,4.1,0,0,0,.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,103.23c1.61.47,2.41,1.35,2.41,2.23s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.35-2.41-2.23s.8-1.76,2.41-2.23A6.47,6.47,0,0,1,161,103.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,103.23c1.61.47,2.41,1.35,2.41,2.23s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.35-2.41-2.23s.8-1.76,2.41-2.23A6.47,6.47,0,0,1,161,103.23Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,105.46v2.36a7.3,7.3,0,0,1-2.51,0v-2.3a.68.68,0,0,0,.36.44,2,2,0,0,0,1.79,0A.61.61,0,0,0,160.37,105.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.22,106a.68.68,0,0,1-.36-.44v2.3l.63.08v-1.82A1.59,1.59,0,0,1,158.22,106Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37,103.1v2.36a.61.61,0,0,1-.36.51,2,2,0,0,1-1.79,0,.68.68,0,0,1-.36-.44v-2.44A7.3,7.3,0,0,1,160.37,103.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.89,109.83a6,6,0,0,0,.38,1.57l.27.69a.62.62,0,0,0,1.15,0l.27-.69a5.63,5.63,0,0,0,.38-1.57A7.2,7.2,0,0,0,157.89,109.83Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.67,112.53v-9.68a1.42,1.42,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13V96.73H157v2.32a1.19,1.19,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,5.28.69C156.67,115.55,155.67,113.8,155.67,112.53Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.71,100.47a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.09V96.73h-.47V99.5a1.3,1.3,0,0,0,.76,1c.4.22,1.69.78,2,1.39a9,9,0,0,1,.21,3.12v7a3.2,3.2,0,0,1-2,3,6.07,6.07,0,0,0,1-.43,2.51,2.51,0,0,0,1.49-2.09v-10A2.52,2.52,0,0,0,162.71,100.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.86,103.09v2.44a.68.68,0,0,0,.36.44,1.59,1.59,0,0,0,.27.12V103Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.46,112.14c0,.09-.15.17-.34.17s-.35-.08-.35-.17.15-.17.35-.17S159.46,112,159.46,112.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,111.52a4.14,4.14,0,0,0,.11-1.36V96h-.22V110.2A4,4,0,0,0,159.23,111.52Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.05,96h-.45v15.22h0a4.43,4.43,0,0,0,.45-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.86,96.05v.68a1.37,1.37,0,0,1-.81,1.12,4.26,4.26,0,0,1-3.87,0,1.76,1.76,0,0,1-.6-.53,1,1,0,0,1-.2-.59V96a.55.55,0,0,1,0-.18,1.5,1.5,0,0,1,.78-.94l0,0a4.33,4.33,0,0,1,3.83,0,1.46,1.46,0,0,1,.78.94A.58.58,0,0,1,161.86,96.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.34,97.62v-1c0-.39.1-1-.6-1a1.94,1.94,0,0,1-1.52-.71l0,0a1.5,1.5,0,0,0-.78.94.55.55,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,1.76,1.76,0,0,0,.6.53,4.26,4.26,0,0,0,3.87,0C160.3,98.15,159.34,98,159.34,97.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.18,97.16a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,157.18,97.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.18,97.16a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,157.18,97.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.86,94v1.72a.68.68,0,0,1,0,.19,1.45,1.45,0,0,1-.78.93,3.68,3.68,0,0,1-1.71.45,4,4,0,0,1-2.16-.45,1.85,1.85,0,0,1-.6-.52,1.14,1.14,0,0,1-.18-.41.62.62,0,0,1,0-.19V94a1.34,1.34,0,0,1,.8-1.12l.15-.08a4.29,4.29,0,0,1,3.72.08A1.37,1.37,0,0,1,161.86,94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.12,88.63a1.49,1.49,0,0,0-1.5,1.49V94h0a.75.75,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0V90.12A1.49,1.49,0,0,0,159.12,88.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,88.9h0a1.51,1.51,0,0,0-.86-.27,1.49,1.49,0,0,0-1.5,1.49V94h0a.75.75,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,1,1,0,0,0,.36-.34,1.36,1.36,0,0,1-1.25.15c-.61-.23-.79-.81-.79-1.62V90.26C158.49,89.26,159.3,88.44,160,88.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.91,92.29h0a.4.4,0,0,1-.39-.39V89.77a.39.39,0,0,1,.39-.38h0a.38.38,0,0,1,.39.38V91.9A.39.39,0,0,1,159.91,92.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.3,93.14a.38.38,0,0,1-.39.39.39.39,0,0,1-.39-.39.4.4,0,0,1,.39-.39A.39.39,0,0,1,160.3,93.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58,96.27a1.85,1.85,0,0,0,.6.52,4,4,0,0,0,2.16.45v-.63c0-.39.12-.86-.6-1a2.81,2.81,0,0,1-1.88-1,1.39,1.39,0,0,1,.47-1.85l-.15.08a1.34,1.34,0,0,0-.8,1.12v1.72a.62.62,0,0,0,0,.19A1.14,1.14,0,0,0,156.58,96.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.14,103.71a4.73,4.73,0,0,0-.45-.23c2.36,1.22,1.28,3-.17,3.73a8.71,8.71,0,0,1-5.21.12,6.76,6.76,0,0,0,5.83-.12,1.85,1.85,0,0,0,0-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91,115.31c-2.07-1.19-2.07-3.11,0-4.29a8.37,8.37,0,0,1,7.49,0c2.08,1.18,2.08,3.1,0,4.29A8.37,8.37,0,0,1,136.91,115.31Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,100.47a3.66,3.66,0,0,0-.69-.33,1.19,1.19,0,0,1-.75-1.09V96.73h-4.31v2.32a1.17,1.17,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10a2.54,2.54,0,0,0,1.48,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,144.6,100.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,100.47a3.66,3.66,0,0,0-.69-.33,1.19,1.19,0,0,1-.75-1.09V96.73h-4.31v2.32a1.17,1.17,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10a2.54,2.54,0,0,0,1.48,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,144.6,100.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.42,114.59c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.11A8,8,0,0,1,137.42,114.59Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.42,114.59c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.11A8,8,0,0,1,137.42,114.59Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.29,105.46v6.74A2.14,2.14,0,0,1,144,114c-.16.09-.33.17-.5.25l-.09,0-.11,0a7.25,7.25,0,0,1-2.33.37,7.48,7.48,0,0,1-2.52-.43l0,0A3.71,3.71,0,0,1,138,114a2.13,2.13,0,0,1-1.26-1.75v-6.74a2.13,2.13,0,0,1,1.26-1.75,6.67,6.67,0,0,1,6.06,0A2.14,2.14,0,0,1,145.29,105.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.86,111.4l-.27.69a.63.63,0,0,1-1.16,0l-.26-.69a5.79,5.79,0,0,1-.42-2.18V96h2.52v13.18A6,6,0,0,1,141.86,111.4Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,103.09v6.13a5.79,5.79,0,0,0,.42,2.18l.26.69a.63.63,0,0,0,1.16,0l.27-.69a6,6,0,0,0,.41-2.18v-6.13A7.61,7.61,0,0,0,139.75,103.09Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.58,112.3l.06,0,.08.06.05,0,.11,0s-.22-.06-.28-.6-.21-1.9-.21-2.57V103l-.64.08v6.13a5.79,5.79,0,0,0,.42,2.18l.26.69a1,1,0,0,0,.09.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.29,112.2A2.14,2.14,0,0,1,144,114c-.16.09-.33.17-.5.25l-.09,0-.11,0a7,7,0,0,1-4.85-.06l0,0A3.71,3.71,0,0,1,138,114a1.85,1.85,0,0,1,0-3.5,6.67,6.67,0,0,1,6.06,0A2.14,2.14,0,0,1,145.29,112.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.94,112.6v-5.53l.23-1.54-1.84-1.33a1.77,1.77,0,0,0-.61,1.26v6.74A2.13,2.13,0,0,0,138,114a3.71,3.71,0,0,0,.49.24l0,0a7.48,7.48,0,0,0,2.52.43,7.25,7.25,0,0,0,2.33-.37l.11,0,.09,0,.14-.07C141,114.82,138.94,113.63,138.94,112.6Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.73,114.11,144,114a3,3,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.7,114.45a4.1,4.1,0,0,0,.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,103.23c1.61.47,2.41,1.35,2.41,2.23s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.6-.48-2.41-1.35-2.41-2.23s.81-1.76,2.41-2.23A6.47,6.47,0,0,1,142.88,103.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,103.23c1.61.47,2.41,1.35,2.41,2.23s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.6-.48-2.41-1.35-2.41-2.23s.81-1.76,2.41-2.23A6.47,6.47,0,0,1,142.88,103.23Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,105.46v2.36a7.35,7.35,0,0,1-2.52,0v-2.3a.67.67,0,0,0,.37.44,1.93,1.93,0,0,0,1.78,0A.61.61,0,0,0,142.27,105.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,106a.67.67,0,0,1-.37-.44v2.3l.64.08v-1.82A1.11,1.11,0,0,1,140.12,106Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,103.1v2.36a.61.61,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.67.67,0,0,1-.37-.44v-2.44A7.35,7.35,0,0,1,142.27,103.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.79,109.83a5.63,5.63,0,0,0,.38,1.57l.26.69a.63.63,0,0,0,1.16,0l.27-.69a6.43,6.43,0,0,0,.38-1.57A7.2,7.2,0,0,0,139.79,109.83Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56,112.53v-9.68a1.43,1.43,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13V96.73h-1.27v2.32a1.17,1.17,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10a2.54,2.54,0,0,0,1.48,2.08,8,8,0,0,0,5.28.69C138.56,115.55,137.56,113.8,137.56,112.53Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,100.47a3.66,3.66,0,0,0-.69-.33,1.19,1.19,0,0,1-.75-1.09V96.73h-.47V99.5a1.32,1.32,0,0,0,.76,1c.41.22,1.7.78,2,1.39a9.09,9.09,0,0,1,.2,3.12v7a3.18,3.18,0,0,1-2,3,5.7,5.7,0,0,0,1-.43,2.49,2.49,0,0,0,1.49-2.09v-10A2.5,2.5,0,0,0,144.6,100.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,103.09v2.44a.67.67,0,0,0,.37.44,1.11,1.11,0,0,0,.27.12V103Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36,112.14c0,.09-.16.17-.35.17s-.35-.08-.35-.17.16-.17.35-.17S141.36,112,141.36,112.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.13,111.52a4.49,4.49,0,0,0,.11-1.36V96H141V110.2A3.81,3.81,0,0,0,141.13,111.52Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,96h-.46v15.22h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,96.05v.68a1.38,1.38,0,0,1-.8,1.12,4.28,4.28,0,0,1-3.88,0,2,2,0,0,1-.6-.53,1,1,0,0,1-.2-.59V96a.57.57,0,0,1,0-.18,1.45,1.45,0,0,1,.77-.94.05.05,0,0,0,0,0,4.35,4.35,0,0,1,3.84,0,1.5,1.5,0,0,1,.78.94A1.11,1.11,0,0,1,143.75,96.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,97.62v-1c0-.39.1-1-.6-1a1.94,1.94,0,0,1-1.53-.71.05.05,0,0,1,0,0,1.45,1.45,0,0,0-.77.94.57.57,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,2,2,0,0,0,.6.53,4.28,4.28,0,0,0,3.88,0C142.19,98.15,141.24,98,141.24,97.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.08,97.16a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,139.08,97.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.08,97.16a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,139.08,97.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,94v1.72a1.37,1.37,0,0,1,0,.19,1.48,1.48,0,0,1-.78.93,3.68,3.68,0,0,1-1.71.45,4.08,4.08,0,0,1-2.17-.45,2.08,2.08,0,0,1-.6-.52,1,1,0,0,1-.17-.41.63.63,0,0,1,0-.19V94a1.37,1.37,0,0,1,.8-1.12l.15-.08a4.31,4.31,0,0,1,3.73.08A1.38,1.38,0,0,1,143.75,94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,88.63a1.49,1.49,0,0,0-1.49,1.49V94h0a.73.73,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,.74.74,0,0,0,.43-.61h0V90.12A1.48,1.48,0,0,0,141,88.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,88.9h0a1.49,1.49,0,0,0-2.35,1.22V94h0a.73.73,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,1,1,0,0,0,.35-.34,1.35,1.35,0,0,1-1.25.15c-.61-.23-.78-.81-.78-1.62V90.26C140.39,89.26,141.19,88.44,141.87,88.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,92.29h0a.39.39,0,0,1-.39-.39V89.77a.38.38,0,0,1,.39-.38h0a.39.39,0,0,1,.39.38V91.9A.4.4,0,0,1,141.81,92.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,93.14a.39.39,0,0,1-.39.39.38.38,0,0,1-.39-.39.39.39,0,0,1,.39-.39A.4.4,0,0,1,142.2,93.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.47,96.27a2.08,2.08,0,0,0,.6.52,4.08,4.08,0,0,0,2.17.45v-.63c0-.39.11-.86-.6-1a2.81,2.81,0,0,1-1.89-1,1.39,1.39,0,0,1,.47-1.85l-.15.08a1.37,1.37,0,0,0-.8,1.12v1.72a.63.63,0,0,0,0,.19A1,1,0,0,0,138.47,96.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,103.71c-.15-.08-.3-.16-.46-.23,2.37,1.22,1.29,3-.17,3.73a8.67,8.67,0,0,1-5.2.12,6.77,6.77,0,0,0,5.83-.12,1.85,1.85,0,0,0,0-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,120.53c-2.07-1.18-2.07-3.1,0-4.28a8.32,8.32,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.28A8.32,8.32,0,0,1,146,120.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,105.69a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08V102H147.9v2.32a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33,2.53,2.53,0,0,0-1.49,2.08v10a2.5,2.5,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.51,2.51,0,0,0,1.48-2.07v-10A2.53,2.53,0,0,0,153.65,105.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,105.69a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08V102H147.9v2.32a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33,2.53,2.53,0,0,0-1.49,2.08v10a2.5,2.5,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.51,2.51,0,0,0,1.48-2.07v-10A2.53,2.53,0,0,0,153.65,105.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,119.81c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.1A8,8,0,0,1,146.47,119.81Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,119.81c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.1A8,8,0,0,1,146.47,119.81Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35,110.69v6.74a2.16,2.16,0,0,1-1.26,1.75,3.85,3.85,0,0,1-.5.24l-.09,0-.11,0a7.45,7.45,0,0,1-4.84-.07h0a4.44,4.44,0,0,1-.49-.24,2.13,2.13,0,0,1-1.25-1.75v-6.74a2.1,2.1,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,154.35,110.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.91,116.63l-.27.68a.61.61,0,0,1-1.15,0l-.27-.68a6,6,0,0,1-.41-2.18V101.27h2.51v13.18A6,6,0,0,1,150.91,116.63Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.81,108.32v6.13a6,6,0,0,0,.41,2.18l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6,6,0,0,0,.41-2.18v-6.13A7.55,7.55,0,0,0,148.81,108.32Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,117.52l.06.06.09,0,0,0,.11,0s-.22-.07-.28-.61-.21-1.89-.21-2.56v-6.28c-.21,0-.42,0-.63.08v6.13a6,6,0,0,0,.41,2.18l.27.68a.51.51,0,0,0,.09.16A.12.12,0,0,0,149.63,117.52Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35,117.43a2.16,2.16,0,0,1-1.26,1.75,3.85,3.85,0,0,1-.5.24l-.09,0-.11,0a7,7,0,0,1-4.84-.07h0a4.44,4.44,0,0,1-.49-.24,2.13,2.13,0,0,1-1.25-1.75,2.1,2.1,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,154.35,117.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,117.83V112.3l.24-1.54-1.85-1.34a1.78,1.78,0,0,0-.6,1.27v6.74a2.13,2.13,0,0,0,1.25,1.75,4.44,4.44,0,0,0,.49.24h0a7.45,7.45,0,0,0,4.84.07l.11,0,.09,0,.14-.06C150,120.05,148,118.86,148,117.83Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,119.34l.31-.16a3.68,3.68,0,0,0,.7-.54V110h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.75,119.68l.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,108.45c1.6.48,2.41,1.36,2.41,2.24s-.81,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.23s.8-1.76,2.41-2.24A6.65,6.65,0,0,1,151.94,108.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,108.45c1.6.48,2.41,1.36,2.41,2.24s-.81,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.23s.8-1.76,2.41-2.24A6.65,6.65,0,0,1,151.94,108.45Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.32,110.69v2.36a7.06,7.06,0,0,1-2.51,0v-2.29a.65.65,0,0,0,.36.44,2,2,0,0,0,1.78,0A.62.62,0,0,0,151.32,110.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17,111.2a.65.65,0,0,1-.36-.44v2.29a4.52,4.52,0,0,0,.63.08v-1.82A1.09,1.09,0,0,1,149.17,111.2Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.32,108.32v2.37a.62.62,0,0,1-.37.51,2,2,0,0,1-1.78,0,.65.65,0,0,1-.36-.44v-2.44A7.55,7.55,0,0,1,151.32,108.32Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84,115.05a6.18,6.18,0,0,0,.38,1.58l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6,6,0,0,0,.38-1.57A7.46,7.46,0,0,0,148.84,115.05Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,117.76v-9.69a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13V102H147.9v2.32a1.17,1.17,0,0,1-.74,1.08,5.53,5.53,0,0,0-.69.33,2.53,2.53,0,0,0-1.49,2.08v10a2.5,2.5,0,0,0,1.49,2.07,7.87,7.87,0,0,0,5.28.69C147.62,120.78,146.62,119,146.62,117.76Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,105.69a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08V102h-.47v2.77a1.29,1.29,0,0,0,.75,1c.41.23,1.7.79,2,1.4a9,9,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,5.83,5.83,0,0,0,1-.44,2.47,2.47,0,0,0,1.48-2.08v-10A2.53,2.53,0,0,0,153.65,105.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.81,108.32v2.44a.65.65,0,0,0,.36.44,1.09,1.09,0,0,0,.27.11v-3.07C149.23,108.26,149,108.28,148.81,108.32Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.41,117.37c0,.09-.15.17-.35.17s-.34-.08-.34-.17.15-.18.34-.18S150.41,117.27,150.41,117.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.18,116.75a4.58,4.58,0,0,0,.11-1.37V101.27h-.23v14.16A3.86,3.86,0,0,0,150.18,116.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,101.27h-.46v15.22h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,101.27V102a1.33,1.33,0,0,1-.8,1.12,4.26,4.26,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52,1,1,0,0,1-.2-.59v-.69a.55.55,0,0,1,0-.18,1.41,1.41,0,0,1,.78-.94l0,0a4.27,4.27,0,0,1,3.83,0,1.45,1.45,0,0,1,.78.93A.65.65,0,0,1,152.8,101.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29,102.85v-1c0-.4.1-1-.6-1a1.94,1.94,0,0,1-1.52-.71l0,0a1.41,1.41,0,0,0-.78.94.55.55,0,0,0,0,.18V102a1,1,0,0,0,.2.59,1.74,1.74,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C151.24,103.37,150.29,103.23,150.29,102.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,102.39a1.18,1.18,0,0,1,0-2.24,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.32,4.32,0,0,1,148.13,102.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,102.39a1.18,1.18,0,0,1,0-2.24,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.32,4.32,0,0,1,148.13,102.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,99.18v1.71a.58.58,0,0,1,0,.19,1.46,1.46,0,0,1-.78.94,4.3,4.3,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52.89.89,0,0,1-.18-.4.62.62,0,0,1,0-.19V99.17a1.33,1.33,0,0,1,.8-1.11l.14-.08a4.31,4.31,0,0,1,3.73.08A1.33,1.33,0,0,1,152.8,99.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.06,93.85a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0V95.34A1.5,1.5,0,0,0,150.06,93.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.92,94.13h0a1.43,1.43,0,0,0-.86-.28,1.49,1.49,0,0,0-1.49,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.86.86,0,0,0,.35-.33,1.38,1.38,0,0,1-1.25.15c-.6-.23-.78-.82-.78-1.62v-2.5C149.44,94.49,150.25,93.66,150.92,94.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,97.51h0a.39.39,0,0,1-.39-.38V95a.4.4,0,0,1,.39-.39h0a.4.4,0,0,1,.39.39v2.13A.39.39,0,0,1,150.86,97.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.86,
    cy: 98.37,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.53,101.49a1.74,1.74,0,0,0,.6.52,3.94,3.94,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.86,2.86,0,0,1-1.89-1,1.38,1.38,0,0,1,.47-1.84l-.14.08a1.33,1.33,0,0,0-.8,1.11v1.73a.62.62,0,0,0,0,.19A.89.89,0,0,0,147.53,101.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.09,108.94a3.81,3.81,0,0,0-.45-.23c2.36,1.21,1.28,3.05-.18,3.73a8.67,8.67,0,0,1-5.2.11,6.7,6.7,0,0,0,5.83-.12,1.84,1.84,0,0,0,0-3.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.85,120.53c-2.07-1.18-2.07-3.1,0-4.28a8.32,8.32,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.28A8.32,8.32,0,0,1,127.85,120.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,105.69a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08V102H129.8v2.32a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07v-10A2.55,2.55,0,0,0,135.55,105.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,105.69a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08V102H129.8v2.32a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07v-10A2.55,2.55,0,0,0,135.55,105.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,119.81c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.1A8,8,0,0,1,128.37,119.81Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,119.81c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.1A8,8,0,0,1,128.37,119.81Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.24,110.69v6.74a2.14,2.14,0,0,1-1.26,1.75,3.71,3.71,0,0,1-.49.24l-.09,0-.11,0a7.29,7.29,0,0,1-2.33.37,7.16,7.16,0,0,1-2.52-.44h0a3.58,3.58,0,0,1-.48-.24,2.14,2.14,0,0,1-1.26-1.75v-6.74a2.12,2.12,0,0,1,1.26-1.75,6.65,6.65,0,0,1,6,0A2.12,2.12,0,0,1,136.24,110.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,116.63l-.26.68a.62.62,0,0,1-1.16,0l-.27-.68a6,6,0,0,1-.41-2.18V101.27h2.52v13.18A5.83,5.83,0,0,1,132.8,116.63Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7,108.32v6.13a6,6,0,0,0,.41,2.18l.27.68a.62.62,0,0,0,1.16,0l.26-.68a5.83,5.83,0,0,0,.42-2.18v-6.13A7.61,7.61,0,0,0,130.7,108.32Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.52,117.52l.07.06.08,0,0,0,.12,0s-.22-.07-.28-.61-.22-1.89-.22-2.56v-6.28c-.21,0-.42,0-.63.08v6.13a6,6,0,0,0,.41,2.18l.27.68a.83.83,0,0,0,.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.24,117.43a2.14,2.14,0,0,1-1.26,1.75,3.71,3.71,0,0,1-.49.24l-.09,0-.11,0a7,7,0,0,1-4.85-.07h0a3.58,3.58,0,0,1-.48-.24,2.14,2.14,0,0,1-1.26-1.75,2.12,2.12,0,0,1,1.26-1.75,6.65,6.65,0,0,1,6,0A2.12,2.12,0,0,1,136.24,117.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.88,117.83V112.3l.24-1.54-1.84-1.34a1.8,1.8,0,0,0-.61,1.27v6.74a2.14,2.14,0,0,0,1.26,1.75,3.58,3.58,0,0,0,.48.24h0a7.16,7.16,0,0,0,2.52.44,7.29,7.29,0,0,0,2.33-.37l.11,0,.09,0,.14-.06C131.9,120.05,129.88,118.86,129.88,117.83Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.67,119.34l.31-.16a3.47,3.47,0,0,0,.71-.54V110h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64,119.68l.51-.14v-9h-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.83,108.45c1.61.48,2.41,1.36,2.41,2.24s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.23s.8-1.76,2.41-2.24A6.65,6.65,0,0,1,133.83,108.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.83,108.45c1.61.48,2.41,1.36,2.41,2.24s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.23s.8-1.76,2.41-2.24A6.65,6.65,0,0,1,133.83,108.45Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.22,110.69v2.36a7.11,7.11,0,0,1-2.52,0v-2.29a.67.67,0,0,0,.37.44,2,2,0,0,0,1.78,0A.64.64,0,0,0,133.22,110.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.07,111.2a.67.67,0,0,1-.37-.44v2.29a4.52,4.52,0,0,0,.63.08v-1.82A1.19,1.19,0,0,1,131.07,111.2Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.22,108.32v2.37a.64.64,0,0,1-.37.51,2,2,0,0,1-1.78,0,.67.67,0,0,1-.37-.44v-2.44A7.61,7.61,0,0,1,133.22,108.32Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74,115.05a6.16,6.16,0,0,0,.37,1.58l.27.68a.62.62,0,0,0,1.16,0l.26-.68a5.63,5.63,0,0,0,.38-1.57A7.4,7.4,0,0,0,130.74,115.05Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,117.76v-9.69a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13V102H129.8v2.32a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.87,7.87,0,0,0,5.28.69C129.51,120.78,128.51,119,128.51,117.76Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,105.69a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08V102h-.47v2.77a1.28,1.28,0,0,0,.76,1c.4.23,1.69.79,2,1.4a9.3,9.3,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,6.1,6.1,0,0,0,1-.44,2.49,2.49,0,0,0,1.49-2.08v-10A2.55,2.55,0,0,0,135.55,105.69Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7,108.32v2.44a.67.67,0,0,0,.37.44,1.19,1.19,0,0,0,.26.11v-3.07C131.12,108.26,130.91,108.28,130.7,108.32Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.31,117.37c0,.09-.16.17-.35.17s-.35-.08-.35-.17.16-.18.35-.18S132.31,117.27,132.31,117.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.08,116.75a4.58,4.58,0,0,0,.11-1.37V101.27H132v14.16A3.59,3.59,0,0,0,132.08,116.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.89,101.27h-.45v15.22h0a4.43,4.43,0,0,0,.45-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,101.27V102a1.36,1.36,0,0,1-.81,1.12,4.26,4.26,0,0,1-3.87,0,1.83,1.83,0,0,1-.6-.52,1,1,0,0,1-.2-.59v-.69a1.1,1.1,0,0,1,0-.18,1.47,1.47,0,0,1,.78-.94l0,0a4.27,4.27,0,0,1,3.83,0,1.47,1.47,0,0,1,.79.93A1.37,1.37,0,0,1,134.7,101.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.18,102.85v-1c0-.4.1-1-.6-1a2,2,0,0,1-1.52-.71l0,0a1.47,1.47,0,0,0-.78.94,1.1,1.1,0,0,0,0,.18V102a1,1,0,0,0,.2.59,1.83,1.83,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C133.14,103.37,132.18,103.23,132.18,102.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.96,
    cy: 101.27,
    rx: 2.74,
    ry: 1.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.96,
    cy: 101.27,
    rx: 2.74,
    ry: 1.58,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,99.18v1.71a1.11,1.11,0,0,1,0,.19,1.48,1.48,0,0,1-.79.94,3.9,3.9,0,0,1-1.71.45A4,4,0,0,1,130,102a1.94,1.94,0,0,1-.6-.52,1.18,1.18,0,0,1-.18-.4,1.23,1.23,0,0,1,0-.19V99.17a1.35,1.35,0,0,1,.8-1.11l.15-.08a4.29,4.29,0,0,1,3.72.08A1.36,1.36,0,0,1,134.7,99.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,93.85a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.74.74,0,0,0,.43.61,2.31,2.31,0,0,0,2.11,0,.73.73,0,0,0,.44-.61h0V95.34A1.49,1.49,0,0,0,132,93.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82,94.13h0a1.45,1.45,0,0,0-.86-.28,1.49,1.49,0,0,0-1.49,1.49v3.83h0a.74.74,0,0,0,.43.61,2.31,2.31,0,0,0,2.11,0,.9.9,0,0,0,.36-.33,1.38,1.38,0,0,1-1.25.15c-.61-.23-.78-.82-.78-1.62v-2.5C131.34,94.49,132.14,93.66,132.82,94.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.75,97.51h0a.38.38,0,0,1-.38-.38V95a.39.39,0,0,1,.38-.39h0a.39.39,0,0,1,.39.39v2.13A.38.38,0,0,1,132.75,97.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.75,
    cy: 98.37,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,101.49a1.94,1.94,0,0,0,.6.52,4,4,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.86,2.86,0,0,1-1.88-1,1.37,1.37,0,0,1,.47-1.84l-.15.08a1.35,1.35,0,0,0-.8,1.11v1.73a1.23,1.23,0,0,0,0,.19A1.18,1.18,0,0,0,129.42,101.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,108.94a4,4,0,0,0-.46-.23c2.37,1.21,1.28,3.05-.17,3.73a8.67,8.67,0,0,1-5.2.11,6.7,6.7,0,0,0,5.83-.12,1.84,1.84,0,0,0,0-3.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.91,125.76c-2.07-1.19-2.07-3.1,0-4.29a8.37,8.37,0,0,1,7.49,0c2.08,1.19,2.08,3.1,0,4.29A8.37,8.37,0,0,1,136.91,125.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,110.92a5.53,5.53,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.08v-2.33h-4.31v2.33a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.08v10a2.51,2.51,0,0,0,1.48,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07V113A2.52,2.52,0,0,0,144.6,110.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,110.92a5.53,5.53,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.08v-2.33h-4.31v2.33a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.08v10a2.51,2.51,0,0,0,1.48,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07V113A2.52,2.52,0,0,0,144.6,110.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.42,125c-2-1.13-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.14,2,3,0,4.11A8,8,0,0,1,137.42,125Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.42,125c-2-1.13-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.14,2,3,0,4.11A8,8,0,0,1,137.42,125Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.29,115.91v6.74A2.12,2.12,0,0,1,144,124.4a4.66,4.66,0,0,1-.5.25l-.09,0-.11,0a7.54,7.54,0,0,1-2.33.36,7.24,7.24,0,0,1-2.52-.43h0c-.17-.08-.34-.16-.49-.25a2.12,2.12,0,0,1-1.26-1.75v-6.74a2.14,2.14,0,0,1,1.26-1.75,6.74,6.74,0,0,1,6.06,0A2.15,2.15,0,0,1,145.29,115.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.86,121.86l-.27.68a.62.62,0,0,1-1.16,0l-.26-.68a5.88,5.88,0,0,1-.42-2.19V106.5h2.52v13.17A6.08,6.08,0,0,1,141.86,121.86Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,113.55v6.12a5.88,5.88,0,0,0,.42,2.19l.26.68a.62.62,0,0,0,1.16,0l.27-.68a6.08,6.08,0,0,0,.41-2.19v-6.12A7.11,7.11,0,0,0,139.75,113.55Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.58,122.75l.06.06.08,0,.05,0,.11,0s-.22-.07-.28-.61-.21-1.89-.21-2.57v-6.28c-.22,0-.43.05-.64.09v6.12a5.88,5.88,0,0,0,.42,2.19l.26.68.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.29,122.65A2.12,2.12,0,0,1,144,124.4a4.66,4.66,0,0,1-.5.25l-.09,0-.11,0a7,7,0,0,1-4.85-.07h0c-.17-.08-.34-.16-.49-.25a2.12,2.12,0,0,1-1.26-1.75A2.14,2.14,0,0,1,138,120.9a6.74,6.74,0,0,1,6.06,0A2.15,2.15,0,0,1,145.29,122.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.94,123.05v-5.52l.23-1.55-1.84-1.33a1.79,1.79,0,0,0-.61,1.26v6.74A2.12,2.12,0,0,0,138,124.4c.15.09.32.17.49.25h0a7.24,7.24,0,0,0,2.52.43,7.54,7.54,0,0,0,2.33-.36l.11,0,.09,0,.14-.06C141,125.27,138.94,124.08,138.94,123.05Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.73,124.56l.31-.16a3.29,3.29,0,0,0,.7-.53v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.7,124.9l.5-.13v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,113.68c1.61.48,2.41,1.35,2.41,2.23s-.8,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.6-.47-2.41-1.35-2.41-2.23s.81-1.75,2.41-2.23A6.65,6.65,0,0,1,142.88,113.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,113.68c1.61.48,2.41,1.35,2.41,2.23s-.8,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.6-.47-2.41-1.35-2.41-2.23s.81-1.75,2.41-2.23A6.65,6.65,0,0,1,142.88,113.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,115.91v2.37a7.61,7.61,0,0,1-2.52,0V116a.7.7,0,0,0,.37.45,2,2,0,0,0,1.78,0A.63.63,0,0,0,142.27,115.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,116.43a.7.7,0,0,1-.37-.45v2.3l.64.08v-1.82A1.69,1.69,0,0,1,140.12,116.43Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,113.55v2.36a.63.63,0,0,1-.37.52,2,2,0,0,1-1.78,0,.7.7,0,0,1-.37-.45v-2.43A7.11,7.11,0,0,1,142.27,113.55Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.79,120.28a5.79,5.79,0,0,0,.38,1.58l.26.68a.62.62,0,0,0,1.16,0l.27-.68a6.62,6.62,0,0,0,.38-1.58A7.46,7.46,0,0,0,139.79,120.28Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.56,123V113.3a1.42,1.42,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13v-2.52h-1.27v2.33a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.08v10a2.51,2.51,0,0,0,1.48,2.07,8,8,0,0,0,5.28.69C138.56,126,137.56,124.25,137.56,123Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,110.92a5.53,5.53,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.08v-2.33h-.47V110a1.32,1.32,0,0,0,.76,1c.41.22,1.7.78,2,1.4a9,9,0,0,1,.2,3.11v7a3.19,3.19,0,0,1-2,3,6.63,6.63,0,0,0,1-.44,2.47,2.47,0,0,0,1.49-2.08V113A2.5,2.5,0,0,0,144.6,110.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,113.55V116a.7.7,0,0,0,.37.45,1.69,1.69,0,0,0,.27.11v-3.07A4.48,4.48,0,0,0,139.75,113.55Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36,122.59c0,.1-.16.17-.35.17s-.35-.07-.35-.17.16-.17.35-.17S141.36,122.5,141.36,122.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.13,122a4.49,4.49,0,0,0,.11-1.36V106.5H141v14.16A3.73,3.73,0,0,0,141.13,122Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,106.5h-.46v15.21h0a4.43,4.43,0,0,0,.46-1.95Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,106.5v.68a1.38,1.38,0,0,1-.8,1.12,4.28,4.28,0,0,1-3.88,0,1.94,1.94,0,0,1-.6-.52,1.05,1.05,0,0,1-.2-.6v-.68a.63.63,0,0,1,0-.19,1.43,1.43,0,0,1,.77-.93l0,0a4.29,4.29,0,0,1,3.84,0,1.48,1.48,0,0,1,.78.93A1.23,1.23,0,0,1,143.75,106.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,108.08v-1c0-.4.1-1-.6-1a2,2,0,0,1-1.53-.7l0,0a1.43,1.43,0,0,0-.77.93.63.63,0,0,0,0,.19v.68a1.05,1.05,0,0,0,.2.6,1.94,1.94,0,0,0,.6.52,4.28,4.28,0,0,0,3.88,0C142.19,108.6,141.24,108.46,141.24,108.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.08,107.61a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,139.08,107.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.08,107.61a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,139.08,107.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,104.41v1.71a1.23,1.23,0,0,1,0,.19,1.48,1.48,0,0,1-.78.93,3.81,3.81,0,0,1-1.71.46,4.18,4.18,0,0,1-2.17-.46,1.94,1.94,0,0,1-.6-.52,1,1,0,0,1-.17-.41.57.57,0,0,1,0-.18V104.4a1.37,1.37,0,0,1,.8-1.12l.15-.08a4.35,4.35,0,0,1,3.73.08A1.38,1.38,0,0,1,143.75,104.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,99.08a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.73.73,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.74.74,0,0,0,.43-.61h0v-3.83A1.49,1.49,0,0,0,141,99.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,99.35h0a1.49,1.49,0,0,0-2.35,1.22v3.83h0a.73.73,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,1,1,0,0,0,.35-.34,1.32,1.32,0,0,1-1.25.15c-.61-.23-.78-.81-.78-1.61v-2.5C140.39,99.72,141.19,98.89,141.87,99.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,102.74h0a.38.38,0,0,1-.39-.39v-2.12a.38.38,0,0,1,.39-.39h0a.39.39,0,0,1,.39.39v2.12A.39.39,0,0,1,141.81,102.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,103.59a.39.39,0,0,1-.39.39.39.39,0,1,1,0-.77A.39.39,0,0,1,142.2,103.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.47,106.72a1.94,1.94,0,0,0,.6.52,4.18,4.18,0,0,0,2.17.46v-.63c0-.4.11-.87-.6-1a2.81,2.81,0,0,1-1.89-1,1.39,1.39,0,0,1,.47-1.85l-.15.08a1.37,1.37,0,0,0-.8,1.12v1.73a.57.57,0,0,0,0,.18A1,1,0,0,0,138.47,106.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,114.16l-.46-.22c2.37,1.21,1.29,3-.17,3.73a8.74,8.74,0,0,1-5.2.11,6.73,6.73,0,0,0,5.83-.12,2.1,2.1,0,0,0,1.25-1.75A2.13,2.13,0,0,0,144,114.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,125.76c-2.07-1.19-2.07-3.1,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.19,2.07,3.1,0,4.29A8.39,8.39,0,0,1,118.8,125.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,110.92a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33h-4.31v2.33a1.18,1.18,0,0,1-.75,1.08,6.3,6.3,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0A2.52,2.52,0,0,0,128,123V113A2.52,2.52,0,0,0,126.5,110.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,110.92a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33h-4.31v2.33a1.18,1.18,0,0,1-.75,1.08,6.3,6.3,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0A2.52,2.52,0,0,0,128,123V113A2.52,2.52,0,0,0,126.5,110.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,125c-2-1.13-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.14,2,3,0,4.11A8,8,0,0,1,119.31,125Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,125c-2-1.13-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.14,2,3,0,4.11A8,8,0,0,1,119.31,125Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,115.91v6.74a2.12,2.12,0,0,1-1.26,1.75,3.75,3.75,0,0,1-.49.25l-.1,0-.11,0a7.49,7.49,0,0,1-2.33.36,7.14,7.14,0,0,1-2.51-.43h0l-.49-.25a2.12,2.12,0,0,1-1.25-1.75v-6.74a2.15,2.15,0,0,1,1.25-1.75,6.74,6.74,0,0,1,6.06,0A2.14,2.14,0,0,1,127.19,115.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,121.86l-.27.68a.61.61,0,0,1-1.15,0l-.27-.68a6.08,6.08,0,0,1-.41-2.19V106.5h2.51v13.17A6.08,6.08,0,0,1,123.75,121.86Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65,113.55v6.12a6.08,6.08,0,0,0,.41,2.19l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.08,6.08,0,0,0,.41-2.19v-6.12A7.06,7.06,0,0,0,121.65,113.55Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.47,122.75l.07.06.08,0,0,0,.11,0s-.21-.07-.28-.61-.21-1.89-.21-2.57v-6.28l-.63.09v6.12a6.08,6.08,0,0,0,.41,2.19l.27.68a.51.51,0,0,0,.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,122.65a2.12,2.12,0,0,1-1.26,1.75,3.75,3.75,0,0,1-.49.25l-.1,0-.11,0a7,7,0,0,1-4.84-.07h0l-.49-.25a2.12,2.12,0,0,1-1.25-1.75,2.15,2.15,0,0,1,1.25-1.75,6.74,6.74,0,0,1,6.06,0A2.14,2.14,0,0,1,127.19,122.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83,123.05v-5.52l.24-1.55-1.85-1.33a1.78,1.78,0,0,0-.6,1.26v6.74a2.12,2.12,0,0,0,1.25,1.75l.49.25h0a7.14,7.14,0,0,0,2.51.43,7.49,7.49,0,0,0,2.33-.36l.11,0,.1,0,.13-.06C122.85,125.27,120.83,124.08,120.83,123.05Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,124.56l.31-.16a2.85,2.85,0,0,0,.7-.53v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,124.9l.5-.13v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,113.68c1.61.48,2.41,1.35,2.41,2.23s-.81,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.61-.47-2.41-1.35-2.41-2.23s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,124.78,113.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,113.68c1.61.48,2.41,1.35,2.41,2.23s-.81,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.61-.47-2.41-1.35-2.41-2.23s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,124.78,113.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16,115.91v2.37a7.55,7.55,0,0,1-2.51,0V116a.72.72,0,0,0,.36.45,2,2,0,0,0,1.78,0A.63.63,0,0,0,124.16,115.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,116.43a.72.72,0,0,1-.36-.45v2.3l.63.08v-1.82Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16,113.55v2.36a.63.63,0,0,1-.37.52,2,2,0,0,1-1.78,0,.72.72,0,0,1-.36-.45v-2.43A7.06,7.06,0,0,1,124.16,113.55Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68,120.28a6.18,6.18,0,0,0,.38,1.58l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.18,6.18,0,0,0,.38-1.58A7.46,7.46,0,0,0,121.68,120.28Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.46,123V113.3a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13v-2.52h-1.27v2.33a1.18,1.18,0,0,1-.75,1.08,6.3,6.3,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,8,8,0,0,0,5.28.69C120.46,126,119.46,124.25,119.46,123Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,110.92a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33h-.47V110a1.3,1.3,0,0,0,.76,1c.4.22,1.69.78,2,1.4a9,9,0,0,1,.2,3.11v7a3.2,3.2,0,0,1-2,3,7.15,7.15,0,0,0,1-.44A2.49,2.49,0,0,0,128,123V113A2.52,2.52,0,0,0,126.5,110.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65,113.55V116a.72.72,0,0,0,.36.45l.27.11v-3.07A4.52,4.52,0,0,0,121.65,113.55Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,122.59c0,.1-.15.17-.34.17s-.35-.07-.35-.17.15-.17.35-.17S123.25,122.5,123.25,122.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,122a4.14,4.14,0,0,0,.11-1.36V106.5h-.22v14.16A3.89,3.89,0,0,0,123,122Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84,106.5h-.45v15.21h0a4.42,4.42,0,0,0,.45-1.95Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,106.5v.68a1.37,1.37,0,0,1-.81,1.12,4.26,4.26,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52,1.05,1.05,0,0,1-.2-.6v-.68a.62.62,0,0,1,0-.19,1.48,1.48,0,0,1,.78-.93l0,0a4.27,4.27,0,0,1,3.83,0,1.45,1.45,0,0,1,.78.93A.63.63,0,0,1,125.65,106.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,108.08v-1c0-.4.1-1-.6-1a2,2,0,0,1-1.52-.7l0,0a1.48,1.48,0,0,0-.78.93.62.62,0,0,0,0,.19v.68a1.05,1.05,0,0,0,.2.6,1.74,1.74,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C124.09,108.6,123.13,108.46,123.13,108.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,107.61a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,121,107.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,107.61a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,121,107.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,104.41v1.71a.63.63,0,0,1,0,.19,1.45,1.45,0,0,1-.78.93,3.81,3.81,0,0,1-1.71.46,4.14,4.14,0,0,1-2.16-.46,1.74,1.74,0,0,1-.6-.52,1.14,1.14,0,0,1-.18-.41.55.55,0,0,1,0-.18V104.4a1.34,1.34,0,0,1,.8-1.12l.15-.08a4.33,4.33,0,0,1,3.72.08A1.37,1.37,0,0,1,125.65,104.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.91,99.08a1.5,1.5,0,0,0-1.5,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0v-3.83A1.49,1.49,0,0,0,122.91,99.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77,99.35h0a1.51,1.51,0,0,0-.86-.27,1.5,1.5,0,0,0-1.5,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,1,1,0,0,0,.36-.34,1.35,1.35,0,0,1-1.26.15c-.6-.23-.78-.81-.78-1.61v-2.5C122.28,99.72,123.09,98.89,123.77,99.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,102.74h0a.39.39,0,0,1-.39-.39v-2.12a.39.39,0,0,1,.39-.39h0a.38.38,0,0,1,.39.39v2.12A.38.38,0,0,1,123.7,102.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.09,103.59a.38.38,0,0,1-.39.39.39.39,0,1,1,0-.77A.38.38,0,0,1,124.09,103.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.37,106.72a1.74,1.74,0,0,0,.6.52,4.14,4.14,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.81,2.81,0,0,1-1.88-1,1.39,1.39,0,0,1,.47-1.85l-.15.08a1.34,1.34,0,0,0-.8,1.12v1.73a.55.55,0,0,0,0,.18A1.14,1.14,0,0,0,120.37,106.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.93,114.16a4.71,4.71,0,0,0-.45-.22c2.36,1.21,1.28,3-.18,3.73a8.74,8.74,0,0,1-5.2.11,6.73,6.73,0,0,0,5.83-.12,2.12,2.12,0,0,0,1.26-1.75A2.14,2.14,0,0,0,125.93,114.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.85,131c-2.07-1.18-2.07-3.1,0-4.28a8.32,8.32,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.28A8.32,8.32,0,0,1,127.85,131Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,116.15a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.09v-2.32H129.8v2.32a1.17,1.17,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,135.55,116.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,116.15a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.09v-2.32H129.8v2.32a1.17,1.17,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,135.55,116.15Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,130.27c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.11A8,8,0,0,1,128.37,130.27Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,130.27c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.11A8,8,0,0,1,128.37,130.27Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.24,121.14v6.74a2.13,2.13,0,0,1-1.26,1.75c-.15.09-.32.17-.49.25l-.09,0-.11,0a7.29,7.29,0,0,1-2.33.37,7.39,7.39,0,0,1-2.52-.43l0,0a3.58,3.58,0,0,1-.48-.24,2.13,2.13,0,0,1-1.26-1.75v-6.74a2.13,2.13,0,0,1,1.26-1.75,6.65,6.65,0,0,1,6,0A2.13,2.13,0,0,1,136.24,121.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,127.08l-.26.69a.63.63,0,0,1-1.16,0l-.27-.69a6,6,0,0,1-.41-2.18V111.72h2.52V124.9A5.79,5.79,0,0,1,132.8,127.08Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7,118.77v6.13a6,6,0,0,0,.41,2.18l.27.69a.63.63,0,0,0,1.16,0l.26-.69a5.79,5.79,0,0,0,.42-2.18v-6.13A7.61,7.61,0,0,0,130.7,118.77Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.52,128a.18.18,0,0,0,.07,0l.08.06,0,0,.12,0s-.22-.06-.28-.61-.22-1.89-.22-2.56v-6.28l-.63.08v6.13a6,6,0,0,0,.41,2.18l.27.69a.54.54,0,0,0,.09.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.24,127.88a2.13,2.13,0,0,1-1.26,1.75c-.15.09-.32.17-.49.25l-.09,0-.11,0a7,7,0,0,1-4.85-.06l0,0a3.58,3.58,0,0,1-.48-.24,1.85,1.85,0,0,1,0-3.5,6.65,6.65,0,0,1,6,0A2.13,2.13,0,0,1,136.24,127.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.88,128.28v-5.53l.24-1.54-1.84-1.33a1.77,1.77,0,0,0-.61,1.26v6.74a2.13,2.13,0,0,0,1.26,1.75,3.58,3.58,0,0,0,.48.24l0,0a7.39,7.39,0,0,0,2.52.43,7.29,7.29,0,0,0,2.33-.37l.11,0,.09,0,.14-.07C131.9,130.5,129.88,129.31,129.88,128.28Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.67,129.79a2.25,2.25,0,0,0,.31-.16,3.15,3.15,0,0,0,.71-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64,130.13l.51-.14v-9h-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.83,118.91c1.61.47,2.41,1.35,2.41,2.23s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.35-2.41-2.23s.8-1.76,2.41-2.23A6.47,6.47,0,0,1,133.83,118.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.83,118.91c1.61.47,2.41,1.35,2.41,2.23s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.35-2.41-2.23s.8-1.76,2.41-2.23A6.47,6.47,0,0,1,133.83,118.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.22,121.14v2.36a7.11,7.11,0,0,1-2.52,0v-2.29a.67.67,0,0,0,.37.44,1.93,1.93,0,0,0,1.78,0A.64.64,0,0,0,133.22,121.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.07,121.65a.67.67,0,0,1-.37-.44v2.29q.31.06.63.09v-1.82A1.23,1.23,0,0,1,131.07,121.65Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.22,118.78v2.36a.64.64,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.67.67,0,0,1-.37-.44v-2.44A7.35,7.35,0,0,1,133.22,118.78Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74,125.51a6,6,0,0,0,.37,1.57l.27.69a.63.63,0,0,0,1.16,0l.26-.69a5.63,5.63,0,0,0,.38-1.57A7.14,7.14,0,0,0,130.74,125.51Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,128.21v-9.68a1.42,1.42,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13v-2.51H129.8v2.32a1.17,1.17,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,5.28.69C129.51,131.23,128.51,129.48,128.51,128.21Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.55,116.15a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.09v-2.32h-.47v2.77a1.3,1.3,0,0,0,.76,1c.4.22,1.69.78,2,1.39a9.33,9.33,0,0,1,.2,3.12v7a3.18,3.18,0,0,1-2,3,6.07,6.07,0,0,0,1-.43,2.51,2.51,0,0,0,1.49-2.09v-10A2.52,2.52,0,0,0,135.55,116.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.7,118.77v2.44a.67.67,0,0,0,.37.44,1.23,1.23,0,0,0,.26.12v-3.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.31,127.82c0,.09-.16.17-.35.17s-.35-.08-.35-.17.16-.17.35-.17S132.31,127.72,132.31,127.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.08,127.2a4.54,4.54,0,0,0,.11-1.36V111.72H132v14.16A3.54,3.54,0,0,0,132.08,127.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.89,111.72h-.45v15.22h0a4.43,4.43,0,0,0,.45-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,111.73v.68a1.37,1.37,0,0,1-.81,1.12,4.32,4.32,0,0,1-3.87,0,1.85,1.85,0,0,1-.6-.53,1,1,0,0,1-.2-.59v-.69a1.1,1.1,0,0,1,0-.18,1.5,1.5,0,0,1,.78-.94l0,0a4.3,4.3,0,0,1,3.83,0,1.48,1.48,0,0,1,.79.94A1.11,1.11,0,0,1,134.7,111.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.18,113.3v-1c0-.39.1-1-.6-1a1.94,1.94,0,0,1-1.52-.71l0,0a1.5,1.5,0,0,0-.78.94,1.1,1.1,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,1.85,1.85,0,0,0,.6.53,4.32,4.32,0,0,0,3.87,0C133.14,113.83,132.18,113.68,132.18,113.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.96,
    cy: 111.72,
    rx: 2.74,
    ry: 1.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.96,
    cy: 111.72,
    rx: 2.74,
    ry: 1.58,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,109.63v1.72a1.37,1.37,0,0,1,0,.19,1.47,1.47,0,0,1-.79.93,3.65,3.65,0,0,1-1.71.45,4,4,0,0,1-2.16-.45,2.08,2.08,0,0,1-.6-.52,1.14,1.14,0,0,1-.18-.41,1.23,1.23,0,0,1,0-.19v-1.72a1.37,1.37,0,0,1,.8-1.12l.15-.08a4.29,4.29,0,0,1,3.72.08A1.37,1.37,0,0,1,134.7,109.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,104.31a1.48,1.48,0,0,0-1.49,1.49v3.83h0a.74.74,0,0,0,.43.61,2.37,2.37,0,0,0,2.11,0,.73.73,0,0,0,.44-.61h0V105.8A1.49,1.49,0,0,0,132,104.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82,104.58h0a1.51,1.51,0,0,0-.86-.27,1.48,1.48,0,0,0-1.49,1.49v3.83h0a.74.74,0,0,0,.43.61,2.37,2.37,0,0,0,2.11,0,1,1,0,0,0,.36-.34,1.38,1.38,0,0,1-1.25.15c-.61-.23-.78-.81-.78-1.62v-2.49C131.34,104.94,132.14,104.12,132.82,104.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.75,108h0a.39.39,0,0,1-.38-.39v-2.13a.39.39,0,0,1,.38-.39h0a.39.39,0,0,1,.39.39v2.13A.39.39,0,0,1,132.75,108Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.75,
    cy: 108.82,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,112a2.08,2.08,0,0,0,.6.52,4,4,0,0,0,2.16.45v-.63c0-.39.12-.86-.6-1a2.85,2.85,0,0,1-1.88-1,1.39,1.39,0,0,1,.47-1.85l-.15.08a1.37,1.37,0,0,0-.8,1.12v1.72a1.23,1.23,0,0,0,0,.19A1.14,1.14,0,0,0,129.42,112Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,119.39l-.46-.23c2.37,1.22,1.28,3-.17,3.73a8.67,8.67,0,0,1-5.2.12,6.77,6.77,0,0,0,5.83-.12,1.85,1.85,0,0,0,0-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75,131c-2.07-1.18-2.07-3.1,0-4.28a8.32,8.32,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.28A8.32,8.32,0,0,1,109.75,131Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,116.15a3.89,3.89,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.09v-2.32h-4.32v2.32a1.17,1.17,0,0,1-.75,1.09,3.89,3.89,0,0,0-.68.33,2.5,2.5,0,0,0-1.49,2.07v10a2.53,2.53,0,0,0,1.49,2.08,8,8,0,0,0,7.18,0,2.53,2.53,0,0,0,1.49-2.08v-10A2.5,2.5,0,0,0,117.44,116.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,116.15a3.89,3.89,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.09v-2.32h-4.32v2.32a1.17,1.17,0,0,1-.75,1.09,3.89,3.89,0,0,0-.68.33,2.5,2.5,0,0,0-1.49,2.07v10a2.53,2.53,0,0,0,1.49,2.08,8,8,0,0,0,7.18,0,2.53,2.53,0,0,0,1.49-2.08v-10A2.5,2.5,0,0,0,117.44,116.15Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,130.27c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.11A8,8,0,0,1,110.26,130.27Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,130.27c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.11A8,8,0,0,1,110.26,130.27Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14,121.14v6.74a2.15,2.15,0,0,1-1.26,1.75c-.16.09-.32.17-.5.25l-.09,0-.11,0a7.2,7.2,0,0,1-2.33.37,7.38,7.38,0,0,1-2.51-.43l0,0a4.44,4.44,0,0,1-.49-.24,2.12,2.12,0,0,1-1.25-1.75v-6.74a2.12,2.12,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.13,2.13,0,0,1,118.14,121.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7,127.08l-.27.69a.62.62,0,0,1-1.15,0l-.27-.69a6,6,0,0,1-.41-2.18V111.72h2.51V124.9A6,6,0,0,1,114.7,127.08Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,118.77v6.13a6,6,0,0,0,.41,2.18l.27.69a.62.62,0,0,0,1.15,0l.27-.69a6,6,0,0,0,.41-2.18v-6.13A7.55,7.55,0,0,0,112.6,118.77Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42,128l.06,0,.09.06,0,0,.11,0s-.22-.06-.28-.61-.21-1.89-.21-2.56v-6.28l-.63.08v6.13a6,6,0,0,0,.41,2.18l.27.69a.38.38,0,0,0,.09.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14,127.88a2.15,2.15,0,0,1-1.26,1.75c-.16.09-.32.17-.5.25l-.09,0-.11,0a7,7,0,0,1-4.84-.06l0,0a4.44,4.44,0,0,1-.49-.24,1.85,1.85,0,0,1,0-3.5,6.67,6.67,0,0,1,6.06,0A2.13,2.13,0,0,1,118.14,127.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78,128.28v-5.53l.24-1.54-1.85-1.33a1.76,1.76,0,0,0-.6,1.26v6.74a2.12,2.12,0,0,0,1.25,1.75,4.44,4.44,0,0,0,.49.24l0,0a7.38,7.38,0,0,0,2.51.43,7.2,7.2,0,0,0,2.33-.37l.11,0,.09,0,.14-.07C113.79,130.5,111.78,129.31,111.78,128.28Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,129.79l.31-.16a3.32,3.32,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54,130.13l.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,118.91c1.6.47,2.41,1.35,2.41,2.23s-.81,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.35-2.41-2.23s.8-1.76,2.41-2.23A6.47,6.47,0,0,1,115.73,118.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,118.91c1.6.47,2.41,1.35,2.41,2.23s-.81,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.35-2.41-2.23s.8-1.76,2.41-2.23A6.47,6.47,0,0,1,115.73,118.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11,121.14v2.36a7.06,7.06,0,0,1-2.51,0v-2.29a.65.65,0,0,0,.36.44,1.93,1.93,0,0,0,1.78,0A.62.62,0,0,0,115.11,121.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,121.65a.65.65,0,0,1-.36-.44v2.29c.2,0,.42.07.63.09v-1.82A1.11,1.11,0,0,1,113,121.65Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11,118.78v2.36a.62.62,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.65.65,0,0,1-.36-.44v-2.44A7.3,7.3,0,0,1,115.11,118.78Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,125.51a6,6,0,0,0,.38,1.57l.27.69a.62.62,0,0,0,1.15,0l.27-.69a6,6,0,0,0,.38-1.57A7.2,7.2,0,0,0,112.63,125.51Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41,128.21v-9.68a1.42,1.42,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13v-2.51h-1.28v2.32a1.17,1.17,0,0,1-.75,1.09,3.89,3.89,0,0,0-.68.33,2.5,2.5,0,0,0-1.49,2.07v10a2.53,2.53,0,0,0,1.49,2.08,8,8,0,0,0,5.28.69C111.41,131.23,110.41,129.48,110.41,128.21Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,116.15a3.89,3.89,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.09v-2.32h-.47v2.77a1.31,1.31,0,0,0,.75,1c.41.22,1.7.78,2,1.39a9.06,9.06,0,0,1,.2,3.12v7a3.18,3.18,0,0,1-2,3,5.81,5.81,0,0,0,1-.43,2.5,2.5,0,0,0,1.48-2.09v-10A2.5,2.5,0,0,0,117.44,116.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,118.77v2.44a.65.65,0,0,0,.36.44,1.11,1.11,0,0,0,.27.12v-3.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,127.82c0,.09-.15.17-.35.17s-.34-.08-.34-.17.15-.17.34-.17S114.2,127.72,114.2,127.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,127.2a4.54,4.54,0,0,0,.11-1.36V111.72h-.23v14.16A3.81,3.81,0,0,0,114,127.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,111.72h-.46v15.22h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,111.73v.68a1.34,1.34,0,0,1-.8,1.12,4.32,4.32,0,0,1-3.87,0,1.76,1.76,0,0,1-.6-.53,1,1,0,0,1-.2-.59v-.69a.55.55,0,0,1,0-.18,1.44,1.44,0,0,1,.78-.94l0,0a4.3,4.3,0,0,1,3.83,0,1.5,1.5,0,0,1,.78.94A.58.58,0,0,1,116.59,111.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.08,113.3v-1c0-.39.1-1-.6-1a1.91,1.91,0,0,1-1.52-.71l0,0a1.44,1.44,0,0,0-.78.94.55.55,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,1.76,1.76,0,0,0,.6.53,4.32,4.32,0,0,0,3.87,0C115,113.83,114.08,113.68,114.08,113.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.92,112.84a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,111.92,112.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.92,112.84a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,111.92,112.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,109.63v1.72a.65.65,0,0,1,0,.19,1.48,1.48,0,0,1-.78.93,3.68,3.68,0,0,1-1.71.45,4,4,0,0,1-2.16-.45,1.85,1.85,0,0,1-.6-.52.88.88,0,0,1-.18-.41.62.62,0,0,1,0-.19v-1.72a1.34,1.34,0,0,1,.8-1.12l.14-.08a4.31,4.31,0,0,1,3.73.08A1.34,1.34,0,0,1,116.59,109.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,104.31a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.75.75,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0V105.8A1.49,1.49,0,0,0,113.85,104.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,104.58h0a1.49,1.49,0,0,0-2.35,1.22v3.83h0a.75.75,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,1,1,0,0,0,.35-.34,1.38,1.38,0,0,1-1.25.15c-.6-.23-.78-.81-.78-1.62v-2.49C113.23,104.94,114,104.12,114.71,104.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.65,108h0a.4.4,0,0,1-.39-.39v-2.13a.4.4,0,0,1,.39-.39h0a.4.4,0,0,1,.39.39v2.13A.4.4,0,0,1,114.65,108Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.65,
    cy: 108.82,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.32,112a1.85,1.85,0,0,0,.6.52,4,4,0,0,0,2.16.45v-.63c0-.39.12-.86-.6-1a2.85,2.85,0,0,1-1.89-1,1.4,1.4,0,0,1,.47-1.85l-.14.08a1.34,1.34,0,0,0-.8,1.12v1.72a.62.62,0,0,0,0,.19A.88.88,0,0,0,111.32,112Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.88,119.39l-.45-.23c2.36,1.22,1.28,3-.18,3.73a8.67,8.67,0,0,1-5.2.12,6.77,6.77,0,0,0,5.83-.12,1.85,1.85,0,0,0,0-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,136.21c-2.07-1.18-2.07-3.1,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.19,2.07,3.11,0,4.29A8.39,8.39,0,0,1,118.8,136.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,121.37a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.32h-4.31V120A1.18,1.18,0,0,1,120,121a6.3,6.3,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07v-10A2.55,2.55,0,0,0,126.5,121.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,121.37a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.32h-4.31V120A1.18,1.18,0,0,1,120,121a6.3,6.3,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07v-10A2.55,2.55,0,0,0,126.5,121.37Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,135.49c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.1A8,8,0,0,1,119.31,135.49Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,135.49c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.1A8,8,0,0,1,119.31,135.49Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,126.37v6.74a2.14,2.14,0,0,1-1.26,1.75,3.71,3.71,0,0,1-.49.24l-.1,0-.11,0a7.49,7.49,0,0,1-2.33.36,7.14,7.14,0,0,1-2.51-.43h0a4.44,4.44,0,0,1-.49-.24,2.15,2.15,0,0,1-1.25-1.75v-6.74a2.12,2.12,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,127.19,126.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75,132.31l-.27.68a.61.61,0,0,1-1.15,0l-.27-.68a6.06,6.06,0,0,1-.41-2.18V117h2.51v13.18A6.06,6.06,0,0,1,123.75,132.31Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65,124v6.13a6.06,6.06,0,0,0,.41,2.18l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.06,6.06,0,0,0,.41-2.18V124A7.3,7.3,0,0,0,121.65,124Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.47,133.2l.07.06.08.05,0,0,.11,0s-.21-.07-.28-.61-.21-1.89-.21-2.56v-6.28c-.21,0-.42,0-.63.08v6.13a6.06,6.06,0,0,0,.41,2.18l.27.68a.51.51,0,0,0,.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,133.11a2.14,2.14,0,0,1-1.26,1.75,3.71,3.71,0,0,1-.49.24l-.1,0-.11,0a7,7,0,0,1-4.84-.07h0a4.44,4.44,0,0,1-.49-.24,2.15,2.15,0,0,1-1.25-1.75,2.12,2.12,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,127.19,133.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83,133.51V128l.24-1.54-1.85-1.34a1.78,1.78,0,0,0-.6,1.27v6.74a2.15,2.15,0,0,0,1.25,1.75,4.44,4.44,0,0,0,.49.24h0a7.14,7.14,0,0,0,2.51.43,7.49,7.49,0,0,0,2.33-.36l.11,0,.1,0,.13-.06C122.85,135.72,120.83,134.53,120.83,133.51Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,135l.31-.16a3.14,3.14,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,135.36l.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,124.13c1.61.48,2.41,1.36,2.41,2.23s-.81,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.24s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,124.78,124.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,124.13c1.61.48,2.41,1.36,2.41,2.23s-.81,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.24s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,124.78,124.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16,126.37v2.36a7.55,7.55,0,0,1-2.51,0v-2.3a.67.67,0,0,0,.36.45,2,2,0,0,0,1.78,0A.62.62,0,0,0,124.16,126.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,126.88a.68.68,0,0,1-.36-.44v2.29c.21,0,.42.06.63.08V127A1.53,1.53,0,0,1,122,126.88Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16,124v2.37a.62.62,0,0,1-.37.51,2,2,0,0,1-1.78,0,.67.67,0,0,1-.36-.45V124A7.55,7.55,0,0,1,124.16,124Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68,130.73a6.18,6.18,0,0,0,.38,1.58l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.2,6.2,0,0,0,.38-1.57A7.46,7.46,0,0,0,121.68,130.73Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.46,133.44v-9.69a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13v-2.51h-1.27V120A1.18,1.18,0,0,1,120,121a6.3,6.3,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.87,7.87,0,0,0,5.28.69C120.46,136.46,119.46,134.71,119.46,133.44Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,121.37a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.32h-.47v2.77a1.3,1.3,0,0,0,.76,1c.4.22,1.69.79,2,1.4a9,9,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,6.1,6.1,0,0,0,1-.44,2.49,2.49,0,0,0,1.49-2.08v-10A2.55,2.55,0,0,0,126.5,121.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65,124v2.44a.68.68,0,0,0,.36.44,1.53,1.53,0,0,0,.27.11v-3.07C122.07,123.94,121.86,124,121.65,124Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,133c0,.1-.15.18-.34.18s-.35-.08-.35-.18.15-.17.35-.17S123.25,133,123.25,133Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,132.43a4.23,4.23,0,0,0,.11-1.37V117h-.22v14.16A4,4,0,0,0,123,132.43Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84,117h-.45v15.22h0a4.43,4.43,0,0,0,.45-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,117v.68a1.36,1.36,0,0,1-.81,1.12,4.26,4.26,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52,1,1,0,0,1-.2-.59V117a.55.55,0,0,1,0-.18,1.47,1.47,0,0,1,.78-.94l0,0a4.27,4.27,0,0,1,3.83,0,1.45,1.45,0,0,1,.78.93A.68.68,0,0,1,125.65,117Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,118.53v-1c0-.4.1-1-.6-1a2,2,0,0,1-1.52-.71l0,0a1.47,1.47,0,0,0-.78.94.55.55,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,1.74,1.74,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C124.09,119.05,123.13,118.91,123.13,118.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,118.07a1.18,1.18,0,0,1,0-2.24,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.32,4.32,0,0,1,121,118.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,118.07a1.18,1.18,0,0,1,0-2.24,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.32,4.32,0,0,1,121,118.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,114.86v1.71a.58.58,0,0,1,0,.19,1.46,1.46,0,0,1-.78.94,4.3,4.3,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52,1.18,1.18,0,0,1-.18-.4.65.65,0,0,1,0-.19v-1.73a1.36,1.36,0,0,1,.8-1.12l.15-.07a4.29,4.29,0,0,1,3.72.07A1.38,1.38,0,0,1,125.65,114.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.91,109.53a1.5,1.5,0,0,0-1.5,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0V111A1.49,1.49,0,0,0,122.91,109.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77,109.8h0a1.51,1.51,0,0,0-.86-.27,1.5,1.5,0,0,0-1.5,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.91.91,0,0,0,.36-.34,1.37,1.37,0,0,1-1.26.16c-.6-.24-.78-.82-.78-1.62v-2.5C122.28,110.17,123.09,109.34,123.77,109.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,113.19h0a.39.39,0,0,1-.39-.38v-2.13a.4.4,0,0,1,.39-.39h0a.39.39,0,0,1,.39.39v2.13A.38.38,0,0,1,123.7,113.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.7,
    cy: 114.05,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.37,117.17a1.74,1.74,0,0,0,.6.52,4,4,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.86,2.86,0,0,1-1.88-1,1.37,1.37,0,0,1,.47-1.84l-.15.07a1.36,1.36,0,0,0-.8,1.12v1.73a.65.65,0,0,0,0,.19A1.18,1.18,0,0,0,120.37,117.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.93,124.62a3.17,3.17,0,0,0-.45-.23c2.36,1.21,1.28,3-.18,3.73a8.67,8.67,0,0,1-5.2.11,6.7,6.7,0,0,0,5.83-.12,1.84,1.84,0,0,0,0-3.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,136.21c-2.07-1.18-2.07-3.1,0-4.29a8.37,8.37,0,0,1,7.49,0c2.07,1.19,2.08,3.11,0,4.29A8.37,8.37,0,0,1,100.7,136.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,121.37a5.53,5.53,0,0,0-.69-.33A1.18,1.18,0,0,1,107,120v-2.32h-4.31V120a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.54,2.54,0,0,0-1.48,2.08v10a2.51,2.51,0,0,0,1.48,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07v-10A2.55,2.55,0,0,0,108.39,121.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,121.37a5.53,5.53,0,0,0-.69-.33A1.18,1.18,0,0,1,107,120v-2.32h-4.31V120a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.54,2.54,0,0,0-1.48,2.08v10a2.51,2.51,0,0,0,1.48,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07v-10A2.55,2.55,0,0,0,108.39,121.37Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,135.49c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.1A8,8,0,0,1,101.21,135.49Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,135.49c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.1A8,8,0,0,1,101.21,135.49Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.08,126.37v6.74a2.15,2.15,0,0,1-1.25,1.75,4.59,4.59,0,0,1-.5.24l-.09,0-.11,0a7.54,7.54,0,0,1-2.33.36,7.24,7.24,0,0,1-2.52-.43h0a3.19,3.19,0,0,1-.49-.24,2.14,2.14,0,0,1-1.26-1.75v-6.74a2.12,2.12,0,0,1,1.26-1.75,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,109.08,126.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.65,132.31l-.27.68a.62.62,0,0,1-1.16,0l-.26-.68a5.87,5.87,0,0,1-.42-2.18V117h2.52v13.18A6.06,6.06,0,0,1,105.65,132.31Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54,124v6.13a5.87,5.87,0,0,0,.42,2.18l.26.68a.62.62,0,0,0,1.16,0l.27-.68a6.06,6.06,0,0,0,.41-2.18V124A7.35,7.35,0,0,0,103.54,124Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.36,133.2l.07.06.08.05,0,0,.11,0s-.22-.07-.28-.61-.21-1.89-.21-2.56v-6.28c-.22,0-.43,0-.64.08v6.13a5.87,5.87,0,0,0,.42,2.18l.26.68.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.08,133.11a2.15,2.15,0,0,1-1.25,1.75,4.59,4.59,0,0,1-.5.24l-.09,0-.11,0a7,7,0,0,1-4.85-.07h0a3.19,3.19,0,0,1-.49-.24,2.14,2.14,0,0,1-1.26-1.75,2.12,2.12,0,0,1,1.26-1.75,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,109.08,133.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.73,133.51V128l.23-1.54-1.84-1.34a1.8,1.8,0,0,0-.61,1.27v6.74a2.14,2.14,0,0,0,1.26,1.75,3.19,3.19,0,0,0,.49.24h0a7.24,7.24,0,0,0,2.52.43,7.54,7.54,0,0,0,2.33-.36l.11,0,.09,0,.14-.06C104.74,135.72,102.73,134.53,102.73,133.51Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.52,135l.31-.16a3.68,3.68,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49,135.36l.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,124.13c1.61.48,2.41,1.36,2.41,2.23s-.8,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.6-.48-2.41-1.36-2.41-2.24s.81-1.75,2.41-2.23A6.65,6.65,0,0,1,106.67,124.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,124.13c1.61.48,2.41,1.36,2.41,2.23s-.8,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.6-.48-2.41-1.36-2.41-2.24s.81-1.75,2.41-2.23A6.65,6.65,0,0,1,106.67,124.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,126.37v2.36a7.61,7.61,0,0,1-2.52,0v-2.3a.66.66,0,0,0,.37.45,2,2,0,0,0,1.78,0A.62.62,0,0,0,106.06,126.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91,126.88a.67.67,0,0,1-.37-.44v2.29c.21,0,.42.06.64.08V127A1.09,1.09,0,0,1,103.91,126.88Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,124v2.37a.62.62,0,0,1-.37.51,2,2,0,0,1-1.78,0,.66.66,0,0,1-.37-.45V124A7.61,7.61,0,0,1,106.06,124Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,130.73a5.79,5.79,0,0,0,.38,1.58l.26.68a.62.62,0,0,0,1.16,0l.27-.68a6.18,6.18,0,0,0,.37-1.57A7.4,7.4,0,0,0,103.58,130.73Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.35,133.44v-9.69a1.43,1.43,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13v-2.51h-1.27V120a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.54,2.54,0,0,0-1.48,2.08v10a2.51,2.51,0,0,0,1.48,2.07,7.88,7.88,0,0,0,5.28.69C102.35,136.46,101.35,134.71,101.35,133.44Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,121.37a5.53,5.53,0,0,0-.69-.33A1.18,1.18,0,0,1,107,120v-2.32h-.47v2.77a1.3,1.3,0,0,0,.76,1c.41.22,1.7.79,2,1.4a9,9,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,5.72,5.72,0,0,0,1-.44,2.47,2.47,0,0,0,1.49-2.08v-10A2.55,2.55,0,0,0,108.39,121.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54,124v2.44a.67.67,0,0,0,.37.44,1.09,1.09,0,0,0,.27.11v-3.07C104,123.94,103.75,124,103.54,124Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,133c0,.1-.16.18-.35.18s-.35-.08-.35-.18.16-.17.35-.17S105.15,133,105.15,133Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.92,132.43a4.58,4.58,0,0,0,.11-1.37V117h-.23v14.16A3.59,3.59,0,0,0,104.92,132.43Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74,117h-.46v15.22h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.54,117v.68a1.37,1.37,0,0,1-.8,1.12,4.28,4.28,0,0,1-3.88,0,1.94,1.94,0,0,1-.6-.52,1,1,0,0,1-.2-.59V117a1.1,1.1,0,0,1,0-.18,1.47,1.47,0,0,1,.78-.94l0,0a4.29,4.29,0,0,1,3.84,0,1.48,1.48,0,0,1,.78.93A1.37,1.37,0,0,1,107.54,117Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,118.53v-1c0-.4.1-1-.6-1a2,2,0,0,1-1.53-.71l0,0a1.47,1.47,0,0,0-.78.94,1.1,1.1,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,1.94,1.94,0,0,0,.6.52,4.28,4.28,0,0,0,3.88,0C106,119.05,105,118.91,105,118.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,118.07a1.18,1.18,0,0,1,0-2.24,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.32,4.32,0,0,1,102.87,118.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,118.07a1.18,1.18,0,0,1,0-2.24,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.32,4.32,0,0,1,102.87,118.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.54,114.86v1.71a1.11,1.11,0,0,1,0,.19,1.5,1.5,0,0,1-.78.94,3.94,3.94,0,0,1-1.71.45,4,4,0,0,1-2.17-.46,1.94,1.94,0,0,1-.6-.52,1.18,1.18,0,0,1-.18-.4,1.37,1.37,0,0,1,0-.19v-1.73a1.38,1.38,0,0,1,.8-1.12l.15-.07a4.31,4.31,0,0,1,3.73.07A1.39,1.39,0,0,1,107.54,114.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.8,109.53a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.73.73,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.74.74,0,0,0,.43-.61h0V111A1.49,1.49,0,0,0,104.8,109.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.66,109.8h0a1.49,1.49,0,0,0-2.35,1.22v3.83h0a.73.73,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.88.88,0,0,0,.35-.34,1.35,1.35,0,0,1-1.25.16c-.61-.24-.78-.82-.78-1.62v-2.5C104.18,110.17,105,109.34,105.66,109.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,113.19h0a.38.38,0,0,1-.39-.38v-2.13a.39.39,0,0,1,.39-.39h0a.4.4,0,0,1,.39.39v2.13A.39.39,0,0,1,105.6,113.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,114.05a.39.39,0,0,1-.39.38.39.39,0,1,1,0-.77A.39.39,0,0,1,106,114.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.26,117.17a1.94,1.94,0,0,0,.6.52,4,4,0,0,0,2.17.46v-.63c0-.4.11-.87-.6-1a2.86,2.86,0,0,1-1.89-1,1.37,1.37,0,0,1,.47-1.84l-.15.07a1.38,1.38,0,0,0-.8,1.12v1.73a1.37,1.37,0,0,0,0,.19A1.18,1.18,0,0,0,102.26,117.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.83,124.62a4,4,0,0,0-.46-.23c2.37,1.21,1.29,3-.17,3.73a8.67,8.67,0,0,1-5.2.11,6.7,6.7,0,0,0,5.83-.12,1.84,1.84,0,0,0,0-3.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75,141.44c-2.07-1.19-2.07-3.11,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.29A8.39,8.39,0,0,1,109.75,141.44Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,126.6a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08v-2.33h-4.32v2.33a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33,2.5,2.5,0,0,0-1.49,2.08v9.95a2.5,2.5,0,0,0,1.49,2.08,7.9,7.9,0,0,0,7.18,0,2.5,2.5,0,0,0,1.49-2.08v-10A2.5,2.5,0,0,0,117.44,126.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,126.6a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08v-2.33h-4.32v2.33a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33,2.5,2.5,0,0,0-1.49,2.08v9.95a2.5,2.5,0,0,0,1.49,2.08,7.9,7.9,0,0,0,7.18,0,2.5,2.5,0,0,0,1.49-2.08v-10A2.5,2.5,0,0,0,117.44,126.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.85,
    cy: 138.67,
    rx: 5.08,
    ry: 2.9,
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.85,
    cy: 138.67,
    rx: 5.08,
    ry: 2.9,
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14,131.59v6.74a2.14,2.14,0,0,1-1.26,1.75,3.89,3.89,0,0,1-.5.25l-.09,0-.11,0a7.49,7.49,0,0,1-2.33.36,7.14,7.14,0,0,1-2.51-.43h0l-.49-.25a2.1,2.1,0,0,1-1.25-1.75v-6.74a2.13,2.13,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.14,2.14,0,0,1,118.14,131.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7,137.54l-.27.68a.61.61,0,0,1-1.15,0l-.27-.68a6.08,6.08,0,0,1-.41-2.19V122.17h2.51v13.18A6.08,6.08,0,0,1,114.7,137.54Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,129.23v6.12a6.08,6.08,0,0,0,.41,2.19l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.08,6.08,0,0,0,.41-2.19v-6.12A7.06,7.06,0,0,0,112.6,129.23Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42,138.43l.06.06.09,0,0,0,.11,0s-.22-.07-.28-.61-.21-1.89-.21-2.57v-6.28c-.21,0-.43.05-.63.09v6.12a6.08,6.08,0,0,0,.41,2.19l.27.68a.51.51,0,0,0,.09.16S113.4,138.41,113.42,138.43Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14,138.33a2.14,2.14,0,0,1-1.26,1.75,3.89,3.89,0,0,1-.5.25l-.09,0-.11,0a7,7,0,0,1-4.84-.07h0l-.49-.25a2.1,2.1,0,0,1-1.25-1.75,2.13,2.13,0,0,1,1.25-1.75,6.74,6.74,0,0,1,6.06,0A2.14,2.14,0,0,1,118.14,138.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.78,138.73v-5.52l.24-1.55-1.85-1.33a1.76,1.76,0,0,0-.6,1.26v6.74a2.1,2.1,0,0,0,1.25,1.75l.49.25h0a7.14,7.14,0,0,0,2.51.43,7.49,7.49,0,0,0,2.33-.36l.11,0,.09,0,.14-.06C113.79,141,111.78,139.76,111.78,138.73Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,140.24l.31-.16a3.29,3.29,0,0,0,.7-.53V131h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54,140.58l.5-.13v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,129.36c1.6.48,2.41,1.35,2.41,2.23s-.81,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.61-.47-2.41-1.35-2.41-2.23s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,115.73,129.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,129.36c1.6.48,2.41,1.35,2.41,2.23s-.81,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.61-.47-2.41-1.35-2.41-2.23s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,115.73,129.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11,131.59V134a7.3,7.3,0,0,1-2.51,0v-2.3a.65.65,0,0,0,.36.44,1.93,1.93,0,0,0,1.78,0A.61.61,0,0,0,115.11,131.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,132.1a.65.65,0,0,1-.36-.44V134l.63.08v-1.82A1.11,1.11,0,0,1,113,132.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11,129.23v2.36a.61.61,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.65.65,0,0,1-.36-.44v-2.43A7.06,7.06,0,0,1,115.11,129.23Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,136a6.18,6.18,0,0,0,.38,1.58l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.18,6.18,0,0,0,.38-1.58A7.2,7.2,0,0,0,112.63,136Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41,138.67V129a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13v-2.52h-1.28v2.33a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33,2.5,2.5,0,0,0-1.49,2.08v9.95a2.5,2.5,0,0,0,1.49,2.08,8,8,0,0,0,5.28.69C111.41,141.69,110.41,139.93,110.41,138.67Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,126.6a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08v-2.33h-.47v2.77a1.31,1.31,0,0,0,.75,1c.41.22,1.7.78,2,1.4a9,9,0,0,1,.2,3.11v7a3.17,3.17,0,0,1-2,3,5.81,5.81,0,0,0,1-.43,2.47,2.47,0,0,0,1.48-2.09v-10A2.5,2.5,0,0,0,117.44,126.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,129.23v2.43a.65.65,0,0,0,.36.44,1.11,1.11,0,0,0,.27.12v-3.08C113,129.16,112.8,129.19,112.6,129.23Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,138.27c0,.1-.15.17-.35.17s-.34-.07-.34-.17.15-.17.34-.17S114.2,138.18,114.2,138.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,137.65a4.49,4.49,0,0,0,.11-1.36V122.17h-.23v14.17A3.73,3.73,0,0,0,114,137.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,122.17h-.46v15.22h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,122.18v.68a1.34,1.34,0,0,1-.8,1.12,4.26,4.26,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52,1,1,0,0,1-.2-.6v-.68a.58.58,0,0,1,0-.19,1.42,1.42,0,0,1,.78-.93l0,0a4.3,4.3,0,0,1,3.83,0,1.48,1.48,0,0,1,.78.93A.62.62,0,0,1,116.59,122.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.08,123.75v-1c0-.4.1-1-.6-1A1.91,1.91,0,0,1,112,121l0,0a1.42,1.42,0,0,0-.78.93.58.58,0,0,0,0,.19v.68a1,1,0,0,0,.2.6,1.74,1.74,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C115,124.28,114.08,124.13,114.08,123.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.92,123.29a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,111.92,123.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.92,123.29a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,111.92,123.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,120.09v1.71a.62.62,0,0,1,0,.19,1.48,1.48,0,0,1-.78.93,3.81,3.81,0,0,1-1.71.46,4.12,4.12,0,0,1-2.16-.46,1.74,1.74,0,0,1-.6-.52.88.88,0,0,1-.18-.41.55.55,0,0,1,0-.18v-1.73a1.34,1.34,0,0,1,.8-1.12l.14-.08a4.31,4.31,0,0,1,3.73.08A1.34,1.34,0,0,1,116.59,120.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,114.76a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0v-3.83A1.5,1.5,0,0,0,113.85,114.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,115h0a1.49,1.49,0,0,0-2.35,1.22v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,1,1,0,0,0,.35-.34,1.35,1.35,0,0,1-1.25.15c-.6-.23-.78-.81-.78-1.62v-2.49C113.23,115.4,114,114.57,114.71,115Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.65,118.42h0a.39.39,0,0,1-.39-.39v-2.12a.39.39,0,0,1,.39-.39h0a.39.39,0,0,1,.39.39V118A.39.39,0,0,1,114.65,118.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.65,
    cy: 119.27,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.32,122.4a1.74,1.74,0,0,0,.6.52,4.12,4.12,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.81,2.81,0,0,1-1.89-1,1.4,1.4,0,0,1,.47-1.85l-.14.08a1.34,1.34,0,0,0-.8,1.12v1.73a.55.55,0,0,0,0,.18A.88.88,0,0,0,111.32,122.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.88,129.84c-.14-.08-.3-.15-.45-.22,2.36,1.21,1.28,3-.18,3.72a8.67,8.67,0,0,1-5.2.12,6.77,6.77,0,0,0,5.83-.12,1.85,1.85,0,0,0,0-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.64,141.44c-2.07-1.19-2.07-3.11,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.29A8.39,8.39,0,0,1,91.64,141.44Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,126.6a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33H93.59v2.33a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.08v9.95a2.52,2.52,0,0,0,1.49,2.08,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,99.34,126.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,126.6a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33H93.59v2.33a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.08v9.95a2.52,2.52,0,0,0,1.49,2.08,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,99.34,126.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,140.72c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.14,2,3,0,4.11A8,8,0,0,1,92.16,140.72Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,140.72c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.14,2,3,0,4.11A8,8,0,0,1,92.16,140.72Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,131.59v6.74a2.12,2.12,0,0,1-1.26,1.75,3.75,3.75,0,0,1-.49.25l-.09,0-.11,0a7.58,7.58,0,0,1-2.33.36,7.16,7.16,0,0,1-2.52-.43h0a5.39,5.39,0,0,1-.48-.25,2.12,2.12,0,0,1-1.26-1.75v-6.74a2.14,2.14,0,0,1,1.26-1.75,6.65,6.65,0,0,1,6,0A2.14,2.14,0,0,1,100,131.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.59,137.54l-.26.68a.62.62,0,0,1-1.16,0l-.27-.68a6.08,6.08,0,0,1-.41-2.19V122.17H97v13.18A5.88,5.88,0,0,1,96.59,137.54Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,129.23v6.12a6.08,6.08,0,0,0,.41,2.19l.27.68a.62.62,0,0,0,1.16,0l.26-.68a5.88,5.88,0,0,0,.42-2.19v-6.12A7.11,7.11,0,0,0,94.49,129.23Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31,138.43l.07.06.08,0,0,0,.12,0s-.22-.07-.28-.61-.22-1.89-.22-2.57v-6.28l-.63.09v6.12a6.08,6.08,0,0,0,.41,2.19l.27.68a.83.83,0,0,0,.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,138.33a2.12,2.12,0,0,1-1.26,1.75,3.75,3.75,0,0,1-.49.25l-.09,0-.11,0a7,7,0,0,1-4.85-.07h0a5.39,5.39,0,0,1-.48-.25,2.12,2.12,0,0,1-1.26-1.75,2.14,2.14,0,0,1,1.26-1.75,6.71,6.71,0,0,1,6,0A2.14,2.14,0,0,1,100,138.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.67,138.73v-5.52l.24-1.55-1.84-1.33a1.77,1.77,0,0,0-.61,1.26v6.74a2.12,2.12,0,0,0,1.26,1.75,5.39,5.39,0,0,0,.48.25h0a7.16,7.16,0,0,0,2.52.43,7.58,7.58,0,0,0,2.33-.36l.11,0,.09,0,.14-.06C95.69,141,93.67,139.76,93.67,138.73Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.46,140.24l.31-.16a3.13,3.13,0,0,0,.71-.53V131h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.43,140.58l.51-.13v-9h-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,129.36c1.61.48,2.41,1.35,2.41,2.23s-.8,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.61-.47-2.41-1.35-2.41-2.23s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,97.62,129.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,129.36c1.61.48,2.41,1.35,2.41,2.23s-.8,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.61-.47-2.41-1.35-2.41-2.23s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,97.62,129.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,131.59V134a7.35,7.35,0,0,1-2.52,0v-2.3a.67.67,0,0,0,.37.44,1.93,1.93,0,0,0,1.78,0A.63.63,0,0,0,97,131.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,132.1a.67.67,0,0,1-.37-.44V134l.63.08v-1.82A1.23,1.23,0,0,1,94.86,132.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,129.23v2.36a.63.63,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.67.67,0,0,1-.37-.44v-2.43A7.11,7.11,0,0,1,97,129.23Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.53,136a6.16,6.16,0,0,0,.37,1.58l.27.68a.62.62,0,0,0,1.16,0l.26-.68A5.79,5.79,0,0,0,97,136,7.14,7.14,0,0,0,94.53,136Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3,138.67V129a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13v-2.52H93.59v2.33a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.08v9.95a2.52,2.52,0,0,0,1.49,2.08,8,8,0,0,0,5.28.69C93.3,141.69,92.3,139.93,92.3,138.67Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,126.6a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33h-.47v2.77a1.3,1.3,0,0,0,.76,1c.4.22,1.69.78,2,1.4a9.26,9.26,0,0,1,.2,3.11v7a3.17,3.17,0,0,1-2,3,6.07,6.07,0,0,0,1-.43,2.49,2.49,0,0,0,1.49-2.09v-10A2.52,2.52,0,0,0,99.34,126.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,129.23v2.43a.67.67,0,0,0,.37.44,1.23,1.23,0,0,0,.26.12v-3.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1,138.27c0,.1-.16.17-.35.17s-.35-.07-.35-.17.16-.17.35-.17S96.1,138.18,96.1,138.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.87,137.65a4.49,4.49,0,0,0,.11-1.36V122.17h-.23v14.17A3.47,3.47,0,0,0,95.87,137.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,122.17h-.45v15.22h0a4.43,4.43,0,0,0,.45-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.49,122.18v.68a1.37,1.37,0,0,1-.81,1.12,4.26,4.26,0,0,1-3.87,0,1.83,1.83,0,0,1-.6-.52,1.05,1.05,0,0,1-.2-.6v-.68a1.11,1.11,0,0,1,0-.19,1.48,1.48,0,0,1,.78-.93l0,0a4.3,4.3,0,0,1,3.83,0,1.47,1.47,0,0,1,.79.93A1.23,1.23,0,0,1,98.49,122.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,123.75v-1c0-.4.1-1-.6-1a1.94,1.94,0,0,1-1.52-.71l0,0A1.48,1.48,0,0,0,93,122a1.11,1.11,0,0,0,0,.19v.68a1.05,1.05,0,0,0,.2.6,1.83,1.83,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C96.93,124.28,96,124.13,96,123.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.75,
    cy: 122.17,
    rx: 2.74,
    ry: 1.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.75,
    cy: 122.17,
    rx: 2.74,
    ry: 1.58,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.49,120.09v1.71a1.23,1.23,0,0,1,0,.19,1.47,1.47,0,0,1-.79.93,3.78,3.78,0,0,1-1.71.46,4.14,4.14,0,0,1-2.16-.46,1.94,1.94,0,0,1-.6-.52A1.14,1.14,0,0,1,93,122a1.1,1.1,0,0,1,0-.18v-1.73a1.37,1.37,0,0,1,.8-1.12l.15-.08a4.29,4.29,0,0,1,3.72.08A1.37,1.37,0,0,1,98.49,120.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,114.76a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.74.74,0,0,0,.43.61,2.31,2.31,0,0,0,2.11,0,.73.73,0,0,0,.44-.61h0v-3.83A1.49,1.49,0,0,0,95.75,114.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,115h0a1.51,1.51,0,0,0-.86-.27,1.49,1.49,0,0,0-1.49,1.49v3.83h0a.74.74,0,0,0,.43.61,2.31,2.31,0,0,0,2.11,0,1,1,0,0,0,.36-.34,1.35,1.35,0,0,1-1.25.15c-.61-.23-.78-.81-.78-1.62v-2.49C95.13,115.4,95.93,114.57,96.61,115Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54,118.42h0a.38.38,0,0,1-.38-.39v-2.12a.38.38,0,0,1,.38-.39h0a.38.38,0,0,1,.39.39V118A.38.38,0,0,1,96.54,118.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.54,
    cy: 119.27,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.21,122.4a1.94,1.94,0,0,0,.6.52,4.14,4.14,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.81,2.81,0,0,1-1.88-1,1.39,1.39,0,0,1,.47-1.85l-.15.08a1.37,1.37,0,0,0-.8,1.12v1.73a1.1,1.1,0,0,0,0,.18A1.14,1.14,0,0,0,93.21,122.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.78,129.84l-.46-.22c2.36,1.21,1.28,3-.17,3.72a8.71,8.71,0,0,1-5.21.12,6.79,6.79,0,0,0,5.84-.12,1.85,1.85,0,0,0,0-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,146.66c-2.07-1.18-2.07-3.1,0-4.28a8.3,8.3,0,0,1,7.49,0c2.07,1.18,2.08,3.1,0,4.28A8.3,8.3,0,0,1,100.7,146.66Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,131.83a3.66,3.66,0,0,0-.69-.33,1.2,1.2,0,0,1-.75-1.09v-2.32h-4.31v2.32a1.18,1.18,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10a2.54,2.54,0,0,0,1.48,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,108.39,131.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,131.83a3.66,3.66,0,0,0-.69-.33,1.2,1.2,0,0,1-.75-1.09v-2.32h-4.31v2.32a1.18,1.18,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10a2.54,2.54,0,0,0,1.48,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,108.39,131.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,146c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.11A8,8,0,0,1,101.21,146Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,146c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.11A8,8,0,0,1,101.21,146Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.08,136.82v6.74a2.14,2.14,0,0,1-1.25,1.75c-.16.09-.33.17-.5.25l-.09,0-.11,0a7.48,7.48,0,0,1-4.85-.07h0a3.19,3.19,0,0,1-.49-.24,2.13,2.13,0,0,1-1.26-1.75v-6.74a2.13,2.13,0,0,1,1.26-1.75,6.67,6.67,0,0,1,6.06,0A2.14,2.14,0,0,1,109.08,136.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.65,142.76l-.27.69a.63.63,0,0,1-1.16,0l-.26-.69a5.79,5.79,0,0,1-.42-2.18V127.4h2.52v13.18A6,6,0,0,1,105.65,142.76Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54,134.45v6.13a5.79,5.79,0,0,0,.42,2.18l.26.69a.63.63,0,0,0,1.16,0l.27-.69a6,6,0,0,0,.41-2.18v-6.13A7.61,7.61,0,0,0,103.54,134.45Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.36,143.66l.07.05.08,0,0,0,.11,0s-.22-.06-.28-.61-.21-1.89-.21-2.56v-6.28l-.64.08v6.13a5.79,5.79,0,0,0,.42,2.18l.26.69a1,1,0,0,0,.09.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.08,143.56a2.14,2.14,0,0,1-1.25,1.75c-.16.09-.33.17-.5.25l-.09,0-.11,0a6.92,6.92,0,0,1-4.85-.07h0a3.19,3.19,0,0,1-.49-.24,1.85,1.85,0,0,1,0-3.5,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,109.08,143.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.73,144v-5.53l.23-1.54-1.84-1.33a1.76,1.76,0,0,0-.61,1.26v6.74a2.13,2.13,0,0,0,1.26,1.75,3.19,3.19,0,0,0,.49.24h0a7.48,7.48,0,0,0,4.85.07l.11,0,.09,0,.14-.07C104.74,146.18,102.73,145,102.73,144Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.52,145.47l.31-.16a3.32,3.32,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49,145.81l.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,134.58c1.61.48,2.41,1.36,2.41,2.24s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.6-.48-2.41-1.35-2.41-2.23s.81-1.76,2.41-2.24A6.65,6.65,0,0,1,106.67,134.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,134.58c1.61.48,2.41,1.36,2.41,2.24s-.8,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.6-.48-2.41-1.35-2.41-2.23s.81-1.76,2.41-2.24A6.65,6.65,0,0,1,106.67,134.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,136.82v2.36a7.11,7.11,0,0,1-2.52,0v-2.29a.67.67,0,0,0,.37.44,1.93,1.93,0,0,0,1.78,0A.62.62,0,0,0,106.06,136.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91,137.33a.67.67,0,0,1-.37-.44v2.29c.21,0,.42.07.64.09v-1.82A1.69,1.69,0,0,1,103.91,137.33Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.06,134.45v2.37a.62.62,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.67.67,0,0,1-.37-.44v-2.44A7.61,7.61,0,0,1,106.06,134.45Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,141.19a5.63,5.63,0,0,0,.38,1.57l.26.69a.63.63,0,0,0,1.16,0l.27-.69a6,6,0,0,0,.37-1.57A7.14,7.14,0,0,0,103.58,141.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.35,143.89v-9.68a1.43,1.43,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13v-2.51h-1.27v2.32a1.18,1.18,0,0,1-.75,1.09,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10a2.54,2.54,0,0,0,1.48,2.08,8,8,0,0,0,5.28.69C102.35,146.91,101.35,145.16,101.35,143.89Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,131.83a3.66,3.66,0,0,0-.69-.33,1.2,1.2,0,0,1-.75-1.09v-2.32h-.47v2.77a1.31,1.31,0,0,0,.76,1c.41.22,1.7.78,2,1.39a9,9,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,5.7,5.7,0,0,0,1-.43,2.49,2.49,0,0,0,1.49-2.09v-10A2.52,2.52,0,0,0,108.39,131.83Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54,134.45v2.44a.67.67,0,0,0,.37.44,1.69,1.69,0,0,0,.27.12v-3.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,143.5c0,.09-.16.17-.35.17s-.35-.08-.35-.17.16-.17.35-.17S105.15,143.4,105.15,143.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.92,142.88a4.58,4.58,0,0,0,.11-1.37V127.4h-.23v14.16A3.54,3.54,0,0,0,104.92,142.88Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74,127.4h-.46v15.22h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.54,127.41v.68a1.38,1.38,0,0,1-.8,1.12,4.34,4.34,0,0,1-3.88,0,2.11,2.11,0,0,1-.6-.53,1,1,0,0,1-.2-.59v-.69a1.1,1.1,0,0,1,0-.18,1.5,1.5,0,0,1,.78-.94l0,0a4.32,4.32,0,0,1,3.84,0,1.5,1.5,0,0,1,.78.94A1.11,1.11,0,0,1,107.54,127.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,129v-1c0-.4.1-1-.6-1a1.94,1.94,0,0,1-1.53-.71l0,0a1.5,1.5,0,0,0-.78.94,1.1,1.1,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,2.11,2.11,0,0,0,.6.53,4.34,4.34,0,0,0,3.88,0C106,129.5,105,129.36,105,129Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,128.52a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,102.87,128.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,128.52a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,102.87,128.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.54,125.31V127a1.36,1.36,0,0,1,0,.2,1.48,1.48,0,0,1-.78.93,3.68,3.68,0,0,1-1.71.45,4.08,4.08,0,0,1-2.17-.45,2.08,2.08,0,0,1-.6-.52,1,1,0,0,1-.2-.6v-1.72a1.37,1.37,0,0,1,.8-1.12l.15-.08a4.31,4.31,0,0,1,3.73.08A1.38,1.38,0,0,1,107.54,125.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.8,120a1.5,1.5,0,0,0-1.49,1.5v3.83h0a.73.73,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,.74.74,0,0,0,.43-.61h0v-3.83A1.49,1.49,0,0,0,104.8,120Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.66,120.26h0a1.48,1.48,0,0,0-2.35,1.22v3.83h0a.73.73,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,1,1,0,0,0,.35-.34,1.38,1.38,0,0,1-1.25.15c-.61-.23-.78-.81-.78-1.62v-2.49C104.18,120.62,105,119.8,105.66,120.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,123.65h0a.39.39,0,0,1-.39-.39v-2.13a.39.39,0,0,1,.39-.39h0a.4.4,0,0,1,.39.39v2.13A.4.4,0,0,1,105.6,123.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,124.5a.4.4,0,0,1-.39.39.39.39,0,0,1-.39-.39.38.38,0,0,1,.39-.39A.39.39,0,0,1,106,124.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.26,127.63a2.08,2.08,0,0,0,.6.52,4.08,4.08,0,0,0,2.17.45V128c0-.4.11-.86-.6-1a2.85,2.85,0,0,1-1.89-1,1.39,1.39,0,0,1,.47-1.85l-.15.08a1.37,1.37,0,0,0-.8,1.12V127a1,1,0,0,0,.2.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.83,135.07l-.46-.23c2.37,1.22,1.29,3-.17,3.73a8.67,8.67,0,0,1-5.2.12,6.77,6.77,0,0,0,5.83-.12,2.15,2.15,0,0,0,1.25-1.75A2.12,2.12,0,0,0,107.83,135.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,146.66c-2.07-1.18-2.07-3.1,0-4.28a8.32,8.32,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.28A8.32,8.32,0,0,1,82.59,146.66Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,131.83a4.37,4.37,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.09v-2.32H84.54v2.32a1.2,1.2,0,0,1-.75,1.09,4,4,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,90.29,131.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,131.83a4.37,4.37,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.09v-2.32H84.54v2.32a1.2,1.2,0,0,1-.75,1.09,4,4,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,7.19,0,2.55,2.55,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,90.29,131.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,146c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.11A8,8,0,0,1,83.1,146Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,146c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.13,2,3,0,4.11A8,8,0,0,1,83.1,146Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,136.82v6.74a2.13,2.13,0,0,1-1.26,1.75,4.66,4.66,0,0,1-.5.25l-.09,0-.11,0a7.45,7.45,0,0,1-4.84-.07h0a4.44,4.44,0,0,1-.49-.24,2.14,2.14,0,0,1-1.25-1.75v-6.74a2.14,2.14,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.13,2.13,0,0,1,91,136.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.54,142.76l-.27.69a.62.62,0,0,1-1.15,0l-.27-.69a6,6,0,0,1-.41-2.18V127.4H88v13.18A6,6,0,0,1,87.54,142.76Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.44,134.45v6.13a6,6,0,0,0,.41,2.18l.27.69a.62.62,0,0,0,1.15,0l.27-.69a6,6,0,0,0,.41-2.18v-6.13A7.55,7.55,0,0,0,85.44,134.45Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.26,143.66a.18.18,0,0,0,.07.05l.08,0,0,0,.11,0s-.22-.06-.28-.61-.21-1.89-.21-2.56v-6.28l-.63.08v6.13a6,6,0,0,0,.41,2.18l.27.69a.38.38,0,0,0,.09.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,143.56a2.13,2.13,0,0,1-1.26,1.75,4.66,4.66,0,0,1-.5.25l-.09,0-.11,0a6.89,6.89,0,0,1-4.84-.07h0a4.44,4.44,0,0,1-.49-.24,1.85,1.85,0,0,1,0-3.5,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,91,143.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,144v-5.53l.24-1.54L83,135.56a1.74,1.74,0,0,0-.6,1.26v6.74a2.14,2.14,0,0,0,1.25,1.75,4.44,4.44,0,0,0,.49.24h0a7.45,7.45,0,0,0,4.84.07l.11,0,.09,0,.14-.07C86.64,146.18,84.62,145,84.62,144Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.41,145.47l.31-.16a2.87,2.87,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38,145.81l.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,134.58c1.6.48,2.41,1.36,2.41,2.24s-.81,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.35-2.41-2.23s.8-1.76,2.41-2.24A6.65,6.65,0,0,1,88.57,134.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,134.58c1.6.48,2.41,1.36,2.41,2.24s-.81,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.35-2.41-2.23s.8-1.76,2.41-2.24A6.65,6.65,0,0,1,88.57,134.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,136.82v2.36a7.06,7.06,0,0,1-2.51,0v-2.29a.68.68,0,0,0,.36.44,1.93,1.93,0,0,0,1.78,0A.62.62,0,0,0,88,136.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,137.33a.68.68,0,0,1-.36-.44v2.29l.63.09v-1.82A2.21,2.21,0,0,1,85.8,137.33Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,134.45v2.37a.62.62,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.68.68,0,0,1-.36-.44v-2.44A7.55,7.55,0,0,1,88,134.45Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.47,141.19a6,6,0,0,0,.38,1.57l.27.69a.62.62,0,0,0,1.15,0l.27-.69a6,6,0,0,0,.38-1.57A7.2,7.2,0,0,0,85.47,141.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.25,143.89v-9.68a1.42,1.42,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13v-2.51H84.54v2.32a1.2,1.2,0,0,1-.75,1.09,4,4,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.55,2.55,0,0,0,1.49,2.08,8,8,0,0,0,5.28.69C84.25,146.91,83.25,145.16,83.25,143.89Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,131.83a4.37,4.37,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.09v-2.32h-.47v2.77a1.31,1.31,0,0,0,.76,1c.4.22,1.69.78,2,1.39a9,9,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,5.81,5.81,0,0,0,1-.43,2.51,2.51,0,0,0,1.49-2.09v-10A2.52,2.52,0,0,0,90.29,131.83Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.44,134.45v2.44a.68.68,0,0,0,.36.44,2.21,2.21,0,0,0,.27.12v-3.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,143.5c0,.09-.15.17-.34.17s-.35-.08-.35-.17.15-.17.35-.17S87,143.4,87,143.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,142.88a4.23,4.23,0,0,0,.11-1.37V127.4H86.7v14.16A4,4,0,0,0,86.81,142.88Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.63,127.4h-.45v15.22h0a4.43,4.43,0,0,0,.45-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,127.41v.68a1.34,1.34,0,0,1-.8,1.12,4.32,4.32,0,0,1-3.87,0,1.87,1.87,0,0,1-.6-.53,1,1,0,0,1-.2-.59v-.69a.55.55,0,0,1,0-.18,1.5,1.5,0,0,1,.78-.94l0,0a4.3,4.3,0,0,1,3.83,0,1.46,1.46,0,0,1,.78.94A.58.58,0,0,1,89.43,127.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,129v-1c0-.4.1-1-.6-1a1.94,1.94,0,0,1-1.52-.71l0,0a1.5,1.5,0,0,0-.78.94.55.55,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,1.87,1.87,0,0,0,.6.53,4.32,4.32,0,0,0,3.87,0C87.88,129.5,86.92,129.36,86.92,129Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.76,128.52a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,84.76,128.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.76,128.52a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,84.76,128.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,125.31V127a.68.68,0,0,1,0,.2,1.45,1.45,0,0,1-.78.93,3.68,3.68,0,0,1-1.71.45,4,4,0,0,1-2.16-.45,1.85,1.85,0,0,1-.6-.52,1.05,1.05,0,0,1-.18-.41.62.62,0,0,1,0-.19v-1.72a1.34,1.34,0,0,1,.8-1.12l.14-.08a4.31,4.31,0,0,1,3.73.08A1.34,1.34,0,0,1,89.43,125.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,120a1.5,1.5,0,0,0-1.5,1.5v3.83h0a.75.75,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0v-3.83A1.5,1.5,0,0,0,86.7,120Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.55,120.26h0a1.47,1.47,0,0,0-.85-.28,1.5,1.5,0,0,0-1.5,1.5v3.83h0a.75.75,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,1,1,0,0,0,.36-.34,1.41,1.41,0,0,1-1.26.15c-.6-.23-.78-.81-.78-1.62v-2.49C86.07,120.62,86.88,119.8,87.55,120.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.49,123.65h0a.4.4,0,0,1-.39-.39v-2.13a.4.4,0,0,1,.39-.39h0a.39.39,0,0,1,.39.39v2.13A.39.39,0,0,1,87.49,123.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.49,
    cy: 124.5,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,127.63a1.85,1.85,0,0,0,.6.52,4,4,0,0,0,2.16.45V128c0-.4.12-.86-.6-1a2.85,2.85,0,0,1-1.88-1,1.38,1.38,0,0,1,.46-1.85l-.14.08a1.34,1.34,0,0,0-.8,1.12V127a.62.62,0,0,0,0,.19A1.05,1.05,0,0,0,84.16,127.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72,135.07a4.73,4.73,0,0,0-.45-.23c2.36,1.22,1.28,3-.18,3.73a8.67,8.67,0,0,1-5.2.12,6.76,6.76,0,0,0,5.83-.12A2.14,2.14,0,0,0,91,136.82,2.12,2.12,0,0,0,89.72,135.07Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.64,151.89c-2.07-1.18-2.07-3.1,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.19,2.07,3.11,0,4.29A8.39,8.39,0,0,1,91.64,151.89Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,137.05a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.32H93.59v2.32a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07v-10A2.55,2.55,0,0,0,99.34,137.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,137.05a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.32H93.59v2.32a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.07v-10A2.55,2.55,0,0,0,99.34,137.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,151.17c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.1A8,8,0,0,1,92.16,151.17Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,151.17c-2-1.13-2-3,0-4.1a8,8,0,0,1,7.18,0c2,1.13,2,3,0,4.1A8,8,0,0,1,92.16,151.17Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,142v6.75a2.14,2.14,0,0,1-1.26,1.75,3.71,3.71,0,0,1-.49.24l-.09,0-.11,0a7.58,7.58,0,0,1-2.33.36,7.16,7.16,0,0,1-2.52-.43h0a3.58,3.58,0,0,1-.48-.24,2.14,2.14,0,0,1-1.26-1.75V142a2.12,2.12,0,0,1,1.26-1.74,6.65,6.65,0,0,1,6,0A2.12,2.12,0,0,1,100,142Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.59,148l-.26.68a.62.62,0,0,1-1.16,0L94.9,148a6.08,6.08,0,0,1-.41-2.19V132.63H97V145.8A5.88,5.88,0,0,1,96.59,148Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,139.68v6.12A6.08,6.08,0,0,0,94.9,148l.27.68a.62.62,0,0,0,1.16,0l.26-.68A5.88,5.88,0,0,0,97,145.8v-6.12A7.11,7.11,0,0,0,94.49,139.68Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31,148.88l.07.06.08.05,0,0,.12,0s-.22-.07-.28-.61-.22-1.89-.22-2.56V139.6a4.52,4.52,0,0,0-.63.08v6.12A6.08,6.08,0,0,0,94.9,148l.27.68a.83.83,0,0,0,.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,148.79a2.14,2.14,0,0,1-1.26,1.75,3.71,3.71,0,0,1-.49.24l-.09,0-.11,0a7,7,0,0,1-4.85-.07h0a3.58,3.58,0,0,1-.48-.24,2.14,2.14,0,0,1-1.26-1.75A2.12,2.12,0,0,1,92.72,147a6.65,6.65,0,0,1,6,0A2.12,2.12,0,0,1,100,148.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.67,149.19v-5.53l.24-1.55-1.84-1.33a1.79,1.79,0,0,0-.61,1.26v6.75a2.14,2.14,0,0,0,1.26,1.75,3.58,3.58,0,0,0,.48.24h0a7.16,7.16,0,0,0,2.52.43,7.58,7.58,0,0,0,2.33-.36l.11,0,.09,0,.14-.06C95.69,151.4,93.67,150.21,93.67,149.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.46,150.7l.31-.16a3.47,3.47,0,0,0,.71-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.43,151l.51-.14v-9h-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,139.81c1.61.48,2.41,1.36,2.41,2.23s-.8,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.24s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,97.62,139.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,139.81c1.61.48,2.41,1.36,2.41,2.23s-.8,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.24s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,97.62,139.81Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,142v2.37a7.61,7.61,0,0,1-2.52,0v-2.3a.66.66,0,0,0,.37.45,2,2,0,0,0,1.78,0A.64.64,0,0,0,97,142Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,142.56a.66.66,0,0,1-.37-.45v2.3c.21,0,.42.06.63.08v-1.82Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,139.68V142a.64.64,0,0,1-.37.52,2,2,0,0,1-1.78,0,.66.66,0,0,1-.37-.45v-2.43A7.11,7.11,0,0,1,97,139.68Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.53,146.41A6.16,6.16,0,0,0,94.9,148l.27.68a.62.62,0,0,0,1.16,0l.26-.68a5.79,5.79,0,0,0,.38-1.58A7.68,7.68,0,0,0,94.53,146.41Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3,149.12v-9.69a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13v-2.51H93.59v2.32a1.17,1.17,0,0,1-.75,1.08,7.32,7.32,0,0,0-.69.33,2.55,2.55,0,0,0-1.49,2.08v10a2.52,2.52,0,0,0,1.49,2.07,7.87,7.87,0,0,0,5.28.69C93.3,152.14,92.3,150.39,92.3,149.12Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,137.05a7.32,7.32,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.32h-.47v2.77a1.3,1.3,0,0,0,.76,1c.4.22,1.69.78,2,1.4a9.3,9.3,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,6.1,6.1,0,0,0,1-.44,2.49,2.49,0,0,0,1.49-2.08v-10A2.55,2.55,0,0,0,99.34,137.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,139.68v2.43a.66.66,0,0,0,.37.45l.26.11V139.6C94.91,139.62,94.7,139.64,94.49,139.68Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1,148.72c0,.1-.16.18-.35.18s-.35-.08-.35-.18.16-.17.35-.17S96.1,148.63,96.1,148.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.87,148.1a4.43,4.43,0,0,0,.11-1.36V132.63h-.23v14.16A3.47,3.47,0,0,0,95.87,148.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,132.63h-.45v15.22h0a4.43,4.43,0,0,0,.45-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.49,132.63v.68a1.36,1.36,0,0,1-.81,1.12,4.26,4.26,0,0,1-3.87,0,1.83,1.83,0,0,1-.6-.52,1,1,0,0,1-.2-.59v-.69a1.37,1.37,0,0,1,0-.19,1.48,1.48,0,0,1,.78-.93l0,0a4.27,4.27,0,0,1,3.83,0,1.47,1.47,0,0,1,.79.93A1.37,1.37,0,0,1,98.49,132.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,134.21v-1c0-.4.1-1-.6-1a2,2,0,0,1-1.52-.7l0,0a1.48,1.48,0,0,0-.78.93,1.37,1.37,0,0,0,0,.19v.69a1,1,0,0,0,.2.59,1.83,1.83,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C96.93,134.73,96,134.59,96,134.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.75,
    cy: 132.63,
    rx: 2.74,
    ry: 1.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.75,
    cy: 132.63,
    rx: 2.74,
    ry: 1.58,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.49,130.54v1.71a1.23,1.23,0,0,1,0,.19,1.51,1.51,0,0,1-.79.94,3.9,3.9,0,0,1-1.71.45,4,4,0,0,1-2.16-.46,1.94,1.94,0,0,1-.6-.52,1.14,1.14,0,0,1-.18-.41,1.1,1.1,0,0,1,0-.18v-1.73a1.38,1.38,0,0,1,.8-1.12l.15-.07a4.29,4.29,0,0,1,3.72.07A1.38,1.38,0,0,1,98.49,130.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,125.21a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.74.74,0,0,0,.43.61,2.31,2.31,0,0,0,2.11,0,.73.73,0,0,0,.44-.61h0V126.7A1.49,1.49,0,0,0,95.75,125.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,125.48h0a1.51,1.51,0,0,0-.86-.27,1.49,1.49,0,0,0-1.49,1.49v3.83h0a.74.74,0,0,0,.43.61,2.31,2.31,0,0,0,2.11,0,.91.91,0,0,0,.36-.34,1.35,1.35,0,0,1-1.25.16c-.61-.24-.78-.82-.78-1.62v-2.5C95.13,125.85,95.93,125,96.61,125.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54,128.87h0a.38.38,0,0,1-.38-.39v-2.12a.38.38,0,0,1,.38-.39h0a.38.38,0,0,1,.39.39v2.12A.38.38,0,0,1,96.54,128.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.54,
    cy: 129.73,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.21,132.85a1.94,1.94,0,0,0,.6.52,4,4,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.81,2.81,0,0,1-1.88-1,1.37,1.37,0,0,1,.47-1.84l-.15.07a1.38,1.38,0,0,0-.8,1.12v1.73a1.1,1.1,0,0,0,0,.18A1.14,1.14,0,0,0,93.21,132.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.78,140.29l-.46-.22c2.36,1.21,1.28,3.05-.17,3.73a8.7,8.7,0,0,1-5.21.11,6.72,6.72,0,0,0,5.84-.12A2.12,2.12,0,0,0,100,142,2.15,2.15,0,0,0,98.78,140.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.54,151.89c-2.07-1.18-2.07-3.1,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.19,2.07,3.11,0,4.29A8.39,8.39,0,0,1,73.54,151.89Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.23,137.05a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08v-2.32H75.48v2.32a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33,2.53,2.53,0,0,0-1.49,2.08v10a2.5,2.5,0,0,0,1.49,2.07,7.9,7.9,0,0,0,7.18,0,2.5,2.5,0,0,0,1.49-2.07v-10A2.53,2.53,0,0,0,81.23,137.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.23,137.05a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08v-2.32H75.48v2.32a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33,2.53,2.53,0,0,0-1.49,2.08v10a2.5,2.5,0,0,0,1.49,2.07,7.9,7.9,0,0,0,7.18,0,2.5,2.5,0,0,0,1.49-2.07v-10A2.53,2.53,0,0,0,81.23,137.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.64,
    cy: 149.12,
    rx: 5.08,
    ry: 2.9,
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.64,
    cy: 149.12,
    rx: 5.08,
    ry: 2.9,
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.93,142v6.75a2.16,2.16,0,0,1-1.26,1.75,3.85,3.85,0,0,1-.5.24l-.09,0-.11,0a7.49,7.49,0,0,1-2.33.36,7.14,7.14,0,0,1-2.51-.43h0a4.44,4.44,0,0,1-.49-.24,2.13,2.13,0,0,1-1.25-1.75V142a2.1,2.1,0,0,1,1.25-1.74,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,81.93,142Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,148l-.27.68a.61.61,0,0,1-1.15,0L76.8,148a6.08,6.08,0,0,1-.41-2.19V132.63H78.9V145.8A6.08,6.08,0,0,1,78.49,148Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.39,139.68v6.12A6.08,6.08,0,0,0,76.8,148l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.08,6.08,0,0,0,.41-2.19v-6.12A7.06,7.06,0,0,0,76.39,139.68Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.21,148.88l.06.06.08.05.05,0,.11,0s-.22-.07-.28-.61-.21-1.89-.21-2.56V139.6a4.34,4.34,0,0,0-.63.08v6.12A6.08,6.08,0,0,0,76.8,148l.27.68a.51.51,0,0,0,.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.93,148.79a2.16,2.16,0,0,1-1.26,1.75,3.85,3.85,0,0,1-.5.24l-.09,0-.11,0a7,7,0,0,1-4.84-.07h0a4.44,4.44,0,0,1-.49-.24,2.13,2.13,0,0,1-1.25-1.75A2.1,2.1,0,0,1,74.61,147a6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,81.93,148.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.57,149.19v-5.53l.23-1.55L74,140.78a1.78,1.78,0,0,0-.6,1.26v6.75a2.13,2.13,0,0,0,1.25,1.75,4.44,4.44,0,0,0,.49.24h0a7.14,7.14,0,0,0,2.51.43,7.49,7.49,0,0,0,2.33-.36l.11,0,.09,0,.14-.06C77.58,151.4,75.57,150.21,75.57,149.19Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.36,150.7l.31-.16a3.68,3.68,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33,151l.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,139.81c1.6.48,2.41,1.36,2.41,2.23s-.81,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.24s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,79.52,139.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,139.81c1.6.48,2.41,1.36,2.41,2.23s-.81,1.76-2.41,2.24a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.24s.8-1.75,2.41-2.23A6.65,6.65,0,0,1,79.52,139.81Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,142v2.37a7.55,7.55,0,0,1-2.51,0v-2.3a.64.64,0,0,0,.36.45,2,2,0,0,0,1.78,0A.62.62,0,0,0,78.9,142Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.75,142.56a.64.64,0,0,1-.36-.45v2.3c.2,0,.42.06.63.08v-1.82A1.69,1.69,0,0,1,76.75,142.56Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,139.68V142a.62.62,0,0,1-.37.52,2,2,0,0,1-1.78,0,.64.64,0,0,1-.36-.45v-2.43A7.06,7.06,0,0,1,78.9,139.68Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.42,146.41A6.18,6.18,0,0,0,76.8,148l.27.68a.61.61,0,0,0,1.15,0l.27-.68a6.18,6.18,0,0,0,.38-1.58A7.74,7.74,0,0,0,76.42,146.41Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2,149.12v-9.69a1.41,1.41,0,0,1,.88-1.47c1.49-.76,1.68-1.37,1.68-2.13v-2.51H75.48v2.32a1.17,1.17,0,0,1-.75,1.08,6.13,6.13,0,0,0-.68.33,2.53,2.53,0,0,0-1.49,2.08v10a2.5,2.5,0,0,0,1.49,2.07,7.86,7.86,0,0,0,5.28.69C75.2,152.14,74.2,150.39,74.2,149.12Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.23,137.05a6.13,6.13,0,0,0-.68-.33,1.17,1.17,0,0,1-.75-1.08v-2.32h-.47v2.77a1.31,1.31,0,0,0,.75,1c.41.22,1.7.78,2,1.4a9,9,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,5.83,5.83,0,0,0,1-.44,2.47,2.47,0,0,0,1.48-2.08v-10A2.53,2.53,0,0,0,81.23,137.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.39,139.68v2.43a.64.64,0,0,0,.36.45,1.69,1.69,0,0,0,.27.11V139.6C76.81,139.62,76.59,139.64,76.39,139.68Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,148.72c0,.1-.15.18-.35.18s-.34-.08-.34-.18.15-.17.34-.17S78,148.63,78,148.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.76,148.1a4.43,4.43,0,0,0,.11-1.36V132.63h-.23v14.16A3.73,3.73,0,0,0,77.76,148.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.58,132.63h-.46v15.22h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38,132.63v.68a1.34,1.34,0,0,1-.8,1.12,4.26,4.26,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52,1,1,0,0,1-.2-.59v-.69a.65.65,0,0,1,0-.19,1.42,1.42,0,0,1,.78-.93l0,0a4.27,4.27,0,0,1,3.83,0,1.48,1.48,0,0,1,.78.93A.65.65,0,0,1,80.38,132.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,134.21v-1c0-.4.1-1-.6-1a1.93,1.93,0,0,1-1.52-.7l0,0a1.42,1.42,0,0,0-.78.93.65.65,0,0,0,0,.19v.69a1,1,0,0,0,.2.59,1.74,1.74,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C78.82,134.73,77.87,134.59,77.87,134.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,133.75a1.18,1.18,0,0,1,0-2.24,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.32,4.32,0,0,1,75.71,133.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,133.75a1.18,1.18,0,0,1,0-2.24,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.32,4.32,0,0,1,75.71,133.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38,130.54v1.71a.62.62,0,0,1,0,.19,1.52,1.52,0,0,1-.78.94,4.3,4.3,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52.88.88,0,0,1-.18-.41.55.55,0,0,1,0-.18v-1.73a1.36,1.36,0,0,1,.8-1.12l.14-.07a4.31,4.31,0,0,1,3.73.07A1.37,1.37,0,0,1,80.38,130.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,125.21a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0V126.7A1.5,1.5,0,0,0,77.64,125.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,125.48h0a1.49,1.49,0,0,0-2.35,1.22v3.83h0a.75.75,0,0,0,.44.61,2.31,2.31,0,0,0,2.11,0,.88.88,0,0,0,.35-.34,1.35,1.35,0,0,1-1.25.16c-.6-.24-.78-.82-.78-1.62v-2.5C77,125.85,77.83,125,78.5,125.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.44,128.87h0a.38.38,0,0,1-.39-.39v-2.12a.38.38,0,0,1,.39-.39h0a.39.39,0,0,1,.39.39v2.12A.39.39,0,0,1,78.44,128.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.44,
    cy: 129.73,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.11,132.85a1.74,1.74,0,0,0,.6.52,3.94,3.94,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.81,2.81,0,0,1-1.89-1,1.38,1.38,0,0,1,.47-1.84l-.14.07a1.36,1.36,0,0,0-.8,1.12v1.73a.55.55,0,0,0,0,.18A.88.88,0,0,0,75.11,132.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.67,140.29c-.14-.08-.3-.15-.45-.22,2.36,1.21,1.28,3.05-.18,3.73a8.67,8.67,0,0,1-5.2.11,6.7,6.7,0,0,0,5.83-.12A2.12,2.12,0,0,0,81.93,142,2.14,2.14,0,0,0,80.67,140.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,157.12c-2.07-1.19-2.07-3.11,0-4.29a8.39,8.39,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.29A8.39,8.39,0,0,1,82.59,157.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,142.28a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33H84.54v2.33a1.18,1.18,0,0,1-.75,1.08,4,4,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.52,2.52,0,0,0,1.49,2.08,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,90.29,142.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,142.28a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33H84.54v2.33a1.18,1.18,0,0,1-.75,1.08,4,4,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.52,2.52,0,0,0,1.49,2.08,7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,90.29,142.28Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,156.4c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.14,2,3,0,4.11A8,8,0,0,1,83.1,156.4Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,156.4c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.19,0c2,1.14,2,3,0,4.11A8,8,0,0,1,83.1,156.4Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,147.27V154a2.12,2.12,0,0,1-1.26,1.75,4.66,4.66,0,0,1-.5.25l-.09,0-.11,0a7.49,7.49,0,0,1-2.33.36,7.14,7.14,0,0,1-2.51-.43h0l-.49-.25A2.12,2.12,0,0,1,82.41,154v-6.74a2.15,2.15,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.14,2.14,0,0,1,91,147.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.54,153.22l-.27.68a.62.62,0,0,1-1.15,0l-.27-.68a6.08,6.08,0,0,1-.41-2.19V137.85H88V151A6.08,6.08,0,0,1,87.54,153.22Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.44,144.9V151a6.08,6.08,0,0,0,.41,2.19l.27.68a.62.62,0,0,0,1.15,0l.27-.68A6.08,6.08,0,0,0,88,151v-6.12A7.3,7.3,0,0,0,85.44,144.9Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.26,154.11l.07.06.08.05,0,0a.45.45,0,0,0,.11,0s-.22-.06-.28-.6-.21-1.9-.21-2.57v-6.28l-.63.08V151a6.08,6.08,0,0,0,.41,2.19l.27.68a.51.51,0,0,0,.09.16Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,154a2.12,2.12,0,0,1-1.26,1.75,4.66,4.66,0,0,1-.5.25l-.09,0-.11,0a7,7,0,0,1-4.84-.07h0l-.49-.25a1.85,1.85,0,0,1,0-3.5,6.74,6.74,0,0,1,6.06,0A2.13,2.13,0,0,1,91,154Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,154.41v-5.52l.24-1.55L83,146a1.76,1.76,0,0,0-.6,1.26V154a2.12,2.12,0,0,0,1.25,1.75l.49.25h0a7.14,7.14,0,0,0,2.51.43,7.49,7.49,0,0,0,2.33-.36l.11,0,.09,0,.14-.07C86.64,156.63,84.62,155.44,84.62,154.41Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.41,155.92l.31-.16a2.65,2.65,0,0,0,.7-.54v-8.59h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38,156.26l.5-.13v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,145c1.6.48,2.41,1.35,2.41,2.23s-.81,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.61-.47-2.41-1.35-2.41-2.23s.8-1.75,2.41-2.23A6.47,6.47,0,0,1,88.57,145Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,145c1.6.48,2.41,1.35,2.41,2.23s-.81,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.61-.47-2.41-1.35-2.41-2.23s.8-1.75,2.41-2.23A6.47,6.47,0,0,1,88.57,145Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,147.27v2.36a7.3,7.3,0,0,1-2.51,0v-2.3a.68.68,0,0,0,.36.44,1.93,1.93,0,0,0,1.78,0A.61.61,0,0,0,88,147.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,147.78a.68.68,0,0,1-.36-.44v2.3l.63.08V147.9A1.31,1.31,0,0,1,85.8,147.78Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,144.91v2.36a.61.61,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.68.68,0,0,1-.36-.44V144.9A7.3,7.3,0,0,1,88,144.91Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.47,151.64a6.18,6.18,0,0,0,.38,1.58l.27.68a.62.62,0,0,0,1.15,0l.27-.68a6.18,6.18,0,0,0,.38-1.58A7.2,7.2,0,0,0,85.47,151.64Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.25,154.35v-9.69a1.43,1.43,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13v-2.51H84.54v2.33a1.18,1.18,0,0,1-.75,1.08,4,4,0,0,0-.69.33,2.52,2.52,0,0,0-1.49,2.07v10a2.54,2.54,0,0,0,1.49,2.08,8,8,0,0,0,5.28.69C84.25,157.36,83.25,155.61,83.25,154.35Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,142.28a4.37,4.37,0,0,0-.69-.33,1.17,1.17,0,0,1-.75-1.08v-2.33h-.47v2.77a1.3,1.3,0,0,0,.76,1c.4.22,1.69.78,2,1.39a9.09,9.09,0,0,1,.2,3.12v7a3.17,3.17,0,0,1-2,3,5.81,5.81,0,0,0,1-.43,2.5,2.5,0,0,0,1.49-2.09v-10A2.52,2.52,0,0,0,90.29,142.28Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.44,144.9v2.44a.68.68,0,0,0,.36.44,1.31,1.31,0,0,0,.27.12v-3.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,154c0,.1-.15.17-.34.17s-.35-.07-.35-.17.15-.17.35-.17S87,153.86,87,154Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,153.33a4.14,4.14,0,0,0,.11-1.36V137.85H86.7V152A3.89,3.89,0,0,0,86.81,153.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.63,137.85h-.45v15.22h0a4.43,4.43,0,0,0,.45-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,137.86v.68a1.34,1.34,0,0,1-.8,1.12,4.26,4.26,0,0,1-3.87,0,1.74,1.74,0,0,1-.6-.52,1,1,0,0,1-.2-.6v-.69a.55.55,0,0,1,0-.18,1.48,1.48,0,0,1,.78-.93l0,0a4.3,4.3,0,0,1,3.83,0,1.45,1.45,0,0,1,.78.93A.62.62,0,0,1,89.43,137.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,139.43v-1c0-.4.1-1-.6-1a1.94,1.94,0,0,1-1.52-.71l0,0a1.48,1.48,0,0,0-.78.93.55.55,0,0,0,0,.18v.69a1,1,0,0,0,.2.6,1.74,1.74,0,0,0,.6.52,4.26,4.26,0,0,0,3.87,0C87.88,140,86.92,139.81,86.92,139.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.76,139a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,84.76,139Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.76,139a1.18,1.18,0,0,1,0-2.23,4.26,4.26,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.23A4.26,4.26,0,0,1,84.76,139Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,135.77v1.71a.65.65,0,0,1,0,.19,1.45,1.45,0,0,1-.78.93,3.81,3.81,0,0,1-1.71.46,4.14,4.14,0,0,1-2.16-.46,1.85,1.85,0,0,1-.6-.52,1,1,0,0,1-.18-.41.55.55,0,0,1,0-.18v-1.73a1.34,1.34,0,0,1,.8-1.12l.14-.08a4.31,4.31,0,0,1,3.73.08A1.34,1.34,0,0,1,89.43,135.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,130.44a1.5,1.5,0,0,0-1.5,1.49v3.83h0a.75.75,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,.75.75,0,0,0,.44-.61h0v-3.83A1.49,1.49,0,0,0,86.7,130.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.55,130.71h0a1.46,1.46,0,0,0-.85-.27,1.5,1.5,0,0,0-1.5,1.49v3.83h0a.75.75,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,1,1,0,0,0,.36-.34,1.38,1.38,0,0,1-1.26.15c-.6-.23-.78-.81-.78-1.62v-2.49C86.07,131.08,86.88,130.25,87.55,130.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.49,134.1h0a.39.39,0,0,1-.39-.39v-2.12a.39.39,0,0,1,.39-.39h0a.38.38,0,0,1,.39.39v2.12A.38.38,0,0,1,87.49,134.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.49,
    cy: 134.95,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,138.08a1.85,1.85,0,0,0,.6.52,4.14,4.14,0,0,0,2.16.46v-.63c0-.4.12-.87-.6-1a2.81,2.81,0,0,1-1.88-1,1.38,1.38,0,0,1,.46-1.85l-.14.08a1.34,1.34,0,0,0-.8,1.12v1.73a.55.55,0,0,0,0,.18A1,1,0,0,0,84.16,138.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72,145.52a4.71,4.71,0,0,0-.45-.22c2.36,1.21,1.28,3-.18,3.72a8.67,8.67,0,0,1-5.2.12,6.76,6.76,0,0,0,5.83-.12,1.85,1.85,0,0,0,0-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.49,157.12c-2.08-1.19-2.08-3.11,0-4.29a8.37,8.37,0,0,1,7.49,0c2.07,1.18,2.07,3.1,0,4.29A8.37,8.37,0,0,1,64.49,157.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,142.28a3.66,3.66,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.08v-2.33H66.43v2.33a1.17,1.17,0,0,1-.75,1.08,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10A2.51,2.51,0,0,0,65,156.39a7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,72.18,142.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,142.28a3.66,3.66,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.08v-2.33H66.43v2.33a1.17,1.17,0,0,1-.75,1.08,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10A2.51,2.51,0,0,0,65,156.39a7.92,7.92,0,0,0,7.19,0,2.52,2.52,0,0,0,1.49-2.08v-10A2.52,2.52,0,0,0,72.18,142.28Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,156.4c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.14,2,3,0,4.11A8,8,0,0,1,65,156.4Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,156.4c-2-1.14-2-3,0-4.11a8,8,0,0,1,7.18,0c2,1.14,2,3,0,4.11A8,8,0,0,1,65,156.4Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.87,147.27V154a2.12,2.12,0,0,1-1.25,1.75l-.5.25-.09,0-.11,0a7.54,7.54,0,0,1-2.33.36,7.2,7.2,0,0,1-2.52-.43s0,0,0,0a5.39,5.39,0,0,1-.48-.25A2.12,2.12,0,0,1,64.3,154v-6.74a2.14,2.14,0,0,1,1.26-1.75,6.67,6.67,0,0,1,6.06,0A2.15,2.15,0,0,1,72.87,147.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.44,153.22l-.27.68a.63.63,0,0,1-1.16,0l-.26-.68a5.88,5.88,0,0,1-.42-2.19V137.85h2.52V151A6.08,6.08,0,0,1,69.44,153.22Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,144.9V151a5.88,5.88,0,0,0,.42,2.19l.26.68a.63.63,0,0,0,1.16,0l.27-.68a6.08,6.08,0,0,0,.41-2.19v-6.12A7.35,7.35,0,0,0,67.33,144.9Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.15,154.11l.07.06.08.05,0,0a.35.35,0,0,0,.11,0s-.22-.06-.28-.6-.21-1.9-.21-2.57v-6.28l-.64.08V151a5.88,5.88,0,0,0,.42,2.19l.26.68.09.16A.12.12,0,0,1,68.15,154.11Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.87,154a2.12,2.12,0,0,1-1.25,1.75l-.5.25-.09,0-.11,0a7,7,0,0,1-4.85-.07s0,0,0,0a5.39,5.39,0,0,1-.48-.25,1.85,1.85,0,0,1,0-3.5,6.74,6.74,0,0,1,6.06,0A2.14,2.14,0,0,1,72.87,154Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.52,154.41v-5.52l.23-1.55L64.91,146a1.77,1.77,0,0,0-.61,1.26V154a2.12,2.12,0,0,0,1.26,1.75A5.39,5.39,0,0,0,66,156s0,0,0,0a7.2,7.2,0,0,0,2.52.43,7.54,7.54,0,0,0,2.33-.36l.11,0,.09,0,.14-.07C68.53,156.63,66.52,155.44,66.52,154.41Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,155.92l.31-.16a3,3,0,0,0,.7-.54v-8.59h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.27,156.26l.51-.13v-9h-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.46,145c1.61.48,2.41,1.35,2.41,2.23s-.8,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.6-.47-2.41-1.35-2.41-2.23s.81-1.75,2.41-2.23A6.47,6.47,0,0,1,70.46,145Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.46,145c1.61.48,2.41,1.35,2.41,2.23s-.8,1.76-2.41,2.23a6.47,6.47,0,0,1-3.75,0c-1.6-.47-2.41-1.35-2.41-2.23s.81-1.75,2.41-2.23A6.47,6.47,0,0,1,70.46,145Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.85,147.27v2.36a7.35,7.35,0,0,1-2.52,0v-2.3a.67.67,0,0,0,.37.44,1.93,1.93,0,0,0,1.78,0A.61.61,0,0,0,69.85,147.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,147.78a.67.67,0,0,1-.37-.44v2.3l.64.08V147.9A1.11,1.11,0,0,1,67.7,147.78Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.85,144.91v2.36a.61.61,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.67.67,0,0,1-.37-.44V144.9A7.35,7.35,0,0,1,69.85,144.91Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.37,151.64a5.79,5.79,0,0,0,.38,1.58l.26.68a.63.63,0,0,0,1.16,0l.27-.68a6.16,6.16,0,0,0,.37-1.58A7.14,7.14,0,0,0,67.37,151.64Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.14,154.35v-9.69a1.44,1.44,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13v-2.51H66.43v2.33a1.17,1.17,0,0,1-.75,1.08,4.37,4.37,0,0,0-.69.33,2.51,2.51,0,0,0-1.48,2.07v10A2.52,2.52,0,0,0,65,156.39a8,8,0,0,0,5.28.69C66.14,157.36,65.14,155.61,65.14,154.35Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,142.28a3.66,3.66,0,0,0-.69-.33,1.18,1.18,0,0,1-.75-1.08v-2.33h-.47v2.77a1.3,1.3,0,0,0,.76,1c.41.22,1.7.78,2,1.39a9.09,9.09,0,0,1,.2,3.12v7a3.17,3.17,0,0,1-2,3,5.7,5.7,0,0,0,1-.43,2.48,2.48,0,0,0,1.49-2.09v-10A2.52,2.52,0,0,0,72.18,142.28Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,144.9v2.44a.67.67,0,0,0,.37.44,1.11,1.11,0,0,0,.27.12v-3.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.94,154c0,.1-.16.17-.35.17s-.35-.07-.35-.17.16-.17.35-.17S68.94,153.86,68.94,154Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,153.33a4.49,4.49,0,0,0,.11-1.36V137.85h-.23V152A3.47,3.47,0,0,0,68.71,153.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.53,137.85h-.46v15.22h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.33,137.86v.68a1.38,1.38,0,0,1-.8,1.12,4.28,4.28,0,0,1-3.88,0,1.94,1.94,0,0,1-.6-.52,1.05,1.05,0,0,1-.2-.6v-.69a1.1,1.1,0,0,1,0-.18,1.48,1.48,0,0,1,.78-.93l0,0a4.32,4.32,0,0,1,3.84,0,1.48,1.48,0,0,1,.78.93A1.23,1.23,0,0,1,71.33,137.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.81,139.43v-1c0-.4.11-1-.59-1a1.94,1.94,0,0,1-1.53-.71l0,0a1.48,1.48,0,0,0-.78.93,1.1,1.1,0,0,0,0,.18v.69a1.05,1.05,0,0,0,.2.6,1.94,1.94,0,0,0,.6.52,4.28,4.28,0,0,0,3.88,0C69.77,140,68.81,139.81,68.81,139.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.65,139a1.18,1.18,0,0,1,0-2.23,4.28,4.28,0,0,1,3.88,0,1.18,1.18,0,0,1,0,2.23A4.28,4.28,0,0,1,66.65,139Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.65,139a1.18,1.18,0,0,1,0-2.23,4.28,4.28,0,0,1,3.88,0,1.18,1.18,0,0,1,0,2.23A4.28,4.28,0,0,1,66.65,139Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.33,135.77v1.71a1.37,1.37,0,0,1,0,.19,1.48,1.48,0,0,1-.78.93,3.82,3.82,0,0,1-1.72.46,4.16,4.16,0,0,1-2.16-.46,2.08,2.08,0,0,1-.6-.52,1.14,1.14,0,0,1-.18-.41,1.1,1.1,0,0,1,0-.18v-1.73a1.37,1.37,0,0,1,.8-1.12l.15-.08a4.31,4.31,0,0,1,3.73.08A1.38,1.38,0,0,1,71.33,135.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.59,130.44a1.49,1.49,0,0,0-1.49,1.49v3.83h0a.73.73,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0,.74.74,0,0,0,.43-.61h0v-3.83A1.49,1.49,0,0,0,68.59,130.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,130.71h0a1.49,1.49,0,0,0-2.35,1.22v3.83h0a.73.73,0,0,0,.44.61,2.37,2.37,0,0,0,2.11,0A1,1,0,0,0,70,136a1.35,1.35,0,0,1-1.25.15c-.61-.23-.78-.81-.78-1.62v-2.49C68,131.08,68.77,130.25,69.45,130.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.39,134.1h0a.38.38,0,0,1-.39-.39v-2.12a.38.38,0,0,1,.39-.39h0a.39.39,0,0,1,.39.39v2.12A.39.39,0,0,1,69.39,134.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.78,135a.39.39,0,0,1-.39.39A.38.38,0,0,1,69,135a.39.39,0,0,1,.39-.39A.4.4,0,0,1,69.78,135Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.05,138.08a2.08,2.08,0,0,0,.6.52,4.16,4.16,0,0,0,2.16.46v-.63c0-.4.12-.87-.59-1a2.81,2.81,0,0,1-1.89-1,1.39,1.39,0,0,1,.47-1.85l-.15.08a1.37,1.37,0,0,0-.8,1.12v1.73a1.1,1.1,0,0,0,0,.18A1.14,1.14,0,0,0,66.05,138.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.62,145.52l-.46-.22c2.37,1.21,1.28,3-.17,3.72a8.67,8.67,0,0,1-5.2.12,6.77,6.77,0,0,0,5.83-.12,1.85,1.85,0,0,0,0-3.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.54,162.34c-2.07-1.18-2.07-3.1,0-4.28a8.32,8.32,0,0,1,7.5,0c2.07,1.18,2.07,3.1,0,4.28A8.32,8.32,0,0,1,73.54,162.34Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.23,147.51a4.79,4.79,0,0,0-.68-.34,1.16,1.16,0,0,1-.75-1.08v-2.32H75.48v2.32a1.16,1.16,0,0,1-.75,1.08,4.79,4.79,0,0,0-.68.34,2.5,2.5,0,0,0-1.49,2.07v10a2.53,2.53,0,0,0,1.49,2.08,8,8,0,0,0,7.18,0,2.53,2.53,0,0,0,1.49-2.08v-10A2.5,2.5,0,0,0,81.23,147.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.23,147.51a4.79,4.79,0,0,0-.68-.34,1.16,1.16,0,0,1-.75-1.08v-2.32H75.48v2.32a1.16,1.16,0,0,1-.75,1.08,4.79,4.79,0,0,0-.68.34,2.5,2.5,0,0,0-1.49,2.07v10a2.53,2.53,0,0,0,1.49,2.08,8,8,0,0,0,7.18,0,2.53,2.53,0,0,0,1.49-2.08v-10A2.5,2.5,0,0,0,81.23,147.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.64,
    cy: 159.57,
    rx: 5.08,
    ry: 2.9,
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.64,
    cy: 159.57,
    rx: 5.08,
    ry: 2.9,
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.93,152.5v6.74A2.16,2.16,0,0,1,80.67,161c-.16.09-.32.17-.5.25l-.09,0-.11,0a7.45,7.45,0,0,1-4.84-.07h0a4.44,4.44,0,0,1-.49-.24,2.13,2.13,0,0,1-1.25-1.75V152.5a2.1,2.1,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,81.93,152.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,158.44l-.27.69a.62.62,0,0,1-1.15,0l-.27-.69a6,6,0,0,1-.41-2.18V143.08H78.9v13.18A6,6,0,0,1,78.49,158.44Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.39,150.13v6.13a6,6,0,0,0,.41,2.18l.27.69a.62.62,0,0,0,1.15,0l.27-.69a6,6,0,0,0,.41-2.18v-6.13A7.55,7.55,0,0,0,76.39,150.13Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.21,159.33l.06.06.08.05.05,0,.11,0s-.22-.06-.28-.61S77,157,77,156.33v-6.28c-.21,0-.43,0-.63.08v6.13a6,6,0,0,0,.41,2.18l.27.69a.38.38,0,0,0,.09.15Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.93,159.24A2.16,2.16,0,0,1,80.67,161c-.16.09-.32.17-.5.25l-.09,0-.11,0a7,7,0,0,1-4.84-.07h0a4.44,4.44,0,0,1-.49-.24,2.13,2.13,0,0,1-1.25-1.75,2.1,2.1,0,0,1,1.25-1.75,6.67,6.67,0,0,1,6.06,0A2.12,2.12,0,0,1,81.93,159.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.57,159.64v-5.53l.23-1.54L74,151.24a1.74,1.74,0,0,0-.6,1.26v6.74A2.13,2.13,0,0,0,74.61,161a4.44,4.44,0,0,0,.49.24h0a7.45,7.45,0,0,0,4.84.07l.11,0,.09,0,.14-.07C77.58,161.86,75.57,160.67,75.57,159.64Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.36,161.15l.31-.16a3.68,3.68,0,0,0,.7-.54v-8.6h-1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33,161.49l.5-.14v-9h-.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,150.26c1.6.48,2.41,1.36,2.41,2.24s-.81,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.23s.8-1.76,2.41-2.24A6.65,6.65,0,0,1,79.52,150.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,150.26c1.6.48,2.41,1.36,2.41,2.24s-.81,1.75-2.41,2.23a6.65,6.65,0,0,1-3.75,0c-1.61-.48-2.41-1.36-2.41-2.23s.8-1.76,2.41-2.24A6.65,6.65,0,0,1,79.52,150.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,152.5v2.36a7.06,7.06,0,0,1-2.51,0v-2.29a.65.65,0,0,0,.36.44,1.93,1.93,0,0,0,1.78,0A.62.62,0,0,0,78.9,152.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.75,153a.65.65,0,0,1-.36-.44v2.29a4.34,4.34,0,0,0,.63.08v-1.81A1.69,1.69,0,0,1,76.75,153Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,150.13v2.37a.62.62,0,0,1-.37.51,1.93,1.93,0,0,1-1.78,0,.65.65,0,0,1-.36-.44v-2.44A7.55,7.55,0,0,1,78.9,150.13Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.42,156.87a6,6,0,0,0,.38,1.57l.27.69a.62.62,0,0,0,1.15,0l.27-.69a6,6,0,0,0,.38-1.57A7.2,7.2,0,0,0,76.42,156.87Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2,159.57v-9.68a1.42,1.42,0,0,1,.88-1.48c1.49-.75,1.68-1.36,1.68-2.13v-2.51H75.48v2.32a1.16,1.16,0,0,1-.75,1.08,4.79,4.79,0,0,0-.68.34,2.5,2.5,0,0,0-1.49,2.07v10a2.53,2.53,0,0,0,1.49,2.08,8,8,0,0,0,5.28.69C75.2,162.59,74.2,160.84,74.2,159.57Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.23,147.51a4.79,4.79,0,0,0-.68-.34,1.16,1.16,0,0,1-.75-1.08v-2.32h-.47v2.77a1.32,1.32,0,0,0,.75,1c.41.22,1.7.78,2,1.39a9,9,0,0,1,.2,3.12v7a3.19,3.19,0,0,1-2,3,5.13,5.13,0,0,0,1-.44,2.47,2.47,0,0,0,1.48-2.08v-10A2.5,2.5,0,0,0,81.23,147.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.39,150.13v2.44a.65.65,0,0,0,.36.44,1.69,1.69,0,0,0,.27.12v-3.08Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.64,
    cy: 159.18,
    rx: 0.35,
    ry: 0.17,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.76,158.56a4.58,4.58,0,0,0,.11-1.37V143.08h-.23v14.16A3.81,3.81,0,0,0,77.76,158.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.58,143.08h-.46V158.3h0a4.44,4.44,0,0,0,.46-2Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38,143.09v.67a1.36,1.36,0,0,1-.8,1.13,4.32,4.32,0,0,1-3.87,0,1.87,1.87,0,0,1-.6-.53,1,1,0,0,1-.2-.59v-.69a.55.55,0,0,1,0-.18,1.41,1.41,0,0,1,.78-.94l0,0a4.3,4.3,0,0,1,3.83,0,1.47,1.47,0,0,1,.78.94A.58.58,0,0,1,80.38,143.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,144.66v-1c0-.4.1-1-.6-1a1.91,1.91,0,0,1-1.52-.71l0,0a1.41,1.41,0,0,0-.78.94.55.55,0,0,0,0,.18v.69a1,1,0,0,0,.2.59,1.87,1.87,0,0,0,.6.53,4.32,4.32,0,0,0,3.87,0C78.82,145.18,77.87,145,77.87,144.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,144.2a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,75.71,144.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,144.2a1.18,1.18,0,0,1,0-2.24,4.32,4.32,0,0,1,3.87,0,1.18,1.18,0,0,1,0,2.24A4.26,4.26,0,0,1,75.71,144.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38,141v1.71a.68.68,0,0,1,0,.2,1.48,1.48,0,0,1-.78.93,3.81,3.81,0,0,1-1.71.45,4,4,0,0,1-2.16-.45,1.76,1.76,0,0,1-.6-.53.85.85,0,0,1-.18-.4.62.62,0,0,1,0-.19V141a1.34,1.34,0,0,1,.8-1.12l.14-.08a4.31,4.31,0,0,1,3.73.08A1.34,1.34,0,0,1,80.38,141Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,135.66a1.5,1.5,0,0,0-1.49,1.5V141h0a.73.73,0,0,0,.44.6,2.31,2.31,0,0,0,2.11,0,.73.73,0,0,0,.44-.6h0v-3.83A1.5,1.5,0,0,0,77.64,135.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,135.94h0a1.48,1.48,0,0,0-2.35,1.22V141h0a.73.73,0,0,0,.44.6,2.31,2.31,0,0,0,2.11,0,.86.86,0,0,0,.35-.33,1.38,1.38,0,0,1-1.25.15c-.6-.23-.78-.82-.78-1.62V137.3C77,136.3,77.83,135.47,78.5,135.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.44,139.33h0a.39.39,0,0,1-.39-.39v-2.13a.39.39,0,0,1,.39-.39h0a.4.4,0,0,1,.39.39v2.13A.4.4,0,0,1,78.44,139.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.44,
    cy: 140.18,
    r: 0.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.11,143.3a1.76,1.76,0,0,0,.6.53,4,4,0,0,0,2.16.45v-.63c0-.4.12-.86-.6-1a2.82,2.82,0,0,1-1.89-1,1.39,1.39,0,0,1,.47-1.84l-.14.08a1.34,1.34,0,0,0-.8,1.12v1.72a.62.62,0,0,0,0,.19A.85.85,0,0,0,75.11,143.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.67,150.75a3.81,3.81,0,0,0-.45-.23c2.36,1.21,1.28,3-.18,3.73a8.67,8.67,0,0,1-5.2.12,6.77,6.77,0,0,0,5.83-.12,2.14,2.14,0,0,0,1.26-1.75A2.12,2.12,0,0,0,80.67,150.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 75.05 141.38 56.47 39.46 115.31 39.46 121.4 71.64 139.98 173.57 81.14 173.57 75.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 75.05 173.57 81.14 71.64 139.98 71.64 133.89 173.57 75.05",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.64 133.89 39.46 115.31 39.46 121.4 71.64 139.98 71.64 133.89",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,74.5a7.61,7.61,0,0,1,6.68,0c1.85,1,1.85,2.71,0,3.74a7.54,7.54,0,0,1-6.68,0C153.44,77.21,153.44,75.54,155.29,74.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,56.19l.05,0a4.4,4.4,0,0,0,.74-4.58,13.86,13.86,0,0,1-.58-1.61c-.25-1.05,0-2.86-1.51-2.86s-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.86.86,0,0,1-.61.84,4.22,4.22,0,0,0-1,.41A1.86,1.86,0,0,0,155,59.56l-.81,16.21c0,.93.86,1.87,2.58,2.38a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.38l-.81-16.22A1.86,1.86,0,0,0,161.43,58a4.22,4.22,0,0,0-1-.41.87.87,0,0,1-.62-.84h0A.87.87,0,0,1,160.06,56.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,56.19l.05,0a4.4,4.4,0,0,0,.74-4.58,13.86,13.86,0,0,1-.58-1.61c-.25-1.05,0-2.86-1.51-2.86s-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.86.86,0,0,1-.61.84,4.22,4.22,0,0,0-1,.41A1.86,1.86,0,0,0,155,59.56l-.81,16.21c0,.93.86,1.87,2.58,2.38a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.38l-.81-16.22A1.86,1.86,0,0,0,161.43,58a4.22,4.22,0,0,0-1-.41.87.87,0,0,1-.62-.84h0A.87.87,0,0,1,160.06,56.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,73.89a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.75a7.18,7.18,0,0,1-6.48,0C153.74,76.6,153.74,74.93,155.52,73.89Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,78.36a7.21,7.21,0,0,0,.92-.21c1.72-.51,2.58-1.45,2.58-2.38l-.81-16.22A1.86,1.86,0,0,0,161.43,58a4.22,4.22,0,0,0-1-.41.87.87,0,0,1-.62-.84,1.19,1.19,0,0,0,.65,1.29c.59.38,1.56.33,1.71,2.38s.7,13.91.7,14.89S162.61,77.49,159.85,78.36Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.55,75.78,162,63.92h0a1.62,1.62,0,0,0-.94-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.94,1.3h0L155,75.78a.87.87,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.14,2.14,0,0,0,1-1.17A.87.87,0,0,0,162.55,75.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,74.18a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C154.63,76.41,154.63,75,156.1,74.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.91,76.91l-.69-14.16-.17-.12-.72.07.72,14.75.38-.19A2.71,2.71,0,0,0,161.91,76.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,62.85l-.46-.09.53,15a6.17,6.17,0,0,0,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.17,75.81c.07-1.38.08-7.14.28-11.18l-.13-2.35a3.46,3.46,0,0,0-.81.34,1.58,1.58,0,0,0-.94,1.3h0L155,75.78a.87.87,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C159.16,77.86,157.1,77.19,157.17,75.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,62.62a5,5,0,0,1,4.51,0c1.25.72,1.25,1.88,0,2.6a5,5,0,0,1-4.51,0C155.26,64.5,155.26,63.34,156.51,62.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,62.62a5,5,0,0,1,4.51,0c1.25.72,1.25,1.88,0,2.6a5,5,0,0,1-4.51,0C155.26,64.5,155.26,63.34,156.51,62.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.41,72.63a7.56,7.56,0,0,0,3.38-.73,2.16,2.16,0,0,0,1.28-1.75l-.28-5.39a2,2,0,0,1-1.19,1.63,7.15,7.15,0,0,1-3.19.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.76,72.85a6.17,6.17,0,0,0,3.05-.73,2.12,2.12,0,0,0,1.27-1.76l-.27-5.4a2,2,0,0,1-1.19,1.65,5.78,5.78,0,0,1-2.85.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93,75.37c0-.91.53-13.52.67-15s.69-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.51,3.51,0,0,1-1-3.62,18.14,18.14,0,0,0,.81-3.33c.14-1.57.55-2,1.12-1.86a1.23,1.23,0,0,0-.57-.12c-1.47,0-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7.84.84,0,0,1,.22.58.86.86,0,0,1-.61.84,4.22,4.22,0,0,0-1,.41A1.86,1.86,0,0,0,155,59.56l-.81,16.21c0,.93.86,1.87,2.58,2.38a7,7,0,0,0,4,0,5.54,5.54,0,0,0,.69-.25C157.24,79.05,155.93,76.29,155.93,75.37Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59,51.86c-.16-.38-.4-.74-.53-1.13a6.5,6.5,0,0,1-.23-1.59c0-.17-.05-.58-.23-.68s-.29.06-.33.21a7.49,7.49,0,0,0-.16,2.06,6.61,6.61,0,0,0,.57,1.69,6.62,6.62,0,0,1,.14,1.93.76.76,0,0,0,.05.27.24.24,0,0,0,.22.14.35.35,0,0,0,.19-.13,1.72,1.72,0,0,0,.36-.49,2.84,2.84,0,0,0,.16-1.63A3.79,3.79,0,0,0,160.59,51.86Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,65.22c1.25-.72,1.25-1.88,0-2.6a3.85,3.85,0,0,0-.8-.34c2.71,1,1.16,3.32-1.46,3.26-2.29-.06-3.06-1.15-3.1-1.2a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,161,65.22Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.24,69.28a7.54,7.54,0,0,1,6.68,0c1.84,1,1.84,2.7,0,3.74a7.61,7.61,0,0,1-6.68,0C144.39,72,144.39,70.31,146.24,69.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,51l0-.05a4.38,4.38,0,0,0,.75-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a12.81,12.81,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7h0a.9.9,0,0,1,.22.59h0a.86.86,0,0,1-.62.83,4.63,4.63,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c1.71-.52,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.89.89,0,0,1,151,51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,51l0-.05a4.38,4.38,0,0,0,.75-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a12.81,12.81,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7h0a.9.9,0,0,1,.22.59h0a.86.86,0,0,1-.62.83,4.63,4.63,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c1.71-.52,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.89.89,0,0,1,151,51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,68.67a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C144.68,71.38,144.68,69.7,146.47,68.67Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,73.13a7.18,7.18,0,0,0,.92-.2c1.71-.52,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.62-.83,1.17,1.17,0,0,0,.65,1.28c.59.39,1.55.33,1.7,2.38s.71,13.91.71,14.89S153.56,72.26,150.8,73.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,70.55l-.6-11.86h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.94,1.31h0l-.59,11.85a.82.82,0,0,0,.07.31A2.1,2.1,0,0,0,147.05,72a5.89,5.89,0,0,0,5.33,0,2.08,2.08,0,0,0,1-1.17A.84.84,0,0,0,153.5,70.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,69a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C145.57,71.18,145.57,69.8,147.05,69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86,71.69l-.69-14.17a1.08,1.08,0,0,0-.18-.11l-.71.06L152,72.22l.38-.19A3.69,3.69,0,0,0,152.86,71.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,57.63l-.46-.09.53,15a4.74,4.74,0,0,0,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.12,70.58c.07-1.37.08-7.14.28-11.18l-.13-2.35a3.72,3.72,0,0,0-.81.34,1.58,1.58,0,0,0-.94,1.31h0l-.59,11.85a.82.82,0,0,0,.07.31A2.1,2.1,0,0,0,147.05,72a5.89,5.89,0,0,0,5.33,0C150.1,72.63,148.05,72,148.12,70.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,57.39a5,5,0,0,1,4.51,0A1.38,1.38,0,0,1,152,60a5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,147.46,57.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,57.39a5,5,0,0,1,4.51,0A1.38,1.38,0,0,1,152,60a5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,147.46,57.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.36,67.4a7.52,7.52,0,0,0,3.37-.73A2.11,2.11,0,0,0,154,64.93l-.27-5.39a2,2,0,0,1-1.2,1.62,7.14,7.14,0,0,1-3.18.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.71,67.63a6.28,6.28,0,0,0,3-.73A2.16,2.16,0,0,0,154,65.14l-.27-5.41a2,2,0,0,1-1.18,1.66,5.9,5.9,0,0,1-2.86.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87,70.15c0-.92.53-13.53.68-15s.68-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.48,3.48,0,0,1-1-3.61,20.17,20.17,0,0,0,.81-3.33c.14-1.57.55-2,1.12-1.87a1.37,1.37,0,0,0-.57-.12c-1.48,0-1.22,1.79-1.5,2.87a12.81,12.81,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7.9.9,0,0,1,.22.59.86.86,0,0,1-.62.83,4.63,4.63,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c.25-.08.47-.16.69-.25C148.19,73.82,146.88,71.06,146.87,70.15Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.54,46.64A11.79,11.79,0,0,1,151,45.5a6.49,6.49,0,0,1-.23-1.58c0-.18-.06-.59-.23-.68s-.3,0-.33.2a7.15,7.15,0,0,0-.16,2.06,6.48,6.48,0,0,0,.57,1.69,6.69,6.69,0,0,1,.14,1.94.65.65,0,0,0,0,.27.23.23,0,0,0,.22.13.36.36,0,0,0,.18-.12,1.59,1.59,0,0,0,.36-.5,2.81,2.81,0,0,0,.17-1.62A4.92,4.92,0,0,0,151.54,46.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,60a1.38,1.38,0,0,0,0-2.61,3.85,3.85,0,0,0-.8-.34c2.7,1,1.16,3.33-1.46,3.26-2.29-.05-3.07-1.15-3.1-1.2a1.89,1.89,0,0,0,.85.89A5,5,0,0,0,152,60Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.24,79.73a7.61,7.61,0,0,1,6.68,0c1.84,1,1.84,2.71,0,3.74a7.61,7.61,0,0,1-6.68,0C144.39,82.44,144.39,80.76,146.24,79.73Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,61.42l0-.06a4.37,4.37,0,0,0,.75-4.57,12.76,12.76,0,0,1-.58-1.61c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.88a14.23,14.23,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.69h0a.92.92,0,0,1,.22.59h0a.88.88,0,0,1-.62.84,4.13,4.13,0,0,0-1,.4,1.88,1.88,0,0,0-1.11,1.54L145.13,81c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.88,1.88,0,0,0-1.1-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84h0A.87.87,0,0,1,151,61.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,61.42l0-.06a4.37,4.37,0,0,0,.75-4.57,12.76,12.76,0,0,1-.58-1.61c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.88a14.23,14.23,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.69h0a.92.92,0,0,1,.22.59h0a.88.88,0,0,1-.62.84,4.13,4.13,0,0,0-1,.4,1.88,1.88,0,0,0-1.11,1.54L145.13,81c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.88,1.88,0,0,0-1.1-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84h0A.87.87,0,0,1,151,61.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,79.12a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C144.68,81.83,144.68,80.15,146.47,79.12Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,83.58a7.18,7.18,0,0,0,.92-.2c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.88,1.88,0,0,0-1.1-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84c0,.67.05.9.65,1.28s1.55.33,1.7,2.38.71,13.92.71,14.89S153.56,82.71,150.8,83.58Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,81l-.6-11.87h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.59,1.59,0,0,0-.94,1.31h0L145.93,81a.82.82,0,0,0,.07.3,2.1,2.1,0,0,0,1.05,1.17,5.89,5.89,0,0,0,5.33,0,2.16,2.16,0,0,0,1.05-1.16A1.25,1.25,0,0,0,153.5,81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,79.4a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C145.57,81.63,145.57,80.25,147.05,79.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86,82.14,152.17,68l-.18-.11-.71.07L152,82.67l.38-.19A2.93,2.93,0,0,0,152.86,82.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,68.08l-.46-.09.53,15a4.74,4.74,0,0,0,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.12,81c.07-1.38.08-7.14.28-11.18l-.13-2.36a3.72,3.72,0,0,0-.81.34,1.59,1.59,0,0,0-.94,1.31h0L145.93,81a.82.82,0,0,0,.07.3,2.1,2.1,0,0,0,1.05,1.17,5.89,5.89,0,0,0,5.33,0C150.1,83.09,148.05,82.41,148.12,81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,67.84a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,147.46,67.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,67.84a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,147.46,67.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.36,77.86a7.65,7.65,0,0,0,3.37-.73A2.14,2.14,0,0,0,154,75.38L153.74,70a2,2,0,0,1-1.2,1.63,7.24,7.24,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.71,78.08a6.17,6.17,0,0,0,3-.73A2.14,2.14,0,0,0,154,75.59l-.27-5.41a2,2,0,0,1-1.18,1.66,5.9,5.9,0,0,1-2.86.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87,80.6c0-.92.54-13.53.68-15s.68-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.51,3.51,0,0,1-1-3.62,19.94,19.94,0,0,0,.81-3.33c.14-1.57.55-2,1.12-1.86a1.23,1.23,0,0,0-.57-.13c-1.48,0-1.22,1.79-1.5,2.88a14.23,14.23,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.69.92.92,0,0,1,.22.59.88.88,0,0,1-.62.84,4.13,4.13,0,0,0-1,.4,1.88,1.88,0,0,0-1.11,1.54L145.13,81c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c.25-.08.47-.16.69-.25C148.19,84.27,146.88,81.51,146.87,80.6Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.54,57.09c-.16-.38-.41-.74-.53-1.13a6.64,6.64,0,0,1-.23-1.59c0-.17-.06-.58-.23-.68s-.3.06-.33.2a7.15,7.15,0,0,0-.16,2.06,6.55,6.55,0,0,0,.57,1.7,6.62,6.62,0,0,1,.14,1.93.62.62,0,0,0,0,.27A.24.24,0,0,0,151,60a.32.32,0,0,0,.18-.13,1.55,1.55,0,0,0,.36-.49,2.85,2.85,0,0,0,.17-1.63A4.92,4.92,0,0,0,151.54,57.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,70.45a1.38,1.38,0,0,0,0-2.61,3.36,3.36,0,0,0-.8-.33c2.7,1,1.16,3.32-1.46,3.25-2.29-.05-3.07-1.15-3.1-1.19a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,152,70.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,74.5a7.63,7.63,0,0,1,6.69,0c1.84,1,1.84,2.71,0,3.74a7.56,7.56,0,0,1-6.69,0C135.34,77.21,135.34,75.54,137.18,74.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,56.19l.05,0a4.43,4.43,0,0,0,.75-4.58,12.23,12.23,0,0,1-.58-1.61c-.25-1.05,0-2.86-1.51-2.86s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.87.87,0,0,1-.62.84,4.22,4.22,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.93.86,1.87,2.57,2.38a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.38l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.42,4.42,0,0,0-1-.41.87.87,0,0,1-.62-.84h0A.92.92,0,0,1,142,56.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,56.19l.05,0a4.43,4.43,0,0,0,.75-4.58,12.23,12.23,0,0,1-.58-1.61c-.25-1.05,0-2.86-1.51-2.86s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.87.87,0,0,1-.62.84,4.22,4.22,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.93.86,1.87,2.57,2.38a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.38l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.42,4.42,0,0,0-1-.41.87.87,0,0,1-.62-.84h0A.92.92,0,0,1,142,56.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.42,73.89a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.75a7.18,7.18,0,0,1-6.48,0C135.63,76.6,135.63,74.93,137.42,73.89Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,78.36a7.06,7.06,0,0,0,.91-.21c1.72-.51,2.58-1.45,2.58-2.38l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.42,4.42,0,0,0-1-.41.87.87,0,0,1-.62-.84,1.18,1.18,0,0,0,.64,1.29c.6.38,1.56.33,1.71,2.38s.71,13.91.71,14.89S144.5,77.49,141.75,78.36Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.44,75.78l-.59-11.86h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.52,0,1.58,1.58,0,0,0-.93,1.3h0l-.59,11.86a.7.7,0,0,0,.07.31,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0,2.12,2.12,0,0,0,1-1.17A.7.7,0,0,0,144.44,75.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,74.18a5.91,5.91,0,0,1,5.34,0c1.47.85,1.47,2.23,0,3.08a5.91,5.91,0,0,1-5.34,0C136.52,76.41,136.52,75,138,74.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81,76.91l-.69-14.16-.18-.12-.72.07.72,14.75.39-.19A3.72,3.72,0,0,0,143.81,76.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,62.85l-.45-.09.53,15a6,6,0,0,0,.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.07,75.81c.07-1.38.08-7.14.28-11.18l-.14-2.35a3.65,3.65,0,0,0-.81.34,1.58,1.58,0,0,0-.93,1.3h0l-.59,11.86a.7.7,0,0,0,.07.31,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0C141.05,77.86,139,77.19,139.07,75.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,62.62a5,5,0,0,1,4.52,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.52,0A1.37,1.37,0,0,1,138.4,62.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,62.62a5,5,0,0,1,4.52,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.52,0A1.37,1.37,0,0,1,138.4,62.62Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,72.63a7.52,7.52,0,0,0,3.37-.73A2.16,2.16,0,0,0,145,70.15l-.27-5.39a2,2,0,0,1-1.2,1.63,7.14,7.14,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66,72.85a6.2,6.2,0,0,0,3.05-.73A2.13,2.13,0,0,0,145,70.36L144.7,65a2,2,0,0,1-1.18,1.65,5.82,5.82,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,75.37c0-.91.53-13.52.68-15s.68-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.49,3.49,0,0,1-1-3.62,19.94,19.94,0,0,0,.81-3.33c.14-1.57.54-2,1.11-1.86a1.16,1.16,0,0,0-.56-.12c-1.48,0-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7.89.89,0,0,1,.22.58.87.87,0,0,1-.62.84,4.22,4.22,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.93.86,1.87,2.57,2.38a7,7,0,0,0,4,0,5.54,5.54,0,0,0,.69-.25C139.14,79.05,137.83,76.29,137.82,75.37Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48,51.86c-.15-.38-.4-.74-.52-1.13a7,7,0,0,1-.24-1.59c0-.17-.05-.58-.23-.68s-.29.06-.32.21a6.79,6.79,0,0,0-.16,2.06,7,7,0,0,0,.56,1.69,6.63,6.63,0,0,1,.15,1.93.59.59,0,0,0,.05.27.23.23,0,0,0,.21.14.31.31,0,0,0,.19-.13,1.72,1.72,0,0,0,.36-.49,2.84,2.84,0,0,0,.16-1.63A3.08,3.08,0,0,0,142.48,51.86Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.92,65.22a1.37,1.37,0,0,0,0-2.6,4.37,4.37,0,0,0-.8-.34c2.7,1,1.16,3.32-1.46,3.26-2.29-.06-3.07-1.15-3.1-1.2a1.89,1.89,0,0,0,.84.88A5,5,0,0,0,142.92,65.22Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,85a7.56,7.56,0,0,1,6.69,0c1.84,1,1.84,2.7,0,3.74a7.63,7.63,0,0,1-6.69,0C135.34,87.66,135.34,86,137.18,85Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,66.64l.05,0a4.43,4.43,0,0,0,.75-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.9.9,0,0,1,.22.59h0a.86.86,0,0,1-.62.83,4.71,4.71,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.16,7.16,0,0,0,4,0c1.72-.52,2.58-1.45,2.58-2.39L144.43,70a1.87,1.87,0,0,0-1.1-1.54,5,5,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.94.94,0,0,1,142,66.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,66.64l.05,0a4.43,4.43,0,0,0,.75-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.9.9,0,0,1,.22.59h0a.86.86,0,0,1-.62.83,4.71,4.71,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.16,7.16,0,0,0,4,0c1.72-.52,2.58-1.45,2.58-2.39L144.43,70a1.87,1.87,0,0,0-1.1-1.54,5,5,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.94.94,0,0,1,142,66.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.42,84.35a7.12,7.12,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C135.63,87.06,135.63,85.38,137.42,84.35Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,88.81a9.21,9.21,0,0,0,.91-.2c1.72-.52,2.58-1.45,2.58-2.39L144.43,70a1.87,1.87,0,0,0-1.1-1.54,5,5,0,0,0-1-.41.86.86,0,0,1-.62-.83,1.17,1.17,0,0,0,.64,1.28c.6.39,1.56.33,1.71,2.38s.71,13.91.71,14.89S144.5,87.94,141.75,88.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.44,86.23l-.59-11.86h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.52,0,1.58,1.58,0,0,0-.93,1.31h0l-.59,11.85a.67.67,0,0,0,.07.31,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0,2.12,2.12,0,0,0,1-1.17A.67.67,0,0,0,144.44,86.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,84.63a5.91,5.91,0,0,1,5.34,0c1.47.85,1.47,2.23,0,3.08a5.91,5.91,0,0,1-5.34,0C136.52,86.86,136.52,85.48,138,84.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.81,87.36l-.69-14.16-.18-.11-.72.06.72,14.75.39-.19A3,3,0,0,0,143.81,87.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,73.3l-.45-.08.53,15a4.28,4.28,0,0,0,.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.07,86.26c.07-1.37.08-7.14.28-11.18l-.14-2.35a4.19,4.19,0,0,0-.81.34,1.58,1.58,0,0,0-.93,1.31h0l-.59,11.85a.67.67,0,0,0,.07.31,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0C141.05,88.31,139,87.64,139.07,86.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,73.07a5,5,0,0,1,4.52,0,1.38,1.38,0,0,1,0,2.61,5.06,5.06,0,0,1-4.52,0A1.38,1.38,0,0,1,138.4,73.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,73.07a5,5,0,0,1,4.52,0,1.38,1.38,0,0,1,0,2.61,5.06,5.06,0,0,1-4.52,0A1.38,1.38,0,0,1,138.4,73.07Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,83.08a7.52,7.52,0,0,0,3.37-.73A2.15,2.15,0,0,0,145,80.61l-.27-5.39a2,2,0,0,1-1.2,1.62,7.14,7.14,0,0,1-3.18.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66,83.31a6.31,6.31,0,0,0,3.05-.73A2.16,2.16,0,0,0,145,80.81l-.27-5.4a2,2,0,0,1-1.18,1.65,5.82,5.82,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,85.83c0-.92.53-13.53.68-15s.68-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.48,3.48,0,0,1-1-3.61,20,20,0,0,0,.81-3.34c.14-1.56.54-2,1.11-1.86a1.29,1.29,0,0,0-.56-.12c-1.48,0-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7.9.9,0,0,1,.22.59.86.86,0,0,1-.62.83,4.71,4.71,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.16,7.16,0,0,0,4,0c.25-.08.48-.16.69-.25C139.14,89.5,137.83,86.74,137.82,85.83Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48,62.32c-.15-.38-.4-.74-.52-1.14a7,7,0,0,1-.24-1.58c0-.18-.05-.59-.23-.68s-.29,0-.32.2a6.81,6.81,0,0,0-.16,2.06,6.85,6.85,0,0,0,.56,1.69,6.67,6.67,0,0,1,.15,1.94.65.65,0,0,0,.05.27.22.22,0,0,0,.21.13.35.35,0,0,0,.19-.12,1.77,1.77,0,0,0,.36-.5,2.81,2.81,0,0,0,.16-1.62A3.08,3.08,0,0,0,142.48,62.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.92,75.68a1.38,1.38,0,0,0,0-2.61,4.37,4.37,0,0,0-.8-.34c2.7,1,1.16,3.33-1.46,3.26-2.29-.06-3.07-1.15-3.1-1.2a1.91,1.91,0,0,0,.84.89A5.06,5.06,0,0,0,142.92,75.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.13,79.73a7.61,7.61,0,0,1,6.68,0c1.85,1,1.85,2.71,0,3.74a7.61,7.61,0,0,1-6.68,0C126.29,82.44,126.29,80.76,128.13,79.73Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,61.42l0-.06a4.38,4.38,0,0,0,.74-4.57,12.61,12.61,0,0,1-.57-1.61c-.26-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.51,2.88a14,14,0,0,1-.56,1.53,4.39,4.39,0,0,0,.76,4.69h0a.88.88,0,0,1,.23.59h0a.88.88,0,0,1-.62.84,4.2,4.2,0,0,0-1,.4,1.86,1.86,0,0,0-1.1,1.54L127,81c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.61-.84h0A.86.86,0,0,1,132.9,61.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,61.42l0-.06a4.38,4.38,0,0,0,.74-4.57,12.61,12.61,0,0,1-.57-1.61c-.26-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.51,2.88a14,14,0,0,1-.56,1.53,4.39,4.39,0,0,0,.76,4.69h0a.88.88,0,0,1,.23.59h0a.88.88,0,0,1-.62.84,4.2,4.2,0,0,0-1,.4,1.86,1.86,0,0,0-1.1,1.54L127,81c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.61-.84h0A.86.86,0,0,1,132.9,61.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,79.12a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.12,7.12,0,0,1-6.48,0C126.58,81.83,126.58,80.15,128.37,79.12Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7,83.58a7.41,7.41,0,0,0,.91-.2c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.61-.84c0,.67.05.9.64,1.28s1.56.33,1.71,2.38.7,13.92.7,14.89S135.45,82.71,132.7,83.58Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.39,81l-.59-11.87h0a1.58,1.58,0,0,0-.94-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.93,1.31h0L127.82,81a1.09,1.09,0,0,0,.07.3,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.12,2.12,0,0,0,1-1.16A.92.92,0,0,0,135.39,81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.94,79.4a5.89,5.89,0,0,1,5.33,0c1.48.85,1.48,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C127.47,81.63,127.47,80.25,128.94,79.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.76,82.14,134.07,68l-.18-.11-.72.07.72,14.74a2.69,2.69,0,0,0,.38-.19A2.64,2.64,0,0,0,134.76,82.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.69,68.08l-.45-.09.53,15a4.61,4.61,0,0,0,.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,81c.06-1.38.08-7.14.28-11.18l-.14-2.36a3.94,3.94,0,0,0-.81.34,1.58,1.58,0,0,0-.93,1.31h0L127.82,81a1.09,1.09,0,0,0,.07.3,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C132,83.09,130,82.41,130,81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.35,67.84a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,129.35,67.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.35,67.84a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,129.35,67.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.26,77.86a7.65,7.65,0,0,0,3.37-.73,2.16,2.16,0,0,0,1.28-1.75L135.64,70a2,2,0,0,1-1.2,1.63,7.27,7.27,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,78.08a6.23,6.23,0,0,0,3-.73,2.14,2.14,0,0,0,1.26-1.76l-.27-5.41a2,2,0,0,1-1.19,1.66,5.86,5.86,0,0,1-2.85.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77,80.6c0-.92.53-13.53.68-15s.68-1.81,1.65-2.56a1.12,1.12,0,0,0,.15-1.79,3.52,3.52,0,0,1-1-3.62,19.94,19.94,0,0,0,.81-3.33c.14-1.57.54-2,1.11-1.86a1.19,1.19,0,0,0-.56-.13c-1.48,0-1.22,1.79-1.51,2.88a14,14,0,0,1-.56,1.53,4.39,4.39,0,0,0,.76,4.69.88.88,0,0,1-.39,1.43,4.2,4.2,0,0,0-1,.4,1.86,1.86,0,0,0-1.1,1.54L127,81c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0,5.54,5.54,0,0,0,.69-.25C130.08,84.27,128.78,81.51,128.77,80.6Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.43,57.09c-.16-.38-.4-.74-.53-1.13a7.18,7.18,0,0,1-.23-1.59c0-.17,0-.58-.23-.68s-.29.06-.33.21A7.42,7.42,0,0,0,132,56a7.39,7.39,0,0,0,.57,1.7,6.62,6.62,0,0,1,.14,1.93.81.81,0,0,0,.05.27.24.24,0,0,0,.22.14.31.31,0,0,0,.19-.13,1.72,1.72,0,0,0,.36-.49,2.85,2.85,0,0,0,.16-1.63A3.79,3.79,0,0,0,133.43,57.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,70.45a1.38,1.38,0,0,0,0-2.61,3.36,3.36,0,0,0-.8-.33c2.71,1,1.17,3.32-1.45,3.25-2.3-.05-3.07-1.15-3.11-1.19a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,133.86,70.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.13,90.18a7.61,7.61,0,0,1,6.68,0c1.85,1,1.85,2.71,0,3.74a7.54,7.54,0,0,1-6.68,0C126.29,92.89,126.29,91.22,128.13,90.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,71.87l0-.05a4.4,4.4,0,0,0,.74-4.58,12.09,12.09,0,0,1-.57-1.61c-.26-1,0-2.86-1.51-2.86s-1.22,1.79-1.51,2.87a13.3,13.3,0,0,1-.56,1.53,4.4,4.4,0,0,0,.76,4.7h0a.85.85,0,0,1,.23.58h0a.87.87,0,0,1-.62.84,4.22,4.22,0,0,0-1,.41,1.85,1.85,0,0,0-1.1,1.53L127,91.44c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.86,1.86,0,0,0-1.11-1.53,4.34,4.34,0,0,0-1-.41.87.87,0,0,1-.62-.84h0A.86.86,0,0,1,132.9,71.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,71.87l0-.05a4.4,4.4,0,0,0,.74-4.58,12.09,12.09,0,0,1-.57-1.61c-.26-1,0-2.86-1.51-2.86s-1.22,1.79-1.51,2.87a13.3,13.3,0,0,1-.56,1.53,4.4,4.4,0,0,0,.76,4.7h0a.85.85,0,0,1,.23.58h0a.87.87,0,0,1-.62.84,4.22,4.22,0,0,0-1,.41,1.85,1.85,0,0,0-1.1,1.53L127,91.44c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.86,1.86,0,0,0-1.11-1.53,4.34,4.34,0,0,0-1-.41.87.87,0,0,1-.62-.84h0A.86.86,0,0,1,132.9,71.87Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,89.57a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.75a7.18,7.18,0,0,1-6.48,0C126.58,92.28,126.58,90.61,128.37,89.57Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7,94a7.47,7.47,0,0,0,.91-.21c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.86,1.86,0,0,0-1.11-1.53,4.34,4.34,0,0,0-1-.41.87.87,0,0,1-.62-.84,1.18,1.18,0,0,0,.64,1.29c.59.38,1.56.33,1.71,2.38s.7,13.91.7,14.89S135.45,93.17,132.7,94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.39,91.46,134.8,79.6h0a1.58,1.58,0,0,0-.94-1.3,5,5,0,0,0-4.51,0,1.56,1.56,0,0,0-.93,1.3h0l-.6,11.86a1.16,1.16,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.1,2.1,0,0,0,1-1.17A.87.87,0,0,0,135.39,91.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.94,89.86a5.89,5.89,0,0,1,5.33,0c1.48.85,1.48,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C127.47,92.09,127.47,90.71,128.94,89.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.76,92.59l-.69-14.16-.18-.12-.72.07.72,14.75c.13-.06.26-.12.38-.19A3.25,3.25,0,0,0,134.76,92.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.69,78.53l-.45-.09.53,15c.22,0,.43-.1.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,91.49c.06-1.38.08-7.14.28-11.18L130.16,78a3.46,3.46,0,0,0-.81.34,1.56,1.56,0,0,0-.93,1.3h0l-.6,11.86a1.16,1.16,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C132,93.54,130,92.87,130,91.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.35,78.3a5,5,0,0,1,4.51,0c1.25.72,1.25,1.88,0,2.6a5,5,0,0,1-4.51,0C128.1,80.18,128.1,79,129.35,78.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.35,78.3a5,5,0,0,1,4.51,0c1.25.72,1.25,1.88,0,2.6a5,5,0,0,1-4.51,0C128.1,80.18,128.1,79,129.35,78.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.26,88.31a7.52,7.52,0,0,0,3.37-.73,2.16,2.16,0,0,0,1.28-1.75l-.27-5.39a2,2,0,0,1-1.2,1.63,7.14,7.14,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,88.53a6.23,6.23,0,0,0,3-.73A2.13,2.13,0,0,0,135.92,86l-.27-5.4a2,2,0,0,1-1.19,1.65,5.75,5.75,0,0,1-2.85.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77,91.05c0-.91.53-13.52.68-15s.68-1.81,1.65-2.56a1.12,1.12,0,0,0,.15-1.79,3.51,3.51,0,0,1-1-3.62,19.94,19.94,0,0,0,.81-3.33c.14-1.57.54-2,1.11-1.86a1.19,1.19,0,0,0-.56-.12c-1.48,0-1.22,1.79-1.51,2.87a13.3,13.3,0,0,1-.56,1.53,4.4,4.4,0,0,0,.76,4.7.85.85,0,0,1,.23.58.87.87,0,0,1-.62.84,4.22,4.22,0,0,0-1,.41,1.85,1.85,0,0,0-1.1,1.53L127,91.44c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0,5.54,5.54,0,0,0,.69-.25C130.08,94.73,128.78,92,128.77,91.05Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.43,67.54c-.16-.38-.4-.74-.53-1.13a7,7,0,0,1-.23-1.59c0-.17,0-.58-.23-.68s-.29.06-.33.21a7.49,7.49,0,0,0-.16,2.06,7.48,7.48,0,0,0,.57,1.69,6.62,6.62,0,0,1,.14,1.93.76.76,0,0,0,.05.27.24.24,0,0,0,.22.14.31.31,0,0,0,.19-.13,1.72,1.72,0,0,0,.36-.49,2.84,2.84,0,0,0,.16-1.63A3.79,3.79,0,0,0,133.43,67.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86,80.9c1.25-.72,1.25-1.88,0-2.6a3.85,3.85,0,0,0-.8-.34c2.71,1,1.17,3.32-1.45,3.26-2.3-.06-3.07-1.15-3.11-1.2a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,133.86,80.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,85a7.54,7.54,0,0,1,6.68,0c1.85,1,1.85,2.7,0,3.74a7.61,7.61,0,0,1-6.68,0C117.23,87.66,117.23,86,119.08,85Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,66.64l.05,0a4.4,4.4,0,0,0,.74-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.21,1.79-1.5,2.87a11.29,11.29,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7h0a.9.9,0,0,1,.22.59h0a.85.85,0,0,1-.61.83,4.71,4.71,0,0,0-1,.41A1.86,1.86,0,0,0,118.78,70L118,86.22c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c1.72-.52,2.58-1.45,2.58-2.39L126.33,70a1.86,1.86,0,0,0-1.11-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.89.89,0,0,1,123.85,66.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,66.64l.05,0a4.4,4.4,0,0,0,.74-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.21,1.79-1.5,2.87a11.29,11.29,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7h0a.9.9,0,0,1,.22.59h0a.85.85,0,0,1-.61.83,4.71,4.71,0,0,0-1,.41A1.86,1.86,0,0,0,118.78,70L118,86.22c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c1.72-.52,2.58-1.45,2.58-2.39L126.33,70a1.86,1.86,0,0,0-1.11-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.89.89,0,0,1,123.85,66.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,84.35a7.12,7.12,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C117.53,87.06,117.53,85.38,119.31,84.35Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,88.81a7.18,7.18,0,0,0,.92-.2c1.72-.52,2.58-1.45,2.58-2.39L126.33,70a1.86,1.86,0,0,0-1.11-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.62-.83,1.18,1.18,0,0,0,.65,1.28c.59.39,1.56.33,1.71,2.38s.7,13.91.7,14.89S126.4,87.94,123.64,88.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.34,86.23l-.6-11.86h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.94,1.31h0l-.59,11.85a.82.82,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.14,2.14,0,0,0,1-1.17A.82.82,0,0,0,126.34,86.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.89,84.63a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C118.41,86.86,118.41,85.48,119.89,84.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,87.36,125,73.2l-.17-.11-.72.06.72,14.75c.13-.06.26-.12.38-.19A2.29,2.29,0,0,0,125.7,87.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,73.3l-.46-.08.53,15a4.74,4.74,0,0,0,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,86.26c.07-1.37.08-7.14.28-11.18l-.13-2.35a3.94,3.94,0,0,0-.81.34,1.58,1.58,0,0,0-.94,1.31h0l-.59,11.85a.82.82,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C123,88.31,120.89,87.64,121,86.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3,73.07a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,120.3,73.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3,73.07a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,120.3,73.07Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,83.08a7.56,7.56,0,0,0,3.38-.73,2.15,2.15,0,0,0,1.28-1.74l-.28-5.39a2,2,0,0,1-1.19,1.62,7.15,7.15,0,0,1-3.19.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55,83.31a6.28,6.28,0,0,0,3-.73,2.17,2.17,0,0,0,1.27-1.77l-.27-5.4a2,2,0,0,1-1.19,1.65,5.79,5.79,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,85.83c0-.92.53-13.53.67-15s.69-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.5,3.5,0,0,1-1-3.61,18.23,18.23,0,0,0,.81-3.34c.14-1.56.55-2,1.12-1.86a1.37,1.37,0,0,0-.57-.12c-1.47,0-1.21,1.79-1.5,2.87a11.29,11.29,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7.9.9,0,0,1,.22.59.85.85,0,0,1-.61.83,4.71,4.71,0,0,0-1,.41A1.86,1.86,0,0,0,118.78,70L118,86.22c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c.25-.08.48-.16.69-.25C121,89.5,119.72,86.74,119.72,85.83Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,62.32c-.16-.38-.4-.74-.53-1.14a6.49,6.49,0,0,1-.23-1.58c0-.18-.05-.59-.23-.68s-.3,0-.33.2a7.15,7.15,0,0,0-.16,2.06,6.48,6.48,0,0,0,.57,1.69,6.66,6.66,0,0,1,.14,1.94.65.65,0,0,0,0,.27.23.23,0,0,0,.22.13.44.44,0,0,0,.19-.12,1.77,1.77,0,0,0,.36-.5,2.89,2.89,0,0,0,.16-1.62A3.79,3.79,0,0,0,124.38,62.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.81,75.68a1.38,1.38,0,0,0,0-2.61,3.85,3.85,0,0,0-.8-.34c2.7,1,1.16,3.33-1.46,3.26-2.29-.06-3.06-1.15-3.1-1.2a1.89,1.89,0,0,0,.85.89A5,5,0,0,0,124.81,75.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,95.41a7.61,7.61,0,0,1,6.68,0c1.85,1,1.85,2.71,0,3.74a7.61,7.61,0,0,1-6.68,0C117.23,98.12,117.23,96.44,119.08,95.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,77.1l.05-.06a4.38,4.38,0,0,0,.74-4.57,13.35,13.35,0,0,1-.58-1.61c-.25-1.06,0-2.87-1.51-2.87s-1.21,1.79-1.5,2.87a11.9,11.9,0,0,1-.57,1.54,4.41,4.41,0,0,0,.77,4.69h0a.9.9,0,0,1,.22.59h0a.87.87,0,0,1-.61.84,4.2,4.2,0,0,0-1,.4,1.88,1.88,0,0,0-1.11,1.54L118,96.67c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84h0A.87.87,0,0,1,123.85,77.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,77.1l.05-.06a4.38,4.38,0,0,0,.74-4.57,13.35,13.35,0,0,1-.58-1.61c-.25-1.06,0-2.87-1.51-2.87s-1.21,1.79-1.5,2.87a11.9,11.9,0,0,1-.57,1.54,4.41,4.41,0,0,0,.77,4.69h0a.9.9,0,0,1,.22.59h0a.87.87,0,0,1-.61.84,4.2,4.2,0,0,0-1,.4,1.88,1.88,0,0,0-1.11,1.54L118,96.67c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84h0A.87.87,0,0,1,123.85,77.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,94.8a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C117.53,97.51,117.53,95.83,119.31,94.8Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,99.26a7.18,7.18,0,0,0,.92-.2c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84,1.17,1.17,0,0,0,.65,1.28c.59.39,1.56.33,1.71,2.38s.7,13.92.7,14.89S126.4,98.39,123.64,99.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.34,96.69l-.59-11.87h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.59,1.59,0,0,0-.94,1.31h0l-.59,11.86a.82.82,0,0,0,.07.3,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.14,2.14,0,0,0,1-1.17A.82.82,0,0,0,126.34,96.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.89,95.08a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C118.42,97.31,118.42,95.93,119.89,95.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,97.82,125,83.65l-.17-.11-.72.07.72,14.74c.13-.06.26-.12.38-.19A2.27,2.27,0,0,0,125.7,97.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,83.76l-.46-.09.53,15a4.74,4.74,0,0,0,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,96.72c.07-1.38.08-7.14.28-11.18l-.13-2.36a3.94,3.94,0,0,0-.81.34,1.59,1.59,0,0,0-.94,1.31h0l-.59,11.86a.82.82,0,0,0,.07.3,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C123,98.77,120.89,98.09,121,96.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3,83.52a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,120.3,83.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3,83.52a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,120.3,83.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,93.54a7.7,7.7,0,0,0,3.38-.73,2.16,2.16,0,0,0,1.28-1.75l-.28-5.39a2,2,0,0,1-1.19,1.63,7.29,7.29,0,0,1-3.19.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55,93.76a6.17,6.17,0,0,0,3-.73,2.16,2.16,0,0,0,1.27-1.76l-.27-5.41a2,2,0,0,1-1.19,1.66,5.9,5.9,0,0,1-2.86.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.72,96.28c0-.92.53-13.53.67-15s.69-1.81,1.66-2.56a1.13,1.13,0,0,0,.15-1.8,3.5,3.5,0,0,1-1-3.61A18.14,18.14,0,0,0,122,70c.14-1.57.55-2,1.12-1.87a1.37,1.37,0,0,0-.57-.12c-1.47,0-1.21,1.79-1.5,2.87a11.9,11.9,0,0,1-.57,1.54,4.41,4.41,0,0,0,.77,4.69.9.9,0,0,1,.22.59.87.87,0,0,1-.61.84,4.2,4.2,0,0,0-1,.4,1.88,1.88,0,0,0-1.11,1.54L118,96.67c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c.25-.08.48-.16.69-.25C121,100,119.72,97.19,119.72,96.28Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,72.77c-.16-.38-.4-.74-.53-1.13a6.64,6.64,0,0,1-.23-1.59c0-.17-.05-.58-.23-.68s-.3.06-.33.2a7.15,7.15,0,0,0-.16,2.06,6.55,6.55,0,0,0,.57,1.7,6.6,6.6,0,0,1,.14,1.93.62.62,0,0,0,0,.27.24.24,0,0,0,.22.14.38.38,0,0,0,.19-.13,1.72,1.72,0,0,0,.36-.49,2.94,2.94,0,0,0,.16-1.63A3.79,3.79,0,0,0,124.38,72.77Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.81,86.13a1.38,1.38,0,0,0,0-2.61,3.36,3.36,0,0,0-.8-.33c2.7,1,1.16,3.32-1.46,3.25a3.8,3.8,0,0,1-3.1-1.19,1.87,1.87,0,0,0,.85.88A5,5,0,0,0,124.81,86.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,90.18a7.61,7.61,0,0,1,6.68,0c1.84,1,1.84,2.71,0,3.74a7.54,7.54,0,0,1-6.68,0C108.18,92.89,108.18,91.22,110,90.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,71.87l0-.05a4.39,4.39,0,0,0,.75-4.58,12.23,12.23,0,0,1-.58-1.61c-.25-1,0-2.86-1.51-2.86s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.87.87,0,0,1-.62.84,4.15,4.15,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.53l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.53,4.22,4.22,0,0,0-1-.41.87.87,0,0,1-.62-.84h0A.87.87,0,0,1,114.8,71.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,71.87l0-.05a4.39,4.39,0,0,0,.75-4.58,12.23,12.23,0,0,1-.58-1.61c-.25-1,0-2.86-1.51-2.86s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.87.87,0,0,1-.62.84,4.15,4.15,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.53l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.53,4.22,4.22,0,0,0-1-.41.87.87,0,0,1-.62-.84h0A.87.87,0,0,1,114.8,71.87Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,89.57a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.75a7.18,7.18,0,0,1-6.48,0C108.47,92.28,108.47,90.61,110.26,89.57Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.59,94a7.21,7.21,0,0,0,.92-.21c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.53,4.22,4.22,0,0,0-1-.41.87.87,0,0,1-.62-.84,1.17,1.17,0,0,0,.65,1.29c.59.38,1.55.33,1.7,2.38s.71,13.91.71,14.89S117.34,93.17,114.59,94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29,91.46l-.6-11.86h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.87.87,0,0,0,.07.31,2.1,2.1,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.08,2.08,0,0,0,1-1.17A.89.89,0,0,0,117.29,91.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,89.86a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C109.36,92.09,109.36,90.71,110.84,89.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.65,92.59,116,78.43l-.18-.12-.71.07.72,14.75c.13-.06.26-.12.38-.19A3.72,3.72,0,0,0,116.65,92.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.59,78.53l-.46-.09.53,15c.22,0,.44-.1.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91,91.49c.07-1.38.08-7.14.28-11.18L112.06,78a3.29,3.29,0,0,0-.81.34,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.87.87,0,0,0,.07.31,2.1,2.1,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C113.89,93.54,111.84,92.87,111.91,91.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,78.3a5,5,0,0,1,4.51,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.51,0C110,80.18,110,79,111.25,78.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,78.3a5,5,0,0,1,4.51,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.51,0C110,80.18,110,79,111.25,78.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.15,88.31a7.52,7.52,0,0,0,3.37-.73,2.14,2.14,0,0,0,1.28-1.75l-.27-5.39a2,2,0,0,1-1.2,1.63,7.14,7.14,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5,88.53a6.17,6.17,0,0,0,3-.73A2.13,2.13,0,0,0,117.81,86l-.27-5.4a2,2,0,0,1-1.18,1.65,5.79,5.79,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.66,91.05c0-.91.53-13.52.68-15s.68-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.49,3.49,0,0,1-1-3.62,19.94,19.94,0,0,0,.81-3.33c.14-1.57.54-2,1.12-1.86a1.23,1.23,0,0,0-.57-.12c-1.48,0-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7.89.89,0,0,1,.22.58.87.87,0,0,1-.62.84,4.15,4.15,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.53l-.81,16.21c0,.94.86,1.88,2.58,2.39a6.91,6.91,0,0,0,4.7-.25C112,94.73,110.67,92,110.66,91.05Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33,67.54c-.16-.38-.41-.74-.53-1.13a6.5,6.5,0,0,1-.23-1.59c0-.17-.06-.58-.23-.68s-.3.06-.33.21a7.12,7.12,0,0,0-.16,2.06,6.61,6.61,0,0,0,.57,1.69,7,7,0,0,1,.14,1.93.59.59,0,0,0,0,.27.24.24,0,0,0,.22.14.32.32,0,0,0,.18-.13,1.55,1.55,0,0,0,.36-.49,2.85,2.85,0,0,0,.17-1.63A4.92,4.92,0,0,0,115.33,67.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,80.9a1.37,1.37,0,0,0,0-2.6A3.85,3.85,0,0,0,115,78c2.7,1,1.16,3.32-1.46,3.26-2.29-.06-3.07-1.15-3.1-1.2a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,115.76,80.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,100.64a7.54,7.54,0,0,1,6.68,0c1.84,1,1.84,2.7,0,3.74a7.61,7.61,0,0,1-6.68,0C108.18,103.34,108.18,101.67,110,100.64Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,82.32l0,0a4.38,4.38,0,0,0,.75-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87S112.28,75,112,76.09a13.49,13.49,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7h0a.9.9,0,0,1,.22.59h0a.86.86,0,0,1-.62.83,4.15,4.15,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c1.71-.52,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.22,4.22,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.89.89,0,0,1,114.8,82.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,82.32l0,0a4.38,4.38,0,0,0,.75-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87S112.28,75,112,76.09a13.49,13.49,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7h0a.9.9,0,0,1,.22.59h0a.86.86,0,0,1-.62.83,4.15,4.15,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c1.71-.52,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.22,4.22,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.89.89,0,0,1,114.8,82.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,100a7.12,7.12,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C108.47,102.74,108.47,101.06,110.26,100Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.59,104.49a9.4,9.4,0,0,0,.92-.2c1.71-.52,2.57-1.45,2.57-2.39l-.81-16.21a1.87,1.87,0,0,0-1.1-1.54,4.22,4.22,0,0,0-1-.41.86.86,0,0,1-.62-.83,1.17,1.17,0,0,0,.65,1.28c.59.39,1.55.33,1.7,2.38s.71,13.91.71,14.89S117.34,103.62,114.59,104.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29,101.91l-.6-11.86h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.82.82,0,0,0,.07.31,2.1,2.1,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.08,2.08,0,0,0,1-1.17A.84.84,0,0,0,117.29,101.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,100.31a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C109.36,102.54,109.36,101.16,110.84,100.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.65,103,116,88.88a1.08,1.08,0,0,0-.18-.11l-.71.06.72,14.75.38-.19A3,3,0,0,0,116.65,103Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.59,89l-.46-.08.53,15a4.74,4.74,0,0,0,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.91,101.94c.07-1.37.08-7.14.28-11.18l-.13-2.35a3.72,3.72,0,0,0-.81.34,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.82.82,0,0,0,.07.31,2.1,2.1,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C113.89,104,111.84,103.32,111.91,101.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,88.75a5,5,0,0,1,4.51,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.51,0C110,90.64,110,89.47,111.25,88.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.25,88.75a5,5,0,0,1,4.51,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.51,0C110,90.64,110,89.47,111.25,88.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.15,98.76a7.52,7.52,0,0,0,3.37-.73,2.12,2.12,0,0,0,1.28-1.74l-.27-5.39a2,2,0,0,1-1.2,1.62,7.14,7.14,0,0,1-3.18.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5,99a6.28,6.28,0,0,0,3-.73,2.16,2.16,0,0,0,1.26-1.77l-.27-5.4a2,2,0,0,1-1.18,1.65,5.79,5.79,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.66,101.51c0-.92.53-13.53.68-15s.68-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.49,3.49,0,0,1-1-3.62A19.71,19.71,0,0,0,113,75.2c.14-1.56.55-2,1.12-1.86a1.37,1.37,0,0,0-.57-.12c-1.48,0-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.42,4.42,0,0,0,.77,4.7.9.9,0,0,1,.22.59.86.86,0,0,1-.62.83,4.15,4.15,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.39a7.2,7.2,0,0,0,4,0c.25-.08.47-.16.69-.25C112,105.18,110.67,102.42,110.66,101.51Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33,78a11.79,11.79,0,0,1-.53-1.14,6.49,6.49,0,0,1-.23-1.58c0-.18-.06-.59-.23-.68s-.3.05-.33.2a7.15,7.15,0,0,0-.16,2.06,6.48,6.48,0,0,0,.57,1.69,7,7,0,0,1,.14,1.94.65.65,0,0,0,0,.27.23.23,0,0,0,.22.13.36.36,0,0,0,.18-.12,1.59,1.59,0,0,0,.36-.5,2.82,2.82,0,0,0,.17-1.62A4.49,4.49,0,0,0,115.33,78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,91.35a1.37,1.37,0,0,0,0-2.6,3.85,3.85,0,0,0-.8-.34c2.7,1,1.16,3.33-1.46,3.26-2.29-.06-3.07-1.15-3.1-1.2a1.83,1.83,0,0,0,.85.88A5,5,0,0,0,115.76,91.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,95.41a7.63,7.63,0,0,1,6.69,0c1.84,1,1.84,2.71,0,3.74a7.63,7.63,0,0,1-6.69,0C99.13,98.12,99.13,96.44,101,95.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74,77.1l.05-.06a4.41,4.41,0,0,0,.75-4.57,11.83,11.83,0,0,1-.58-1.61c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a13.59,13.59,0,0,1-.57,1.54,4.39,4.39,0,0,0,.77,4.69h0a.92.92,0,0,1,.22.59h0a.88.88,0,0,1-.62.84,4.2,4.2,0,0,0-1,.4,1.88,1.88,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.1-1.54,4.4,4.4,0,0,0-1-.4.88.88,0,0,1-.62-.84h0A.91.91,0,0,1,105.74,77.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74,77.1l.05-.06a4.41,4.41,0,0,0,.75-4.57,11.83,11.83,0,0,1-.58-1.61c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a13.59,13.59,0,0,1-.57,1.54,4.39,4.39,0,0,0,.77,4.69h0a.92.92,0,0,1,.22.59h0a.88.88,0,0,1-.62.84,4.2,4.2,0,0,0-1,.4,1.88,1.88,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.1-1.54,4.4,4.4,0,0,0-1-.4.88.88,0,0,1-.62-.84h0A.91.91,0,0,1,105.74,77.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,94.8a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C99.42,97.51,99.42,95.83,101.21,94.8Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54,99.26a7,7,0,0,0,.91-.2c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.1-1.54,4.4,4.4,0,0,0-1-.4.88.88,0,0,1-.62-.84c0,.67,0,.9.64,1.28s1.56.33,1.71,2.38.71,13.92.71,14.89S108.29,98.39,105.54,99.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23,96.69l-.59-11.87h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.52,0,1.6,1.6,0,0,0-.93,1.31h0l-.59,11.86a.66.66,0,0,0,.07.3,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0,2.12,2.12,0,0,0,1-1.17A.66.66,0,0,0,108.23,96.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,95.08a5.91,5.91,0,0,1,5.34,0c1.47.85,1.47,2.23,0,3.08a5.91,5.91,0,0,1-5.34,0C100.31,97.31,100.31,95.93,101.78,95.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6,97.82l-.69-14.17-.18-.11-.72.07.72,14.74.39-.19A2.93,2.93,0,0,0,107.6,97.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.53,83.76l-.45-.09.53,15a4.28,4.28,0,0,0,.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,96.72c.07-1.38.08-7.14.28-11.18L103,83.18a4.19,4.19,0,0,0-.81.34,1.6,1.6,0,0,0-.93,1.31h0l-.59,11.86a.66.66,0,0,0,.07.3,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0C104.84,98.77,102.79,98.09,102.86,96.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,83.52a5,5,0,0,1,4.52,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.52,0A1.38,1.38,0,0,1,102.19,83.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,83.52a5,5,0,0,1,4.52,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.52,0A1.38,1.38,0,0,1,102.19,83.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,93.54a7.65,7.65,0,0,0,3.37-.73,2.16,2.16,0,0,0,1.28-1.75l-.27-5.39a2,2,0,0,1-1.2,1.63,7.27,7.27,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,93.76a6.2,6.2,0,0,0,3-.73,2.14,2.14,0,0,0,1.26-1.76l-.27-5.41a2,2,0,0,1-1.18,1.66,5.93,5.93,0,0,1-2.86.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61,96.28c0-.92.53-13.53.68-15s.68-1.81,1.66-2.56a1.13,1.13,0,0,0,.15-1.8,3.48,3.48,0,0,1-1-3.61A19.94,19.94,0,0,0,103.9,70c.14-1.57.54-2,1.11-1.86a1.16,1.16,0,0,0-.56-.13c-1.48,0-1.22,1.79-1.5,2.87a13.59,13.59,0,0,1-.57,1.54,4.39,4.39,0,0,0,.77,4.69.92.92,0,0,1,.22.59.88.88,0,0,1-.62.84,4.2,4.2,0,0,0-1,.4,1.88,1.88,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.57,2.39a7,7,0,0,0,4,0c.25-.08.48-.16.69-.25C102.93,100,101.62,97.19,101.61,96.28Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.27,72.77c-.15-.38-.4-.74-.52-1.13a7.2,7.2,0,0,1-.24-1.59c0-.17-.05-.58-.23-.68s-.29.06-.32.2a6.81,6.81,0,0,0-.16,2.06,6.92,6.92,0,0,0,.56,1.7,6.63,6.63,0,0,1,.15,1.93.5.5,0,0,0,0,.27.23.23,0,0,0,.21.14.31.31,0,0,0,.19-.13,1.72,1.72,0,0,0,.36-.49,2.85,2.85,0,0,0,.16-1.63A3.08,3.08,0,0,0,106.27,72.77Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.71,86.13a1.38,1.38,0,0,0,0-2.61,3.74,3.74,0,0,0-.8-.33c2.7,1,1.16,3.32-1.46,3.25-2.29,0-3.07-1.15-3.1-1.19a1.89,1.89,0,0,0,.84.88A5,5,0,0,0,106.71,86.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,105.86a7.63,7.63,0,0,1,6.69,0c1.84,1,1.84,2.71,0,3.74a7.56,7.56,0,0,1-6.69,0C99.13,108.57,99.13,106.9,101,105.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74,87.55l.05,0a4.43,4.43,0,0,0,.75-4.58,10.94,10.94,0,0,1-.58-1.61c-.25-1,0-2.86-1.51-2.86s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.87.87,0,0,1-.62.84,4.7,4.7,0,0,0-1,.4,1.9,1.9,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.9,1.9,0,0,0-1.1-1.54,4.94,4.94,0,0,0-1-.4.87.87,0,0,1-.62-.84h0A.91.91,0,0,1,105.74,87.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74,87.55l.05,0a4.43,4.43,0,0,0,.75-4.58,10.94,10.94,0,0,1-.58-1.61c-.25-1,0-2.86-1.51-2.86s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.87.87,0,0,1-.62.84,4.7,4.7,0,0,0-1,.4,1.9,1.9,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.9,1.9,0,0,0-1.1-1.54,4.94,4.94,0,0,0-1-.4.87.87,0,0,1-.62-.84h0A.91.91,0,0,1,105.74,87.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,105.25a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.12,7.12,0,0,1-6.48,0C99.42,108,99.42,106.29,101.21,105.25Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54,109.72a7.06,7.06,0,0,0,.91-.21c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.9,1.9,0,0,0-1.1-1.54,4.94,4.94,0,0,0-1-.4.87.87,0,0,1-.62-.84,1.18,1.18,0,0,0,.64,1.29c.6.38,1.56.32,1.71,2.38s.71,13.91.71,14.88S108.29,108.85,105.54,109.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23,107.14l-.59-11.86h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.52,0,1.58,1.58,0,0,0-.93,1.3h0l-.59,11.86a.7.7,0,0,0,.07.31,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0,2.12,2.12,0,0,0,1-1.17A.7.7,0,0,0,108.23,107.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,105.54a5.91,5.91,0,0,1,5.34,0c1.47.85,1.47,2.23,0,3.08a5.91,5.91,0,0,1-5.34,0C100.31,107.77,100.31,106.39,101.78,105.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6,108.27l-.69-14.16-.18-.12-.72.07.72,14.75.39-.19A3.72,3.72,0,0,0,107.6,108.27Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.53,94.21l-.45-.09.53,15a6,6,0,0,0,.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,107.17c.07-1.38.08-7.14.28-11.18L103,93.64a3.65,3.65,0,0,0-.81.34,1.58,1.58,0,0,0-.93,1.3h0l-.59,11.86a.7.7,0,0,0,.07.31,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0C104.84,109.22,102.79,108.55,102.86,107.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,94a5,5,0,0,1,4.52,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.52,0A1.37,1.37,0,0,1,102.19,94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,94a5,5,0,0,1,4.52,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.52,0A1.37,1.37,0,0,1,102.19,94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,104a7.52,7.52,0,0,0,3.37-.73,2.16,2.16,0,0,0,1.28-1.75l-.27-5.39a2,2,0,0,1-1.2,1.63,7.27,7.27,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.45,104.21a6.2,6.2,0,0,0,3-.73,2.13,2.13,0,0,0,1.26-1.76l-.27-5.4A2,2,0,0,1,107.31,98a5.82,5.82,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61,106.73c0-.91.53-13.53.68-15s.68-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.5,3.5,0,0,1-1-3.62,19.94,19.94,0,0,0,.81-3.33c.14-1.57.54-2,1.11-1.86a1.16,1.16,0,0,0-.56-.12c-1.48,0-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7.89.89,0,0,1,.22.58.87.87,0,0,1-.62.84,4.7,4.7,0,0,0-1,.4,1.9,1.9,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.57,2.39a7,7,0,0,0,4,0,5.54,5.54,0,0,0,.69-.25C102.93,110.4,101.62,107.65,101.61,106.73Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.27,83.22c-.15-.38-.4-.74-.52-1.13a7,7,0,0,1-.24-1.59c0-.17-.05-.58-.23-.68s-.29.06-.32.21a6.79,6.79,0,0,0-.16,2.06,7,7,0,0,0,.56,1.69,6.63,6.63,0,0,1,.15,1.93.49.49,0,0,0,0,.27.23.23,0,0,0,.21.14A.31.31,0,0,0,106,86a1.72,1.72,0,0,0,.36-.49,2.84,2.84,0,0,0,.16-1.63A3.08,3.08,0,0,0,106.27,83.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.71,96.58a1.37,1.37,0,0,0,0-2.6,4.37,4.37,0,0,0-.8-.34c2.7,1,1.16,3.32-1.46,3.26-2.29-.06-3.07-1.15-3.1-1.2a1.89,1.89,0,0,0,.84.88A5,5,0,0,0,106.71,96.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,100.64a7.54,7.54,0,0,1,6.68,0c1.85,1,1.85,2.7,0,3.74a7.61,7.61,0,0,1-6.68,0C90.08,103.34,90.08,101.67,91.92,100.64Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.69,82.32l0,0a4.4,4.4,0,0,0,.74-4.58,12.51,12.51,0,0,1-.57-1.6c-.26-1.06,0-2.87-1.51-2.87S94.18,75,93.89,76.09a13.3,13.3,0,0,1-.56,1.53,4.4,4.4,0,0,0,.76,4.7h0a.86.86,0,0,1,.23.59h0a.86.86,0,0,1-.62.83,4.22,4.22,0,0,0-1,.41,1.85,1.85,0,0,0-1.1,1.54l-.81,16.21c0,.94.85,1.87,2.57,2.39a7.2,7.2,0,0,0,4,0c1.72-.52,2.58-1.45,2.58-2.39l-.81-16.21a1.86,1.86,0,0,0-1.11-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.61-.83h0A.88.88,0,0,1,96.69,82.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.69,82.32l0,0a4.4,4.4,0,0,0,.74-4.58,12.51,12.51,0,0,1-.57-1.6c-.26-1.06,0-2.87-1.51-2.87S94.18,75,93.89,76.09a13.3,13.3,0,0,1-.56,1.53,4.4,4.4,0,0,0,.76,4.7h0a.86.86,0,0,1,.23.59h0a.86.86,0,0,1-.62.83,4.22,4.22,0,0,0-1,.41,1.85,1.85,0,0,0-1.1,1.54l-.81,16.21c0,.94.85,1.87,2.57,2.39a7.2,7.2,0,0,0,4,0c1.72-.52,2.58-1.45,2.58-2.39l-.81-16.21a1.86,1.86,0,0,0-1.11-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.61-.83h0A.88.88,0,0,1,96.69,82.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,100a7.12,7.12,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C90.37,102.74,90.37,101.06,92.16,100Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.49,104.49c.3,0,.61-.12.91-.2,1.72-.52,2.58-1.45,2.58-2.39l-.81-16.21a1.86,1.86,0,0,0-1.11-1.54,4.71,4.71,0,0,0-1-.41.86.86,0,0,1-.61-.83,1.17,1.17,0,0,0,.64,1.28c.59.39,1.56.33,1.71,2.38s.7,13.91.7,14.89S99.24,103.62,96.49,104.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.18,101.91l-.59-11.86h0a1.6,1.6,0,0,0-.94-1.3,5,5,0,0,0-4.51,0,1.56,1.56,0,0,0-.93,1.31h0l-.6,11.85a.82.82,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.14,2.14,0,0,0,1-1.17A.82.82,0,0,0,99.18,101.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.73,100.31a5.89,5.89,0,0,1,5.33,0c1.48.85,1.48,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C91.26,102.54,91.26,101.16,92.73,100.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,103l-.69-14.16-.18-.11-.72.06.72,14.75.38-.19A2.67,2.67,0,0,0,98.55,103Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.48,89,96,88.9l.53,15a4.61,4.61,0,0,0,.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8,101.94c.07-1.37.09-7.14.29-11.18L94,88.41a3.94,3.94,0,0,0-.81.34,1.56,1.56,0,0,0-.93,1.31h0l-.6,11.85a.82.82,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C95.79,104,93.74,103.32,93.8,101.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,88.75a5,5,0,0,1,4.51,0c1.25.72,1.25,1.89,0,2.6a5,5,0,0,1-4.51,0C91.89,90.64,91.89,89.47,93.14,88.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,88.75a5,5,0,0,1,4.51,0c1.25.72,1.25,1.89,0,2.6a5,5,0,0,1-4.51,0C91.89,90.64,91.89,89.47,93.14,88.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,98.76A7.52,7.52,0,0,0,98.42,98a2.15,2.15,0,0,0,1.28-1.74l-.27-5.39a2,2,0,0,1-1.2,1.62,7.14,7.14,0,0,1-3.18.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,99a6.34,6.34,0,0,0,3-.73,2.16,2.16,0,0,0,1.26-1.77l-.27-5.4a2,2,0,0,1-1.19,1.65,5.75,5.75,0,0,1-2.85.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.56,101.51c0-.92.53-13.53.68-15s.68-1.81,1.65-2.56A1.12,1.12,0,0,0,95,82.15a3.51,3.51,0,0,1-1-3.62,19.71,19.71,0,0,0,.81-3.33c.14-1.56.54-2,1.11-1.86a1.32,1.32,0,0,0-.56-.12c-1.48,0-1.22,1.79-1.51,2.87a13.3,13.3,0,0,1-.56,1.53,4.4,4.4,0,0,0,.76,4.7.87.87,0,0,1-.39,1.42,4.22,4.22,0,0,0-1,.41,1.85,1.85,0,0,0-1.1,1.54l-.81,16.21c0,.94.85,1.87,2.57,2.39a7.2,7.2,0,0,0,4,0c.25-.08.48-.16.69-.25C93.87,105.18,92.57,102.42,92.56,101.51Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,78c-.16-.38-.4-.74-.53-1.14a7,7,0,0,1-.23-1.58c0-.18,0-.59-.23-.68s-.29.05-.33.2a7.52,7.52,0,0,0-.16,2.06,7.32,7.32,0,0,0,.57,1.69,6.66,6.66,0,0,1,.14,1.94.86.86,0,0,0,0,.27.23.23,0,0,0,.22.13.35.35,0,0,0,.19-.12,1.77,1.77,0,0,0,.36-.5,2.81,2.81,0,0,0,.16-1.62A3.53,3.53,0,0,0,97.22,78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.65,91.35c1.25-.71,1.25-1.88,0-2.6a3.85,3.85,0,0,0-.8-.34c2.71,1,1.17,3.33-1.45,3.26-2.3-.06-3.07-1.15-3.11-1.2a1.83,1.83,0,0,0,.85.88A5,5,0,0,0,97.65,91.35Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,111.09a7.61,7.61,0,0,1,6.68,0c1.85,1,1.85,2.71,0,3.74a7.61,7.61,0,0,1-6.68,0C90.08,113.8,90.08,112.12,91.92,111.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.69,92.78l0-.06a4.38,4.38,0,0,0,.74-4.57,13.18,13.18,0,0,1-.57-1.61c-.26-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.51,2.87a13.41,13.41,0,0,1-.56,1.54,4.39,4.39,0,0,0,.76,4.69h0a.86.86,0,0,1,.23.59h0a.88.88,0,0,1-.62.84,4.2,4.2,0,0,0-1,.4,1.86,1.86,0,0,0-1.1,1.54l-.81,16.21c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.61-.84h0A.86.86,0,0,1,96.69,92.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.69,92.78l0-.06a4.38,4.38,0,0,0,.74-4.57,13.18,13.18,0,0,1-.57-1.61c-.26-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.51,2.87a13.41,13.41,0,0,1-.56,1.54,4.39,4.39,0,0,0,.76,4.69h0a.86.86,0,0,1,.23.59h0a.88.88,0,0,1-.62.84,4.2,4.2,0,0,0-1,.4,1.86,1.86,0,0,0-1.1,1.54l-.81,16.21c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.61-.84h0A.86.86,0,0,1,96.69,92.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,110.48a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C90.37,113.19,90.37,111.51,92.16,110.48Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.49,114.94a7.41,7.41,0,0,0,.91-.2c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21a1.88,1.88,0,0,0-1.11-1.54,4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.61-.84c0,.67,0,.9.64,1.28S98.68,95,98.83,97s.7,13.92.7,14.89S99.24,114.07,96.49,114.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.18,112.37l-.59-11.87h0a1.58,1.58,0,0,0-.94-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.93,1.31h0l-.6,11.86a1.09,1.09,0,0,0,.07.3,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.1,2.1,0,0,0,1-1.17A.82.82,0,0,0,99.18,112.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.73,110.76a5.89,5.89,0,0,1,5.33,0c1.48.85,1.48,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C91.26,113,91.26,111.61,92.73,110.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,113.5l-.69-14.17-.18-.11-.72.07L97.68,114l.38-.19A2.64,2.64,0,0,0,98.55,113.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.48,99.44,96,99.35l.53,15a4.61,4.61,0,0,0,.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8,112.4c.07-1.38.09-7.14.29-11.18L94,98.86a3.94,3.94,0,0,0-.81.34,1.58,1.58,0,0,0-.93,1.31h0l-.6,11.86a1.09,1.09,0,0,0,.07.3,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C95.79,114.45,93.74,113.77,93.8,112.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,99.2a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,93.14,99.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,99.2a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,93.14,99.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,109.22a7.65,7.65,0,0,0,3.37-.73,2.16,2.16,0,0,0,1.28-1.75l-.27-5.39a2,2,0,0,1-1.2,1.63,7.27,7.27,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,109.44a6.23,6.23,0,0,0,3-.73A2.14,2.14,0,0,0,99.71,107l-.27-5.41a2,2,0,0,1-1.19,1.66,5.86,5.86,0,0,1-2.85.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.56,112c0-.92.53-13.53.68-15s.68-1.81,1.65-2.56A1.12,1.12,0,0,0,95,92.6,3.5,3.5,0,0,1,94,89a20.17,20.17,0,0,0,.81-3.33c.14-1.57.54-2,1.11-1.87a1.32,1.32,0,0,0-.56-.12c-1.48,0-1.22,1.79-1.51,2.87a13.41,13.41,0,0,1-.56,1.54,4.39,4.39,0,0,0,.76,4.69.86.86,0,0,1,.23.59.88.88,0,0,1-.62.84,4.2,4.2,0,0,0-1,.4,1.86,1.86,0,0,0-1.1,1.54l-.81,16.21c0,.94.85,1.88,2.57,2.39a7,7,0,0,0,4,0c.25-.08.48-.16.69-.25C93.87,115.63,92.57,112.87,92.56,112Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.22,88.45c-.16-.38-.4-.74-.53-1.13a7.18,7.18,0,0,1-.23-1.59c0-.17,0-.58-.23-.68s-.29.06-.33.2a7.52,7.52,0,0,0-.16,2.06,7.56,7.56,0,0,0,.57,1.7,6.6,6.6,0,0,1,.14,1.93.81.81,0,0,0,0,.27.24.24,0,0,0,.22.14.31.31,0,0,0,.19-.13,1.72,1.72,0,0,0,.36-.49,2.85,2.85,0,0,0,.16-1.63A3.79,3.79,0,0,0,97.22,88.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.65,101.81a1.38,1.38,0,0,0,0-2.61,3.36,3.36,0,0,0-.8-.33c2.71,1,1.17,3.32-1.45,3.25-2.3-.05-3.07-1.15-3.11-1.19a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,97.65,101.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.87,105.86a7.61,7.61,0,0,1,6.68,0c1.85,1,1.85,2.71,0,3.74a7.54,7.54,0,0,1-6.68,0C81,108.57,81,106.9,82.87,105.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.64,87.55l0,0a4.39,4.39,0,0,0,.75-4.58,12.23,12.23,0,0,1-.58-1.61c-.25-1,0-2.86-1.51-2.86s-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53,4.43,4.43,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.86.86,0,0,1-.61.84,4.22,4.22,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.53l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21A1.88,1.88,0,0,0,89,89.38,4.22,4.22,0,0,0,88,89a.87.87,0,0,1-.62-.84h0A.87.87,0,0,1,87.64,87.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.64,87.55l0,0a4.39,4.39,0,0,0,.75-4.58,12.23,12.23,0,0,1-.58-1.61c-.25-1,0-2.86-1.51-2.86s-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53,4.43,4.43,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.86.86,0,0,1-.61.84,4.22,4.22,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.53l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21A1.88,1.88,0,0,0,89,89.38,4.22,4.22,0,0,0,88,89a.87.87,0,0,1-.62-.84h0A.87.87,0,0,1,87.64,87.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,105.25a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.12,7.12,0,0,1-6.48,0C81.32,108,81.32,106.29,83.1,105.25Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,109.72a7.21,7.21,0,0,0,.92-.21c1.72-.51,2.58-1.45,2.58-2.39l-.81-16.21A1.88,1.88,0,0,0,89,89.38,4.22,4.22,0,0,0,88,89a.87.87,0,0,1-.62-.84,1.19,1.19,0,0,0,.65,1.29c.59.38,1.56.32,1.71,2.38s.7,13.91.7,14.88S90.19,108.85,87.43,109.72Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,107.14l-.6-11.86h0A1.58,1.58,0,0,0,88.6,94a5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.87.87,0,0,0,.07.31,2.14,2.14,0,0,0,1.05,1.17,5.89,5.89,0,0,0,5.33,0,2.14,2.14,0,0,0,1-1.17A.87.87,0,0,0,90.13,107.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.68,105.54a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C82.2,107.77,82.2,106.39,83.68,105.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.49,108.27,88.8,94.11,88.63,94l-.72.07.72,14.75.38-.19A3.13,3.13,0,0,0,89.49,108.27Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,94.21,87,94.12l.53,15c.22,0,.44-.1.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,107.17c.07-1.38.08-7.14.28-11.18l-.13-2.35a3.46,3.46,0,0,0-.81.34,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.87.87,0,0,0,.07.31,2.14,2.14,0,0,0,1.05,1.17,5.89,5.89,0,0,0,5.33,0C86.74,109.22,84.68,108.55,84.75,107.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,94a5,5,0,0,1,4.51,0c1.25.72,1.25,1.88,0,2.6a5,5,0,0,1-4.51,0C82.84,95.86,82.84,94.7,84.09,94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,94a5,5,0,0,1,4.51,0c1.25.72,1.25,1.88,0,2.6a5,5,0,0,1-4.51,0C82.84,95.86,82.84,94.7,84.09,94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,104a7.56,7.56,0,0,0,3.38-.73,2.14,2.14,0,0,0,1.27-1.75l-.27-5.39a2,2,0,0,1-1.2,1.63,7.08,7.08,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.34,104.21a6.17,6.17,0,0,0,3-.73,2.14,2.14,0,0,0,1.27-1.76l-.27-5.4A2,2,0,0,1,89.2,98a5.79,5.79,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5,106.73c0-.91.54-13.53.68-15s.68-1.81,1.66-2.56A1.12,1.12,0,0,0,86,87.38a3.52,3.52,0,0,1-1-3.62,18.14,18.14,0,0,0,.81-3.33c.14-1.57.55-2,1.12-1.86a1.23,1.23,0,0,0-.57-.12c-1.48,0-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53,4.43,4.43,0,0,0,.77,4.7.89.89,0,0,1,.22.58.86.86,0,0,1-.61.84,4.22,4.22,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.53l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0,5.54,5.54,0,0,0,.69-.25C84.82,110.4,83.51,107.65,83.5,106.73Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.17,83.22c-.16-.38-.4-.74-.53-1.13a6.5,6.5,0,0,1-.23-1.59c0-.17,0-.58-.23-.68s-.3.06-.33.21a7.12,7.12,0,0,0-.16,2.06,6.61,6.61,0,0,0,.57,1.69,6.62,6.62,0,0,1,.14,1.93.59.59,0,0,0,0,.27.24.24,0,0,0,.22.14.38.38,0,0,0,.19-.13,1.72,1.72,0,0,0,.36-.49,2.93,2.93,0,0,0,.16-1.63A3.79,3.79,0,0,0,88.17,83.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6,96.58c1.25-.72,1.25-1.88,0-2.6a3.85,3.85,0,0,0-.8-.34c2.7,1,1.16,3.32-1.46,3.26-2.29-.06-3.07-1.15-3.1-1.2a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,88.6,96.58Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.87,116.32a7.54,7.54,0,0,1,6.68,0c1.85,1,1.85,2.7,0,3.74a7.61,7.61,0,0,1-6.68,0C81,119,81,117.35,82.87,116.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.64,98l0,0a4.38,4.38,0,0,0,.75-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53A4.42,4.42,0,0,0,85,98h0a.9.9,0,0,1,.22.59h0a.85.85,0,0,1-.61.83,4.22,4.22,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.38a7,7,0,0,0,4,0c1.72-.51,2.58-1.44,2.58-2.38l-.81-16.21A1.86,1.86,0,0,0,89,99.83a4.22,4.22,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.89.89,0,0,1,87.64,98Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.64,98l0,0a4.38,4.38,0,0,0,.75-4.58,12.66,12.66,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53A4.42,4.42,0,0,0,85,98h0a.9.9,0,0,1,.22.59h0a.85.85,0,0,1-.61.83,4.22,4.22,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.38a7,7,0,0,0,4,0c1.72-.51,2.58-1.44,2.58-2.38l-.81-16.21A1.86,1.86,0,0,0,89,99.83a4.22,4.22,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.89.89,0,0,1,87.64,98Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,115.71a7.12,7.12,0,0,1,6.48,0c1.79,1,1.79,2.7,0,3.74a7.18,7.18,0,0,1-6.48,0C81.32,118.41,81.32,116.74,83.1,115.71Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,120.17a7.21,7.21,0,0,0,.92-.21c1.72-.51,2.58-1.44,2.58-2.38l-.81-16.21A1.86,1.86,0,0,0,89,99.83a4.22,4.22,0,0,0-1-.41.86.86,0,0,1-.62-.83,1.18,1.18,0,0,0,.65,1.28c.59.39,1.56.33,1.71,2.38s.7,13.91.7,14.89S90.19,119.3,87.43,120.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,117.59l-.6-11.86h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.82.82,0,0,0,.07.31,2.14,2.14,0,0,0,1.05,1.17,5.89,5.89,0,0,0,5.33,0,2.14,2.14,0,0,0,1-1.17A.82.82,0,0,0,90.13,117.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.68,116A5.89,5.89,0,0,1,89,116c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C82.2,118.22,82.2,116.84,83.68,116Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.49,118.72l-.69-14.16-.17-.11-.72.06.72,14.75c.13-.06.26-.12.38-.19A2.29,2.29,0,0,0,89.49,118.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,104.66l-.46-.08.53,15a4.74,4.74,0,0,0,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75,117.62c.07-1.37.08-7.14.28-11.18l-.13-2.35a3.94,3.94,0,0,0-.81.34,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.82.82,0,0,0,.07.31,2.14,2.14,0,0,0,1.05,1.17,5.89,5.89,0,0,0,5.33,0C86.74,119.67,84.68,119,84.75,117.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,104.43a5,5,0,0,1,4.51,0c1.25.72,1.25,1.88,0,2.6a5,5,0,0,1-4.51,0C82.84,106.32,82.84,105.15,84.09,104.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,104.43a5,5,0,0,1,4.51,0c1.25.72,1.25,1.88,0,2.6a5,5,0,0,1-4.51,0C82.84,106.32,82.84,105.15,84.09,104.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,114.44a7.56,7.56,0,0,0,3.38-.73A2.15,2.15,0,0,0,90.65,112l-.28-5.4a2,2,0,0,1-1.2,1.63,7.08,7.08,0,0,1-3.18.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.34,114.67a6.28,6.28,0,0,0,3-.73,2.17,2.17,0,0,0,1.27-1.77l-.27-5.4a2,2,0,0,1-1.19,1.65,5.79,5.79,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.51,117.19c0-.92.53-13.53.67-15s.68-1.81,1.66-2.56A1.12,1.12,0,0,0,86,97.83a3.51,3.51,0,0,1-1-3.62,18,18,0,0,0,.81-3.33c.14-1.56.55-2,1.12-1.86a1.23,1.23,0,0,0-.57-.12c-1.47,0-1.21,1.79-1.5,2.87a11.81,11.81,0,0,1-.57,1.53A4.42,4.42,0,0,0,85,98a.9.9,0,0,1,.22.59.85.85,0,0,1-.61.83,4.22,4.22,0,0,0-1,.41,1.86,1.86,0,0,0-1.11,1.54l-.81,16.21c0,.94.86,1.87,2.58,2.38a7,7,0,0,0,4,0,5.55,5.55,0,0,0,.69-.24C84.82,120.86,83.51,118.1,83.51,117.19Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.17,93.68c-.16-.38-.4-.74-.53-1.14A6.49,6.49,0,0,1,87.41,91c0-.18,0-.59-.23-.68s-.3,0-.33.2a7.12,7.12,0,0,0-.16,2.06,6.61,6.61,0,0,0,.57,1.69,6.66,6.66,0,0,1,.14,1.94.58.58,0,0,0,0,.26.22.22,0,0,0,.22.14.44.44,0,0,0,.19-.12,1.77,1.77,0,0,0,.36-.5,2.93,2.93,0,0,0,.16-1.63A3.69,3.69,0,0,0,88.17,93.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6,107c1.25-.72,1.25-1.88,0-2.6a3.85,3.85,0,0,0-.8-.34c2.7,1,1.16,3.32-1.46,3.26-2.29-.06-3.07-1.15-3.1-1.2a1.83,1.83,0,0,0,.85.88A5,5,0,0,0,88.6,107Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.82,111.09a7.61,7.61,0,0,1,6.68,0c1.84,1,1.84,2.71,0,3.74a7.61,7.61,0,0,1-6.68,0C72,113.8,72,112.12,73.82,111.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,92.78l0-.06a4.39,4.39,0,0,0,.75-4.57,13.35,13.35,0,0,1-.58-1.61c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a13.59,13.59,0,0,1-.57,1.54A4.39,4.39,0,0,0,76,92.77h0a.9.9,0,0,1,.22.59h0a.88.88,0,0,1-.62.84,4.4,4.4,0,0,0-1,.4,1.88,1.88,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21A1.88,1.88,0,0,0,80,94.6a4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84h0A.87.87,0,0,1,78.59,92.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,92.78l0-.06a4.39,4.39,0,0,0,.75-4.57,13.35,13.35,0,0,1-.58-1.61c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a13.59,13.59,0,0,1-.57,1.54A4.39,4.39,0,0,0,76,92.77h0a.9.9,0,0,1,.22.59h0a.88.88,0,0,1-.62.84,4.4,4.4,0,0,0-1,.4,1.88,1.88,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21A1.88,1.88,0,0,0,80,94.6a4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84h0A.87.87,0,0,1,78.59,92.78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,110.48a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.18,7.18,0,0,1-6.48,0C72.26,113.19,72.26,111.51,74.05,110.48Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,114.94a7.18,7.18,0,0,0,.92-.2c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21A1.88,1.88,0,0,0,80,94.6a4.2,4.2,0,0,0-1-.4.88.88,0,0,1-.62-.84c0,.67,0,.9.65,1.28s1.55.33,1.7,2.38.71,13.92.71,14.89S81.13,114.07,78.38,114.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.07,112.37l-.59-11.87h0a1.58,1.58,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.59,1.59,0,0,0-.94,1.31h0l-.59,11.86a.82.82,0,0,0,.07.3,2.12,2.12,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0,2.08,2.08,0,0,0,1-1.17A.66.66,0,0,0,81.07,112.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.62,110.76a5.91,5.91,0,0,1,5.34,0c1.47.85,1.47,2.23,0,3.08a5.91,5.91,0,0,1-5.34,0C73.15,113,73.15,111.61,74.62,110.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.44,113.5l-.69-14.17-.18-.11-.71.07L79.57,114a3.54,3.54,0,0,0,.39-.19A2.93,2.93,0,0,0,80.44,113.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,99.44l-.46-.09.53,15a4.74,4.74,0,0,0,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,112.4c.07-1.38.08-7.14.28-11.18l-.13-2.36a3.72,3.72,0,0,0-.81.34,1.59,1.59,0,0,0-.94,1.31h0l-.59,11.86a.82.82,0,0,0,.07.3,2.12,2.12,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0C77.68,114.45,75.63,113.77,75.7,112.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,99.2a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,75,99.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,99.2a5,5,0,0,1,4.51,0,1.38,1.38,0,0,1,0,2.61,5,5,0,0,1-4.51,0A1.38,1.38,0,0,1,75,99.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.94,109.22a7.65,7.65,0,0,0,3.37-.73,2.16,2.16,0,0,0,1.28-1.75l-.27-5.39a2,2,0,0,1-1.2,1.63,7.27,7.27,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.29,109.44a6.2,6.2,0,0,0,3-.73A2.14,2.14,0,0,0,81.6,107l-.27-5.41a2,2,0,0,1-1.18,1.66,5.9,5.9,0,0,1-2.86.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.45,112c0-.92.53-13.53.68-15s.68-1.81,1.66-2.56a1.13,1.13,0,0,0,.15-1.8,3.48,3.48,0,0,1-1-3.61,20.17,20.17,0,0,0,.81-3.33c.14-1.57.54-2,1.12-1.87a1.37,1.37,0,0,0-.57-.12c-1.48,0-1.22,1.79-1.5,2.87a13.59,13.59,0,0,1-.57,1.54A4.39,4.39,0,0,0,76,92.77a.9.9,0,0,1,.22.59.88.88,0,0,1-.62.84,4.4,4.4,0,0,0-1,.4,1.88,1.88,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c.24-.08.47-.16.69-.25C75.77,115.63,74.46,112.87,74.45,112Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.12,88.45c-.16-.38-.41-.74-.53-1.13a7.2,7.2,0,0,1-.24-1.59c0-.17,0-.58-.22-.68s-.3.06-.33.2a7.15,7.15,0,0,0-.16,2.06,6.68,6.68,0,0,0,.57,1.7,7,7,0,0,1,.14,1.93.62.62,0,0,0,.05.27.23.23,0,0,0,.22.14.32.32,0,0,0,.18-.13,1.55,1.55,0,0,0,.36-.49,2.85,2.85,0,0,0,.17-1.63A4.92,4.92,0,0,0,79.12,88.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.55,101.81a1.38,1.38,0,0,0,0-2.61,3.36,3.36,0,0,0-.8-.33c2.7,1,1.16,3.32-1.46,3.25-2.29-.05-3.07-1.15-3.1-1.19a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,79.55,101.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.82,121.54a7.61,7.61,0,0,1,6.68,0c1.84,1,1.84,2.71,0,3.74a7.54,7.54,0,0,1-6.68,0C72,124.25,72,122.58,73.82,121.54Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,103.23l0,0a4.39,4.39,0,0,0,.75-4.58A12.23,12.23,0,0,1,78.8,97c-.25-1,0-2.87-1.51-2.87s-1.22,1.8-1.5,2.88a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.87.87,0,0,1-.62.84,4.94,4.94,0,0,0-1,.4,1.9,1.9,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.9,1.9,0,0,0-1.1-1.54,4.7,4.7,0,0,0-1-.4.87.87,0,0,1-.62-.84h0A.87.87,0,0,1,78.59,103.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,103.23l0,0a4.39,4.39,0,0,0,.75-4.58A12.23,12.23,0,0,1,78.8,97c-.25-1,0-2.87-1.51-2.87s-1.22,1.8-1.5,2.88a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7h0a.89.89,0,0,1,.22.58h0a.87.87,0,0,1-.62.84,4.94,4.94,0,0,0-1,.4,1.9,1.9,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.58,2.39a7,7,0,0,0,4,0c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.9,1.9,0,0,0-1.1-1.54,4.7,4.7,0,0,0-1-.4.87.87,0,0,1-.62-.84h0A.87.87,0,0,1,78.59,103.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,120.93a7.18,7.18,0,0,1,6.48,0c1.79,1,1.79,2.71,0,3.74a7.12,7.12,0,0,1-6.48,0C72.26,123.64,72.26,122,74.05,120.93Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,125.4a7.21,7.21,0,0,0,.92-.21c1.71-.51,2.57-1.45,2.57-2.39l-.81-16.21a1.9,1.9,0,0,0-1.1-1.54,4.7,4.7,0,0,0-1-.4.87.87,0,0,1-.62-.84A1.17,1.17,0,0,0,79,105.1c.59.38,1.55.32,1.7,2.38s.71,13.91.71,14.88S81.13,124.52,78.38,125.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,122.82,80.48,111h0a1.57,1.57,0,0,0-.93-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.87.87,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0,2.08,2.08,0,0,0,1-1.17A.89.89,0,0,0,81.08,122.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63,121.22a5.89,5.89,0,0,1,5.33,0c1.47.85,1.47,2.23,0,3.08a5.89,5.89,0,0,1-5.33,0C73.15,123.45,73.15,122.07,74.63,121.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.44,124l-.69-14.17-.18-.11-.71.07.71,14.75a3.54,3.54,0,0,0,.39-.19A3.72,3.72,0,0,0,80.44,124Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,109.89l-.46-.09.53,15,.65-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,122.85c.07-1.38.08-7.14.28-11.18l-.13-2.35a3,3,0,0,0-.81.34,1.58,1.58,0,0,0-.94,1.3h0l-.59,11.86a.87.87,0,0,0,.07.31,2.14,2.14,0,0,0,1,1.17,5.89,5.89,0,0,0,5.33,0C77.68,124.9,75.63,124.23,75.7,122.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,109.66a5,5,0,0,1,4.51,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.51,0C73.79,111.54,73.79,110.38,75,109.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,109.66a5,5,0,0,1,4.51,0,1.37,1.37,0,0,1,0,2.6,5,5,0,0,1-4.51,0C73.79,111.54,73.79,110.38,75,109.66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.94,119.67a7.52,7.52,0,0,0,3.37-.73,2.14,2.14,0,0,0,1.28-1.75l-.27-5.39a2,2,0,0,1-1.2,1.63,7.27,7.27,0,0,1-3.18.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.29,119.89a6.17,6.17,0,0,0,3-.73,2.13,2.13,0,0,0,1.26-1.76l-.27-5.4a2,2,0,0,1-1.18,1.65,5.79,5.79,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.45,122.41c0-.91.53-13.53.68-15s.68-1.81,1.66-2.56a1.12,1.12,0,0,0,.15-1.79,3.5,3.5,0,0,1-1-3.62,19.94,19.94,0,0,0,.81-3.33c.14-1.57.54-2,1.12-1.86a1.23,1.23,0,0,0-.57-.13c-1.48,0-1.22,1.8-1.5,2.88a13.49,13.49,0,0,1-.57,1.53,4.41,4.41,0,0,0,.77,4.7.89.89,0,0,1,.22.58.87.87,0,0,1-.62.84,4.94,4.94,0,0,0-1,.4,1.9,1.9,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.88,2.58,2.39a6.91,6.91,0,0,0,4.7-.25C75.77,126.08,74.46,123.33,74.45,122.41Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.12,98.9c-.16-.38-.41-.74-.53-1.13a7.11,7.11,0,0,1-.24-1.59c0-.17,0-.58-.22-.68s-.3.06-.33.21a7.12,7.12,0,0,0-.16,2.06,6.61,6.61,0,0,0,.57,1.69,7,7,0,0,1,.14,1.93.62.62,0,0,0,.05.27.24.24,0,0,0,.22.14.32.32,0,0,0,.18-.13,1.55,1.55,0,0,0,.36-.49,2.85,2.85,0,0,0,.17-1.63A4.92,4.92,0,0,0,79.12,98.9Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.55,112.26a1.37,1.37,0,0,0,0-2.6,3.38,3.38,0,0,0-.8-.34c2.7,1,1.16,3.32-1.46,3.26-2.29-.06-3.07-1.15-3.1-1.2a1.87,1.87,0,0,0,.85.88A5,5,0,0,0,79.55,112.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.76,116.32a7.56,7.56,0,0,1,6.69,0c1.84,1,1.84,2.7,0,3.74a7.63,7.63,0,0,1-6.69,0C62.92,119,62.92,117.35,64.76,116.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.53,98l0,0a4.43,4.43,0,0,0,.75-4.58,11.27,11.27,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.42,4.42,0,0,0,.76,4.7h0a.86.86,0,0,1,.23.59h0a.86.86,0,0,1-.62.83,4.22,4.22,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.87,2.57,2.39a7.2,7.2,0,0,0,4,0c1.72-.52,2.58-1.45,2.58-2.39L72,101.37a1.87,1.87,0,0,0-1.1-1.54,4.42,4.42,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.88.88,0,0,1,69.53,98Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.53,98l0,0a4.43,4.43,0,0,0,.75-4.58,11.27,11.27,0,0,1-.58-1.6c-.25-1.06,0-2.87-1.51-2.87s-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.42,4.42,0,0,0,.76,4.7h0a.86.86,0,0,1,.23.59h0a.86.86,0,0,1-.62.83,4.22,4.22,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.87,2.57,2.39a7.2,7.2,0,0,0,4,0c1.72-.52,2.58-1.45,2.58-2.39L72,101.37a1.87,1.87,0,0,0-1.1-1.54,4.42,4.42,0,0,0-1-.41.86.86,0,0,1-.62-.83h0A.88.88,0,0,1,69.53,98Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,115.71a7.12,7.12,0,0,1,6.48,0c1.79,1,1.79,2.7,0,3.74a7.18,7.18,0,0,1-6.48,0C63.21,118.41,63.21,116.74,65,115.71Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.33,120.17a9.21,9.21,0,0,0,.91-.2c1.72-.52,2.58-1.45,2.58-2.39L72,101.37a1.87,1.87,0,0,0-1.1-1.54,4.42,4.42,0,0,0-1-.41.86.86,0,0,1-.62-.83A1.17,1.17,0,0,0,70,99.87c.6.39,1.56.33,1.71,2.38s.71,13.91.71,14.89S72.08,119.3,69.33,120.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,117.59l-.59-11.86h0a1.58,1.58,0,0,0-.94-1.3,5,5,0,0,0-4.51,0,1.58,1.58,0,0,0-.93,1.3h0l-.6,11.86a.84.84,0,0,0,.08.31,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0,2.12,2.12,0,0,0,1-1.17A.82.82,0,0,0,72,117.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.57,116a5.91,5.91,0,0,1,5.34,0c1.47.85,1.47,2.23,0,3.08a5.91,5.91,0,0,1-5.34,0C64.1,118.22,64.1,116.84,65.57,116Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,118.72l-.69-14.16-.18-.11-.72.06.72,14.75.39-.19A3,3,0,0,0,71.39,118.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.32,104.66l-.45-.08.53,15a4.28,4.28,0,0,0,.64-.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.65,117.62c.07-1.37.08-7.14.28-11.18l-.14-2.35a4.19,4.19,0,0,0-.81.34,1.58,1.58,0,0,0-.93,1.3h0l-.6,11.86a.84.84,0,0,0,.08.31,2.08,2.08,0,0,0,1,1.17,5.91,5.91,0,0,0,5.34,0C68.63,119.67,66.58,119,66.65,117.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,104.43a5,5,0,0,1,4.51,0c1.25.72,1.25,1.89,0,2.6A5,5,0,0,1,66,107,1.37,1.37,0,0,1,66,104.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,104.43a5,5,0,0,1,4.51,0c1.25.72,1.25,1.89,0,2.6A5,5,0,0,1,66,107,1.37,1.37,0,0,1,66,104.43Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.89,114.44a7.52,7.52,0,0,0,3.37-.73A2.15,2.15,0,0,0,72.54,112l-.27-5.4a2,2,0,0,1-1.2,1.63,7.14,7.14,0,0,1-3.18.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.24,114.67a6.31,6.31,0,0,0,3.05-.73,2.16,2.16,0,0,0,1.26-1.77l-.27-5.4a2,2,0,0,1-1.18,1.65,5.82,5.82,0,0,1-2.86.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4,117.19c0-.92.53-13.53.68-15s.68-1.81,1.66-2.56a1.11,1.11,0,0,0,.14-1.79,3.51,3.51,0,0,1-1-3.62,19.71,19.71,0,0,0,.81-3.33c.14-1.56.54-2,1.11-1.86a1.29,1.29,0,0,0-.56-.12c-1.48,0-1.22,1.79-1.5,2.87a13.49,13.49,0,0,1-.57,1.53,4.42,4.42,0,0,0,.76,4.7.87.87,0,0,1-.39,1.42,4.22,4.22,0,0,0-1,.41,1.87,1.87,0,0,0-1.1,1.54l-.81,16.21c0,.94.86,1.87,2.57,2.39a7.2,7.2,0,0,0,4,0c.25-.08.48-.16.69-.25C66.72,120.86,65.41,118.1,65.4,117.19Z",
    style: {
      fill: "#f0f0f0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.06,93.68c-.15-.38-.4-.74-.52-1.14A6.5,6.5,0,0,1,69.3,91c0-.18,0-.59-.23-.68s-.29,0-.32.2a6.79,6.79,0,0,0-.16,2.06,7,7,0,0,0,.56,1.69,6.34,6.34,0,0,1,.14,1.94.66.66,0,0,0,.06.27.22.22,0,0,0,.21.13.35.35,0,0,0,.19-.12,1.77,1.77,0,0,0,.36-.5,2.84,2.84,0,0,0,.16-1.63A3.69,3.69,0,0,0,70.06,93.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.49,107c1.25-.71,1.25-1.88,0-2.6a3.85,3.85,0,0,0-.8-.34c2.71,1,1.17,3.33-1.45,3.26-2.3-.06-3.07-1.15-3.1-1.2A1.85,1.85,0,0,0,66,107,5,5,0,0,0,70.49,107Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.93 34.68 146.75 16.09 34.09 81.14 34.09 87.22 66.28 105.81 178.93 40.77 178.93 34.68",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.93 34.68 178.93 40.77 66.28 105.81 66.28 99.72 178.93 34.68",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.28 99.72 34.09 81.14 34.09 87.22 66.28 105.81 66.28 99.72",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.28 105.81 66.28 286.8 34.09 268.21 34.09 87.22 66.28 105.81",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.28 105.81 71.64 102.71 71.64 283.7 66.28 286.8 66.28 105.81",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.57 155.23 173.57 218.76 71.64 277.61 71.64 214.07 173.57 155.23",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.11 184.36 122.1 184.94 122.1 248.49 123.11 247.91 123.11 184.36",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7,206v6.2l-.54.31a.62.62,0,0,1-.92-.53v-4.47a1.18,1.18,0,0,1,.58-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.51,201.46v6.2l.54-.31a2.48,2.48,0,0,0,.92-1.59v-4.47c0-.41-.22-.54-.59-.33Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Counter--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--counter--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "81.32 297.24 186.94 358.21 430.66 217.5 268.18 123.69 207.25 158.87 304.74 215.16 182.87 285.51 142.25 262.06 81.32 297.24",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.32 297.24 186.94 358.21 430.66 217.5 268.18 123.69 207.25 158.87 304.74 215.16 182.87 285.51 142.25 262.06 81.32 297.24",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.32 269.1 81.32 283.17 186.94 344.14 186.94 330.07 81.32 269.1",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.32 269.1 81.32 283.17 186.94 344.14 186.94 330.07 81.32 269.1",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.66 189.36 430.66 203.43 186.94 344.14 186.94 330.07 430.66 189.36",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.66 189.36 430.66 203.43 186.94 344.14 186.94 330.07 430.66 189.36",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.25 130.73 207.25 144.8 292.55 194.05 304.74 187.01 207.25 130.73",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.25 130.73 207.25 144.8 292.55 194.05 304.74 187.01 207.25 130.73",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.39 285.51 85.39 294.89 186.94 353.52 186.94 344.14 85.39 285.51",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.39 285.51 85.39 294.89 186.94 353.52 186.94 344.14 85.39 285.51",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.6 205.78 426.6 215.16 186.94 353.52 186.94 344.14 426.6 205.78",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.32 297.24 81.32 381.67 186.94 442.64 186.94 358.21 81.32 297.24",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.32 297.24 81.32 381.67 186.94 442.64 186.94 358.21 81.32 297.24",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.25 158.87 207.25 243.3 280.36 201.09 207.25 158.87",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.25 158.87 207.25 243.3 280.36 201.09 207.25 158.87",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.66 217.5 430.66 301.93 186.94 442.64 186.94 358.21 430.66 217.5",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.66 217.5 430.66 301.93 186.94 442.64 186.94 358.21 430.66 217.5",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.31 147.14 211.31 156.53 284.43 198.74 292.55 194.05 211.31 147.14",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.31 147.14 211.31 156.53 284.43 198.74 292.55 194.05 211.31 147.14",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.32 269.1 186.94 330.07 430.66 189.36 268.18 95.55 207.25 130.73 304.74 187.01 182.87 257.37 142.25 233.92 81.32 269.1",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.32 269.1 186.94 330.07 430.66 189.36 268.18 95.55 207.25 130.73 304.74 187.01 182.87 257.37 142.25 233.92 81.32 269.1",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.24,307.85c-2.94-1.71-7-1.48-11.5,1.12-9,5.18-16.25,17.78-16.25,28.14,0,5.18,1.82,8.81,4.76,10.51l4.06,2.34c2.94,1.7,7,1.47,11.49-1.13,9-5.18,16.25-17.78,16.25-28.14,0-5.2-1.84-8.84-4.81-10.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55,339.45c0-10.36,7.27-23,16.25-28.14s16.25-1,16.25,9.38-7.28,23-16.25,28.14S292.55,349.82,292.55,339.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.81 318.51 320.81 327.76 312.8 332.38 312.8 332.38 312.8 332.38 312.8 341.63 304.79 346.26 304.79 337.01 304.79 337.01 304.79 337.01 296.78 341.63 296.78 332.38 304.79 327.76 304.79 318.51 312.8 313.89 312.8 323.14 320.81 318.51",
    style: {
      fill: "#399252"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pop-display--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.09,217.56a9,9,0,0,1,4.07-7.05l41.49-23.95c2.25-1.3,4.07-.25,4.07,2.35V212L94.81,240.28l-.72-1Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.09,217.56a9,9,0,0,1,4.07-7.05l41.49-23.95c2.25-1.3,4.07-.25,4.07,2.35V212L94.81,240.28l-.72-1Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.81,218a9,9,0,0,1,4.07-7.05l41.49-24c2.25-1.29,4.07-.24,4.07,2.35v22.33L94.81,240.28Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.09 270.17 143.72 241.51 166.63 254.74 117 283.39 94.09 270.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.09 239.31 94.81 240.28 94.81 238.9 143.72 210.66 143.72 241.51 94.09 270.17 94.09 239.31",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.63 254.74 143.72 241.51 143.72 210.66 166.63 241.51 166.63 254.74",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.63 254.74 143.72 241.51 143.72 210.66 166.63 241.51 166.63 254.74",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.63 244.43 136.63 213.58 148.09 206.97 148.09 237.82 136.63 244.43",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.63 244.43 136.63 213.58 148.09 206.97 148.09 237.82 136.63 244.43",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.63 213.58 132.82 211.37 132.82 242.23 136.63 244.43 136.63 213.58",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.63 213.58 132.82 211.37 132.82 242.23 136.63 244.43 136.63 213.58",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.82 211.37 144.27 204.76 148.09 206.97 136.63 213.58 132.82 211.37",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.82 211.37 144.27 204.76 148.09 206.97 136.63 213.58 132.82 211.37",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.42 253.63 120.42 222.77 131.88 216.16 131.88 247.01 120.42 253.63",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.42 253.63 120.42 222.77 131.88 216.16 131.88 247.01 120.42 253.63",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.42 222.77 116.61 220.57 116.61 251.42 120.42 253.63 120.42 222.77",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.42 222.77 116.61 220.57 116.61 251.42 120.42 253.63 120.42 222.77",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.61 220.57 128.06 213.96 131.88 216.16 120.42 222.77 116.61 220.57",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.61 220.57 128.06 213.96 131.88 216.16 120.42 222.77 116.61 220.57",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.21 262.82 104.21 231.97 115.67 225.35 115.67 256.21 104.21 262.82",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.21 262.82 104.21 231.97 115.67 225.35 115.67 256.21 104.21 262.82",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.21 231.97 100.39 229.76 100.39 260.62 104.21 262.82 104.21 231.97",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.21 231.97 100.39 229.76 100.39 260.62 104.21 262.82 104.21 231.97",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.39 229.76 111.85 223.15 115.67 225.35 104.21 231.97 100.39 229.76",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.39 229.76 111.85 223.15 115.67 225.35 104.21 231.97 100.39 229.76",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.72 252.01 143.72 221.15 155.17 214.54 155.17 245.4 143.72 252.01",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.72 252.01 143.72 221.15 155.17 214.54 155.17 245.4 143.72 252.01",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.72 221.15 139.9 218.95 139.9 249.8 143.72 252.01 143.72 221.15",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.72 221.15 139.9 218.95 139.9 249.8 143.72 252.01 143.72 221.15",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.9 218.95 151.36 212.34 155.17 214.54 143.72 221.15 139.9 218.95",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.9 218.95 151.36 212.34 155.17 214.54 143.72 221.15 139.9 218.95",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.51 261.2 127.51 230.35 138.96 223.74 138.96 254.59 127.51 261.2",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.51 261.2 127.51 230.35 138.96 223.74 138.96 254.59 127.51 261.2",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.51 230.35 123.69 228.14 123.69 259 127.51 261.2 127.51 230.35",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.51 230.35 123.69 228.14 123.69 259 127.51 261.2 127.51 230.35",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.69 228.14 135.15 221.53 138.96 223.74 127.51 230.35 123.69 228.14",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.69 228.14 135.15 221.53 138.96 223.74 127.51 230.35 123.69 228.14",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 270.4 111.3 239.54 122.75 232.93 122.75 263.79 111.3 270.4",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 270.4 111.3 239.54 122.75 232.93 122.75 263.79 111.3 270.4",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 239.54 107.48 237.34 107.48 268.19 111.3 270.4 111.3 239.54",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 239.54 107.48 237.34 107.48 268.19 111.3 270.4 111.3 239.54",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.48 237.34 118.94 230.73 122.75 232.93 111.3 239.54 107.48 237.34",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.48 237.34 118.94 230.73 122.75 232.93 111.3 239.54 107.48 237.34",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.81 259.58 150.81 228.73 162.26 222.12 162.26 252.97 150.81 259.58",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.81 259.58 150.81 228.73 162.26 222.12 162.26 252.97 150.81 259.58",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.81 228.73 146.99 226.52 146.99 257.38 150.81 259.58 150.81 228.73",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.81 228.73 146.99 226.52 146.99 257.38 150.81 259.58 150.81 228.73",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.99 226.52 158.44 219.91 162.26 222.12 150.81 228.73 146.99 226.52",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.99 226.52 158.44 219.91 162.26 222.12 150.81 228.73 146.99 226.52",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.6 268.78 134.6 237.92 146.05 231.31 146.05 262.17 134.6 268.78",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.6 268.78 134.6 237.92 146.05 231.31 146.05 262.17 134.6 268.78",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.6 237.92 130.78 235.72 130.78 266.57 134.6 268.78 134.6 237.92",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.6 237.92 130.78 235.72 130.78 266.57 134.6 268.78 134.6 237.92",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.78 235.72 142.23 229.11 146.05 231.31 134.6 237.92 130.78 235.72",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.78 235.72 142.23 229.11 146.05 231.31 134.6 237.92 130.78 235.72",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.39 277.97 118.39 247.12 129.84 240.5 129.84 271.36 118.39 277.97",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.39 277.97 118.39 247.12 129.84 240.5 129.84 271.36 118.39 277.97",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.39 247.12 114.57 244.91 114.57 275.77 118.39 277.97 118.39 247.12",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.39 247.12 114.57 244.91 114.57 275.77 118.39 277.97 118.39 247.12",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.57 244.91 126.02 238.3 129.84 240.5 118.39 247.12 114.57 244.91",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.57 244.91 126.02 238.3 129.84 240.5 118.39 247.12 114.57 244.91",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117 270.17 166.63 241.51 166.63 254.74 117 283.39 117 270.17",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.09 270.17 117 283.39 117 270.17 94.09 239.31 94.09 270.17",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.09 270.17 117 283.39 117 270.17 94.09 239.31 94.09 270.17",
    style: {
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M342.74,156.92l10.44-6c1.57-.91,1.57-2.37,0-3.28l-74.91-43.25a6.27,6.27,0,0,0-5.69,0l-10.44,6c-1.56.91-1.56,2.38,0,3.28l74.92,43.26A6.31,6.31,0,0,0,342.74,156.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M306.24,156l-18.88,11a2.25,2.25,0,0,1-2,0L232.21,136.4a.62.62,0,0,1,0-1.17l18.89-11a2.25,2.25,0,0,1,2,0l53.12,30.63C306.8,155.18,306.8,155.7,306.24,156Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.66,133a.71.71,0,0,1,.42-.58l16.81-9.71a2.22,2.22,0,0,1,2,0l51.3,29.67a.71.71,0,0,1,.42.58v1.76a.71.71,0,0,1-.42.58L287.39,165a2.23,2.23,0,0,1-2,0l-51.31-29.62a.71.71,0,0,1-.42-.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.39,163.18l16.81-9.66a.61.61,0,0,0,0-1.16l-51.3-29.67a2.22,2.22,0,0,0-2,0l-16.81,9.71a.61.61,0,0,0,0,1.16l51.31,29.62A2.2,2.2,0,0,0,287.39,163.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.46,163.42v1.8a2.17,2.17,0,0,0,.94-.23l16.8-9.71a.71.71,0,0,0,.41-.58v-1.76a.73.73,0,0,1-.41.58l-16.8,9.66A2,2,0,0,1,286.46,163.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8,133v0l1.67-1,2.25,1.31-1.67,1-2.26-1.3Zm2.61-1.5s0,0,0,0l1.66-1,1.77,1-1.67,1-1.77-1Zm.54,3.33s0,0,0,0l1.66-1,1.77,1-1.67,1-1.77-1ZM242,130s0,0,0,0l1.67-1,2.86,1.66-1.67,1L242,130.05Zm.06,3a0,0,0,0,1,0,0l1.66-1,1.41.81-1.68,1-1.4-.82Zm.55,3.33v0l1.67-1,1.77,1-1.67,1-1.77-1Zm1.76-2v0l1.66-1,1.41.81-1.67,1-1.41-.82Zm.24-5.88s0,0,0,0l1.66-1,2.26,1.3-1.68,1-2.25-1.3Zm.67,9.42v0l1.67-1,12.81,7.39-1.68,1L245.29,138Zm.48-5.74a0,0,0,0,1,0,0l1.67-1,1.4.81-1.67,1-1.41-.81Zm.91,3.53a0,0,0,0,1,0,0l1.66-1,1.41.81-1.68,1-1.4-.81Zm.54-8.71a0,0,0,0,1,0,0l1.67-1,1.4.81-1.67,1-1.41-.81Zm.55,3.32v0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.31,3.19s0,0,0,0l1.66-1,1.41.81-1.68,1-1.4-.81Zm.91,3.53v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.54-8.71s0,0,0,0l1.66-1,1.41.81-1.68,1-1.4-.81Zm.54,3.32s0,0,0,0l1.66-1,1.41.82-1.68,1-1.4-.81Zm.31,3.19v0l1.67-1,1.4.81-1.67,1-1.41-.81Zm0-9.67a0,0,0,0,1,0,0l1.67-1,1.77,1-1.68,1-1.77-1Zm.91,13.2a0,0,0,0,1,0,0l1.66-1,1.41.82-1.68,1-1.4-.81Zm.54-8.71v0l1.67-1,1.4.81-1.67,1-1.41-.81Zm.55,3.33s0,0,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.31,3.18s0,0,0,0l1.66-1,1.41.81-1.68,1-1.4-.81Zm.91,3.53v0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.45-12.41v0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.08,3.7a0,0,0,0,1,0,0l1.66-1,1.41.81-1.68,1-1.4-.82Zm.55,3.33s0,0,0,0l1.66-1,1.41.82-1.68,1-1.4-.81Zm.31,3.18v0l1.67-1,1.4.81-1.67,1-1.41-.82Zm.91,3.54s0,0,0,0l1.67-1,1.41.82-1.68,1-1.4-.81Zm.46-12.42a0,0,0,0,1,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.08,3.7v0l1.66-1,1.41.81-1.67,1-1.41-.82Zm.55,3.33a0,0,0,0,1,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.3,3.18a0,0,0,0,1,0,0l1.66-1,1.41.81-1.68,1-1.4-.82Zm.92,3.54s0,0,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.45-12.42v0l1.67-1,1.41.82-1.68,1-1.41-.81Zm.08,3.7a0,0,0,0,1,0,0l1.66-1,1.41.81-1.68,1-1.4-.82Zm.26,12.18a0,0,0,0,1,0,0l1.66-1,1.78,1-1.68,1-1.77-1Zm.29-8.85v0l1.67-1,1.41.82-1.68,1-1.4-.81Zm.31,3.18v0l1.67-1,1.4.81L261,141l-1.41-.82Zm.91,3.54s0,0,0,0l1.67-1,1.41.82-1.68,1-1.4-.81Zm.46-12.41s0,0,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.08,3.69v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.55,3.33v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.07,9.06a0,0,0,0,1,0,0l1.66-1,1.78,1-1.68,1-1.77-1Zm.23-5.88a0,0,0,0,1,0,0l1.66-1,1.41.81-1.68,1-1.4-.82Zm.92,3.54v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.53-8.72v0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.55,3.33v0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.31,3.18v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.06-9.62s0,0,0,0l1.66-1,1.41.82-1.68,1-1.4-.81Zm.07,15.71s0,0,0,0l1.66-1,1.77,1-1.67,1-1.77-1Zm.78-2.55v0l1.67-1,1.4.81-1.67,1-1.41-.81Zm.54-8.72v0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.55,3.33v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.3,3.18a0,0,0,0,1,0,0l1.67-1,1.41.82-1.68,1-1.4-.81Zm.07-9.62s0,0,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.43,15.92s0,0,0,0l1.66-1,2.26,1.3-1.68,1L267,150.5Zm.42-2.76s0,0,0,0l1.66-1,4.44,2.56-1.67,1-4.44-2.56ZM268,139s0,0,0,0l1.67-1,1.41.82-1.68,1L268,139Zm.55,3.33a0,0,0,0,1,0,0l1.67-1,1.41.81-1.68,1-1.41-.81Zm.31,3.18v0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.06-9.62,0,0,1.66-1,1.41.82-1.68,1-1.4-.81Zm1.39,4.45s0,0,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.37,12.24s0,0,0,0l1.67-1,1.41.82-1.68,1-1.4-.81Zm.18-8.92s0,0,0,0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.3,3.19s0,0,0,0l1.67-1,1.29.75a1.06,1.06,0,0,0,.83,0l2.18-1.26,1.65.95-4.28,2.5-3.34-1.93Zm.07-9.63v0l1.66-1,1.41.82-1.67,1-1.41-.81Zm1.38,4.45v0l1.67-1,1.41.82-1.68,1-1.4-.81Zm.38,12.25s0,0,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.17-8.93a0,0,0,0,1,0,0l1.67-1,1.4.81-1.67,1-1.41-.82Zm1.38-5.86s0,0,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.38,3.87a0,0,0,0,1,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.37,12.25s0,0,0,0l1.66-1,1.41.82-1.68,1-1.4-.81Zm.3-2.84v0l1.67-1,1.41.81-1.68,1-1.4-.82Zm1.25-11.95a0,0,0,0,1,0,0l1.67-1,1.4.82-1.67,1-1.41-.81Zm.38,3.87a0,0,0,0,1,0,0l1.67-1,2.5,1.44-1.68,1-2.49-1.44Zm.86,12.53a0,0,0,0,1,0,0l1.67-1,3.71,2.15-1.67,1-3.71-2.14Zm.42-8.79v0l1.66-1,1.41.81-1.67,1-1.41-.82Zm.65-6.28s0,0,0,0l1.66-1,1.41.81-1.68,1-1.4-.81Zm1.54,13.56v0l1.66-1,1.41.81-1.67,1-1.41-.82Zm.11-5.95a0,0,0,0,1,0,0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.3-2.83,0,0,1.66-1,1.41.81-1.68,1-1.4-.81Zm.35-3.45v0l1.67-1,1.4.81-1.67,1-1.41-.81Zm1.24,16.4a0,0,0,0,1,0,0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.3-2.84a0,0,0,0,1,0,0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.12-6v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.18,3.12v0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.12-5.95a0,0,0,0,1,0,0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.85-3.16a0,0,0,0,1,0,0l1.66-1,1.41.81-1.68,1-1.4-.81Zm.74,16.11v0l4.27-2.47,1.41.82-4.28,2.49-1.41-.81Zm.3-2.84v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm.3-2.83a0,0,0,0,1,0,0l1.66-1,1.41.81L287,156l-1.41-.81Zm.11-6v0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.19,3.11v0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.67-6.27v0l1.66-1,1.41.81-1.67,1-1.41-.81Zm1.33,10.44v0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.3-2.83s0,0,0,0l1.67-1,1.41.82-1.68,1-1.4-.81Zm.3-2.84v0l1.67-1,1.41.81-1.68,1-1.4-.81Zm.37-3.44s0,0,0,0l1.66-1,1.41.82-1.68,1-1.4-.81Zm1.34,10.44v0l4.27-2.47,1.41.82-4.28,2.5-1.41-.82Zm.3-2.83s0,0,0,0l1.66-1,1.41.82-1.67,1-1.41-.81Zm.3-2.84s0,0,0,0l1.66-1,1.41.81-1.67,1-1.41-.82Zm1.52-3.54,0,0,.7-.42,1.41.81-.72.45-1.4-.81Zm.78,4.87v0l1.67-1,1.41.81-1.68,1-1.4-.82ZM294.6,150a0,0,0,0,1,0,0l.71-.42,1.41.81-.73.45-1.4-.81Zm.78,4.87s0,0,0,0l1.66-1,1.41.81-1.67,1-1.41-.81Zm1.52-3.54v0l.71-.42,1.41.81-.72.45-1.4-.81Zm2.31,1.33v0l.71-.42,1.4.82-.72.44-1.4-.81Z",
    style: {
      fill: "#399252"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.26,143.41l-11.51-6.66a3,3,0,0,1-1.77-2.48c0-.89,0-1.6,0-1.6l10.83-6.14a2.55,2.55,0,0,0,1.14-2V110.35L313.05,122v14.19a2.53,2.53,0,0,1-1.15,2l-9,5.27A9.51,9.51,0,0,1,294.26,143.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.22,138.67v1.59l3.68-2.12a2.53,2.53,0,0,0,1.15-2V122l-3.83-2.21c-.08,1-.17,2-.25,3l2.69,1.55v11.09a2.52,2.52,0,0,1-1.14,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.66,135.36a2.5,2.5,0,0,1-1.15,2l-7.65,4.47a9.51,9.51,0,0,1-8.6,0l-11.51-6.66c-2.37-1.36-2.37-3.59,0-5l7.66-4.47a2.54,2.54,0,0,0,1.15-2V112.66l20.1,11.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.08,127.08h0l2.33-1.34a2.54,2.54,0,0,0,1.15-2V112.66l20.1,11.61v11.09a2.5,2.5,0,0,1-1.15,2l-2.29,1.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.87,148.33a3.77,3.77,0,0,1-3-.17l-72.4-41.83a2.56,2.56,0,0,1-1.21-2.36l8.27-57.78A3.16,3.16,0,0,1,273.32,44a3.77,3.77,0,0,1,3,.17L348.7,86a2.56,2.56,0,0,1,1.21,2.36l-8.27,57.77A3.16,3.16,0,0,1,339.87,148.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.89,148.16l-72.4-41.84a2.54,2.54,0,0,1-1.21-2.35l8.27-57.78c.12-.84.86-1.15,1.65-.7l72.4,41.83a2.56,2.56,0,0,1,1.21,2.36l-8.27,57.78C338.42,148.3,337.68,148.61,336.89,148.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.76,139.59l7-49.21a1.53,1.53,0,0,0-.72-1.41L274.91,49.58c-.48-.27-.92-.09-1,.42l-7.05,49.21a1.52,1.52,0,0,0,.73,1.41L335.77,140A.6.6,0,0,0,336.76,139.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,57.47l59.61,34.41a1.4,1.4,0,0,1,.66,1.29L333,133.25a.55.55,0,0,1-.9.38L272.46,99.22a1.4,1.4,0,0,1-.66-1.29l5.74-40.08A.55.55,0,0,1,278.44,57.47Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.44,57.47l59.61,34.41a1.4,1.4,0,0,1,.66,1.29L333,133.25a.55.55,0,0,1-.9.38L272.46,99.22a1.4,1.4,0,0,1-.66-1.29l5.74-40.08A.55.55,0,0,1,278.44,57.47Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.37,70.68l38.79,22.4a2.64,2.64,0,0,1,1.25,2.44l-3.8,26.53c-.12.88-.89,1.2-1.71.73l-38.78-22.41a2.65,2.65,0,0,1-1.26-2.44l3.8-26.52C283.78,70.53,284.55,70.21,285.37,70.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,98.29a.4.4,0,0,0,.34-.14.28.28,0,0,0-.07-.44l-4.94-2.83a.43.43,0,0,0-.52.1.27.27,0,0,0,.07.44l4.94,2.82A.35.35,0,0,0,322.75,98.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.32,101.26a.4.4,0,0,0,.34-.14.27.27,0,0,0-.07-.44l-4.94-2.83a.43.43,0,0,0-.52.1.29.29,0,0,0,.07.44l4.94,2.82A.31.31,0,0,0,322.32,101.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9,104.24a.45.45,0,0,0,.34-.15.29.29,0,0,0-.07-.44l-4.94-2.82a.43.43,0,0,0-.53.09.28.28,0,0,0,.08.44l4.94,2.83A.48.48,0,0,0,321.9,104.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.47,107.21a.43.43,0,0,0,.34-.15.28.28,0,0,0-.07-.44l-4.94-2.82a.41.41,0,0,0-.52.09.28.28,0,0,0,.07.44l4.94,2.83A.41.41,0,0,0,321.47,107.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.05,110.18a.45.45,0,0,0,.34-.15.28.28,0,0,0-.07-.43l-4.95-2.83a.43.43,0,0,0-.52.09.28.28,0,0,0,.08.44l4.94,2.83A.35.35,0,0,0,321.05,110.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.76,94.34a.43.43,0,0,0,.34-.15.28.28,0,0,0-.07-.44l-29.31-16.9a.43.43,0,0,0-.52.09.28.28,0,0,0,.07.44l29.31,16.91A.53.53,0,0,0,315.76,94.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.33,97.31a.47.47,0,0,0,.35-.15.28.28,0,0,0-.08-.44l-29.3-16.9a.43.43,0,0,0-.52.1.27.27,0,0,0,.07.43l29.31,16.91A.48.48,0,0,0,315.33,97.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.91,100.28a.43.43,0,0,0,.34-.15.29.29,0,0,0-.07-.44l-29.31-16.9a.43.43,0,0,0-.52.1.29.29,0,0,0,.07.44l29.31,16.9A.37.37,0,0,0,314.91,100.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.48,103.25a.44.44,0,0,0,.35-.15.27.27,0,0,0-.08-.43l-29.3-16.91a.44.44,0,0,0-.53.1.28.28,0,0,0,.08.44l29.3,16.9A.41.41,0,0,0,314.48,103.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.06,106.22a.42.42,0,0,0,.34-.14.28.28,0,0,0-.07-.44L285,88.73a.43.43,0,0,0-.52.1.29.29,0,0,0,.07.44l29.31,16.9A.35.35,0,0,0,314.06,106.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.77,119.09a.4.4,0,0,0,.34-.14.28.28,0,0,0-.07-.44L283.76,97.62a.43.43,0,0,0-.52.1.28.28,0,0,0,.08.44L319.59,119A.41.41,0,0,0,319.77,119.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.71,93.16a1.38,1.38,0,0,0-.66-1.28L278.44,57.47a.55.55,0,0,0-.9.38l-.44,3.08,61.17,35.32Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.82,121.44a2.41,2.41,0,0,1,1.14,2.21,1,1,0,0,1-1.55.66,2.37,2.37,0,0,1-1.14-2.21A1,1,0,0,1,299.82,121.44Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.64,87l-3.09,1.31a2.38,2.38,0,0,1,.27,1.33l-7.29,50.87-1,7.07a1,1,0,0,1-1.44.81,3.84,3.84,0,0,0,2.77.06,3.21,3.21,0,0,0,1.77-2.19l1-7.06,7.28-50.87A2.29,2.29,0,0,0,349.64,87Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.13,170l6.7,3.87a7.4,7.4,0,0,0,7.4-.39l11-8.07c2-1.43,1.85-3.59-.25-4.81l-3.36-1.95a9.15,9.15,0,0,0-7.77-.23l-13.64,7.4C303.08,166.88,303,168.75,305.13,170Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,161.88l-7.65,6-5.64,4.42a5.16,5.16,0,0,1-1.8.43,4.86,4.86,0,0,1-2.67-.57l-6-3.46h0l0,0a4.22,4.22,0,0,1-1.21-6.06l.17-.25a8,8,0,0,1,4.82-3.05l3-.61c4.92-1,8.95-1.48,9.42-1.17l7.51,4.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.18,165.22l.43-.34L319.87,161l5.9-1.83-.59-.34-5.9,1.82-4-2.32-.76.15Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,171.9l0,0h0l5.37-3.88,7.24-5.23v-.82s0-.05,0-.06l0,0c-.53-.19-3.68.76-7.47,2.27l-2.52,1a7.9,7.9,0,0,0-2.15,1.28,8,8,0,0,0-2.9,6.17v.13a5.16,5.16,0,0,0,1.8-.43Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pill-bottles--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.93,281.57a13.75,13.75,0,0,0,12.4,0c3.42-2,3.42-5.19,0-7.16a13.69,13.69,0,0,0-12.4,0C192.5,276.38,192.5,279.59,195.93,281.57Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.87,263.4c0-1.22-.81-2.44-2.42-3.37a12.88,12.88,0,0,0-11.69,0c-1.62.93-2.42,2.15-2.42,3.37h0v14.05h0c0,1.23.8,2.45,2.42,3.38a12.94,12.94,0,0,0,11.69,0c1.61-.93,2.42-2.15,2.42-3.38h0Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.69,259.65v21.56c.26-.12.52-.24.76-.38a6.63,6.63,0,0,0,1.31-1V261a6.6,6.6,0,0,0-1.31-1A6.73,6.73,0,0,0,207.69,259.65Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,281.91a9,9,0,0,0,1.19-.32V259.27a10.92,10.92,0,0,0-1.19-.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.72,262.52a5.83,5.83,0,0,0-1.92-1.67,13.86,13.86,0,0,0-11.65-.38v-.65c-.13.07-.27.13-.39.21-1.62.93-2.42,2.15-2.42,3.37v3.23h0v6.2h0v4.62c0,1.23.8,2.45,2.42,3.38a12.94,12.94,0,0,0,11.69,0,6.37,6.37,0,0,0,1.47-1.15c-1.54,1.43-5.36,2.22-8.21,1.66s-4.56-2.37-4.56-3.66v-1.25a12.36,12.36,0,0,0,5.71,1.27v-6.3a12.33,12.33,0,0,1-5.71-1.17v-1.84A13.86,13.86,0,0,0,208.8,268a5.69,5.69,0,0,0,2.07-1.91v-2.7A2.71,2.71,0,0,0,210.72,262.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,278.05v-17.3a3.54,3.54,0,0,0-1.39,2.65v14.05c0,1.23.8,2.45,2.42,3.38A10.27,10.27,0,0,0,199.9,282C196.79,281.12,195.73,279,195.73,278.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.37,259.63c0-1.3-.86-2.59-2.57-3.58a13.69,13.69,0,0,0-12.4,0c-1.71,1-2.57,2.28-2.57,3.58h0v3.88h0c0,1.3.86,2.59,2.57,3.58a13.69,13.69,0,0,0,12.4,0c1.71-1,2.57-2.28,2.57-3.58h0v-3.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-15--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 211.16,
    y: 259.27,
    width: 0.42,
    height: 6.04
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 210.19,
    y: 260.9,
    width: 0.42,
    height: 6.08
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 208.73,
    y: 262.02,
    width: 0.42,
    height: 6.11
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 207.06,
    y: 262.72,
    width: 0.42,
    height: 6.14
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 205.22,
    y: 263.19,
    width: 0.42,
    height: 6.18
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 203.28,
    y: 263.42,
    width: 0.42,
    height: 6.21
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 201.31,
    y: 263.41,
    width: 0.42,
    height: 6.24
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 199.38,
    y: 263.16,
    width: 0.42,
    height: 6.27
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 197.58,
    y: 262.64,
    width: 0.42,
    height: 6.31
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 195.94,
    y: 261.83,
    width: 0.42,
    height: 6.34
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 194.65,
    y: 260.72,
    width: 0.42,
    height: 6.37
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 193.62,
    y: 258.91,
    width: 0.42,
    height: 6.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M204.7,268.42c-4.34,0-6.63-1.38-7.32-2.53a9,9,0,0,1-.62-4.09s-.49-3.64-.4-3.66-1-.24-1.88-.42a3.31,3.31,0,0,0-.65,1.91h0v3.88h0c0,1.3.86,2.59,2.57,3.58A13.49,13.49,0,0,0,204.7,268.42Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,263.21a13.75,13.75,0,0,0,12.4,0c3.42-2,3.42-5.19,0-7.16a13.69,13.69,0,0,0-12.4,0C193,258,193,261.23,196.4,263.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.27,262.9c2.94-2,2.79-5-.47-6.85a12.46,12.46,0,0,0-6-1.48,9.76,9.76,0,0,0-3.2,1.09c-3,1.69-3,5.07,0,6.76A12.1,12.1,0,0,0,209.27,262.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.23,280.45a13.46,13.46,0,0,0,10.74,0c3-1.49,3-3.9,0-5.39a13.46,13.46,0,0,0-10.74,0C194.27,276.55,194.27,279,197.23,280.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,267c0,1.22.8,2.44,2.42,3.38a12,12,0,0,0,5.84,1.39V278a12,12,0,0,1-5.84-1.4c-1.62-.93-2.42-2.15-2.42-3.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,261.57a11.74,11.74,0,0,0,8.36,2.72c5.51-.15,7.72-3.16,8-4.09a3.43,3.43,0,0,0-.75-3.17,3.65,3.65,0,0,1,1.25,2.6v3.88c0,.33.17,1.46-1.61,2.92a4.29,4.29,0,0,0,1-2.32v-2.68s-2,3.26-7.94,3.26S194.81,262.06,194.5,261.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.24,293.29a13.69,13.69,0,0,0,12.4,0c3.42-2,3.42-5.18,0-7.16a13.75,13.75,0,0,0-12.4,0C212.81,288.11,212.81,291.31,216.24,293.29Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.18,275.13c0-1.22-.81-2.44-2.42-3.38a12.94,12.94,0,0,0-11.69,0c-1.62.94-2.42,2.16-2.42,3.38h0v14.05h0c0,1.22.8,2.44,2.42,3.37a12.88,12.88,0,0,0,11.69,0c1.61-.93,2.42-2.15,2.42-3.37h0Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,271.37v21.57c.26-.12.52-.25.76-.39a6.6,6.6,0,0,0,1.31-1V272.75a6.63,6.63,0,0,0-1.31-1C228.52,271.61,228.26,271.49,228,271.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.83,293.64a10.92,10.92,0,0,0,1.19-.33V271c-.38-.12-.78-.23-1.19-.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,274.25a5.83,5.83,0,0,0-1.92-1.67,13.82,13.82,0,0,0-11.65-.38v-.65l-.39.2c-1.62.94-2.42,2.16-2.42,3.38v3.23h0v6.19h0v4.63c0,1.22.8,2.44,2.42,3.37a12.88,12.88,0,0,0,11.69,0,5.87,5.87,0,0,0,1.47-1.15c-1.54,1.44-5.36,2.23-8.21,1.67s-4.56-2.38-4.56-3.66v-1.26a12.24,12.24,0,0,0,5.71,1.28v-6.3a12.45,12.45,0,0,1-5.71-1.17v-1.84a13.86,13.86,0,0,0,11.65-.39,5.67,5.67,0,0,0,2.07-1.9v-2.7A2.67,2.67,0,0,0,231,274.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,289.77V272.48a3.52,3.52,0,0,0-1.39,2.65v14.05c0,1.22.8,2.44,2.42,3.37a10,10,0,0,0,3.14,1.13C217.1,292.84,216,290.72,216,289.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,271.35c0-1.29-.86-2.59-2.57-3.58a13.75,13.75,0,0,0-12.4,0c-1.71,1-2.57,2.29-2.57,3.58h0v3.89h0c0,1.29.86,2.59,2.57,3.58a13.75,13.75,0,0,0,12.4,0c1.71-1,2.57-2.29,2.57-3.58h0v-3.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-16--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 231.47,
    y: 270.99,
    width: 0.42,
    height: 6.04
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 230.5,
    y: 272.63,
    width: 0.42,
    height: 6.08
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 229.04,
    y: 273.75,
    width: 0.42,
    height: 6.11
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 227.37,
    y: 274.45,
    width: 0.42,
    height: 6.14
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 225.53,
    y: 274.91,
    width: 0.42,
    height: 6.18
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 223.59,
    y: 275.15,
    width: 0.42,
    height: 6.21
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 221.62,
    y: 275.14,
    width: 0.42,
    height: 6.24
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 219.69,
    y: 274.88,
    width: 0.42,
    height: 6.27
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 217.89,
    y: 274.36,
    width: 0.42,
    height: 6.31
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 273.56,
    width: 0.42,
    height: 6.34
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 214.96,
    y: 272.44,
    width: 0.42,
    height: 6.37
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 213.93,
    y: 270.63,
    width: 0.42,
    height: 6.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M225,280.15c-4.34,0-6.63-1.39-7.32-2.54a9,9,0,0,1-.62-4.08s-.49-3.65-.4-3.66-1-.24-1.88-.42a3.28,3.28,0,0,0-.65,1.9h0v3.89h0c0,1.29.86,2.59,2.57,3.58A13.49,13.49,0,0,0,225,280.15Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.71,274.93a13.69,13.69,0,0,0,12.4,0c3.42-2,3.42-5.18,0-7.16a13.75,13.75,0,0,0-12.4,0C213.29,269.75,213.29,273,216.71,274.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.58,274.63c2.94-2,2.79-5-.47-6.86a12.57,12.57,0,0,0-6-1.47,9.61,9.61,0,0,0-3.2,1.09c-3,1.69-3,5.07,0,6.76A12.1,12.1,0,0,0,229.58,274.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.54,292.18a13.46,13.46,0,0,0,10.74,0c3-1.49,3-3.91,0-5.4a13.46,13.46,0,0,0-10.74,0C214.58,288.27,214.58,290.69,217.54,292.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.65,278.77c0,1.22.8,2.44,2.42,3.37a12,12,0,0,0,5.84,1.4v6.19a12,12,0,0,1-5.84-1.39c-1.62-.94-2.42-2.16-2.42-3.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.81,273.3a11.74,11.74,0,0,0,8.36,2.72c5.51-.15,7.72-3.16,8-4.09a3.45,3.45,0,0,0-.75-3.18,3.69,3.69,0,0,1,1.25,2.6v3.89c0,.33.17,1.46-1.61,2.92a4.29,4.29,0,0,0,1-2.32v-2.69s-2,3.26-7.94,3.26S215.12,273.79,214.81,273.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.68,291a13.75,13.75,0,0,0,12.4,0c3.42-2,3.42-5.19,0-7.16a13.69,13.69,0,0,0-12.4,0C176.26,285.76,176.26,289,179.68,291Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,272.78c0-1.22-.81-2.44-2.42-3.37a12.88,12.88,0,0,0-11.69,0c-1.62.93-2.42,2.15-2.42,3.37h0v14.05h0c0,1.23.8,2.45,2.42,3.38a12.94,12.94,0,0,0,11.69,0c1.61-.93,2.42-2.15,2.42-3.38h0Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,269v21.56c.26-.12.52-.24.76-.38a6,6,0,0,0,1.31-1v-18.8a6,6,0,0,0-1.31-1A6.73,6.73,0,0,0,191.44,269Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.28,291.3a11.41,11.41,0,0,0,1.18-.33V268.65a11.41,11.41,0,0,0-1.18-.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,271.9a5.87,5.87,0,0,0-1.93-1.67,13.86,13.86,0,0,0-11.65-.38v-.65l-.39.21c-1.62.93-2.42,2.15-2.42,3.37V276h0v6.2h0v4.62c0,1.23.8,2.45,2.42,3.38a12.94,12.94,0,0,0,11.69,0,6.37,6.37,0,0,0,1.47-1.15c-1.54,1.43-5.36,2.22-8.21,1.66s-4.56-2.37-4.56-3.66v-1.25a12.38,12.38,0,0,0,5.72,1.27v-6.3a12.34,12.34,0,0,1-5.72-1.17v-1.84a13.86,13.86,0,0,0,11.65-.38,5.61,5.61,0,0,0,2.07-1.91v-2.7A3,3,0,0,0,194.48,271.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,287.43v-17.3a3.54,3.54,0,0,0-1.39,2.65v14.05c0,1.23.8,2.45,2.42,3.38a10.27,10.27,0,0,0,3.14,1.13C180.54,290.5,179.48,288.38,179.48,287.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.12,269c0-1.3-.86-2.59-2.57-3.58a13.69,13.69,0,0,0-12.4,0c-1.71,1-2.56,2.28-2.56,3.58h0v3.88h0c0,1.3.85,2.59,2.56,3.58a13.69,13.69,0,0,0,12.4,0c1.71-1,2.57-2.28,2.57-3.58h0V269Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-17--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 194.91,
    y: 268.65,
    width: 0.42,
    height: 6.04
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 193.94,
    y: 270.28,
    width: 0.42,
    height: 6.08
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 192.48,
    y: 271.4,
    width: 0.42,
    height: 6.11
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 190.81,
    y: 272.1,
    width: 0.42,
    height: 6.14
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 188.97,
    y: 272.57,
    width: 0.42,
    height: 6.18
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 187.03,
    y: 272.8,
    width: 0.42,
    height: 6.21
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 185.06,
    y: 272.79,
    width: 0.42,
    height: 6.24
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 183.13,
    y: 272.54,
    width: 0.42,
    height: 6.27
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 181.33,
    y: 272.02,
    width: 0.42,
    height: 6.31
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 179.7,
    y: 271.21,
    width: 0.42,
    height: 6.34
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 178.4,
    y: 270.1,
    width: 0.42,
    height: 6.37
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 177.38,
    y: 268.29,
    width: 0.42,
    height: 6.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,277.8c-4.34,0-6.63-1.38-7.32-2.53a9,9,0,0,1-.62-4.09s-.49-3.64-.4-3.65-1-.25-1.88-.43a3.29,3.29,0,0,0-.64,1.91h0v3.88h0c0,1.3.85,2.59,2.56,3.58A13.49,13.49,0,0,0,188.45,277.8Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.15,272.59a13.75,13.75,0,0,0,12.4,0c3.43-2,3.43-5.18,0-7.16a13.69,13.69,0,0,0-12.4,0C176.73,267.41,176.73,270.61,180.15,272.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,272.29c2.94-2,2.79-5-.47-6.86a12.69,12.69,0,0,0-6-1.48,9.84,9.84,0,0,0-3.2,1.09c-3,1.69-3,5.07,0,6.76A12.14,12.14,0,0,0,193,272.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,289.83a13.46,13.46,0,0,0,10.74,0c3-1.49,3-3.9,0-5.39a13.46,13.46,0,0,0-10.74,0C178,285.93,178,288.34,181,289.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.09,276.42c0,1.22.8,2.44,2.42,3.38a12,12,0,0,0,5.84,1.39v6.2a12,12,0,0,1-5.84-1.4c-1.62-.93-2.42-2.15-2.42-3.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.26,271s2.85,2.87,8.36,2.72,7.71-3.16,8-4.09a3.45,3.45,0,0,0-.74-3.17,3.68,3.68,0,0,1,1.24,2.6v3.88c0,.33.17,1.46-1.61,2.93a4.34,4.34,0,0,0,1-2.33v-2.68s-2,3.26-7.93,3.26S178.56,271.44,178.26,271Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,302.67a13.69,13.69,0,0,0,12.4,0c3.42-2,3.42-5.18,0-7.16a13.75,13.75,0,0,0-12.4,0C196.57,297.49,196.57,300.7,200,302.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.93,284.51c0-1.22-.81-2.44-2.42-3.38a12.94,12.94,0,0,0-11.69,0c-1.62.94-2.42,2.16-2.42,3.38h0v14.05h0c0,1.22.8,2.44,2.42,3.38a12.94,12.94,0,0,0,11.69,0c1.61-.94,2.42-2.16,2.42-3.38h0Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75,280.75v21.57l.76-.38a6.72,6.72,0,0,0,1.31-1V282.13a6.72,6.72,0,0,0-1.31-1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.59,303c.4-.09.8-.2,1.18-.32V280.37c-.38-.12-.78-.23-1.18-.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.79,283.63a5.87,5.87,0,0,0-1.93-1.67,13.82,13.82,0,0,0-11.65-.38v-.65l-.39.2c-1.62.94-2.42,2.16-2.42,3.38v3.23h0v6.19h0v4.63c0,1.22.8,2.44,2.42,3.38a12.94,12.94,0,0,0,11.69,0,6.13,6.13,0,0,0,1.47-1.16c-1.54,1.44-5.36,2.23-8.21,1.67s-4.56-2.37-4.56-3.66v-1.26a12.26,12.26,0,0,0,5.72,1.28v-6.3a12.34,12.34,0,0,1-5.72-1.17V289.5a13.89,13.89,0,0,0,11.65-.38,5.69,5.69,0,0,0,2.07-1.91v-2.7A2.94,2.94,0,0,0,214.79,283.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.79,299.15V281.86a3.52,3.52,0,0,0-1.39,2.65v14.05c0,1.22.8,2.44,2.42,3.38a10.54,10.54,0,0,0,3.14,1.13C200.85,302.22,199.79,300.1,199.79,299.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.43,280.73c0-1.29-.86-2.59-2.57-3.58a13.75,13.75,0,0,0-12.4,0c-1.71,1-2.56,2.29-2.56,3.58h0v3.89h0c0,1.3.85,2.59,2.56,3.58a13.69,13.69,0,0,0,12.4,0c1.71-1,2.57-2.28,2.57-3.58h0v-3.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-18--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 215.22,
    y: 280.37,
    width: 0.42,
    height: 6.04
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 214.25,
    y: 282.01,
    width: 0.42,
    height: 6.08
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 212.79,
    y: 283.13,
    width: 0.42,
    height: 6.11
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 211.12,
    y: 283.83,
    width: 0.42,
    height: 6.14
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 209.28,
    y: 284.29,
    width: 0.42,
    height: 6.18
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 207.34,
    y: 284.53,
    width: 0.42,
    height: 6.21
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 205.37,
    y: 284.52,
    width: 0.42,
    height: 6.24
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 203.44,
    y: 284.26,
    width: 0.42,
    height: 6.27
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 201.64,
    y: 283.74,
    width: 0.42,
    height: 6.31
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 200.01,
    y: 282.94,
    width: 0.42,
    height: 6.34
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 198.71,
    y: 281.82,
    width: 0.42,
    height: 6.37
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 197.69,
    y: 280.01,
    width: 0.42,
    height: 6.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M208.76,289.53c-4.34,0-6.63-1.39-7.32-2.54a9,9,0,0,1-.62-4.08s-.49-3.65-.4-3.66-1-.24-1.88-.42a3.29,3.29,0,0,0-.64,1.9h0v3.89h0c0,1.3.85,2.59,2.56,3.58A13.49,13.49,0,0,0,208.76,289.53Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.46,284.31a13.69,13.69,0,0,0,12.4,0c3.43-2,3.43-5.18,0-7.16a13.75,13.75,0,0,0-12.4,0C197,279.13,197,282.34,200.46,284.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.33,284c2.94-2,2.79-5-.47-6.86a12.57,12.57,0,0,0-6-1.47,9.84,9.84,0,0,0-3.2,1.09c-3,1.69-3,5.07,0,6.76A12.1,12.1,0,0,0,213.33,284Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.29,301.56a13.46,13.46,0,0,0,10.74,0c3-1.49,3-3.91,0-5.4a13.46,13.46,0,0,0-10.74,0C198.33,297.65,198.33,300.07,201.29,301.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4,288.15c0,1.22.8,2.44,2.42,3.37a12,12,0,0,0,5.84,1.4v6.19a12,12,0,0,1-5.84-1.39c-1.62-.93-2.42-2.16-2.42-3.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.57,282.68s2.85,2.87,8.36,2.72,7.71-3.16,8-4.09a3.47,3.47,0,0,0-.74-3.18,3.71,3.71,0,0,1,1.24,2.6v3.89c0,.33.17,1.46-1.61,2.92a4.29,4.29,0,0,0,1-2.32v-2.69s-2,3.26-7.93,3.26S198.87,283.17,198.57,282.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Capsules--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.31,248.26l26,15a3.11,3.11,0,0,0,2.79,0l14.22-8.21a.85.85,0,0,0,0-1.61l-26-15a3.05,3.05,0,0,0-2.79,0l-14.22,8.21A.85.85,0,0,0,225.31,248.26Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.7,263.48l26,15a3.11,3.11,0,0,0,2.79,0l14.22-8.21a.85.85,0,0,0,0-1.61l-26-15a3.05,3.05,0,0,0-2.79,0l-14.23,8.21A.85.85,0,0,0,229.7,263.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--capsules--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.58,248.31,251,262.43a2.9,2.9,0,0,0,2.63,0L267,254.71a.8.8,0,0,0,0-1.52l-24.45-14.12a2.9,2.9,0,0,0-2.63,0l-13.37,7.73A.8.8,0,0,0,226.58,248.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.58,247.6,251,261.72a2.88,2.88,0,0,0,2.62,0L267,254a.8.8,0,0,0,0-1.52l-24.45-14.12a2.9,2.9,0,0,0-2.63,0l-13.38,7.73A.8.8,0,0,0,226.58,247.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.66,261.72l12.07-7h0c-3.8,1.95-11,6.11-12.08,6.53s-1.7.6-3.68-.55-22-12.35-22-12.35L251,261.72A2.88,2.88,0,0,0,253.66,261.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.64,256.92a.36.36,0,0,1-.32,0l-24.38-14.08c-.1-.05-.1-.13,0-.18a.36.36,0,0,1,.32,0l24.38,14.08C259.73,256.78,259.73,256.86,259.64,256.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,244h0a1.34,1.34,0,0,0,.24.12l.09,0a2.92,2.92,0,0,0,2.21-.19l2.3-1.33h0a1.65,1.65,0,0,0,.06-2.88,1.28,1.28,0,0,0-.24-.11l-.1,0a2.9,2.9,0,0,0-2.2.2l-2.3,1.32,0,0a1.6,1.6,0,0,0-.66.63A1.63,1.63,0,0,0,240,244Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.92,241.13a2.81,2.81,0,0,0-2.54.05l-2.3,1.32c-.73.42-.76,1.08-.08,1.47a2.84,2.84,0,0,0,2.54,0l2.3-1.33C245.56,242.18,245.6,241.52,244.92,241.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.55,241.89a1.63,1.63,0,0,0-.63-2.18,1.28,1.28,0,0,0-.24-.11l-.1,0a3,3,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.65,1.65,0,0,1,245.55,241.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,240.79a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-1.24.71a1.36,1.36,0,0,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.16,239.81a1.36,1.36,0,1,1,1.36,2.35l-1.7,1a.67.67,0,0,0,.28-.62,2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74,241.07a.52.52,0,0,0-.71-.19L242,242.06a1.89,1.89,0,0,0,.68.72l.08,0,1.82-1A.52.52,0,0,0,244.74,241.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,240.79a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-1.24.71a1.36,1.36,0,0,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.1,242.52a2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07l.1-.06.07,0a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-.17.1A.67.67,0,0,0,243.1,242.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.35,243.92h0a1.42,1.42,0,0,1-.62-.57,1.34,1.34,0,0,1,.49-1.85l1.24-.71a.66.66,0,0,1,.68.07,1.15,1.15,0,0,1,.33.26l-2.06,1.18A1,1,0,0,0,240.35,243.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,243.48a.53.53,0,0,1,.19-.71l2.09-1.2a2,2,0,0,1,.28,1v.09l-1.85,1.07A.53.53,0,0,1,240.54,243.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.1,240.46l0,.07a.43.43,0,0,0,0,.05s0,0,0,.06a.19.19,0,0,0,0,.07v0a.88.88,0,0,1,0,.28h0v.1h0a1,1,0,0,0-1.43-.76l-1.3.75a1.15,1.15,0,0,0-.33-.26.66.66,0,0,0-.68-.07l1.7-1a1.36,1.36,0,0,1,1.86.5l.06.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.42,249h0l.24.11.1,0a2.85,2.85,0,0,0,2.2-.2l2.3-1.33h0A1.69,1.69,0,0,0,237,247a1.66,1.66,0,0,0-.6-2.25l-.25-.11-.09,0a2.92,2.92,0,0,0-2.21.19l-2.3,1.33h0a1.59,1.59,0,0,0-.67.64,1.65,1.65,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34,246.13a2.78,2.78,0,0,0-2.54,0l-2.3,1.33c-.72.42-.76,1.08-.08,1.47a2.81,2.81,0,0,0,2.54-.05l2.3-1.33C237,247.18,237,246.52,236.34,246.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,246.89a1.66,1.66,0,0,0-.63-2.19l-.25-.11-.09,0a2.94,2.94,0,0,0-1.92.06,2.82,2.82,0,0,1,2.41.43A1.67,1.67,0,0,1,237,246.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.88,245.78a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.67.66.66,0,0,1-.28.62l-1.23.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.59,244.8a1.36,1.36,0,0,1,1.36,2.36l-1.71,1a.66.66,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.67.69.69,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.16,246.07a.52.52,0,0,0-.71-.2l-2.06,1.19a2.15,2.15,0,0,0,.68.72l.08,0,1.82-1A.52.52,0,0,0,236.16,246.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.88,245.78a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.67.66.66,0,0,1-.28.62l-1.23.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.52,247.52a2.13,2.13,0,0,0-1-1.67.69.69,0,0,0-.68-.07l.1-.05.08,0a.66.66,0,0,1,.67.06,2.13,2.13,0,0,1,1,1.67.66.66,0,0,1-.28.62l-.17.1A.66.66,0,0,0,234.52,247.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.78,248.91h0a1.31,1.31,0,0,1-.63-.56,1.36,1.36,0,0,1,.5-1.86l1.23-.71a.69.69,0,0,1,.68.07,1.64,1.64,0,0,1,.33.26l-2.06,1.19A1,1,0,0,0,231.78,248.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,248.48a.51.51,0,0,1,.19-.71l2.08-1.2a1.89,1.89,0,0,1,.28,1v.09l-1.84,1.06A.52.52,0,0,1,232,248.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.52,245.45l0,.08s0,0,0,.05,0,0,0,.06,0,0,0,.06v0a1.43,1.43,0,0,1,0,.29h0a.41.41,0,0,0,0,.11h0a1,1,0,0,0-1.42-.76l-1.31.74a1.64,1.64,0,0,0-.33-.26.69.69,0,0,0-.68-.07l1.71-1a1.37,1.37,0,0,1,1.86.5l.05.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.15,247.53h0l.24.11.1,0a2.94,2.94,0,0,0,2.2-.2l2.3-1.33h0a1.64,1.64,0,0,0,.07-2.88l-.25-.11-.09,0a2.88,2.88,0,0,0-2.21.19l-2.3,1.33h0a1.62,1.62,0,0,0-.67.63,1.66,1.66,0,0,0,.6,2.25Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.07,244.68a2.81,2.81,0,0,0-2.54,0l-2.3,1.33c-.72.42-.76,1.07-.08,1.47a2.81,2.81,0,0,0,2.54-.05l2.3-1.33C251.72,245.73,251.75,245.08,251.07,244.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.71,245.44a1.65,1.65,0,0,0-.63-2.18l-.25-.11-.09,0a2.88,2.88,0,0,0-1.92.06,2.82,2.82,0,0,1,2.41.42A1.65,1.65,0,0,1,251.71,245.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,244.34a.67.67,0,0,1,.67.07,2.14,2.14,0,0,1,1,1.66.66.66,0,0,1-.29.62l-1.23.72a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.32,243.36a1.36,1.36,0,0,1,1.36,2.36l-1.71,1a.66.66,0,0,0,.29-.62,2.14,2.14,0,0,0-1-1.66.67.67,0,0,0-.67-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,244.62a.52.52,0,0,0-.71-.19l-2.06,1.19a2,2,0,0,0,.68.71l.09,0,1.81-1A.51.51,0,0,0,250.89,244.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,244.34a.67.67,0,0,1,.67.07,2.14,2.14,0,0,1,1,1.66.66.66,0,0,1-.29.62l-1.23.72a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,246.07a2.14,2.14,0,0,0-1-1.66.67.67,0,0,0-.67-.07l.09-.05.08,0a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.68.68,0,0,1-.29.63l-.17.09A.66.66,0,0,0,249.26,246.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.51,247.47h0a1.31,1.31,0,0,1-.63-.56,1.36,1.36,0,0,1,.5-1.86l1.24-.71a.67.67,0,0,1,.67.07,2,2,0,0,1,.34.26l-2.07,1.19A1,1,0,0,0,246.51,247.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7,247a.51.51,0,0,1,.19-.71l2.08-1.2a1.9,1.9,0,0,1,.29.94s0,.07,0,.1l-1.84,1.06A.52.52,0,0,1,246.7,247Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.25,244l0,.07s0,0,0,.06,0,0,0,.06a.14.14,0,0,1,0,.06v0c0,.1,0,.19,0,.28h0s0,.07,0,.1h0a1,1,0,0,0-1.42-.76l-1.3.75a2,2,0,0,0-.34-.26.67.67,0,0,0-.67-.07l1.7-1a1.37,1.37,0,0,1,1.86.5.54.54,0,0,1,0,.11A.08.08,0,0,1,251.25,244Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57,252.52h0a1.15,1.15,0,0,0,.25.12l.09,0a2.88,2.88,0,0,0,2.21-.2l2.3-1.32,0,0a1.6,1.6,0,0,0,.66-.63,1.65,1.65,0,0,0-.6-2.24,1.28,1.28,0,0,0-.24-.11l-.1,0a2.9,2.9,0,0,0-2.2.2l-2.3,1.32,0,0a1.62,1.62,0,0,0-.67.63,1.65,1.65,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,249.68a2.81,2.81,0,0,0-2.54,0l-2.3,1.32c-.73.42-.77,1.08-.09,1.47a2.83,2.83,0,0,0,2.55-.05l2.3-1.32C243.14,250.73,243.18,250.07,242.5,249.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.13,250.44a1.64,1.64,0,0,0-.63-2.18,1.28,1.28,0,0,0-.24-.11l-.1,0a3,3,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.66,1.66,0,0,1,243.13,250.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,249.34a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.74,248.36a1.36,1.36,0,1,1,1.36,2.35l-1.7,1a.67.67,0,0,0,.28-.62,2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.32,249.62a.51.51,0,0,0-.71-.19l-2.06,1.18a1.89,1.89,0,0,0,.68.72l.08,0,1.82-1A.52.52,0,0,0,242.32,249.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,249.34a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.68,251.07a2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07l.1-.06.07,0a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-.17.1A.67.67,0,0,0,240.68,251.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,252.47h0a1.44,1.44,0,0,1-.63-.57,1.36,1.36,0,0,1,.5-1.85l1.24-.71a.66.66,0,0,1,.68.07,1.3,1.3,0,0,1,.33.26L238,250.85A1,1,0,0,0,237.93,252.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.12,252a.52.52,0,0,1,.19-.71l2.09-1.2a2,2,0,0,1,.28.95.28.28,0,0,1,0,.09l-1.84,1.06A.51.51,0,0,1,238.12,252Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.68,249a.19.19,0,0,1,0,.07l0,0s0,0,0,.06,0,0,0,.07v0a1.32,1.32,0,0,1,0,.28h0a.34.34,0,0,1,0,.1h0a1,1,0,0,0-1.42-.76l-1.3.75a1.3,1.3,0,0,0-.33-.26.66.66,0,0,0-.68-.07l1.7-1a1.36,1.36,0,0,1,1.86.49l.06.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.31,251.08h0l.24.11.09,0a2.88,2.88,0,0,0,2.21-.2l2.3-1.33h0a1.66,1.66,0,0,0,.66-.63,1.64,1.64,0,0,0-.6-2.24l-.24-.12-.1,0a2.89,2.89,0,0,0-2.2.19l-2.3,1.33h0a1.71,1.71,0,0,0-.67.64,1.64,1.64,0,0,0,.61,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23,248.24a2.78,2.78,0,0,0-2.54,0l-2.3,1.33c-.73.42-.76,1.08-.08,1.47a2.81,2.81,0,0,0,2.54-.05l2.3-1.33C257.87,249.29,257.91,248.63,257.23,248.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,249a1.63,1.63,0,0,0-.63-2.18l-.24-.12-.1,0a3,3,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.66,1.66,0,0,1,257.86,249Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.77,247.9a.68.68,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.47,246.91a1.36,1.36,0,0,1,1.36,2.36l-1.7,1a.69.69,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.67.68.68,0,0,0-.68-.06Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.05,248.18a.51.51,0,0,0-.71-.19l-2.06,1.18a2,2,0,0,0,.68.72l.08,0,1.82-1A.52.52,0,0,0,257.05,248.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.77,247.9a.68.68,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,249.63a2.13,2.13,0,0,0-1-1.67.68.68,0,0,0-.68-.06l.1-.06.07,0a.68.68,0,0,1,.68.06,2.15,2.15,0,0,1,1,1.67.69.69,0,0,1-.28.62l-.17.1A.69.69,0,0,0,255.41,249.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.66,251h0a1.36,1.36,0,0,1-.13-2.42l1.24-.7a.68.68,0,0,1,.68.06,1.64,1.64,0,0,1,.33.26l-2.06,1.19A1,1,0,0,0,252.66,251Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.85,250.59a.52.52,0,0,1,.19-.71l2.09-1.2a2,2,0,0,1,.28.95v.09l-1.85,1.06A.51.51,0,0,1,252.85,250.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.41,247.57a.14.14,0,0,1,0,.07s0,0,0,.05,0,0,0,.06,0,0,0,.06v0a1.27,1.27,0,0,1,0,.28h0a.38.38,0,0,1,0,.1h0a1,1,0,0,0-1.42-.76l-1.3.74a1.64,1.64,0,0,0-.33-.26.68.68,0,0,0-.68-.06l1.7-1a1.37,1.37,0,0,1,1.86.5l.06.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.73,256.07h0a1.34,1.34,0,0,0,.24.12l.1,0a2.9,2.9,0,0,0,2.2-.19l2.3-1.33h0a1.71,1.71,0,0,0,.67-.64,1.64,1.64,0,0,0-.61-2.24l-.24-.11-.09,0a2.88,2.88,0,0,0-2.21.19l-2.3,1.33h0a1.66,1.66,0,0,0-.66.63,1.64,1.64,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.65,253.23a2.81,2.81,0,0,0-2.54.05l-2.3,1.33c-.72.42-.76,1.07-.08,1.46a2.78,2.78,0,0,0,2.54,0l2.3-1.33C249.3,254.28,249.33,253.62,248.65,253.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.29,254a1.64,1.64,0,0,0-.64-2.18l-.24-.11-.09,0a2.91,2.91,0,0,0-1.93.06c1.08-.11,1.75-.15,2.42.42A1.67,1.67,0,0,1,249.29,254Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,252.89a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.65.65,0,0,1-.28.62l-1.23.72A1.36,1.36,0,1,1,244,253.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.9,251.91a1.36,1.36,0,0,1,1.36,2.36l-1.71,1a.65.65,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.66.69.69,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.47,253.17a.52.52,0,0,0-.71-.19l-2.06,1.18a2,2,0,0,0,.68.72l.08.05,1.82-1.05A.51.51,0,0,0,248.47,253.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,252.89a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.65.65,0,0,1-.28.62l-1.23.72A1.36,1.36,0,1,1,244,253.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.83,254.62a2.13,2.13,0,0,0-1-1.66.69.69,0,0,0-.68-.07l.1,0,.07-.05a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.67.67,0,0,1-.28.63l-.17.09A.65.65,0,0,0,246.83,254.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.09,256h0a1.31,1.31,0,0,1-.63-.56,1.36,1.36,0,0,1,.5-1.86l1.23-.71a.69.69,0,0,1,.68.07,1.64,1.64,0,0,1,.33.26l-2.06,1.19A1,1,0,0,0,244.09,256Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.27,255.59a.52.52,0,0,1,.2-.71l2.08-1.21a2,2,0,0,1,.28,1v.1L245,255.78A.53.53,0,0,1,244.27,255.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.83,252.56l0,.07a.14.14,0,0,0,0,.06s0,0,0,.06,0,0,0,.06v0a1.33,1.33,0,0,1,0,.28h0a.34.34,0,0,0,0,.1h0a1,1,0,0,0-1.43-.76l-1.3.75a1.64,1.64,0,0,0-.33-.26.69.69,0,0,0-.68-.07l1.71-1a1.36,1.36,0,0,1,1.86.5.37.37,0,0,1,.05.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.46,254.63h0l.24.12.1,0a2.89,2.89,0,0,0,2.2-.19l2.3-1.33h0a1.71,1.71,0,0,0,.67-.64,1.65,1.65,0,0,0-.6-2.24,1.12,1.12,0,0,0-.25-.11l-.09,0a2.92,2.92,0,0,0-2.21.2l-2.3,1.32v0a1.62,1.62,0,0,0-.67.63,1.64,1.64,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.38,251.79a2.81,2.81,0,0,0-2.54.05l-2.3,1.32c-.72.42-.76,1.08-.08,1.47a2.84,2.84,0,0,0,2.54,0l2.3-1.33C264,252.84,264.06,252.18,263.38,251.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,252.55a1.65,1.65,0,0,0-.63-2.18,1.12,1.12,0,0,0-.25-.11l-.09,0a3,3,0,0,0-1.92.06,2.82,2.82,0,0,1,2.41.43A1.67,1.67,0,0,1,264,252.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.92,251.45a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.65.65,0,0,1-.28.62l-1.23.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.63,250.47a1.36,1.36,0,1,1,1.36,2.35l-1.71,1a.65.65,0,0,0,.28-.62,2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.2,251.73a.52.52,0,0,0-.71-.19l-2.06,1.18a2.06,2.06,0,0,0,.68.72l.09,0,1.81-1A.51.51,0,0,0,263.2,251.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.92,251.45a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.65.65,0,0,1-.28.62l-1.23.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.56,253.18a2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07l.1-.06.08,0a.64.64,0,0,1,.67.07,2.11,2.11,0,0,1,1,1.66.65.65,0,0,1-.28.62l-.17.1A.65.65,0,0,0,261.56,253.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.82,254.58h0a1.42,1.42,0,0,1-.63-.56,1.36,1.36,0,0,1,.5-1.86l1.23-.71a.66.66,0,0,1,.68.07,1.15,1.15,0,0,1,.33.26L258.87,253A1,1,0,0,0,258.82,254.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,254.14a.52.52,0,0,1,.19-.71l2.08-1.2a1.89,1.89,0,0,1,.28,1v.09l-1.84,1.07A.52.52,0,0,1,259,254.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.56,251.12l0,.07,0,.05s0,0,0,.06,0,0,0,.07v0a1.33,1.33,0,0,1,0,.28h0s0,.07,0,.1h0a1,1,0,0,0-1.42-.76l-1.31.75a1.15,1.15,0,0,0-.33-.26.66.66,0,0,0-.68-.07l1.71-1a1.36,1.36,0,0,1,1.86.5.37.37,0,0,1,.05.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88,259.63h0l.25.11.09,0a2.88,2.88,0,0,0,2.21-.2l2.3-1.33h0a1.62,1.62,0,0,0,.67-.63,1.66,1.66,0,0,0-.6-2.25l-.24-.11-.1,0a2.89,2.89,0,0,0-2.2.19l-2.3,1.33h0a1.64,1.64,0,0,0-.07,2.88Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81,256.79a2.8,2.8,0,0,0-2.55,0L250,258.16c-.73.42-.77,1.08-.09,1.47a2.83,2.83,0,0,0,2.55-.05l2.3-1.33C255.45,257.84,255.49,257.18,254.81,256.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.44,257.55a1.65,1.65,0,0,0-.63-2.19l-.24-.11-.1,0a2.94,2.94,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.66,1.66,0,0,1,255.44,257.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,256.45a.66.66,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.05,255.46a1.36,1.36,0,0,1,1.36,2.36l-1.7,1a.69.69,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.67.66.66,0,0,0-.68-.06Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.63,256.73a.53.53,0,0,0-.71-.2l-2.06,1.19a2,2,0,0,0,.68.72l.08,0,1.82-1A.53.53,0,0,0,254.63,256.73Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,256.45a.66.66,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,258.18a2.13,2.13,0,0,0-1-1.67.66.66,0,0,0-.68-.06l.1-.06.07,0a.68.68,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-.17.1A.69.69,0,0,0,253,258.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.24,259.57h0a1.36,1.36,0,0,1-.13-2.42l1.24-.7a.66.66,0,0,1,.68.06,2.5,2.5,0,0,1,.33.26L250.29,258A1,1,0,0,0,250.24,259.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43,259.14a.52.52,0,0,1,.19-.71l2.09-1.2a2,2,0,0,1,.28.95.28.28,0,0,1,0,.09l-1.84,1.06A.52.52,0,0,1,250.43,259.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,256.11l0,.08,0,.05,0,.06s0,0,0,.06v0a2.83,2.83,0,0,1,0,.29h0a.41.41,0,0,1,0,.11h0a1,1,0,0,0-1.42-.76l-1.3.74a2.5,2.5,0,0,0-.33-.26.66.66,0,0,0-.68-.06l1.7-1a1.37,1.37,0,0,1,1.86.5l.06.11Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--capsules--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.52,263.63,256,277.75a2.88,2.88,0,0,0,2.62,0L272,270a.8.8,0,0,0,0-1.52l-24.45-14.12a2.9,2.9,0,0,0-2.63,0l-13.38,7.73A.8.8,0,0,0,231.52,263.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.52,262.92,256,277a2.88,2.88,0,0,0,2.62,0L272,269.32a.8.8,0,0,0,0-1.52l-24.45-14.12a2.9,2.9,0,0,0-2.63,0l-13.38,7.72A.8.8,0,0,0,231.52,262.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6,277l12.07-7h0c-3.8,1.95-11,6.11-12.08,6.53s-1.7.6-3.69-.55-22-12.35-22-12.35L256,277A2.88,2.88,0,0,0,258.6,277Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.58,272.23a.35.35,0,0,1-.33,0l-24.37-14.08c-.1,0-.1-.13,0-.18a.33.33,0,0,1,.32,0l24.38,14.08C264.66,272.1,264.67,272.18,264.58,272.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.94,259.29h0a1.08,1.08,0,0,0,.24.12l.09,0a2.92,2.92,0,0,0,2.21-.19l2.3-1.33h0a1.69,1.69,0,0,0,.66-.64,1.64,1.64,0,0,0-.6-2.24,1.28,1.28,0,0,0-.24-.11l-.1,0a2.9,2.9,0,0,0-2.2.2L245,256.4l0,0a1.62,1.62,0,0,0-.67.63,1.64,1.64,0,0,0,.61,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,256.45a2.81,2.81,0,0,0-2.54.05l-2.3,1.32c-.73.42-.76,1.08-.08,1.47a2.84,2.84,0,0,0,2.54,0l2.3-1.33C250.5,257.5,250.54,256.84,249.86,256.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,257.21a1.64,1.64,0,0,0-.63-2.18,1.28,1.28,0,0,0-.24-.11l-.1,0a3,3,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.66,1.66,0,0,1,250.49,257.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,256.11a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1,255.13a1.36,1.36,0,1,1,1.36,2.35l-1.7,1a.67.67,0,0,0,.28-.62,2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,256.39a.52.52,0,0,0-.71-.19l-2.06,1.18a1.89,1.89,0,0,0,.68.72l.08,0,1.82-1A.52.52,0,0,0,249.68,256.39Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,256.11a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,257.84a2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07l.1-.06.07,0a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-.17.1A.67.67,0,0,0,248,257.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.29,259.24h0a1.44,1.44,0,0,1-.63-.57,1.36,1.36,0,0,1,.5-1.85l1.24-.71a.66.66,0,0,1,.68.07,1.15,1.15,0,0,1,.33.26l-2.06,1.18A1,1,0,0,0,245.29,259.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.48,258.8a.53.53,0,0,1,.19-.71l2.09-1.2a2,2,0,0,1,.28.95.28.28,0,0,1,0,.09L246.19,259A.51.51,0,0,1,245.48,258.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,255.78a.19.19,0,0,1,0,.07.17.17,0,0,1,0,.05s0,0,0,.06,0,0,0,.07v0a1.32,1.32,0,0,1,0,.28h0a.34.34,0,0,1,0,.1h0a1,1,0,0,0-1.42-.76l-1.3.75a1.15,1.15,0,0,0-.33-.26.66.66,0,0,0-.68-.07l1.7-1a1.35,1.35,0,0,1,1.86.5l.06.11A.08.08,0,0,0,250,255.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,264.29h0l.24.11.1,0a2.85,2.85,0,0,0,2.2-.2l2.3-1.33h0a1.6,1.6,0,0,0,.66-.63,1.64,1.64,0,0,0-.6-2.25l-.24-.11-.1,0a2.9,2.9,0,0,0-2.2.19l-2.3,1.33h0a1.56,1.56,0,0,0-.66.64,1.63,1.63,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,261.45a2.78,2.78,0,0,0-2.54,0l-2.3,1.33c-.72.42-.76,1.08-.08,1.47a2.81,2.81,0,0,0,2.54-.05l2.3-1.33C241.93,262.5,242,261.84,241.28,261.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.92,262.2a1.65,1.65,0,0,0-.64-2.18l-.24-.11-.1,0a2.94,2.94,0,0,0-1.92.06,2.87,2.87,0,0,1,2.42.42A1.68,1.68,0,0,1,241.92,262.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,261.1a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.67.66.66,0,0,1-.28.62l-1.23.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.53,260.12a1.36,1.36,0,0,1,1.36,2.36l-1.71,1a.66.66,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.67.69.69,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,261.39a.52.52,0,0,0-.71-.2l-2.06,1.19a2.05,2.05,0,0,0,.68.72l.08,0,1.82-1A.52.52,0,0,0,241.1,261.39Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,261.1a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.67.66.66,0,0,1-.28.62l-1.23.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.46,262.84a2.13,2.13,0,0,0-1-1.67.69.69,0,0,0-.68-.07l.1-.05.07,0a.68.68,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.66.66,0,0,1-.28.62l-.17.1A.66.66,0,0,0,239.46,262.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.71,264.23h0a1.34,1.34,0,0,1-.62-.56,1.36,1.36,0,0,1,.5-1.86l1.23-.71a.69.69,0,0,1,.68.07,1.64,1.64,0,0,1,.33.26l-2.06,1.19A1,1,0,0,0,236.71,264.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.9,263.8a.53.53,0,0,1,.19-.71l2.09-1.2a2,2,0,0,1,.28.95v.09L237.62,264A.53.53,0,0,1,236.9,263.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,260.77l0,.08,0,0s0,0,0,.06l0,.06v0a1,1,0,0,1,0,.29h0v.1h0a1,1,0,0,0-1.43-.75l-1.3.74a1.64,1.64,0,0,0-.33-.26.69.69,0,0,0-.68-.07l1.71-1a1.36,1.36,0,0,1,1.85.5s0,.08.06.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.09,262.85h0l.24.11.1,0a2.94,2.94,0,0,0,2.2-.2l2.3-1.33h0a1.64,1.64,0,0,0,.06-2.88l-.24-.11-.09,0a2.88,2.88,0,0,0-2.21.19l-2.3,1.33h0a1.64,1.64,0,0,0-.06,2.88Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,260a2.81,2.81,0,0,0-2.54.05l-2.3,1.33c-.72.42-.76,1.07-.08,1.47a2.81,2.81,0,0,0,2.54-.05l2.3-1.33C256.66,261.05,256.69,260.4,256,260Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.65,260.76a1.64,1.64,0,0,0-.64-2.18l-.24-.11-.09,0a2.88,2.88,0,0,0-1.92.06,2.82,2.82,0,0,1,2.41.42A1.67,1.67,0,0,1,256.65,260.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,259.66a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.65.65,0,0,1-.28.62l-1.23.72a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.26,258.68a1.36,1.36,0,0,1,1.36,2.36l-1.71,1a.65.65,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.66.69.69,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.83,259.94a.52.52,0,0,0-.71-.19l-2.06,1.19a2,2,0,0,0,.68.71l.08.05,1.82-1.05A.51.51,0,0,0,255.83,259.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,259.66a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.65.65,0,0,1-.28.62l-1.23.72a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.19,261.39a2.13,2.13,0,0,0-1-1.66.69.69,0,0,0-.68-.07l.1-.05.08-.05a.67.67,0,0,1,.67.07,2.13,2.13,0,0,1,1,1.66.67.67,0,0,1-.28.63l-.17.09A.65.65,0,0,0,254.19,261.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.45,262.79h0a1.31,1.31,0,0,1-.63-.56,1.36,1.36,0,0,1,.5-1.86l1.23-.71a.69.69,0,0,1,.68.07,1.64,1.64,0,0,1,.33.26l-2.06,1.19A1,1,0,0,0,251.45,262.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.64,262.36a.51.51,0,0,1,.19-.71l2.08-1.21a2,2,0,0,1,.28.95v.1l-1.84,1.06A.52.52,0,0,1,251.64,262.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.19,259.33l0,.07,0,.06s0,0,0,.06,0,0,0,.06v0a1.41,1.41,0,0,1,0,.28h0a.38.38,0,0,0,0,.1h0a1,1,0,0,0-1.42-.76l-1.31.75a1.64,1.64,0,0,0-.33-.26.69.69,0,0,0-.68-.07l1.71-1a1.37,1.37,0,0,1,1.86.5.54.54,0,0,1,.05.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.51,267.84h0a1.15,1.15,0,0,0,.25.12l.09,0a2.88,2.88,0,0,0,2.21-.2l2.3-1.32v0a1.56,1.56,0,0,0,.67-.63,1.64,1.64,0,0,0-.6-2.24,1.28,1.28,0,0,0-.24-.11l-.1,0a2.9,2.9,0,0,0-2.2.2L242.6,265h0a1.71,1.71,0,0,0-.67.64,1.65,1.65,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.44,265a2.83,2.83,0,0,0-2.55.05l-2.3,1.32c-.72.42-.76,1.08-.08,1.47a2.83,2.83,0,0,0,2.55,0l2.3-1.32C248.08,266.05,248.12,265.39,247.44,265Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.07,265.76a1.64,1.64,0,0,0-.63-2.18,1.28,1.28,0,0,0-.24-.11l-.1,0a3,3,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.66,1.66,0,0,1,248.07,265.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,264.66a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.68,263.68A1.36,1.36,0,1,1,247,266l-1.7,1a.69.69,0,0,0,.28-.62,2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.26,264.94a.52.52,0,0,0-.71-.19l-2.06,1.18a1.89,1.89,0,0,0,.68.72.2.2,0,0,0,.08,0l1.82-1A.52.52,0,0,0,247.26,264.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,264.66a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.62,266.39a2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07l.09-.06.08,0a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.67.67,0,0,1-.28.62l-.17.1A.69.69,0,0,0,245.62,266.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.87,267.79h0a1.39,1.39,0,0,1-.63-.57,1.36,1.36,0,0,1,.5-1.85l1.24-.71a.66.66,0,0,1,.68.07,1.79,1.79,0,0,1,.33.25l-2.07,1.19A1,1,0,0,0,242.87,267.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.06,267.35a.51.51,0,0,1,.19-.71l2.09-1.2a2,2,0,0,1,.28.95.28.28,0,0,1,0,.09l-1.84,1.06A.51.51,0,0,1,243.06,267.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.61,264.33l0,.07s0,0,0,.05,0,0,0,.06,0,0,0,.07v0a2.64,2.64,0,0,1,0,.28h0a.38.38,0,0,1,0,.1h0a1,1,0,0,0-1.42-.76L245,265a1.79,1.79,0,0,0-.33-.25.66.66,0,0,0-.68-.07l1.7-1a1.36,1.36,0,0,1,1.86.49l.06.12S247.61,264.31,247.61,264.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.24,266.4h0l.25.11.09,0a2.88,2.88,0,0,0,2.21-.2l2.3-1.33h0a1.62,1.62,0,0,0,.67-.63,1.64,1.64,0,0,0-.6-2.24l-.24-.12-.1,0a2.89,2.89,0,0,0-2.2.19l-2.3,1.33h0a1.71,1.71,0,0,0-.67.64,1.65,1.65,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.17,263.56a2.8,2.8,0,0,0-2.55,0l-2.29,1.33c-.73.42-.77,1.08-.09,1.47a2.83,2.83,0,0,0,2.55,0l2.3-1.33C262.81,264.61,262.85,264,262.17,263.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,264.32a1.64,1.64,0,0,0-.63-2.18l-.24-.12-.1,0a3,3,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.66,1.66,0,0,1,262.8,264.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.71,263.22a.68.68,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.41,262.23a1.36,1.36,0,0,1,1.36,2.36l-1.7,1a.69.69,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.67.68.68,0,0,0-.68-.06Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,263.5a.51.51,0,0,0-.71-.19l-2.06,1.18a2,2,0,0,0,.68.72l.08,0,1.82-1A.52.52,0,0,0,262,263.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.71,263.22a.68.68,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.35,265a2.13,2.13,0,0,0-1-1.67.68.68,0,0,0-.68-.06l.1-.06.07,0a.68.68,0,0,1,.68.06,2.15,2.15,0,0,1,1,1.67.69.69,0,0,1-.28.62l-.17.1A.69.69,0,0,0,260.35,265Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,266.34h0a1.36,1.36,0,0,1-.13-2.42l1.24-.7a.68.68,0,0,1,.68.06,2,2,0,0,1,.33.26l-2.06,1.19A1,1,0,0,0,257.6,266.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.79,265.91a.52.52,0,0,1,.19-.71l2.09-1.2a2,2,0,0,1,.28.95.28.28,0,0,1,0,.09l-1.84,1.06A.51.51,0,0,1,257.79,265.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34,262.89s0,0,0,.07l0,.05s0,0,0,.06,0,0,0,.06v0a1.42,1.42,0,0,1,0,.29h0a.41.41,0,0,1,0,.11h0a1,1,0,0,0-1.42-.76l-1.3.74a2,2,0,0,0-.33-.26.68.68,0,0,0-.68-.06l1.7-1a1.37,1.37,0,0,1,1.86.5l.06.11S262.34,262.87,262.34,262.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,271.39h0l.24.12.1,0a2.9,2.9,0,0,0,2.2-.19l2.3-1.33h0a1.65,1.65,0,0,0,.06-2.88l-.24-.11-.1,0a2.9,2.9,0,0,0-2.2.2l-2.3,1.33h0a1.6,1.6,0,0,0-.66.63,1.63,1.63,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.59,268.55a2.81,2.81,0,0,0-2.54.05l-2.3,1.33c-.73.41-.76,1.07-.08,1.46a2.78,2.78,0,0,0,2.54,0l2.3-1.33C254.24,269.6,254.27,268.94,253.59,268.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.23,269.31a1.64,1.64,0,0,0-.64-2.18l-.24-.11-.1,0a3,3,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.67,1.67,0,0,1,254.23,269.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,268.21a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.67.67,0,0,1-.28.62l-1.24.71a1.34,1.34,0,0,1-1.85-.49,1.36,1.36,0,0,1,.49-1.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.84,267.23a1.36,1.36,0,0,1,1.36,2.36l-1.71,1a.67.67,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.66.69.69,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,268.49a.52.52,0,0,0-.71-.19l-2.06,1.18a1.82,1.82,0,0,0,.68.72l.08.05,1.82-1.05A.51.51,0,0,0,253.41,268.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,268.21a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.67.67,0,0,1-.28.62l-1.24.71a1.34,1.34,0,0,1-1.85-.49,1.36,1.36,0,0,1,.49-1.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,269.94a2.13,2.13,0,0,0-1-1.66.69.69,0,0,0-.68-.07l.1,0,.07-.05a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.66.68.68,0,0,1-.28.63l-.17.09A.67.67,0,0,0,251.77,269.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,271.34h0a1.34,1.34,0,0,1-.62-.56,1.36,1.36,0,0,1,.49-1.86l1.24-.71a.69.69,0,0,1,.68.07,1.64,1.64,0,0,1,.33.26l-2.06,1.19A1,1,0,0,0,249,271.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,270.91a.52.52,0,0,1,.19-.71l2.09-1.21a2.07,2.07,0,0,1,.28.95v.1l-1.85,1.06A.53.53,0,0,1,249.21,270.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.77,267.88l0,.07V268a.14.14,0,0,1,0,.06s0,0,0,.06v0a.88.88,0,0,1,0,.28h0v.1h0a1,1,0,0,0-1.43-.76l-1.3.75a1.64,1.64,0,0,0-.33-.26.69.69,0,0,0-.68-.07l1.71-1a1.35,1.35,0,0,1,1.85.5.39.39,0,0,1,.06.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4,270h0a1.34,1.34,0,0,0,.24.12l.1,0a2.9,2.9,0,0,0,2.2-.19l2.3-1.33h0a1.65,1.65,0,0,0,.06-2.88,1,1,0,0,0-.24-.11l-.1,0a2.9,2.9,0,0,0-2.2.2l-2.3,1.32,0,0a1.6,1.6,0,0,0-.66.63,1.64,1.64,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,267.11a2.81,2.81,0,0,0-2.54.05l-2.3,1.32c-.72.42-.76,1.08-.08,1.47a2.84,2.84,0,0,0,2.54,0l2.3-1.33C269,268.16,269,267.5,268.32,267.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,267.87a1.64,1.64,0,0,0-.64-2.18,1,1,0,0,0-.24-.11l-.1,0a3,3,0,0,0-1.92.06,2.84,2.84,0,0,1,2.42.43A1.67,1.67,0,0,1,269,267.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.86,266.77a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.65.65,0,0,1-.28.62l-1.23.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.57,265.79a1.36,1.36,0,0,1,1.36,2.35l-1.71,1a.65.65,0,0,0,.28-.62,2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,267.05a.52.52,0,0,0-.71-.19L265.37,268a2,2,0,0,0,.68.72l.08,0,1.82-1A.51.51,0,0,0,268.14,267.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.86,266.77a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.65.65,0,0,1-.28.62l-1.23.71a1.36,1.36,0,1,1-1.36-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5,268.5a2.11,2.11,0,0,0-1-1.66.66.66,0,0,0-.68-.07l.1-.06.07,0a.66.66,0,0,1,.68.07,2.11,2.11,0,0,1,1,1.66.65.65,0,0,1-.28.62l-.17.1A.65.65,0,0,0,266.5,268.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.75,269.9h0a1.42,1.42,0,0,1-.62-.57,1.35,1.35,0,0,1,.5-1.85l1.23-.71a.66.66,0,0,1,.68.07,1.15,1.15,0,0,1,.33.26l-2.06,1.18A1,1,0,0,0,263.75,269.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.94,269.46a.53.53,0,0,1,.19-.71l2.09-1.2a1.89,1.89,0,0,1,.28.95v.09l-1.84,1.06A.53.53,0,0,1,263.94,269.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,266.44l0,.07,0,.05s0,0,0,.06,0,.05,0,.07v0a1.33,1.33,0,0,1,0,.28h0v.1h0a1,1,0,0,0-1.43-.76l-1.3.75a1.15,1.15,0,0,0-.33-.26.66.66,0,0,0-.68-.07l1.71-1a1.35,1.35,0,0,1,1.85.5.39.39,0,0,1,.06.11S268.49,266.43,268.5,266.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.82,275h0l.24.11.1,0a2.88,2.88,0,0,0,2.21-.2l2.3-1.33h0a1.62,1.62,0,0,0,.67-.63,1.66,1.66,0,0,0-.6-2.25l-.24-.11-.1,0a2.92,2.92,0,0,0-2.21.19l-2.29,1.33h0a1.59,1.59,0,0,0-.67.64,1.65,1.65,0,0,0,.6,2.24Z",
    style: {
      fill: "#fafafa",
      opacity: 0.7000000000000001,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.75,272.11a2.8,2.8,0,0,0-2.55,0l-2.3,1.33c-.72.42-.76,1.08-.08,1.47a2.83,2.83,0,0,0,2.55-.05l2.3-1.33C260.39,273.16,260.43,272.5,259.75,272.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.38,272.86a1.64,1.64,0,0,0-.63-2.18l-.24-.11-.1,0a2.94,2.94,0,0,0-1.92.06,2.88,2.88,0,0,1,2.42.42A1.67,1.67,0,0,1,260.38,272.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,271.76a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,270.78a1.36,1.36,0,0,1,1.36,2.36l-1.7,1a.69.69,0,0,0,.28-.62,2.13,2.13,0,0,0-1-1.67.69.69,0,0,0-.68-.07Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.57,272.05a.54.54,0,0,0-.72-.2L256.79,273a2.15,2.15,0,0,0,.68.72l.09,0,1.82-1A.53.53,0,0,0,259.57,272.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,271.76a.69.69,0,0,1,.68.07,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-1.24.71a1.36,1.36,0,1,1-1.36-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.93,273.5a2.13,2.13,0,0,0-1-1.67.69.69,0,0,0-.68-.07l.09-.05.08,0a.68.68,0,0,1,.68.06,2.13,2.13,0,0,1,1,1.67.69.69,0,0,1-.28.62l-.17.1A.69.69,0,0,0,257.93,273.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.18,274.89h0a1.31,1.31,0,0,1-.63-.56,1.37,1.37,0,0,1,.5-1.86l1.24-.71a.69.69,0,0,1,.68.07,2.5,2.5,0,0,1,.33.26l-2.07,1.19A1,1,0,0,0,255.18,274.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.37,274.46a.51.51,0,0,1,.19-.71l2.08-1.2a1.91,1.91,0,0,1,.29.95s0,.06,0,.09l-1.84,1.06A.52.52,0,0,1,255.37,274.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.92,271.43l0,.08s0,0,0,.05,0,0,0,.06,0,0,0,.06v0a2.83,2.83,0,0,1,0,.29h0a.31.31,0,0,1,0,.1h0a1,1,0,0,0-1.42-.75l-1.3.74a2.5,2.5,0,0,0-.33-.26.69.69,0,0,0-.68-.07l1.7-1a1.37,1.37,0,0,1,1.86.5l.06.11Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Papers--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.22,232.55,311.49,211a2,2,0,0,1,1.74,0L344,228.79c.48.28.48.73,0,1l-37.28,21.52a1.89,1.89,0,0,1-1.73,0l-30.77-17.76C273.74,233.27,273.74,232.82,274.22,232.55Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.22,230.82l37.27-21.52a2,2,0,0,1,1.74,0L344,227.07a.53.53,0,0,1,0,1l-37.28,21.52a1.89,1.89,0,0,1-1.73,0l-30.77-17.77C273.74,231.55,273.74,231.1,274.22,230.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.72,219.82,305,198.3a1.89,1.89,0,0,1,1.73,0l30.78,17.77c.48.27.48.72,0,1l-37.28,21.52a2,2,0,0,1-1.73,0l-30.77-17.77C267.24,220.54,267.24,220.09,267.72,219.82Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.72,218.16,305,196.64a2,2,0,0,1,1.73,0l30.78,17.77c.48.28.48.73,0,1l-37.28,21.52a1.89,1.89,0,0,1-1.73,0l-30.77-17.77C267.24,218.89,267.24,218.44,267.72,218.16Z",
    style: {
      fill: "#399252"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.85,427.22c-10-10.36-15.95-52.55-6.15-60.77h49.85c9.8,8.22,3.9,50.39-6.13,60.76l-.28.29-.35.34c-.28.28-.58.55-.9.82l-.24.19c-.25.19-.49.39-.76.58-.43.3-.86.59-1.3.84-8.26,4.82-21.66,4.82-29.92,0h0a13.29,13.29,0,0,1-1.31-.85c-.25-.18-.48-.36-.71-.54l-.29-.23a11.42,11.42,0,0,1-.88-.79c-.13-.13-.27-.26-.4-.4Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.85,427.22c-10-10.36-15.95-52.55-6.15-60.77h49.85c9.8,8.22,3.9,50.39-6.13,60.76l-.28.29-.35.34c-.28.28-.58.55-.9.82l-.24.19c-.25.19-.49.39-.76.58-.43.3-.86.59-1.3.84-8.26,4.82-21.66,4.82-29.92,0h0a13.29,13.29,0,0,1-1.31-.85c-.25-.18-.48-.36-.71-.54l-.29-.23a11.42,11.42,0,0,1-.88-.79c-.13-.13-.27-.26-.4-.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,363.14c11.38,6.64,11.38,17.41,0,24.05s-29.81,6.64-41.19,0-11.37-17.41,0-24.05S97.85,356.5,109.22,363.14Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.22,363.14c11.38,6.64,11.38,17.41,0,24.05s-29.81,6.64-41.19,0-11.37-17.41,0-24.05S97.85,356.5,109.22,363.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.75,366.34c8.36,4.87,8.36,12.78,0,17.66s-21.89,4.88-30.25,0-8.35-12.79,0-17.66S95.4,361.46,103.75,366.34Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.75,366.34c8.36,4.87,8.36,12.78,0,17.66s-21.89,4.88-30.25,0-8.35-12.79,0-17.66S95.4,361.46,103.75,366.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.5,374.72c8.36-4.88,21.9-4.88,30.25,0a14,14,0,0,1,5,4.64,14.1,14.1,0,0,1-5,4.64c-8.35,4.88-21.89,4.88-30.25,0a14,14,0,0,1-5-4.64A13.89,13.89,0,0,1,73.5,374.72Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,313.41l-1.66,67.77h0a.82.82,0,0,0,.49.68,2.56,2.56,0,0,0,2.35,0,.84.84,0,0,0,.49-.68h0Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.68 366.45 82.04 347.8 89.39 362.02 89.39 357.83 100.29 344 90.48 360.41 88.68 366.45",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.78,351.34a31.79,31.79,0,0,0,2.77,1.93c3.62,2.11,9.12,2.65,14.15,3,3.32.22,7.79.5,11-1.37,1.58-.92,2.9-2.65,2.77-4.32s-1.89-3.21-1.41-5.05c3.84-.39,7.56,1.43,11.32.16a16,16,0,0,0,7-5.29c1.15-1.38,2.27-3.5,2.08-5.14-.22-1.93-2.26-2.84-4-3.55a3.21,3.21,0,0,1-1.28-.77,1.25,1.25,0,0,1-.17-1.43,2.21,2.21,0,0,1,1.78-.82c1.4-.13,2.79-.08,4.2-.29a7.23,7.23,0,0,0,3.94-1.71,9.3,9.3,0,0,0,2.25-4.57,72.43,72.43,0,0,0,1.79-8.36c.1-.67,1.68-7.28,1.89-7.18-6-2.94-13.2-4-20.17-4-3.89,0-9.76.51-12.73,4A8.37,8.37,0,0,0,120.3,310a13.37,13.37,0,0,0-.21,1.67c0,.34-.18,1.69-.75.93a1.4,1.4,0,0,1-.18-.62l-.69-5.77a2.91,2.91,0,0,0-.52-1.6c-.79-.88-3.7-1-7.43.72a14.06,14.06,0,0,0-5.86,5.63c-2.24,3.71-3,7.91-3.81,12-.4-1.36-.81-2.72-1.22-4.08-1.42-4.78-5.89,2.35-6.59,3.95-1.84,4.22-3.36,11.05-3,15.36C90.43,343.15,91.58,347.75,94.78,351.34Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.78,351.34a31.79,31.79,0,0,0,2.77,1.93c3.62,2.11,9.12,2.65,14.15,3,3.32.22,7.79.5,11-1.37,1.58-.92,2.9-2.65,2.77-4.32s-1.89-3.21-1.41-5.05c3.84-.39,7.56,1.43,11.32.16a16,16,0,0,0,7-5.29c1.15-1.38,2.27-3.5,2.08-5.14-.22-1.93-2.26-2.84-4-3.55a3.21,3.21,0,0,1-1.28-.77,1.25,1.25,0,0,1-.17-1.43,2.21,2.21,0,0,1,1.78-.82c1.4-.13,2.79-.08,4.2-.29a7.23,7.23,0,0,0,3.94-1.71,9.3,9.3,0,0,0,2.25-4.57,72.43,72.43,0,0,0,1.79-8.36c.1-.67,1.68-7.28,1.89-7.18-6-2.94-13.2-4-20.17-4-3.89,0-9.76.51-12.73,4A8.37,8.37,0,0,0,120.3,310a13.37,13.37,0,0,0-.21,1.67c0,.34-.18,1.69-.75.93a1.4,1.4,0,0,1-.18-.62l-.69-5.77a2.91,2.91,0,0,0-.52-1.6c-.79-.88-3.7-1-7.43.72a14.06,14.06,0,0,0-5.86,5.63c-2.24,3.71-3,7.91-3.81,12-.4-1.36-.81-2.72-1.22-4.08-1.42-4.78-5.89,2.35-6.59,3.95-1.84,4.22-3.36,11.05-3,15.36C90.43,343.15,91.58,347.75,94.78,351.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,333.63a46.35,46.35,0,0,0,1.91-20.16l0-.15a.61.61,0,0,1,.48-.62.46.46,0,0,1,.58.39v.15a48.07,48.07,0,0,1-1.48,19c12.74-11.81,28.91-22.14,36.19-24.16a.49.49,0,0,1,.64.38.64.64,0,0,1-.47.69c-7.19,2-23.15,12.2-35.7,23.86,12-2.16,20.17,3,20.26,3.09a.48.48,0,0,1,.08.71.61.61,0,0,1-.51.25.48.48,0,0,1-.23-.07c-.09-.06-8.6-5.48-21-2.68-5.84,5.59-10.8,11.46-13.58,16.86a.68.68,0,0,1-.53.36.5.5,0,0,1-.24,0,.51.51,0,0,1-.23-.72C98.43,345.28,103.49,339.32,109.43,333.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85,352.66c-.24.22-2.33,1.42-2.63,1.57-3.38,1.69-8.14,2-12.47,2.15-2.85.1-6.69.21-9.14-1.47a3.75,3.75,0,0,1-1.72-3.77c.38-1.53,2.06-2.68,1.93-4.25-3.22-.45-6.64,1-9.66-.19a11.19,11.19,0,0,1-5.21-4.7,6,6,0,0,1-1-4.44c.46-1.64,2.33-2.36,3.94-2.92a3.06,3.06,0,0,0,1.19-.61,1.12,1.12,0,0,0,.35-1.22c-.21-.51-.84-.67-1.38-.74-1.18-.15-2.37-.15-3.53-.37a5.23,5.23,0,0,1-3.11-1.57,7,7,0,0,1-1.26-4A59.13,59.13,0,0,1,41,319c0-.57-.37-6.25-.57-6.16,5.52-2.34,11.8-3,17.73-2.87,3.32.07,8.23.7,10.24,3.78a6.31,6.31,0,0,1,.92,2.93,11.25,11.25,0,0,1-.07,1.42c0,.3-.08,1.45.51.82a1.19,1.19,0,0,0,.24-.52q.7-2.44,1.42-4.9a2.79,2.79,0,0,1,.67-1.34c.8-.73,3.29-.74,6.21.81a9.87,9.87,0,0,1,4.17,5c1.38,3.23,1.45,6.84,1.51,10.34.54-1.15,1.08-2.3,1.63-3.45,1.89-4,4.67,2.18,5,3.56A31.29,31.29,0,0,1,91,341.55C89.89,345.8,88.25,349.7,85,352.66Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,352.66c-.24.22-2.33,1.42-2.63,1.57-3.38,1.69-8.14,2-12.47,2.15-2.85.1-6.69.21-9.14-1.47a3.75,3.75,0,0,1-1.72-3.77c.38-1.53,2.06-2.68,1.93-4.25-3.22-.45-6.64,1-9.66-.19a11.19,11.19,0,0,1-5.21-4.7,6,6,0,0,1-1-4.44c.46-1.64,2.33-2.36,3.94-2.92a3.06,3.06,0,0,0,1.19-.61,1.12,1.12,0,0,0,.35-1.22c-.21-.51-.84-.67-1.38-.74-1.18-.15-2.37-.15-3.53-.37a5.23,5.23,0,0,1-3.11-1.57,7,7,0,0,1-1.26-4A59.13,59.13,0,0,1,41,319c0-.57-.37-6.25-.57-6.16,5.52-2.34,11.8-3,17.73-2.87,3.32.07,8.23.7,10.24,3.78a6.31,6.31,0,0,1,.92,2.93,11.25,11.25,0,0,1-.07,1.42c0,.3-.08,1.45.51.82a1.19,1.19,0,0,0,.24-.52q.7-2.44,1.42-4.9a2.79,2.79,0,0,1,.67-1.34c.8-.73,3.29-.74,6.21.81a9.87,9.87,0,0,1,4.17,5c1.38,3.23,1.45,6.84,1.51,10.34.54-1.15,1.08-2.3,1.63-3.45,1.89-4,4.67,2.18,5,3.56A31.29,31.29,0,0,1,91,341.55C89.89,345.8,88.25,349.7,85,352.66Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.11,337.16a39.78,39.78,0,0,1,1.29-17.23l0-.13a.43.43,0,0,0-.32-.54.45.45,0,0,0-.54.32l0,.13a41.42,41.42,0,0,0-1.49,16.22c-9.13-10.42-21.38-19.68-27.28-21.6a.48.48,0,1,0-.29.91c5.82,1.89,17.92,11,26.9,21.33a27.31,27.31,0,0,0-17.67,2.06.45.45,0,0,0-.17.61.44.44,0,0,0,.4.22.54.54,0,0,0,.21,0,26.27,26.27,0,0,1,18.22-1.69c4.16,4.93,7.54,10.06,9.12,14.75a.47.47,0,0,0,.39.32.5.5,0,0,0,.21,0,.48.48,0,0,0,.3-.61C82.78,347.4,79.34,342.17,75.11,337.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.47,331.26c-.33.06-2.73-.1-3.06-.14-3.76-.5-7.91-3.15-11.6-5.68-2.44-1.66-5.72-3.93-6.83-7a4.59,4.59,0,0,1,.62-4.6c1.16-1.21,3.19-1.25,4-2.82-2.45-2.4-6.1-3.15-8-6.13a13.79,13.79,0,0,1-1.78-7.64c0-1.62.48-3.75,1.57-4.81,1.29-1.25,3.25-.78,4.9-.3a3,3,0,0,0,1.33.16,1.21,1.21,0,0,0,1-.93,1.89,1.89,0,0,0-.75-1.56c-.9-.87-1.9-1.6-2.76-2.52a6.24,6.24,0,0,1-1.73-3.4,8.48,8.48,0,0,1,1.13-4.49,66.48,66.48,0,0,1,3.67-6.94A56.93,56.93,0,0,0,75,266.3c5.89,1.2,11.51,4.45,16.39,8.24,2.73,2.12,6.49,5.74,6.49,9.88a7.92,7.92,0,0,1-.84,3.32,13.71,13.71,0,0,1-.84,1.3c-.17.27-.87,1.31,0,1.07a1.22,1.22,0,0,0,.49-.33l3.87-3.73a2.76,2.76,0,0,1,1.31-.85c1.06-.19,3.15,1.34,4.74,4.6a12.39,12.39,0,0,1,.76,7.24c-.62,3.88-2.54,7.31-4.41,10.64l3.25-2.23c3.79-2.62,2.71,4.92,2.26,6.45-1.21,4-4.17,9.72-6.94,12.59C98.31,327.83,94.8,330.48,90.47,331.26Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,331.26c-.33.06-2.73-.1-3.06-.14-3.76-.5-7.91-3.15-11.6-5.68-2.44-1.66-5.72-3.93-6.83-7a4.59,4.59,0,0,1,.62-4.6c1.16-1.21,3.19-1.25,4-2.82-2.45-2.4-6.1-3.15-8-6.13a13.79,13.79,0,0,1-1.78-7.64c0-1.62.48-3.75,1.57-4.81,1.29-1.25,3.25-.78,4.9-.3a3,3,0,0,0,1.33.16,1.21,1.21,0,0,0,1-.93,1.89,1.89,0,0,0-.75-1.56c-.9-.87-1.9-1.6-2.76-2.52a6.24,6.24,0,0,1-1.73-3.4,8.48,8.48,0,0,1,1.13-4.49,66.48,66.48,0,0,1,3.67-6.94A56.93,56.93,0,0,0,75,266.3c5.89,1.2,11.51,4.45,16.39,8.24,2.73,2.12,6.49,5.74,6.49,9.88a7.92,7.92,0,0,1-.84,3.32,13.71,13.71,0,0,1-.84,1.3c-.17.27-.87,1.31,0,1.07a1.22,1.22,0,0,0,.49-.33l3.87-3.73a2.76,2.76,0,0,1,1.31-.85c1.06-.19,3.15,1.34,4.74,4.6a12.39,12.39,0,0,1,.76,7.24c-.62,3.88-2.54,7.31-4.41,10.64l3.25-2.23c3.79-2.62,2.71,4.92,2.26,6.45-1.21,4-4.17,9.72-6.94,12.59C98.31,327.83,94.8,330.48,90.47,331.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,310.59a44.36,44.36,0,0,1,10.53-15.41l.1-.1a.55.55,0,0,0,0-.71.41.41,0,0,0-.63,0l-.1.1a45.88,45.88,0,0,0-10.14,14.34c-1.91-15.44-7.07-31.7-10.95-37.15a.45.45,0,0,0-.67-.08.58.58,0,0,0-.07.75c3.82,5.38,8.91,21.44,10.78,36.66a26.11,26.11,0,0,0-15.9-9,.47.47,0,0,0-.48.47.52.52,0,0,0,.21.45.39.39,0,0,0,.21.08,25.28,25.28,0,0,1,16.16,9.67c.77,7.19.77,14.1-.48,19.49a.58.58,0,0,0,.15.54.52.52,0,0,0,.19.11.47.47,0,0,0,.58-.38C91.49,324.94,91.49,317.91,90.7,310.59Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.84,102.16c-.18,2,.65,3.63,0,5.65a43.15,43.15,0,0,0-1.49,5.34c-.49,2.72.62,7.31,4,7.73-.68-1.47-1.38-3.26-.67-4.9,1.63,6.38,9.82,8,15.56,7.9,5.28-.06,10.54-.72,15.25-3.35,2.34-1.3,2.55-2.63,2.55-2.63s.55.53.31,2.65a4.59,4.59,0,0,0,3.32-3.83c.52-2.38,0-4.64-.4-7-.13-.75-1.37-8.1-1.81-8.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.71,122.9c6.75,1.46,9.34,1.8,12.94,8.58,5,9.51,11.05,27.31,11.05,27.31L468.77,168l-2,14.7S449,179.1,438.6,176.34c-3-.79-4-2.67-5.46-4.81-1.21-1.78-13.26-20.15-13.26-20.15Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.23,121c7.09.7,10.52,1.48,12.45,2.07a19.49,19.49,0,0,1,4.58,7.11c3.13,8.42,4.36,14.19,6.7,38.72,1.94,20.25,1.26,37.69,2.46,52.71,1.8,22.56,2.5,35.5,2.5,35.5s-14.17-5.11-40.25-4.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.34,351.07c.2-4.25,1.91-47.16,1.91-47.16L412,319.71c3.72,24.46,5.14,31,5.33,35.09h0a3.71,3.71,0,0,0-.08,1.05c.16,4.86,5.71,7.32,10.08,10.44a79.08,79.08,0,0,0,11.78,7.21c3.15,1.47,9.46,1.43,10.18-.59-5.31-3.82-11.46-8-15.73-12.4C431.57,358.4,430.09,356.18,430.34,351.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.35,377.88c.27,0,.76,2.93-.66,4.22-1.63,1.49-6.47,4-13,3.34s-10.08-2.56-12.74-4.66-6.38-5-9.33-5.62c-2.75-.52-5.74-1.67-6.64-2.49s-.88-4.56-.88-4.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.29,353.62a1,1,0,0,0-1,.9c-.17,1-.3,4.05-.68,5.75a30.32,30.32,0,0,0-.38,9.12c.41,1.91,4.89,3.12,7.76,4.12a36.33,36.33,0,0,1,9.37,5.54c3.12,2.43,9.6,4.86,13.83,4.71,5-.18,10.59-2,11.81-4.32,1.52-2.91.22-4.54-7.3-7.76-1.42-.62-6.44-3.39-8.15-4.4-4.63-2.73-9.25-6.59-11.48-11.6a2.82,2.82,0,0,0-1.11-1.51,2.38,2.38,0,0,0-1.45-.09,12.3,12.3,0,0,0-3.54,1.18c-1,.5-2.38,1.09-2.32,2.37a4.08,4.08,0,0,0,.32,1.28c.1.26.17.61,0,.77s-.5,0-.7-.18a20.13,20.13,0,0,1-2.07-2.34A6.93,6.93,0,0,0,419,356a12.16,12.16,0,0,1-1.3-.79C417.24,354.77,417.33,354.21,417.29,353.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.41,379.05c-1.33-1-2.73-2-4.13-2.9h0s8.88,5.06,12.33,2.55c2.23-1.62,1.1-3.47,1-4.07s5.46-3.34,7.66-3.67h0c.62.33,1.14.58,1.47.73,7.52,3.22,8.82,4.85,7.3,7.76-1.22,2.36-5.25,4.28-11.72,4.47C442.11,384,435.53,381.48,432.41,379.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,372.88c4.67,1.71,2.73,2.63,1.44,2.85s-9.18-4.09-14-7.7c-5.05-3.76-8.29-7.95-10.16-9.33-.7-.51-1.46-1.15-2.13-1.74.09-1,.17-1.95.25-2.44a1,1,0,0,1,1-.9c0,.59-.05,1.15.41,1.59a12.16,12.16,0,0,0,1.3.79,6.93,6.93,0,0,1,1.2,1.16,20.13,20.13,0,0,0,2.07,2.34C426.45,364.5,436.3,371.17,441,372.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.05,375.06a.4.4,0,0,1-.29-.09.45.45,0,0,1-.08-.64,11,11,0,0,1,8.35-3.58.46.46,0,0,1,.42.49.44.44,0,0,1-.49.42,10.15,10.15,0,0,0-7.56,3.23A.43.43,0,0,1,442.05,375.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,372.7a.39.39,0,0,1-.29-.09.46.46,0,0,1-.09-.64,11,11,0,0,1,8.36-3.58.47.47,0,0,1,.42.5.45.45,0,0,1-.49.41,10.17,10.17,0,0,0-7.56,3.23A.46.46,0,0,1,438,372.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.87,370.47a.39.39,0,0,1-.29-.09.46.46,0,0,1-.09-.64,11,11,0,0,1,8.36-3.57.45.45,0,0,1,.42.49.46.46,0,0,1-.5.42,10.13,10.13,0,0,0-7.55,3.22A.46.46,0,0,1,433.87,370.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.06,367.9a.45.45,0,0,1-.29-.09.46.46,0,0,1-.08-.64,11,11,0,0,1,8.35-3.58.46.46,0,0,1,.42.5.44.44,0,0,1-.49.41,10.22,10.22,0,0,0-7.56,3.22A.41.41,0,0,1,430.06,367.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.33,365.33a.47.47,0,0,1-.28-.09.45.45,0,0,1-.1-.64c1.73-2.31,5.73-3.92,9.13-3.64a.45.45,0,0,1,.42.49.46.46,0,0,1-.49.42c-3.06-.25-6.79,1.23-8.32,3.28A.5.5,0,0,1,426.33,365.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,319.73l-19.72-2c-.83,13.73.09,29.13-.61,42-.13,2.43-1.61,18.81-1.11,23.86.75,7.6,9.72,7.32,10.56,2.88s1.38-23.65,1.57-25.62c.6-8.26,4.41-18.58,7.66-33.21C386.58,326.94,387.91,320.43,388.07,319.73Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,389.89c-.18,4.41-.81,7.34-2.33,10s-4.45,3.47-7.46,2.77-6.86-2.66-7.79-6.45-.79-6.39-.19-10.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.82,358.18c-1.23.12-1.49,6-2.09,12-.65,6.37-2.5,9-3.09,14.25-.67,6-.31,8.62,1.84,12.18s9.59,7,13.14,1.74c2.89-4.26,2.93-8.92,2.55-14.86a149.53,149.53,0,0,1-.54-15.11c.16-4.46.39-8.79-.69-9.26-.07.65-.14,1.48-.21,2.13-.06.49-.14,2.91-.83,2.94a9.41,9.41,0,0,1,0-1.68,2,2,0,0,0-.37-1.43,2.27,2.27,0,0,0-1.37-.58,35.16,35.16,0,0,0-3.67-.5,16.33,16.33,0,0,0-1.85-.05,5.14,5.14,0,0,0-1.56.25,1.13,1.13,0,0,0-.65.62,1.72,1.72,0,0,0-.05.68,5,5,0,0,1-.14,1.22c0,.18-.16.4-.33.36s-.21-.21-.21-.36c0-.72.06-1.24.08-2.08,0-.38.06-.91.06-1.3S367.8,358.56,367.82,358.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.89,382.71c-.1.86-.73,6.56.84,7.55s2.53-3.4,2.53-3.4,3.91-1.28,9.67,1.12c-.27.93.66,4,2.22,3.29s2.05-7.2,2.05-7.28c.34,5.69.23,10.21-2.58,14.34-3.55,5.21-11,1.82-13.14-1.74s-2.51-6.22-1.84-12.18C362.71,383.81,362.8,383.25,362.89,382.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.72,387.23c0,2.15-2.13,1.46-2.27-1.57s1.39-10.27,1.28-15.5c.6-5.94.86-11.86,2.09-12,0,.07,0,.14,0,.22l-.1,3c0,.44-.06.83,0,1.29,0,4.39-.42,12.88-.73,16.9A69.89,69.89,0,0,0,366.72,387.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.27,387.94a70.45,70.45,0,0,0,1-7.57c.35-4,1.27-12.34,2-16.68a10.9,10.9,0,0,0,.39-2.46c.07-.6.13-1.36.2-2a.69.69,0,0,1,0-.13c.77.36.87,2.74.8,5.72-.13,1.72-.36,3.86-.7,6.44-1,5.14-.63,12.57-1.28,15.54S374.9,390.06,375.27,387.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.06,388.16a.48.48,0,0,1-.17-.05,14.52,14.52,0,0,0-9.5-.81.46.46,0,0,1-.57-.32.46.46,0,0,1,.32-.56,15.33,15.33,0,0,1,10.16.87.46.46,0,0,1,.2.62A.45.45,0,0,1,376.06,388.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,383.47a.42.42,0,0,1-.15,0,18,18,0,0,0-10.64-.91.45.45,0,1,1-.22-.88,18.61,18.61,0,0,1,11.24,1,.45.45,0,0,1,.23.6A.47.47,0,0,1,377,383.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.43,378.08a.44.44,0,0,1-.39-.3.45.45,0,0,1,.27-.58c5.49-2,11,.74,11.23.86a.46.46,0,0,1,.2.61.46.46,0,0,1-.61.2c-.06,0-5.4-2.65-10.51-.81A.41.41,0,0,1,366.43,378.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.67,373.9a.48.48,0,0,1-.39-.3.44.44,0,0,1,.27-.58,14.15,14.15,0,0,1,11.44.81.46.46,0,1,1-.46.79,13.47,13.47,0,0,0-10.66-.75A.69.69,0,0,1,366.67,373.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,369.19a.43.43,0,0,1-.38-.28.46.46,0,0,1,.25-.6c5.65-2.23,11.3.81,11.53.95a.46.46,0,0,1-.44.8c-.05,0-5.51-3-10.75-.9A.39.39,0,0,1,367,369.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.22,181.71c-3.77,9.09-7.91,15.47-8.11,32.45-.43,36.12.43,62.17.43,62.17-.18,3.19-1.72,7.88-3.58,24.32-1.56,13.77-.79,34.91-.79,34.91s9.28,4.67,17.73,1.06c3.18-11.79,8.68-42.56,12.09-58.34C400.09,264,403,243,403,243l6,35.25s-.76,14.17-.14,22.51c.73,9.69,5.74,36.82,5.74,36.82s9.5,4,16.72-1.59c0,0,2.73-48.89,2.6-60.58-.25-22.92.06-71.24-4.35-95.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.66,332.14c3.51,2.11,14.53,3.35,19.22,1.5l-1.23,5.57s-2.11,1.55-8.63,1.3-9.09-2.91-9.09-2.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.57,332.86c3.76,1.64,14,1.47,18.4-1l-.51,5.69s-1.48,2.15-8,2.39-8.91-1.73-8.91-1.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,243l3.48-25.56s15.18-2.08,20.62-7.49c0,0-6.8,10-17.1,11.75l-4,21.21L409,278Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.82,123.08l-8.53,1c-5.65,1.47-8.18,4-8.69,9a39.4,39.4,0,0,0,.53,16.38c1.9,7.05,6.94,24.3,6.94,24.3s-8.26,7.46-10.5,25.49c20.35,12.86,49.44,7.59,57.69-.48-.82-7.52-1.59-16.4-2.28-23.11,0,0-1.24-10.8-.47-15.36a15.31,15.31,0,0,0,2.43-19c-7-10.54-16.59-18.34-19.16-18.29Z",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.27,116.85c2.52,0,2.82.38,5,3.27,1.33,1.72,10.31,13.06,10.31,13.06s-7.24-6.43-12.19-9a10.7,10.7,0,0,0-3.15-1.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.34,123.09s7.31,18.41,9.09,30.94-3.22,47.68-5.22,73c-1.29,16.34-3.24,40.38-3.24,40.38a83.09,83.09,0,0,1-14.59-1c-8.3-1.45-11.47-3.59-12.91-5.27,0,0,1.9-41.54,3.69-57.56,1.68-15.08,9.54-29.61,9.54-29.61L372,133.71s.39-6.8,6.75-8.79C384.82,123,394.34,123.09,394.34,123.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.17,148.72c1.19-9.59.65-14.32-.84-17.33l-8.78,14.08,6.15,28.44a97.2,97.2,0,0,0-9,25.78c6.11-18.1,14.67-23.62,14.67-23.62l-4-15.18S383.14,157,384.17,148.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.4,78.48,384,82.75a3.3,3.3,0,0,0-.63-4.77A3.64,3.64,0,0,0,378.4,78.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,118c-.12-3.43-8.27-8.28-12.64-15.34s-2.72-18.95,2.86-21c.05,0,.15-1.52.17-1.63a13.17,13.17,0,0,1,1.38-4A17.1,17.1,0,0,1,397.26,68C415,64.79,423.49,71.44,427,79A18.54,18.54,0,0,1,428.7,87,9.33,9.33,0,0,1,421.78,96Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.41,76.75c3.55,1.4,7.07,6.64,7.53,21.62.4,12.7-3.38,16-5.32,17.06s-5.61.82-9.37.37l.1,7.15s2.89,2.64,2,4.41-4.5,3.35-10.19,1.78c-6.45-1.78-8.05-6-8.05-6l-.68-16s-2.07,2.33-6-.84c-3.21-2.63-4.5-7.27-2.25-9.92s5.26-3,8.07-.19l1.92-1.09a36.59,36.59,0,0,0,11.69-4.47C414.44,86.21,416.78,80,417.41,76.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.22,94.16l.28,7a3.31,3.31,0,0,0,3.28-3.53A3.65,3.65,0,0,0,393.22,94.16Z",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418.35,94.28A1.69,1.69,0,1,0,420,92.53,1.71,1.71,0,0,0,418.35,94.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M404.94,95.5a1.84,1.84,0,0,0,1.8,1.88,1.86,1.86,0,0,0,1.82-1.88,1.81,1.81,0,1,0-3.62,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.92,88.82l-4.57-1A2.24,2.24,0,0,1,421.1,86,2.43,2.43,0,0,1,422.92,88.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.19 93.05 414.33 103.46 419.88 102.02 414.19 93.05",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,105.8l5.5,1.5a2.78,2.78,0,0,1-3.4,2.21A3.13,3.13,0,0,1,408,105.8Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.19,109.57a2.88,2.88,0,0,0-3-2.76,1.81,1.81,0,0,1-.23,0,3,3,0,0,0,2.15,2.67A2.67,2.67,0,0,0,411.19,109.57Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.25,115.8c-3.94-.32-12.3-2.45-13.74-5.7a8.64,8.64,0,0,0,3.06,4.08c2.52,2,10.72,4,10.72,4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.82,117.09c-1-.2-1.8.31-2.62,1.74s-2.62,4.48-2.62,4.48-.81,10,.18,12.45c.85,2.13,10.09,10.07,10.09,10.07s-2.26,9-2.3,11.93,5.7,14,6.42,19.71c0,0,1.71-18,.77-24.41-1.63-11.18-5.72-25.13-9.66-29.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,225.22c-1.64-2.49-1.81-4.39-4.19-6.56a7.6,7.6,0,0,1-2.23-3.3,25.53,25.53,0,0,1-1.15-6.38l-12.29,1.4c.3,4.11.33,10.05,1.54,14.34,3.06,10.85,5.7,15.34,10.48,16.16,7.61,1.32,9.3-2,6.37-7.32a27.23,27.23,0,0,1-2.77-7,13.37,13.37,0,0,0,2.93,2.36,2.65,2.65,0,0,0,3.56-.57C378.56,227.82,377.29,227.16,376,225.22Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.65,124.24s-8-.39-12.64,3.51-7.38,14.66-10.67,25.42A132.87,132.87,0,0,0,353,177c-.85,6.29,2.38,34.58,2.38,34.58s8,1.49,14.26-2l1.33-31.33,11-31.68A34.77,34.77,0,0,0,381.65,124.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.35 148.44 441.88 163.01 431.63 210.38 432.53 211.31 470.05 196.68 482.25 149.37 481.35 148.44",
    style: {
      fill: "#399252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.77 163.94 432.53 211.31 431.63 210.38 441.88 163.01 442.77 163.94",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.25 149.37 442.77 163.94 432.53 211.31 470.05 196.68 482.25 149.37",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464,187.17c.38.92,3.45,2.92,7.85,2.49l.71-2.74Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M470.44,159.21s.13-.71.3-1.59-2.15-.38-5.18,1.11L458.43,161c-3,1.48-5.91,2.6-6.08,3.47l-.3,1.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M472.69,152c.11-.55-.79-.42-2.06-.07l-2.27.81s.9-2.31-4.49-.77c-5.93,1.7-6,4.67-6,4.67a24.26,24.26,0,0,1-2.84,1.09c-2,.67-2.18,1.06-2.34,1.61l-.28,1L472.53,153S472.59,152.57,472.69,152Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.61,155.09c-1.86.87-2.63,1.3-2.89,2.65-.3,1.54-.36,2.19-.36,2.19l-10.47,4.3s.54-2.27.67-3-1.27-.74-3.08.13l.41-1.9,16.29-6.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,159.23l.31-1.59c.16-.87-2.16-.38-5.19,1.1L459,161c-3,1.48-5.9,2.59-6.07,3.47l-.31,1.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.07,165.59s-1.33,5.19-1.68,6.51-6.81,4.41-10.06,4.86c-6.2.86-6.89,2.22-5.33,6.62,1.44,4.06,5.51,5.53,11.12,4.79a10.18,10.18,0,0,0,7.6-6.84c1.75-5.23.69-10.77,1.37-13.82S479.63,163.75,478.07,165.59Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.68,88.32l-.78,0a22.45,22.45,0,0,0-7.85.71c-2.49.92-3.36,1.84-4.75,1.92s-2.44-.73-5.13-1.36c-2.15-.49-5.69-.21-8.4.23l-.84.14a1.42,1.42,0,0,0-.91,1.48,3.22,3.22,0,0,0,.84,1.61,1.73,1.73,0,0,1,.29.65,29,29,0,0,0,1.12,4.5,5.59,5.59,0,0,0,1.11,1.58,4.8,4.8,0,0,0,.56.45l.32.2a4.6,4.6,0,0,0,.95.4l.16,0,.25.06.27,0a6.88,6.88,0,0,0,.83.08h.8a6,6,0,0,0,5.68-3.72c.82-1.78.55-4.21,2.14-4.3h.15l.14,0c1.18.21,1.09,2.46,1.86,4a6.26,6.26,0,0,0,1.16,1.7,3.45,3.45,0,0,0,.28.26l.14.12.15.12.14.09.15.1.12.07.09,0a4.69,4.69,0,0,0,1.38.49l.13,0a6.94,6.94,0,0,0,1.68.08,5.09,5.09,0,0,0,4.81-3.45,31,31,0,0,0,.89-4.62,1.48,1.48,0,0,1,.28-.62,3.2,3.2,0,0,0,.69-1.72C428.61,89,428.12,88.35,427.68,88.32Zm-16.41,7.4a5.38,5.38,0,0,1-1.14,2.48h0a4.93,4.93,0,0,1-3.73,1.59,4,4,0,0,1-3.65-1.55l-.11-.16a1.63,1.63,0,0,1-.11-.17.51.51,0,0,1-.09-.16.64.64,0,0,1-.08-.14l-.06-.11s0-.07-.05-.1a1.3,1.3,0,0,0-.08-.17h0c-.07-.17-.13-.34-.19-.5h0c0-.1-.07-.2-.1-.3s-.09-.33-.12-.48l0-.09,0-.09c-.29-1.19-.65-3.55-.07-4.12s2.13-1.21,4.71-1.11l.27,0a11.51,11.51,0,0,1,1.18.13l.46.09a9.65,9.65,0,0,1,1.15.32l.35.12.38.17.08,0,.14.07a2.36,2.36,0,0,1,.78.59C411.66,92.79,411.54,94.36,411.27,95.72Zm15-1.37c-.17,1-.56,3-2.34,4a4.48,4.48,0,0,1-1.9.54,4,4,0,0,1-3.88-1.59v0l-.07-.11-.08-.12,0-.07-.1-.18c0-.08-.07-.15-.11-.22l-.05-.11s0,0,0-.06a.36.36,0,0,1,0-.09l0-.07a6.91,6.91,0,0,1-.26-.88c-.29-1.33-.47-2.89,0-3.66s2.35-1.69,4.17-2a11.21,11.21,0,0,1,1.17-.16h.29l.41,0h.35l.32,0,.59.07.14,0h0l.09,0,.15,0,.17,0,.28.1,0,0a2.2,2.2,0,0,1,.64.37C426.72,90.73,426.46,93.13,426.23,94.35Z",
    style: {
      fill: "#263238"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtPharmacist1);
export default __webpack_public_path__ + "static/media/art__pharmacist__1.a13cb7df559cf9d8d06c9ac8c26a7c86.svg";
export { ForwardRef as ReactComponent };